import React__default, { createContext, forwardRef, Children, useEffect, cloneElement, useContext, Fragment, useState, useRef, useMemo, useCallback, useLayoutEffect, useReducer } from "react";
import { getFirstTabbableIn } from "./auth-service-tools131.js";
import { hasFocusWithin } from "./auth-service-tools132.js";
import { Global, ClassNames, useTheme as useTheme$1, ThemeProvider as ThemeProvider$1 } from "@emotion/react";
import { jsx, jsxs, Fragment as Fragment$1 } from "@emotion/react/jsx-runtime";
import InstacartSans from "./auth-service-tools133.js";
import InstacartSansItalic from "./auth-service-tools134.js";
import { flushSync } from "react-dom";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);

var __typeError = msg => {
  throw TypeError(msg);
};

var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);

  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};

var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

var __name = (target, value) => __defProp(target, "name", {
  value,
  configurable: true
});

var __objRest = (source, exclude) => {
  var target = {};

  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];

  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};

var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }

  return to;
};

var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));

var __await = function (promise, isYieldStar) {
  this[0] = promise;
  this[1] = isYieldStar;
};

var __yieldStar = value => {
  var obj = value[__knownSymbol("asyncIterator")],
      isAwait = false,
      method,
      it = {};

  if (obj == null) {
    obj = value[__knownSymbol("iterator")]();

    method = k => it[k] = x => obj[k](x);
  } else {
    obj = obj.call(value);

    method = k => it[k] = v => {
      if (isAwait) {
        isAwait = false;
        if (k === "throw") throw v;
        return v;
      }

      isAwait = true;
      return {
        done: false,
        value: new __await(new Promise(resolve => {
          var x = obj[k](v);
          if (!(x instanceof Object)) __typeError("Object expected");
          resolve(x);
        }), 1)
      };
    };
  }

  return it[__knownSymbol("iterator")] = () => it, method("next"), "throw" in obj ? method("throw") : it.throw = x => {
    throw x;
  }, "return" in obj && method("return"), it;
};

var require_cjs = __commonJS({
  "../../node_modules/.pnpm/deepmerge@4.3.1/node_modules/deepmerge/dist/cjs.js"(exports, module) {
    var isMergeableObject = /* @__PURE__ */__name(function isMergeableObject2(value) {
      return isNonNullObject(value) && !isSpecial(value);
    }, "isMergeableObject");

    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }

    __name(isNonNullObject, "isNonNullObject");

    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }

    __name(isSpecial, "isSpecial");

    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;

    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }

    __name(isReactElement, "isReactElement");

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    __name(emptyTarget, "emptyTarget");

    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== false && options.isMergeableObject(value) ? deepmerge3(emptyTarget(value), value, options) : value;
    }

    __name(cloneUnlessOtherwiseSpecified, "cloneUnlessOtherwiseSpecified");

    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function (element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }

    __name(defaultArrayMerge, "defaultArrayMerge");

    function getMergeFunction(key, options) {
      if (!options.customMerge) {
        return deepmerge3;
      }

      var customMerge = options.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge3;
    }

    __name(getMergeFunction, "getMergeFunction");

    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
      }) : [];
    }

    __name(getEnumerableOwnPropertySymbols, "getEnumerableOwnPropertySymbols");

    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }

    __name(getKeys, "getKeys");

    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return false;
      }
    }

    __name(propertyIsOnObject, "propertyIsOnObject");

    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }

    __name(propertyIsUnsafe, "propertyIsUnsafe");

    function mergeObject(target, source, options) {
      var destination = {};

      if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function (key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
      }

      getKeys(source).forEach(function (key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }

        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
      });
      return destination;
    }

    __name(mergeObject, "mergeObject");

    function deepmerge3(target, source, options) {
      options = options || {};
      options.arrayMerge = options.arrayMerge || defaultArrayMerge;
      options.isMergeableObject = options.isMergeableObject || isMergeableObject;
      options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
      } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
      } else {
        return mergeObject(target, source, options);
      }
    }

    __name(deepmerge3, "deepmerge");

    deepmerge3.all = /* @__PURE__ */__name(function deepmergeAll(array, options) {
      if (!Array.isArray(array)) {
        throw new Error("first argument should be an array");
      }

      return array.reduce(function (prev, next) {
        return deepmerge3(prev, next, options);
      }, {});
    }, "deepmergeAll");
    var deepmerge_1 = deepmerge3;
    module.exports = deepmerge_1;
  }

});

var A11Y = {
  /**
   * Visually hidden, but available for screen readers
   * https://hub.accessible360.com/kb/articles/1178
   */
  visuallyHidden: {
    border: 0,
    clip: "rect(1px, 1px, 1px, 1px)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
  }
};
var layers = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  "l-1": -1,
  l0: 0,
  l1: 100,
  l2: 200
};
var elevation = {
  /**
   * Our content primary layer. Balance your type and color to express
   * meaningful hierarchy. This layer can include the majority of our components
   * as well as maps, images, and illustrations. This layer is always Pepper/0,
   * except under very special circumstances
   */
  primary: {
    shadow: {
      boxShadow: "none"
    },
    depth: {
      zIndex: layers.l0
    }
  },

  /**
   * This layer is used as an interactive object. Since Layer 2 is interactive
   * it cannot contain individual interactive components such as buttons or
   * interactive rows. This layer can contain rows, images, and illustrations.
   * Layer 2 objects cannot be fixed when scrolling, they must scroll with
   * Layer 1.
   */
  low: {
    shadow: {
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.16)"
    },
    depth: {
      zIndex: layers.l1
    }
  },

  /**
   * This layer is reserved for content or actions that take priority over the
   * first two layers. Layer 3 is used with our top bar as a user scrolls to
   * maintain page titles and quick actions. Layer 3 is used for sheet content
   * to focus the user on an immediate action, information, or confirmation.
   * Sheets are often used with overlays. This layer is also used for toasts.
   * Providing visual feedback as users complete actions. Layer 3 objects are
   * often fixed, and do not scroll with layers 1 & 2.
   */
  high: {
    shadow: {
      boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.16)"
    },
    depth: {
      zIndex: layers.l2
    }
  },

  /**
   * This layer is used as an interactive object. Since Layer 2 is interactive
   * it cannot contain individual interactive components such as buttons or
   * interactive rows. This layer can contain rows, images, and illustrations.
   * Layer 2 objects cannot be fixed when scrolling, they must scroll with Layer
   * 1. The most common Layer 2 components are Cards and the Add to Cart Button.
   */
  pantryLow2: {
    shadow: {
      boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.08)"
    },
    depth: {
      zIndex: layers.l2
    }
  },

  /**
   * This layer is reserved for content or actions that take priority over the
   * first two layers. Layer 3 is used with our top bar as a user scrolls to
   * maintain page titles and quick actions. Layer 3 is used for sheet content
   * to focus the user on an immediate action, information, or confirmation.
   * Sheets are often used with overlays. This layer is also used for toasts.
   * Providing visual feedback as users complete actions. Layer 3 objects are
   * often fixed, and do not scroll with layers 1 & 2.
   */
  pantryHigh3: {
    shadow: {
      boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.16)"
    },
    depth: {
      zIndex: layers.l2
    }
  }
};
var SMOOTH_EASING_FUNCTION_VARIABLE = "--smooth-easing-function";
var ELEVATED_EASING_FUNCTION_VARIABLE = "--elevated-easing-function";
var BOUNCE_EASING_FUNCTION_VARIABLE = "--bounce-easing-function";

function useCssTransition(transitionOptions) {
  if (Array.isArray(transitionOptions)) {
    return transitionOptions.map(mapTransitionOptionsToTransitionString).join(", ");
  }

  return mapTransitionOptionsToTransitionString(transitionOptions);
}

__name(useCssTransition, "useCssTransition");

var motionAtomMap = {
  smooth50: {
    easingFunction: SMOOTH_EASING_FUNCTION_VARIABLE,
    duration: 50
  },
  smooth100: {
    easingFunction: SMOOTH_EASING_FUNCTION_VARIABLE,
    duration: 100
  },
  smooth200: {
    easingFunction: SMOOTH_EASING_FUNCTION_VARIABLE,
    duration: 200
  },
  smooth300: {
    easingFunction: SMOOTH_EASING_FUNCTION_VARIABLE,
    duration: 300
  },
  smooth400: {
    easingFunction: SMOOTH_EASING_FUNCTION_VARIABLE,
    duration: 400
  },
  smooth800: {
    easingFunction: SMOOTH_EASING_FUNCTION_VARIABLE,
    duration: 800
  },
  elevated100: {
    easingFunction: ELEVATED_EASING_FUNCTION_VARIABLE,
    duration: 100
  },
  elevated200: {
    easingFunction: ELEVATED_EASING_FUNCTION_VARIABLE,
    duration: 200
  },
  elevated300: {
    easingFunction: ELEVATED_EASING_FUNCTION_VARIABLE,
    duration: 300
  },
  elevated400: {
    easingFunction: ELEVATED_EASING_FUNCTION_VARIABLE,
    duration: 400
  },
  elevated800: {
    easingFunction: ELEVATED_EASING_FUNCTION_VARIABLE,
    duration: 800
  },
  bounce100: {
    easingFunction: BOUNCE_EASING_FUNCTION_VARIABLE,
    duration: 100
  },
  bounce200: {
    easingFunction: BOUNCE_EASING_FUNCTION_VARIABLE,
    duration: 200
  },
  bounce300: {
    easingFunction: BOUNCE_EASING_FUNCTION_VARIABLE,
    duration: 300
  },
  bounce400: {
    easingFunction: BOUNCE_EASING_FUNCTION_VARIABLE,
    duration: 400
  },
  bounce800: {
    easingFunction: BOUNCE_EASING_FUNCTION_VARIABLE,
    duration: 800
  }
};

function mapTransitionOptionsToTransitionString(transitionOptions) {
  const {
    easingFunction,
    duration
  } = motionAtomMap[transitionOptions.motion];
  return [transitionOptions.property, `${duration}ms`, `var(${easingFunction})`, transitionOptions.delay, transitionOptions.behavior].filter(Boolean).join(" ");
}

__name(mapTransitionOptionsToTransitionString, "mapTransitionOptionsToTransitionString");

var spacing = {
  s4: 4,
  s8: 8,
  s12: 12,
  s16: 16,
  s24: 24,
  s32: 32,
  s40: 40,
  s48: 48
};
var responsive_exports = {};

__export(responsive_exports, {
  DESKTOP_SIZE: () => DESKTOP_SIZE,
  between: () => between,
  breakpoints: () => breakpoints,
  down: () => down,
  only: () => only,
  up: () => up
});

var breakpoints = {
  c: {
    min: 0,
    max: 767
  },
  r: {
    min: 768,
    max: 1023
  },
  l: {
    min: 1024,
    max: 1279
  },
  xl: {
    min: 1280,
    max: void 0
  }
};

var assertValidSizes = /* @__PURE__ */__name(function () {
  for (var _len = arguments.length, sizes = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    sizes[_key2] = arguments[_key2];
  }

  sizes.forEach(size => {
    if (breakpoints[size] === void 0) {
      throw new Error(`Screen size ${size} not supported. Must be one of ${Object.keys(breakpoints).join(", ")}`);
    }
  });
}, "assertValidSizes");

var up = /* @__PURE__ */__name(size => {
  assertValidSizes(size);
  return `@media (min-width: ${breakpoints[size].min}px)`;
}, "up");

var down = /* @__PURE__ */__name(size => {
  if (typeof breakpoints[size].max === "undefined") {
    throw new Error(`size "${size}" not supported`);
  }

  assertValidSizes(size);
  return `@media (max-width: ${breakpoints[size].max}px)`;
}, "down");

var only = /* @__PURE__ */__name(size => {
  assertValidSizes(size);
  const {
    min,
    max
  } = breakpoints[size];

  if (!min) {
    return `@media (max-width: ${max}px)`;
  }

  if (!max) {
    return `@media (min-width: ${min}px)`;
  }

  return `@media (min-width: ${min}px) and (max-width: ${max}px)`;
}, "only");

var between = /* @__PURE__ */__name((lowerSize, upperSize) => {
  assertValidSizes(lowerSize, upperSize);
  const lower = breakpoints[lowerSize].min;
  const upper = breakpoints[upperSize].min;
  return `@media (min-width: ${lower}px) and (max-width: ${upper}px)`;
}, "between");

var DESKTOP_SIZE = up("r");
var DESKTOP_SIZE_TYPOGRAPHY_HACK = `${up("r")} and (min-width: 0px)`;
var DESKTOP_SIZE2 = DESKTOP_SIZE_TYPOGRAPHY_HACK;
var TypographyStyleValues = ["titleLarge", "titleMedium", "subtitleLarge", "subtitleMedium", "subtitleSmall", "bodyLarge1", "bodyLarge2", "bodyMedium1", "bodyMedium2", "bodyMedium3", "bodySmall1", "bodySmall2", "bodySmall3", "displayExtraLarge1", "displayExtraLarge2", "displayLarge1", "displayLarge2", "displayMedium1", "displayMedium2", "priceCurrencyLarge", "priceCurrencySmall", "priceLabelLarge1", "priceLabelLarge2", "priceLabelSmall1", "priceLabelSmall2", "labelLarge", "labelMedium", "labelSmall", "headlineLarge1", "headlineLarge2", "headlineMedium1", "headlineMedium2", "headlineSmall1", "headlineSmall2", "linkLarge", "linkMedium", "linkSmall", "rootElement"];

function isTypographyStyle(val) {
  return TypographyStyleValues.includes(val);
}

__name(isTypographyStyle, "isTypographyStyle");

var toCoreXMap = /* @__PURE__ */new Map([["titleLarge", "headline"], ["titleMedium", "title"], ["subtitleLarge", "subtitle"], ["subtitleMedium", "subtitle"], ["subtitleSmall", "subtitle"], ["bodyLarge2", "bodyRegular"], ["bodyMedium2", "bodyRegular"], ["bodySmall2", "bodyRegular"], ["bodyLarge1", "bodyEmphasized"], ["bodyMedium1", "bodyEmphasized"], ["bodySmall1", "bodyEmphasized"], ["bodyMedium3", "bodyStrikethrough"], ["bodySmall3", "bodyStrikethrough"], ["linkLarge", "bodyLink"], ["linkMedium", "bodyLink"], ["linkSmall", "bodyLink"], ["labelLarge", "accentEmphasized"], ["labelMedium", "accentEmphasized"], ["labelSmall", "accentRegular"], ["headlineLarge1", "headline"], ["headlineLarge2", "headline"], ["titleLarge", "headline"], ["headlineMedium1", "title"], ["headlineMedium2", "title"], ["headlineSmall1", "title"], ["headlineSmall2", "title"]]);

var toCoreXTypography = /* @__PURE__ */__name(value => {
  const fromMap = toCoreXMap.get(value);
  if (fromMap) return fromMap;
  return value;
}, "toCoreXTypography");

var IDS_TYPOGRAPHY_NAME_VARIABLE = "--ids-typography-name";

function hasMediaQueries(value) {
  return DESKTOP_SIZE2 in value;
}

__name(hasMediaQueries, "hasMediaQueries");

function appendIdsTypographyName(themeConfigTypography) {
  const final = __spreadValues({}, themeConfigTypography);

  Object.entries(themeConfigTypography).forEach((_ref) => {
    let [key, value] = _ref;
    const keyAs = key;

    if (hasMediaQueries(value)) {
      const desktopSizeValue = value[DESKTOP_SIZE2];
      final[keyAs] = __spreadProps(__spreadValues({}, value), {
        [IDS_TYPOGRAPHY_NAME_VARIABLE]: `mobile/${keyAs}`,
        [DESKTOP_SIZE2]: __spreadProps(__spreadValues({}, desktopSizeValue), {
          [IDS_TYPOGRAPHY_NAME_VARIABLE]: `web/${keyAs}`
        })
      });
    } else {
      final[keyAs] = __spreadProps(__spreadValues({}, value), {
        [IDS_TYPOGRAPHY_NAME_VARIABLE]: keyAs
      });
    }
  });
  return final;
}

__name(appendIdsTypographyName, "appendIdsTypographyName");

function extractMWebTypographyStyles(cssObject) {
  const mWebStyles = __spreadValues({}, cssObject);

  if (hasMediaQueries(mWebStyles)) {
    delete mWebStyles[DESKTOP_SIZE2];
    return mWebStyles;
  }

  return mWebStyles;
}

__name(extractMWebTypographyStyles, "extractMWebTypographyStyles");

function extractDWebTypographyStyles(cssObject) {
  const mWebStyles = extractMWebTypographyStyles(cssObject);

  if (hasMediaQueries(cssObject)) {
    return __spreadValues(__spreadValues({}, mWebStyles), cssObject[DESKTOP_SIZE2]);
  }

  return mWebStyles;
}

__name(extractDWebTypographyStyles, "extractDWebTypographyStyles");

var useAriaLabel = /* @__PURE__ */__name(props => {
  const {
    description,
    relatedIds,
    describedByIds
  } = props;
  return {
    "aria-label": description,
    "aria-labelledby": Array.isArray(relatedIds) ? relatedIds.join(" ") : relatedIds,
    "aria-describedby": Array.isArray(describedByIds) ? describedByIds.join(" ") : describedByIds
  };
}, "useAriaLabel");

var useAriaLoading = /* @__PURE__ */__name(function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    currentProgressValue,
    progressStartValue,
    progressEndValue
  } = props;
  return {
    role: "progressbar",
    "aria-valuenow": currentProgressValue,
    "aria-valuemin": progressStartValue || 0,
    "aria-valuemax": progressEndValue || 100
  };
}, "useAriaLoading");

var useInitialFocusElem = /* @__PURE__ */__name((_ref2) => {
  let {
    initialFocusElem,
    rootElem,
    checkFocus
  } = _ref2;
  useEffect( /* @__PURE__ */__name(function focusInitialElem() {
    const rootNode = rootElem == null ? void 0 : rootElem.current;
    const initialFocusNode = initialFocusElem == null ? void 0 : initialFocusElem.current;

    if (initialFocusNode) {
      initialFocusNode.focus();
    }

    if (!rootNode) return;

    const isActive = /* @__PURE__ */__name(() => hasFocusWithin(rootNode), "isActive");

    if (isActive()) return;
    const tabbable = getFirstTabbableIn(rootNode, true);
    tabbable && tabbable.focus({
      preventScroll: true
    });
    if (isActive()) return;
    rootNode.focus({
      preventScroll: true
    });
  }, "focusInitialElem"), [checkFocus, initialFocusElem, rootElem]);
}, "useInitialFocusElem");

var useAriaCurrent = /* @__PURE__ */__name(props => {
  const {
    current
  } = props;
  return {
    "aria-current": current
  };
}, "useAriaCurrent");

var aspectRatio = /* @__PURE__ */__name((width, height) => ({
  box: {
    position: "relative",
    paddingTop: `calc((${height} / ${width}) * 100%)`,
    overflow: "hidden",
    height: 0
  },
  boxInside: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}), "aspectRatio");

function hexToRgb(hexColor) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const hex = hexColor.replace(shorthandRegex, (_, r2, g, b) => `${r2 + r2}${g + g}${b + b}`);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    throw new Error(`Could not convert ${hexColor} to RGB`);
  }

  return {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  };
}

__name(hexToRgb, "hexToRgb");

function addAlphaToHex(hexColor, alpha) {
  if (Number.isNaN(alpha)) {
    return hexColor;
  }

  const applyAlpha = alpha < 0 ? 0 : alpha > 1 ? 1 : alpha;
  const rgbValues = hexToRgb(hexColor);

  if (!rgbValues) {
    return hexColor;
  }

  const {
    r: r2,
    g,
    b
  } = rgbValues;
  return `rgba(${r2},${g},${b},${applyAlpha})`;
}

__name(addAlphaToHex, "addAlphaToHex");

function blendColors(colorA, colorB, blendPercent) {
  const {
    r: rA,
    g: gA,
    b: bA
  } = hexToRgb(colorA);
  const {
    r: rB,
    g: gB,
    b: bB
  } = hexToRgb(colorB);
  const amount = blendPercent > 1 ? blendPercent * 0.01 : blendPercent;
  const r2 = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, "0");
  const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, "0");
  const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, "0");
  return `#${r2}${g}${b}`;
}

__name(blendColors, "blendColors");

var combineStyles = /* @__PURE__ */__name((baseStyles, styleOverrides) => {
  if (!styleOverrides) {
    return baseStyles;
  }

  const baseAndVariantStyles = Object.getOwnPropertyNames(baseStyles).reduce((combinedStyles, key) => {
    return __spreadProps(__spreadValues({}, combinedStyles), {
      [key]: [baseStyles[key], styleOverrides[key]]
    });
  }, {});
  return baseAndVariantStyles;
}, "combineStyles");

var positionX = /* @__PURE__ */__name(left => {
  return function () {
    let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const toAdd = `translateX(-${left}%)`;
    const newTransform = obj.transform ? `${obj.transform} ${toAdd}` : toAdd;
    return __spreadProps(__spreadValues({}, obj), {
      left: `${left}%`,
      transform: newTransform
    });
  };
}, "positionX");

var positionY = /* @__PURE__ */__name(top => {
  return function () {
    let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const toAdd = `translateY(-${top}%)`;
    const newTransform = obj.transform ? `${obj.transform} ${toAdd}` : toAdd;
    return __spreadProps(__spreadValues({}, obj), {
      top: `${top}%`,
      transform: newTransform
    });
  };
}, "positionY");

positionX(50)();
var POSITION_Y_CENTER = positionY(50)();
var POSITION_X_Y_CENTER = positionX(50)(positionY(50)());
var STRETCH_OVER_RELATIVE_PARENT = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%"
};
var CSS_RESET = {
  html: {
    lineHeight: 1.15,
    WebkitTextSizeAdjust: "100%",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  },
  body: {
    margin: 0,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale"
  },
  main: {
    display: "block"
  },
  h1: {
    fontSize: "2em",
    margin: "0.67em 0"
  },
  hr: {
    boxSizing: "border-box",
    fontSize: "1em"
  },
  pre: {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  a: {
    backgroundColor: "transparent"
  },
  "abbr[title]": {
    borderBottom: "none",
    textDecoration: ["underline", "underline dotted"]
  },
  "b, strong": {
    fontWeight: "bolder"
  },
  "code, kbd, samp": {
    fontFamily: "monospace monospace",
    fontSize: "1em"
  },
  small: {
    fontSize: "80%"
  },
  "sub, sup": {
    fontSize: "75%",
    lineHeight: 0,
    position: "relative",
    verticalAlign: "baseline"
  },
  sub: {
    bottom: "-0.25em"
  },
  sup: {
    top: "-0.5em"
  },
  img: {
    borderStyle: "none"
  },
  "button, input, optgroup, select, textarea": {
    fontFamily: "inherit",
    fontSize: "100%",
    lineHeight: 1.15,
    margin: 0
  },
  "button, input": {
    overflow: "visible"
  },
  "button, select": {
    textTransform: "none"
  },
  'button, [type="button"], [type="reset"], [type="submit"]': {
    WebkitAppearance: "button"
  },
  'button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner': {
    borderStyle: "none",
    padding: 0
  },
  'button:-moz-focusring, [type="button"]:-moz-focusring, [type="reset"]:-moz-focusring, [type="submit"]:-moz-focusring': {
    outline: "1px dotted ButtonText"
  },
  fieldset: {
    padding: "0.35em 0.75em 0.625em"
  },
  legend: {
    boxSizing: "border-box",
    color: "inherit",
    display: "table",
    maxWidth: "100%",
    padding: 0,
    whiteSpace: "normal"
  },
  progress: {
    verticalAlign: "baseline"
  },
  textarea: {
    overflow: "auto"
  },
  '[type="checkbox"], [type="radio"]': {
    boxSizing: "border-box",
    padding: 0
  },
  '[type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button': {
    height: "auto"
  },
  '[type="search"]': {
    WebkitAppearance: "textfield",
    outlineOffset: "-2px"
  },
  '[type="search"]::-webkit-search-decoration': {
    WebkitAppearance: "none"
  },
  "::-webkit-file-upload-button": {
    WebkitAppearance: "button",
    font: "inherit"
  },
  details: {
    display: "block"
  },
  summary: {
    display: "list-item"
  },
  template: {
    display: "none"
  },
  "[hidden]": {
    display: "none"
  }
};

function CSSReset() {
  return /* @__PURE__ */jsx(Global, {
    styles: CSS_RESET
  });
}

__name(CSSReset, "CSSReset");

var NON_VARIABLE_FONT_SETTINGS = {};

function createGetFontVariationSettings(fontVariationSettings) {
  const getFontVariationSettings = /* @__PURE__ */__name((_ref3) => {
    let {
      wght,
      opsz
    } = _ref3;

    if (!fontVariationSettings) {
      return NON_VARIABLE_FONT_SETTINGS;
    }

    const weight = fontVariationSettings.wght[wght];
    return {
      // Why include both fontWeight and fontVariationSettings? This is intended
      // to support both variable and non-variable fonts. All variable fonts we
      // support must map 1:1 between `wght` axis and font-weight property
      // values.
      fontWeight: weight,
      fontVariationSettings: `"wght" ${weight}, "opsz" ${fontVariationSettings.opsz[opsz]}`
    };
  }, "getFontVariationSettings");

  return getFontVariationSettings;
}

__name(createGetFontVariationSettings, "createGetFontVariationSettings");

var DESKTOP_SIZE3 = DESKTOP_SIZE_TYPOGRAPHY_HACK;
var INSTACART_SANS_FONT_FAMILY = "Instacart Sans";
var INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS = `"${INSTACART_SANS_FONT_FAMILY}", Helvetica, Arial, sans-serif`;
var INSTACART_CONTRAST_FONT_FAMILY = "Instacart Contrast";
var INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS = `"${INSTACART_CONTRAST_FONT_FAMILY}", Helvetica, Arial, sans-serif`;
var FONT_VARIATION_CONSTANTS = {
  wght: {
    normal: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800
  },
  opsz: {
    // These values are encoded into the static versions of our Instacart Sans
    // fonts. With our variable fonts we can just change this axis of variation
    // to get the same effect as changing font families.
    headline: 48,
    // Maps to Instacart Sans Headline
    subhead: 32,
    // Maps to Instacart Sans Subhead
    text: 8 // Maps to Instacart Sans Text

  }
};
var getVariationSettings = createGetFontVariationSettings(FONT_VARIATION_CONSTANTS);
var INSTACART_SANS_THEME_TYPOGRAPHY = appendIdsTypographyName({
  rootElement: {
    fontFamily: INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS,
    fontVariationSettings: `"opsz" ${FONT_VARIATION_CONSTANTS.opsz.text}` // Setting the `wght` axis here would prevent backwards compatibility with font-weight

  },
  titleLarge: __spreadValues({
    fontSize: 29,
    lineHeight: "32px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  titleMedium: __spreadValues({
    fontSize: 21,
    lineHeight: "24px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  subtitleLarge: __spreadValues({
    fontSize: 17,
    lineHeight: "22px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  subtitleMedium: __spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  subtitleSmall: __spreadValues({
    fontSize: 11,
    lineHeight: "16px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  bodyLarge1: __spreadValues({
    fontSize: 17,
    lineHeight: "22px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  bodyLarge2: __spreadValues({
    fontSize: 17,
    lineHeight: "22px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })),
  bodyMedium1: __spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  bodyMedium2: __spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })),
  bodyMedium3: __spreadProps(__spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })), {
    textDecoration: "line-through"
  }),
  bodySmall1: __spreadValues({
    fontSize: 11,
    lineHeight: "16px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  bodySmall2: __spreadValues({
    fontSize: 11,
    lineHeight: "16px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })),
  bodySmall3: __spreadProps(__spreadValues({
    fontSize: 11,
    lineHeight: "16px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })), {
    textDecoration: "line-through"
  }),
  labelLarge: __spreadValues({
    fontSize: 9,
    lineHeight: "12px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  labelMedium: __spreadValues({
    fontSize: 9,
    lineHeight: "12px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  labelSmall: __spreadValues({
    fontSize: 9,
    lineHeight: "12px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })),
  headlineLarge1: __spreadValues({
    fontSize: 29,
    lineHeight: "32px"
  }, getVariationSettings({
    wght: "extraBold",
    opsz: "text"
  })),
  headlineLarge2: __spreadValues({
    fontSize: 29,
    lineHeight: "32px",
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS
  }, getVariationSettings({
    wght: "extraBold",
    opsz: "text"
  })),
  headlineMedium1: __spreadValues({
    fontSize: 21,
    lineHeight: "24px"
  }, getVariationSettings({
    wght: "extraBold",
    opsz: "text"
  })),
  headlineMedium2: __spreadValues({
    fontSize: 21,
    lineHeight: "24px",
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS
  }, getVariationSettings({
    wght: "extraBold",
    opsz: "text"
  })),
  headlineSmall1: __spreadValues({
    fontSize: 17,
    lineHeight: "19px"
  }, getVariationSettings({
    wght: "extraBold",
    opsz: "text"
  })),
  headlineSmall2: __spreadValues({
    fontSize: 17,
    lineHeight: "19px",
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS
  }, getVariationSettings({
    wght: "extraBold",
    opsz: "text"
  })),
  displayExtraLarge1: __spreadValues({
    fontSize: 72,
    lineHeight: "108%"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  displayExtraLarge2: __spreadValues({
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 72,
    lineHeight: "108%"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  displayLarge1: __spreadValues({
    fontSize: 52,
    lineHeight: "116%"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  displayLarge2: __spreadValues({
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 52,
    lineHeight: "116%"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  displayMedium1: __spreadValues({
    fontSize: 36,
    lineHeight: "120%"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  displayMedium2: __spreadValues({
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 36,
    lineHeight: "120%"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  priceCurrencyLarge: __spreadValues({
    fontSize: 23,
    lineHeight: "23px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  priceCurrencySmall: __spreadValues({
    fontSize: 17,
    lineHeight: "17px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  priceLabelLarge1: __spreadValues({
    fontSize: 9,
    lineHeight: "10px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  priceLabelLarge2: __spreadValues({
    fontSize: 9,
    lineHeight: "10px",
    textDecoration: "line-through"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })),
  priceLabelSmall1: __spreadValues({
    fontSize: 8,
    lineHeight: "10px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })),
  priceLabelSmall2: __spreadValues({
    fontSize: 8,
    lineHeight: "10px",
    textDecoration: "line-through"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })),
  linkLarge: __spreadProps(__spreadValues({
    fontSize: 17,
    lineHeight: "22px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    textDecoration: "underline"
  }),
  linkMedium: __spreadProps(__spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    textDecoration: "underline"
  }),
  linkSmall: __spreadProps(__spreadValues({
    fontSize: 11,
    lineHeight: "16px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    textDecoration: "underline"
  }),
  // CoreX New Tokens
  headline: __spreadProps(__spreadValues({
    fontSize: 24,
    lineHeight: "28px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "subhead"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 28,
      lineHeight: "32px"
    }
  }),
  title: __spreadProps(__spreadValues({
    fontSize: 18,
    lineHeight: "22px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "subhead"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 24,
      lineHeight: "28px"
    }
  }),
  subtitle: __spreadProps(__spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 18,
      lineHeight: "22px"
    }
  }),
  bodyRegular: __spreadProps(__spreadValues({
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 14,
      lineHeight: "20px"
    }
  }),
  bodyEmphasized: __spreadProps(__spreadValues({
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 14,
      lineHeight: "20px"
    }
  }),
  bodyStrikethrough: __spreadProps(__spreadValues({
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })), {
    textDecoration: "line-through",
    [DESKTOP_SIZE3]: {
      fontSize: 14,
      lineHeight: "20px"
    }
  }),
  bodyLink: __spreadProps(__spreadValues({
    fontSize: 12,
    lineHeight: "18px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    textDecoration: "underline",
    [DESKTOP_SIZE3]: {
      fontSize: 14,
      lineHeight: "20px"
    }
  }),
  accent: __spreadProps(__spreadValues({
    fontSize: 10,
    lineHeight: "14px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 12,
      lineHeight: "16px"
    }
  }),
  accentEmphasized: __spreadProps(__spreadValues({
    fontSize: 10,
    lineHeight: "14px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 12,
      lineHeight: "16px"
    }
  }),
  accentLink: __spreadProps(__spreadValues({
    fontSize: 10,
    lineHeight: "14px"
  }, getVariationSettings({
    wght: "semiBold",
    opsz: "text"
  })), {
    textDecoration: "underline",
    [DESKTOP_SIZE3]: {
      fontSize: 12,
      lineHeight: "16px"
    }
  }),
  accentRegular: __spreadProps(__spreadValues({
    fontSize: 10,
    lineHeight: "14px"
  }, getVariationSettings({
    wght: "normal",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 12,
      lineHeight: "16px"
    }
  }),
  priceEmphasized: __spreadProps(__spreadValues({
    fontSize: 14,
    lineHeight: "20px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })), {
    [DESKTOP_SIZE3]: {
      fontSize: 18,
      lineHeight: "22px"
    }
  }),
  experimentalDisplay: __spreadValues({
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 72,
    lineHeight: "84px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  })),
  experimentalHero: __spreadValues({
    fontFamily: INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS,
    fontSize: 48,
    lineHeight: "54px"
  }, getVariationSettings({
    wght: "bold",
    opsz: "text"
  }))
});
var InstacartSansFontLoaderVariants = [{
  src: [{
    url: InstacartSans,
    format: "woff2-variations"
  }],
  fontWeight: "400 800",
  fontStyle: "normal"
}, {
  fontStyle: "italic",
  fontWeight: "400 800",
  src: [{
    url: InstacartSansItalic,
    format: "woff2-variations"
  }]
}];

function formatVariantSrc(variant) {
  const _a = variant,
        {
    src
  } = _a,
        restOfVariant = __objRest(_a, ["src"]);

  const formattedSrc = src.map(item => {
    return `url('${item.url}') format('${item.format}')`;
  });
  return __spreadProps(__spreadValues({}, restOfVariant), {
    src: formattedSrc.join(", ")
  });
}

__name(formatVariantSrc, "formatVariantSrc");

var defaultVariants = InstacartSansFontLoaderVariants;

function FontLoader(_ref4) {
  let {
    fontFamily,
    variants
  } = _ref4;
  let fontName = fontFamily;
  let fontVariants = variants;

  if (!fontFamily && !variants) {
    fontName = INSTACART_SANS_FONT_FAMILY;
    fontVariants = defaultVariants;
  }

  return /* @__PURE__ */jsx(Fragment, {
    children: fontVariants == null ? void 0 : fontVariants.map((variant, index) => /* @__PURE__ */jsx(Global, {
      styles: {
        "@font-face": __spreadProps(__spreadValues({}, formatVariantSrc(variant)), {
          // Font name should be the same for all variants
          fontFamily: fontName,
          // Font display should always be swap for performance
          fontDisplay: "swap"
        })
      }
    }, index))
  });
}

__name(FontLoader, "FontLoader");

function FunctionOrReactNodeAsChild(_ref5) {
  let {
    children,
    args
  } = _ref5;

  if (typeof children === "function") {
    return children(args);
  }

  return /* @__PURE__ */jsx(Fragment$1, {
    children
  });
}

__name(FunctionOrReactNodeAsChild, "FunctionOrReactNodeAsChild");

var lineClamp = /* @__PURE__ */__name(lines => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden"
}), "lineClamp");

function forwardRefWithAs(component) {
  return /*#__PURE__*/forwardRef(component);
}

__name(forwardRefWithAs, "forwardRefWithAs");

var import_deepmerge2 = __toESM(require_cjs());

var CORE_COLORS = {
  brandPrimaryRegular: "#108910",
  brandPrimaryDark: "#0D720D",
  brandPrimaryExtraDark: "#0A610A",
  brandPrimaryLight: "#E9FBE9",
  brandSecondaryRegular: "#003D29",
  brandSecondaryDark: "#003121",
  brandSecondaryExtraDark: "#001810",
  brandSecondaryLight: "#EDF7F4",
  brandHighlightRegular: "#2B78C6",
  brandHighlightDark: "#1F5A96",
  brandHighlightLight: "#F2F8FF",
  brandPromotionalRegular: "#D43684",
  brandPromotionalDark: "#A51F61",
  brandPromotionalLight: "#FFF5FA",
  brandLoyaltyRegular: "#E97300",
  brandLoyaltyDark: "#BB5C05",
  brandLoyaltyLight: "#FFF5EB",
  brandExpressRegular: "#FFBE1D",
  brandExpressDark: "#FFA500",
  brandExpressExtraDark: "#BC5B12",
  brandExpressLight: "#F7F5F0",
  brandTertiaryRegular: "#FAF1E5",
  brandTertiaryLight: "#F7F5F0",
  brandTertiaryDark: "#EFE9E1",
  systemSuccessRegular: "#108910",
  systemSuccessDark: "#0D720D",
  systemSuccessLight: "#E9FBE9",
  systemSuccessExtraDark: "#0A610A",
  systemDetrimentalRegular: "#DE3534",
  systemDetrimentalDark: "#BB1C1B",
  systemDetrimentalExtraDark: "#AC1615",
  systemDetrimentalLight: "#FEF0F0",
  systemGrayscale99: "#0B0C0D",
  systemGrayscale90: "#191A1C",
  systemGrayscale80: "#242529",
  systemGrayscale70: "#343538",
  systemGrayscale60: "#56595E",
  systemGrayscale50: "#72767E",
  systemGrayscale40: "#8F939B",
  systemGrayscale30: "#C7C8CD",
  systemGrayscale20: "#E8E9EB",
  systemGrayscale10: "#F6F7F8",
  systemGrayscale00: "#FFFFFF",
  plusExtraLight: "#FFD7E8",
  plusLight: "#B00074",
  plusRegular: "#750046",
  plusDark: "#5E0038",
  plusExtraDark: "#46002A",
  kale: "#003D29",
  kaleDark: "#001810",
  maxYellow: "#FFDC23",
  brandBusinessBlueberry: "#6672FA",
  brandBusinessElderberry: "#10004A",
  brandMaxDark: "#242529",
  brandMaxLight: "#FFDC23",
  brandLime: "#0AAD0A",
  brandKale: "#003D29",
  brandCashew: "#FAF1E5",
  brandLemon: "#FFDC23",
  brandPlum: "#750046"
};
var CORE_COMPONENTS = {
  button: {
    disabledColor: "systemGrayscale10",
    // Commenting out until we have a disabledBorderWeight token
    // disabledBorderColor: 'systemGrayscale10',
    disabledTextColor: "systemGrayscale30",
    elevationShadow: elevation.primary.shadow.boxShadow,
    elevationDepth: elevation.primary.depth.zIndex,
    // Excluding until the pantryButtons experiment is complete
    // heightStandard: `${spacing.s48 + spacing.s8}px`,
    heightSmall: `${spacing.s40}px`,
    heightCompact: `${spacing.s32}px`,
    // Excluding until the pantryButtons experiment is complete
    // radiusStandard: `${CORE_RADII.round}px`,
    // radiusSmall: `${CORE_RADII.round}px`,
    // radiusCompact: `${CORE_RADII.round}px`,
    spaceHorizontalStandard: spacing.s16,
    spaceHorizontalStandardDesktop: spacing.s16,
    spaceHorizontalSmall: spacing.s16,
    spaceHorizontalSmallDesktop: spacing.s16,
    spaceHorizontalCompact: spacing.s16,
    spaceHorizontalCompactDesktop: spacing.s16,
    typographyStandard: INSTACART_SANS_THEME_TYPOGRAPHY.subtitleMedium,
    typographySmall: INSTACART_SANS_THEME_TYPOGRAPHY.bodyEmphasized,
    typographyCompact: INSTACART_SANS_THEME_TYPOGRAPHY.bodyEmphasized
  },
  buttonPrimary: {
    colorBackgroundType: "static-color",
    color: "brandPrimaryRegular"
  },
  buttonSecondary: {
    colorBackgroundType: "static-color",
    color: "systemGrayscale20"
  },
  buttonTertiary: {
    colorBackgroundType: "static-color",
    color: "systemGrayscale00",
    borderColor: "systemGrayscale20" // TODO: Add borderWidth token when it is available

  },
  buttonDetrimental: {
    colorBackgroundType: "static-color",
    color: "systemDetrimentalRegular"
  }
};
var CORE_MOTION = {
  smoothEasingFunction: "linear(0, 0.159 3.3%, 0.29 6.5%, 0.41 10%, 0.515 13.7%, 0.608 17.7%, 0.686 21.9%, 0.754 26.5%, 0.812 31.6%, 0.858 36.9%, 0.896 42.7%, 0.95 56.4%, 0.98 74.2%, 1)",
  elevatedEasingFunction: "linear(0, 0.006 1.2%, 0.026 2.5%, 0.111 5.5%, 0.591 16.8%, 0.785 22.3%, 0.859 25%, 0.918 27.7%, 0.965 30.5%, 1.002 33.5%, 1.038 38.7%, 1.049 44.9%, 1.004 72.8%, 1)",
  bounceEasingFunction: "linear(0, 0.007 1%, 0.031 2.1%, 0.132 4.6%, 0.676 13.5%, 0.888 17.7%, 0.964 19.7%, 1.026 21.8%, 1.071 23.9%, 1.102 26.2%, 1.119 29.2%, 1.115 32.7%, 1.017 47.2%, 0.988 56%, 1)"
};
var CORE_RADII = {
  r0: 0,
  r4: 4,
  r8: 8,
  r12: 12,
  r24: 24,
  round: 999
};
var coreTheme = {
  colors: CORE_COLORS,
  radius: CORE_RADII,
  typography: INSTACART_SANS_THEME_TYPOGRAPHY,
  components: CORE_COMPONENTS,
  motion: CORE_MOTION
};

var getDepth = /* @__PURE__ */__name(o => {
  let values;

  if (Array.isArray(o)) {
    values = o;
  } else if (o && typeof o === "object" && Object.keys(o).length > 0) {
    values = Object.keys(o).map(k => o[k]);
  }

  return values ? Math.max.apply(0, values.map(getDepth)) + 1 : 0;
}, "getDepth");

function useIdsFeatureFlag(flag) {
  const {
    featureFlags
  } = useIdsConfig();
  return featureFlags[flag];
}

__name(useIdsFeatureFlag, "useIdsFeatureFlag");

function processComponentThemeConfig(theme) {
  const {
    components: componentThemeConfig,
    colors
  } = theme;
  const processedComponentThemeConfig = {};
  Object.keys(componentThemeConfig).forEach(componentName => {
    const componentKey = componentName;
    const componentThemeOverrides = componentThemeConfig[componentKey];

    if (!componentThemeOverrides || typeof componentThemeOverrides !== "object") {
      return;
    }

    const processed = __spreadValues({}, componentThemeOverrides);

    Object.entries(componentThemeOverrides).forEach((_ref6) => {
      let [key, value] = _ref6;

      if (key.toLowerCase().includes("color") && value in colors) {
        processed[key] = colors[value];
      }
    });
    processedComponentThemeConfig[componentKey] = processed;
  });
  return processedComponentThemeConfig;
}

__name(processComponentThemeConfig, "processComponentThemeConfig");

var ERROR_MESSAGE = `No <IdsProvider> in scope. Please add a <IdsProvider> to your component tree.`;
var CachedThemeContext = /*#__PURE__*/createContext(void 0);

function useIsIdsThemeConfigured() {
  const ctx = useContext(CachedThemeContext);
  return !!ctx;
}

__name(useIsIdsThemeConfigured, "useIsIdsThemeConfigured");

var useTheme = /* @__PURE__ */__name(() => {
  const ctx = useContext(CachedThemeContext);
  if (!ctx) throw new Error(ERROR_MESSAGE);
  const {
    standard,
    coreX
  } = ctx;
  const doCoreXMapping = useIdsFeatureFlag("coreXTypography") === "variant";
  return doCoreXMapping ? coreX : standard;
}, "useTheme");

function deriveThemeFromThemeConfig(themeConfig) {
  return __spreadProps(__spreadValues({}, themeConfig), {
    typography: __spreadProps(__spreadValues({}, themeConfig.typography), {
      disclaimerSmall: themeConfig.typography.labelSmall,
      disclaimerMedium: themeConfig.typography.labelMedium,
      legalLinkLarge: __spreadProps(__spreadValues({}, themeConfig.typography.linkLarge), {
        color: themeConfig.colors.brandPrimaryRegular
      }),
      legalLinkMedium: __spreadProps(__spreadValues({}, themeConfig.typography.linkMedium), {
        color: themeConfig.colors.brandPrimaryRegular
      }),
      legalLinkSmall: __spreadProps(__spreadValues({}, themeConfig.typography.linkSmall), {
        color: themeConfig.colors.brandPrimaryRegular
      }),
      bodyLegalLink: __spreadProps(__spreadValues({}, themeConfig.typography.bodyLink), {
        color: themeConfig.colors.brandPrimaryRegular
      }),
      accentLegalLink: __spreadProps(__spreadValues({}, themeConfig.typography.accentLink), {
        color: themeConfig.colors.brandPrimaryRegular
      })
    }),
    colors: __spreadProps(__spreadValues({}, themeConfig.colors), {
      tertiaryRegular: themeConfig.colors.brandTertiaryRegular
    })
  });
}

__name(deriveThemeFromThemeConfig, "deriveThemeFromThemeConfig");

function mapCoreXTypography(theme) {
  const typography = __spreadValues({}, theme.typography);

  Object.entries(typography).forEach((_ref7) => {
    let [key] = _ref7;

    if (isTypographyStyle(key)) {
      typography[key] = typography[toCoreXTypography(key)];
    }
  });
  typography.legalLinkSmall = typography.bodyLegalLink;
  typography.legalLinkMedium = typography.bodyLegalLink;
  typography.legalLinkLarge = typography.bodyLegalLink;
  return __spreadProps(__spreadValues({}, theme), {
    typography: __spreadValues({}, typography)
  });
}

__name(mapCoreXTypography, "mapCoreXTypography");

function CachedThemeProvider(_ref8) {
  let {
    children
  } = _ref8;
  const themeObject = useTheme$1();
  if (!Object.keys(themeObject).length) throw new Error(ERROR_MESSAGE);
  const value = useMemo(() => {
    const themeWithHelpers = deriveThemeFromThemeConfig(themeObject);
    const standard = themeWithHelpers;
    const coreX = mapCoreXTypography(themeWithHelpers);
    const processedComponentTheme = processComponentThemeConfig(themeObject);
    return {
      standard,
      coreX,
      processedComponentTheme
    };
  }, [themeObject]);
  return /* @__PURE__ */jsx(CachedThemeContext.Provider, {
    value,
    children
  });
}

__name(CachedThemeProvider, "CachedThemeProvider");

var IdsConfigContext = /*#__PURE__*/createContext(void 0);
IdsConfigContext.displayName = "IdsConfigContext";
var ERROR_MESSAGE2 = `No <IdsProvider> in scope. Please add a <IdsProvider> to your component tree.`;

var useIdsConfig = /* @__PURE__ */__name(() => {
  const idsConfig = useContext(IdsConfigContext);
  if (!idsConfig) throw new Error(ERROR_MESSAGE2);
  return idsConfig;
}, "useIdsConfig");

var import_deepmerge = __toESM(require_cjs());

function ThemeOverride(_ref9) {
  let {
    children,
    themeOverrides
  } = _ref9;
  const theme = useTheme();
  const mergedTheme = useMemo(() => {
    return (0, import_deepmerge.default)(theme, themeOverrides);
  }, [themeOverrides, theme]);
  return /* @__PURE__ */jsx(ThemeProvider$1, {
    theme: mergedTheme,
    children: /* @__PURE__ */jsx(CachedThemeProvider, {
      children
    })
  });
}

__name(ThemeOverride, "ThemeOverride");

function useComponentTheme(componentName) {
  var _a;

  const ctx = useContext(CachedThemeContext);

  if (ctx === void 0 || !("processedComponentTheme" in ctx)) {
    throw new Error(`No <IdsProvider> in scope. Please add a <IdsProvider> to your component tree.`);
  }

  return (_a = ctx.processedComponentTheme[componentName]) != null ? _a : {};
}

__name(useComponentTheme, "useComponentTheme");

var CachedTDSThemeContext = /*#__PURE__*/createContext(void 0);

function computeInteractiveBackgroundColors(backgroundColors, colorType) {
  return {
    primaryColor: computeBackgroundColor(colorType, backgroundColors.color, backgroundColors.color2),
    hoverColor: computeBackgroundColor(colorType, backgroundColors.hoverColor, backgroundColors.hoverColor2),
    activeColor: computeBackgroundColor(colorType, backgroundColors.pressColor, backgroundColors.pressColor2)
  };
}

__name(computeInteractiveBackgroundColors, "computeInteractiveBackgroundColors");

function computeBackgroundColor() {
  let colorType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "static-color";
  let color = arguments.length > 1 ? arguments[1] : undefined;
  let color2 = arguments.length > 2 ? arguments[2] : undefined;
  if (!color) return;

  switch (colorType) {
    case "static-color":
      return color;

    case "linear-gradient-from-top":
      return `linear-gradient(to bottom, ${color}, ${color2 || color})`;

    case "linear-gradient-inverse-vertical":
      return `linear-gradient(to top, ${color}, ${color2 || color})`;

    default:
      {
        const exhaustiveCheck = colorType;
        return exhaustiveCheck;
      }
  }
}

__name(computeBackgroundColor, "computeBackgroundColor");

var defaultFeatureFlags = {
  grayscale: "control",
  pantry: "control",
  pantryButtons: "control",
  coreXTypography: "control"
};

function reducer(state, action) {
  switch (action.type) {
    case "ROTATE":
      if (state === void 0) {
        return state;
      }

      return __spreadProps(__spreadValues({}, state), {
        index: state.index < state.length - 1 ? state.index + 1 : 0
      });

    default:
      return state;
  }
}

__name(reducer, "reducer");

function useFeatureFlagDebugOverrides(params) {
  const skip = params === void 0;
  const defaultState = skip ? void 0 : {
    index: 0,
    length: params.values.length
  };
  const [state, dispatch] = useReducer(reducer, defaultState);
  useEffect(() => {
    if (process.env.NODE_ENV === "development" && (state == null ? void 0 : state.index) != null && params) {
      console.log(`IdsProvider feature flag override: ${params.debugFlag}=${params.values[state.index]}`);
    }
  }, [state, params]);
  useEffect(() => {
    if (skip) {
      return;
    }

    function toggleFeatureFlagOverride(ev) {
      if (ev.key === "/" && ev.ctrlKey && ev.shiftKey && ev.metaKey) {
        dispatch({
          type: "ROTATE"
        });
      }
    }

    __name(toggleFeatureFlagOverride, "toggleFeatureFlagOverride");

    window.addEventListener("keydown", toggleFeatureFlagOverride);
    return () => {
      window.removeEventListener("keydown", toggleFeatureFlagOverride);
    };
  }, [skip]);

  if (skip || (state == null ? void 0 : state.index) == null) {
    return void 0;
  }

  return {
    [params.debugFlag]: params.values[state.index]
  };
}

__name(useFeatureFlagDebugOverrides, "useFeatureFlagDebugOverrides");

var ColorCacheContext = /*#__PURE__*/createContext({
  cache: /* @__PURE__ */new Map()
});

function ColorCacheProvider(_ref10) {
  let {
    children
  } = _ref10;
  const theme = useTheme();
  const [colorCache, setColorCache] = useState( /* @__PURE__ */new Map());
  useEffect(() => {
    setColorCache( /* @__PURE__ */new Map());
  }, [theme]);
  const value = useMemo(() => ({
    cache: colorCache
  }), [colorCache]);
  return /* @__PURE__ */jsx(ColorCacheContext.Provider, {
    value,
    children
  });
}

__name(ColorCacheProvider, "ColorCacheProvider");

function MotionGlobalStyles() {
  const themeConfig = useTheme$1();
  return /* @__PURE__ */jsx(Global, {
    styles: {
      ":root": {
        // Fallback for browsers that don't support linear() easing functions
        // Make sure to update Story file if you change this
        [SMOOTH_EASING_FUNCTION_VARIABLE]: "cubic-bezier(0, 0, 0, 1)",
        [ELEVATED_EASING_FUNCTION_VARIABLE]: "cubic-bezier(0, 1.25, 0.6, 1)",
        [BOUNCE_EASING_FUNCTION_VARIABLE]: "cubic-bezier(0, 1.7, 0.4, 0.9)"
      },
      "@supports(animation-timing-function: linear(0, 1))": {
        ":root": {
          [SMOOTH_EASING_FUNCTION_VARIABLE]: themeConfig.motion.smoothEasingFunction,
          [ELEVATED_EASING_FUNCTION_VARIABLE]: themeConfig.motion.elevatedEasingFunction,
          [BOUNCE_EASING_FUNCTION_VARIABLE]: themeConfig.motion.bounceEasingFunction
        }
      }
    }
  });
}

__name(MotionGlobalStyles, "MotionGlobalStyles");

var ON_PRESS_TOUCH_ACTION = "var(--ids-pressable-touch-action, manipulation)";
var ON_PRESS_TOUCH_ACTION_VAR_NAME = "--ids-pressable-touch-action";
var IS_IOS_MEDIA_QUERY = "@supports (-webkit-touch-callout: none)";

function OnPressGlobalStyles() {
  return /* @__PURE__ */jsx(Global, {
    styles: {
      ":root": {
        [ON_PRESS_TOUCH_ACTION_VAR_NAME]: "manipulation"
      },
      [IS_IOS_MEDIA_QUERY]: {
        ":root": {
          [ON_PRESS_TOUCH_ACTION_VAR_NAME]: "pan-x pan-y pinch-zoom"
        }
      }
    }
  });
}

__name(OnPressGlobalStyles, "OnPressGlobalStyles");

var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? React__default.useLayoutEffect : () => {};

function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
  const ref = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    ref.current = fn;
  }, [fn]);
  return useCallback(function () {
    const f = ref.current;
    return f === null || f === void 0 ? void 0 : f(...arguments);
  }, []);
}

__name($8ae05eaa5c114e9c$export$7f54fc3180508a52, "$8ae05eaa5c114e9c$export$7f54fc3180508a52");

function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
  let [value, setValue] = useState(defaultValue);
  let effect = useRef(null);
  let nextRef = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (!effect.current) return;
    let newValue = effect.current.next();

    if (newValue.done) {
      effect.current = null;
      return;
    }

    if (value === newValue.value) nextRef();else setValue(newValue.value);
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (effect.current) nextRef();
  });
  let queue = $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn => {
    effect.current = fn(value);
    nextRef();
  });
  return [value, queue];
}

__name($1dbecbe27a04f9af$export$14d238f342723f25, "$1dbecbe27a04f9af$export$14d238f342723f25");

var $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
};
var $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */React__default.createContext($b5e257d569688ac6$var$defaultContext);
var $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */React__default.createContext(false);

function $b5e257d569688ac6$var$LegacySSRProvider(props) {
  let cur = useContext($b5e257d569688ac6$var$SSRContext);
  let counter = $b5e257d569688ac6$var$useCounter(cur === $b5e257d569688ac6$var$defaultContext);
  let [isSSR, setIsSSR] = useState(true);
  let value = useMemo(() => ({
    // If this is the first SSRProvider, start with an empty string prefix, otherwise
    // append and increment the counter.
    prefix: cur === $b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
    current: 0
  }), [cur, counter]);
  if (typeof document !== "undefined") useLayoutEffect(() => {
    setIsSSR(false);
  }, []);
  return /* @__PURE__ */React__default.createElement($b5e257d569688ac6$var$SSRContext.Provider, {
    value
  }, /* @__PURE__ */React__default.createElement($b5e257d569688ac6$var$IsSSRContext.Provider, {
    value: isSSR
  }, props.children));
}

__name($b5e257d569688ac6$var$LegacySSRProvider, "$b5e257d569688ac6$var$LegacySSRProvider");

var $b5e257d569688ac6$var$warnedAboutSSRProvider = false;

function $b5e257d569688ac6$export$9f8ac96af4b1b2ae(props) {
  if (typeof React__default["useId"] === "function") {
    if (process.env.NODE_ENV !== "test" && !$b5e257d569688ac6$var$warnedAboutSSRProvider) {
      console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
      $b5e257d569688ac6$var$warnedAboutSSRProvider = true;
    }

    return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, props.children);
  }

  return /* @__PURE__ */React__default.createElement($b5e257d569688ac6$var$LegacySSRProvider, props);
}

__name($b5e257d569688ac6$export$9f8ac96af4b1b2ae, "$b5e257d569688ac6$export$9f8ac96af4b1b2ae");

var $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $b5e257d569688ac6$var$componentIds = /* @__PURE__ */new WeakMap();

function $b5e257d569688ac6$var$useCounter() {
  let isDisabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let ctx = useContext($b5e257d569688ac6$var$SSRContext);
  let ref = useRef(null);

  if (ref.current === null && !isDisabled) {
    var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

    let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;

    if (currentOwner) {
      let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
      if (prevComponentValue == null) $b5e257d569688ac6$var$componentIds.set(currentOwner, {
        id: ctx.current,
        state: currentOwner.memoizedState
      });else if (currentOwner.memoizedState !== prevComponentValue.state) {
        ctx.current = prevComponentValue.id;
        $b5e257d569688ac6$var$componentIds.delete(currentOwner);
      }
    }

    ref.current = ++ctx.current;
  }

  return ref.current;
}

__name($b5e257d569688ac6$var$useCounter, "$b5e257d569688ac6$var$useCounter");

function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext);
  if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
  let prefix = ctx === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ctx.prefix}`;
  return defaultId || `${prefix}-${counter}`;
}

__name($b5e257d569688ac6$var$useLegacySSRSafeId, "$b5e257d569688ac6$var$useLegacySSRSafeId");

function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
  let id = React__default.useId();
  let [didSSR] = useState($b5e257d569688ac6$export$535bd6ca7f90a273());
  let prefix = didSSR || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return defaultId || `${prefix}-${id}`;
}

__name($b5e257d569688ac6$var$useModernSSRSafeId, "$b5e257d569688ac6$var$useModernSSRSafeId");

var $b5e257d569688ac6$export$619500959fc48b26 = typeof React__default["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;

function $b5e257d569688ac6$var$getSnapshot() {
  return false;
}

__name($b5e257d569688ac6$var$getSnapshot, "$b5e257d569688ac6$var$getSnapshot");

function $b5e257d569688ac6$var$getServerSnapshot() {
  return true;
}

__name($b5e257d569688ac6$var$getServerSnapshot, "$b5e257d569688ac6$var$getServerSnapshot");

function $b5e257d569688ac6$var$subscribe(onStoreChange) {
  return () => {};
}

__name($b5e257d569688ac6$var$subscribe, "$b5e257d569688ac6$var$subscribe");

function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  if (typeof React__default["useSyncExternalStore"] === "function") return React__default["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
  return useContext($b5e257d569688ac6$var$IsSSRContext);
}

__name($b5e257d569688ac6$export$535bd6ca7f90a273, "$b5e257d569688ac6$export$535bd6ca7f90a273");

var $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $bdb11010cef70236$export$d41a04c74483c6ef = /* @__PURE__ */new Map();
var $bdb11010cef70236$var$registry;
if (typeof FinalizationRegistry !== "undefined") $bdb11010cef70236$var$registry = new FinalizationRegistry(heldValue => {
  $bdb11010cef70236$export$d41a04c74483c6ef.delete(heldValue);
});

function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  let [value, setValue] = useState(defaultId);
  let nextId = useRef(null);
  let res = $b5e257d569688ac6$export$619500959fc48b26(value);
  let cleanupRef = useRef(null);
  if ($bdb11010cef70236$var$registry) $bdb11010cef70236$var$registry.register(cleanupRef, res);

  if ($bdb11010cef70236$var$canUseDOM) {
    const cacheIdRef = $bdb11010cef70236$export$d41a04c74483c6ef.get(res);
    if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);else $bdb11010cef70236$export$d41a04c74483c6ef.set(res, [nextId]);
  }

  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let r2 = res;
    return () => {
      if ($bdb11010cef70236$var$registry) $bdb11010cef70236$var$registry.unregister(cleanupRef);
      $bdb11010cef70236$export$d41a04c74483c6ef.delete(r2);
    };
  }, [res]);
  useEffect(() => {
    let newId = nextId.current;
    if (newId) setValue(newId);
    return () => {
      if (newId) nextId.current = null;
    };
  });
  return res;
}

__name($bdb11010cef70236$export$f680877a34711e37, "$bdb11010cef70236$export$f680877a34711e37");

function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
  if (idA === idB) return idA;
  let setIdsA = $bdb11010cef70236$export$d41a04c74483c6ef.get(idA);

  if (setIdsA) {
    setIdsA.forEach(ref => ref.current = idB);
    return idB;
  }

  let setIdsB = $bdb11010cef70236$export$d41a04c74483c6ef.get(idB);

  if (setIdsB) {
    setIdsB.forEach(ref => ref.current = idA);
    return idA;
  }

  return idB;
}

__name($bdb11010cef70236$export$cd8c9cb68f842629, "$bdb11010cef70236$export$cd8c9cb68f842629");

function $bdb11010cef70236$export$b4cc09c592e8fdb8() {
  let depArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let id = $bdb11010cef70236$export$f680877a34711e37();
  let [resolvedId, setResolvedId] = $1dbecbe27a04f9af$export$14d238f342723f25(id);
  let updateId = useCallback(() => {
    setResolvedId(function* () {
      yield id;
      yield document.getElementById(id) ? id : void 0;
    });
  }, [id, setResolvedId]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId, [id, updateId, ...depArray]);
  return resolvedId;
}

__name($bdb11010cef70236$export$b4cc09c592e8fdb8, "$bdb11010cef70236$export$b4cc09c592e8fdb8");

function $ff5963eb1fccf552$export$e08e3b67e392101e() {
  for (var _len2 = arguments.length, callbacks = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
    callbacks[_key3] = arguments[_key3];
  }

  return function () {
    for (let callback of callbacks) if (typeof callback === "function") callback(...arguments);
  };
}

__name($ff5963eb1fccf552$export$e08e3b67e392101e, "$ff5963eb1fccf552$export$e08e3b67e392101e");

var $431fbd86ca7dc216$export$b204af158042fbac = /* @__PURE__ */__name(el => {
  var _el_ownerDocument;

  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
}, "$431fbd86ca7dc216$export$b204af158042fbac");

var $431fbd86ca7dc216$export$f21a1ffae260145a = /* @__PURE__ */__name(el => {
  if (el && "window" in el && el.window === el) return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
}, "$431fbd86ca7dc216$export$f21a1ffae260145a");

function $431fbd86ca7dc216$var$isNode(value) {
  return value !== null && typeof value === "object" && "nodeType" in value && typeof value.nodeType === "number";
}

__name($431fbd86ca7dc216$var$isNode, "$431fbd86ca7dc216$var$isNode");

function $431fbd86ca7dc216$export$af51f0f06c0f328a(node) {
  return $431fbd86ca7dc216$var$isNode(node) && node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in node;
}

__name($431fbd86ca7dc216$export$af51f0f06c0f328a, "$431fbd86ca7dc216$export$af51f0f06c0f328a");

var $f4e2df6bd15f8569$var$_shadowDOM = false;

function $f4e2df6bd15f8569$export$98658e8c59125e6a() {
  return $f4e2df6bd15f8569$var$_shadowDOM;
}

__name($f4e2df6bd15f8569$export$98658e8c59125e6a, "$f4e2df6bd15f8569$export$98658e8c59125e6a");

function $d4ee10de306f2510$export$4282f70798064fe0(node, otherNode) {
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return otherNode && node ? node.contains(otherNode) : false;
  if (!node || !otherNode) return false;
  let currentNode = otherNode;

  while (currentNode !== null) {
    if (currentNode === node) return true;
    if (currentNode.tagName === "SLOT" && currentNode.assignedSlot) currentNode = currentNode.assignedSlot.parentNode;else if ($431fbd86ca7dc216$export$af51f0f06c0f328a(currentNode)) currentNode = currentNode.host;else currentNode = currentNode.parentNode;
  }

  return false;
}

__name($d4ee10de306f2510$export$4282f70798064fe0, "$d4ee10de306f2510$export$4282f70798064fe0");

var $d4ee10de306f2510$export$cd4e5573fbe2b576 = /* @__PURE__ */__name(function () {
  let doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var _activeElement_shadowRoot;

  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return doc.activeElement;
  let activeElement = doc.activeElement;

  while (activeElement && "shadowRoot" in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement)) activeElement = activeElement.shadowRoot.activeElement;

  return activeElement;
}, "$d4ee10de306f2510$export$cd4e5573fbe2b576");

function $d4ee10de306f2510$export$e58f029f0fbfdb29(event) {
  if ($f4e2df6bd15f8569$export$98658e8c59125e6a() && event.target.shadowRoot) {
    if (event.composedPath) return event.composedPath()[0];
  }

  return event.target;
}

__name($d4ee10de306f2510$export$e58f029f0fbfdb29, "$d4ee10de306f2510$export$e58f029f0fbfdb29");

var _$dfc540311bf7f109$export$63eb3ababa9c55c4 = class _$dfc540311bf7f109$export$63eb3ababa9c55c42 {
  get currentNode() {
    return this._currentNode;
  }

  set currentNode(node) {
    if (!$d4ee10de306f2510$export$4282f70798064fe0(this.root, node)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const walkers = [];
    let curNode = node;
    let currentWalkerCurrentNode = node;
    this._currentNode = node;

    while (curNode && curNode !== this.root) if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const shadowRoot = curNode;

      const walker2 = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
        acceptNode: this._acceptNode
      });

      walkers.push(walker2);
      walker2.currentNode = currentWalkerCurrentNode;

      this._currentSetFor.add(walker2);

      curNode = currentWalkerCurrentNode = shadowRoot.host;
    } else curNode = curNode.parentNode;

    const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });

    walkers.push(walker);
    walker.currentNode = currentWalkerCurrentNode;

    this._currentSetFor.add(walker);

    this._walkerStack = walkers;
  }

  get doc() {
    return this._doc;
  }

  firstChild() {
    let currentNode = this.currentNode;
    let newNode = this.nextNode();

    if (!$d4ee10de306f2510$export$4282f70798064fe0(currentNode, newNode)) {
      this.currentNode = currentNode;
      return null;
    }

    if (newNode) this.currentNode = newNode;
    return newNode;
  }

  lastChild() {
    let walker = this._walkerStack[0];
    let newNode = walker.lastChild();
    if (newNode) this.currentNode = newNode;
    return newNode;
  }

  nextNode() {
    const nextNode = this._walkerStack[0].nextNode();

    if (nextNode) {
      const shadowRoot = nextNode.shadowRoot;

      if (shadowRoot) {
        var _this_filter;

        let nodeResult;
        if (typeof this.filter === "function") nodeResult = this.filter(nextNode);else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(nextNode);

        if (nodeResult === NodeFilter.FILTER_ACCEPT) {
          this.currentNode = nextNode;
          return nextNode;
        }

        let newNode = this.nextNode();
        if (newNode) this.currentNode = newNode;
        return newNode;
      }

      if (nextNode) this.currentNode = nextNode;
      return nextNode;
    } else {
      if (this._walkerStack.length > 1) {
        this._walkerStack.shift();

        let newNode = this.nextNode();
        if (newNode) this.currentNode = newNode;
        return newNode;
      } else return null;
    }
  }

  previousNode() {
    const currentWalker = this._walkerStack[0];

    if (currentWalker.currentNode === currentWalker.root) {
      if (this._currentSetFor.has(currentWalker)) {
        this._currentSetFor.delete(currentWalker);

        if (this._walkerStack.length > 1) {
          this._walkerStack.shift();

          let newNode = this.previousNode();
          if (newNode) this.currentNode = newNode;
          return newNode;
        } else return null;
      }

      return null;
    }

    const previousNode = currentWalker.previousNode();

    if (previousNode) {
      const shadowRoot = previousNode.shadowRoot;

      if (shadowRoot) {
        var _this_filter;

        let nodeResult;
        if (typeof this.filter === "function") nodeResult = this.filter(previousNode);else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) nodeResult = this.filter.acceptNode(previousNode);

        if (nodeResult === NodeFilter.FILTER_ACCEPT) {
          if (previousNode) this.currentNode = previousNode;
          return previousNode;
        }

        let newNode = this.lastChild();
        if (newNode) this.currentNode = newNode;
        return newNode;
      }

      if (previousNode) this.currentNode = previousNode;
      return previousNode;
    } else {
      if (this._walkerStack.length > 1) {
        this._walkerStack.shift();

        let newNode = this.previousNode();
        if (newNode) this.currentNode = newNode;
        return newNode;
      } else return null;
    }
  }
  /**
   * @deprecated
   */


  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */


  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */


  parentNode() {
    return null;
  }

  constructor(doc, root, whatToShow, filter) {
    this._walkerStack = [];
    this._currentSetFor = /* @__PURE__ */new Set();

    this._acceptNode = node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const shadowRoot2 = node.shadowRoot;

        if (shadowRoot2) {
          const walker = this._doc.createTreeWalker(shadowRoot2, this.whatToShow, {
            acceptNode: this._acceptNode
          });

          this._walkerStack.unshift(walker);

          return NodeFilter.FILTER_ACCEPT;
        } else {
          var _this_filter;

          if (typeof this.filter === "function") return this.filter(node);else if ((_this_filter = this.filter) === null || _this_filter === void 0 ? void 0 : _this_filter.acceptNode) return this.filter.acceptNode(node);else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }

      return NodeFilter.FILTER_SKIP;
    };

    this._doc = doc;
    this.root = root;
    this.filter = filter !== null && filter !== void 0 ? filter : null;
    this.whatToShow = whatToShow !== null && whatToShow !== void 0 ? whatToShow : NodeFilter.SHOW_ALL;
    this._currentNode = root;

    this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));

    const shadowRoot = root.shadowRoot;

    if (shadowRoot) {
      const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
        acceptNode: this._acceptNode
      });

      this._walkerStack.unshift(walker);
    }
  }

};

__name(_$dfc540311bf7f109$export$63eb3ababa9c55c4, "$dfc540311bf7f109$export$63eb3ababa9c55c4");

var $dfc540311bf7f109$export$63eb3ababa9c55c4 = _$dfc540311bf7f109$export$63eb3ababa9c55c4;

function $dfc540311bf7f109$export$4d0f8be8b12a7ef6(doc, root, whatToShow, filter) {
  if ($f4e2df6bd15f8569$export$98658e8c59125e6a()) return new $dfc540311bf7f109$export$63eb3ababa9c55c4(doc, root, whatToShow, filter);
  return doc.createTreeWalker(root, whatToShow, filter);
}

__name($dfc540311bf7f109$export$4d0f8be8b12a7ef6, "$dfc540311bf7f109$export$4d0f8be8b12a7ef6");

function r(e) {
  var t,
      f,
      n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;

    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}

__name(r, "r");

function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);

  return n;
}

__name(clsx, "clsx");

var clsx_default = clsx;

function $3ef42575df84b30b$export$9d1611c77c2fe928() {
  let result = __spreadValues({}, arguments.length <= 0 ? undefined : arguments[0]);

  for (let i = 1; i < arguments.length; i++) {
    let props = i < 0 || arguments.length <= i ? undefined : arguments[i];

    for (let key in props) {
      let a = result[key];
      let b = props[key];
      if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
      key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >=
      /* 'A' */
      65 && key.charCodeAt(2) <=
      /* 'Z' */
      90) result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a, b);else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = clsx_default(a, b);else if (key === "id" && a && b) result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a, b);else result[key] = b !== void 0 ? b : a;
    }
  }

  return result;
}

__name($3ef42575df84b30b$export$9d1611c77c2fe928, "$3ef42575df84b30b$export$9d1611c77c2fe928");

function $5dc95899b306f630$export$c9058316764c140e() {
  for (var _len3 = arguments.length, refs = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  if (refs.length === 1 && refs[0]) return refs[0];
  return value => {
    for (let ref of refs) {
      if (typeof ref === "function") ref(value);else if (ref != null) ref.current = value;
    }
  };
}

__name($5dc95899b306f630$export$c9058316764c140e, "$5dc95899b306f630$export$c9058316764c140e");

var $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */new Set(["id"]);
var $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */new Set(["aria-label", "aria-labelledby", "aria-describedby", "aria-details"]);
var $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */new Set(["href", "hrefLang", "target", "rel", "download", "ping", "referrerPolicy"]);
var $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;

function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let {
    labelable,
    isLink,
    propNames
  } = opts;
  let filteredProps = {};

  for (const prop in props) if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];

  return filteredProps;
}

__name($65484d02dcb7eb3e$export$457c3d6518dd4c6f, "$65484d02dcb7eb3e$export$457c3d6518dd4c6f");

function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}

__name($7215afc6de606d6b$export$de79e2c695e052f3, "$7215afc6de606d6b$export$de79e2c695e052f3");

var $7215afc6de606d6b$var$supportsPreventScrollCached = null;

function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;

    try {
      let focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }

      });
    } catch (e) {}
  }

  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}

__name($7215afc6de606d6b$var$supportsPreventScroll, "$7215afc6de606d6b$var$supportsPreventScroll");

function $7215afc6de606d6b$var$getScrollableElements(element) {
  let parent = element.parentNode;
  let scrollableElements = [];
  let rootScrollingElement = document.scrollingElement || document.documentElement;

  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }

  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}

__name($7215afc6de606d6b$var$getScrollableElements, "$7215afc6de606d6b$var$getScrollableElements");

function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  for (let {
    element,
    scrollTop,
    scrollLeft
  } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}

__name($7215afc6de606d6b$var$restoreScrollPosition, "$7215afc6de606d6b$var$restoreScrollPosition");

function $c87311424ea30a05$var$testUserAgent(re) {
  var _window_navigator_userAgentData;

  if (typeof window === "undefined" || window.navigator == null) return false;
  return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some(brand => re.test(brand.brand))) || re.test(window.navigator.userAgent);
}

__name($c87311424ea30a05$var$testUserAgent, "$c87311424ea30a05$var$testUserAgent");

function $c87311424ea30a05$var$testPlatform(re) {
  var _window_navigator_userAgentData;

  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}

__name($c87311424ea30a05$var$testPlatform, "$c87311424ea30a05$var$testPlatform");

function $c87311424ea30a05$var$cached(fn) {
  let res = null;
  return () => {
    if (res == null) res = fn();
    return res;
  };
}

__name($c87311424ea30a05$var$cached, "$c87311424ea30a05$var$cached");

var $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
});
var $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
var $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
var $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
});
var $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
});
var $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
var $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
});
var $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function () {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
});
var $ea8dcbcb9ea1b556$var$RouterContext = /* @__PURE__ */createContext({
  isNative: true,
  open: $ea8dcbcb9ea1b556$var$openSyntheticLink,
  useHref: /* @__PURE__ */__name(href => href, "useHref")
});

function $ea8dcbcb9ea1b556$export$323e4fc2fa4753fb(props) {
  let {
    children,
    navigate,
    useHref
  } = props;
  let ctx = useMemo(() => ({
    isNative: false,
    open: /* @__PURE__ */__name((target, modifiers, href, routerOptions) => {
      $ea8dcbcb9ea1b556$var$getSyntheticLink(target, link => {
        if ($ea8dcbcb9ea1b556$export$efa8c9099e530235(link, modifiers)) navigate(href, routerOptions);else $ea8dcbcb9ea1b556$export$95185d699e05d4d7(link, modifiers);
      });
    }, "open"),
    useHref: useHref || (href => href)
  }), [navigate, useHref]);
  return /* @__PURE__ */React__default.createElement($ea8dcbcb9ea1b556$var$RouterContext.Provider, {
    value: ctx
  }, children);
}

__name($ea8dcbcb9ea1b556$export$323e4fc2fa4753fb, "$ea8dcbcb9ea1b556$export$323e4fc2fa4753fb");

function $ea8dcbcb9ea1b556$export$9a302a45f65d0572() {
  return useContext($ea8dcbcb9ea1b556$var$RouterContext);
}

__name($ea8dcbcb9ea1b556$export$9a302a45f65d0572, "$ea8dcbcb9ea1b556$export$9a302a45f65d0572");

function $ea8dcbcb9ea1b556$export$efa8c9099e530235(link, modifiers) {
  let target = link.getAttribute("target");
  return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
  !modifiers.ctrlKey && // open in new tab (windows)
  !modifiers.altKey && // download
  !modifiers.shiftKey;
}

__name($ea8dcbcb9ea1b556$export$efa8c9099e530235, "$ea8dcbcb9ea1b556$export$efa8c9099e530235");

function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(target, modifiers) {
  let setOpening = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _window_event_type, _window_event;

  let {
    metaKey,
    ctrlKey,
    altKey,
    shiftKey
  } = modifiers;

  if ($c87311424ea30a05$export$b7d78993b74f766d() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
    if ($c87311424ea30a05$export$9ac100e40613ea10()) metaKey = true;else ctrlKey = true;
  }

  let event = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() && true ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey,
    ctrlKey,
    altKey,
    shiftKey
  }) : new MouseEvent("click", {
    metaKey,
    ctrlKey,
    altKey,
    shiftKey,
    bubbles: true,
    cancelable: true
  });
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = setOpening;
  $7215afc6de606d6b$export$de79e2c695e052f3(target);
  target.dispatchEvent(event);
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
}

__name($ea8dcbcb9ea1b556$export$95185d699e05d4d7, "$ea8dcbcb9ea1b556$export$95185d699e05d4d7");

$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;

function $ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
  if (target instanceof HTMLAnchorElement) open(target);else if (target.hasAttribute("data-href")) {
    let link = document.createElement("a");
    link.href = target.getAttribute("data-href");
    if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
    if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
    if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
    if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
    if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
    target.appendChild(link);
    open(link);
    target.removeChild(link);
  }
}

__name($ea8dcbcb9ea1b556$var$getSyntheticLink, "$ea8dcbcb9ea1b556$var$getSyntheticLink");

function $ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
  $ea8dcbcb9ea1b556$var$getSyntheticLink(target, link => $ea8dcbcb9ea1b556$export$95185d699e05d4d7(link, modifiers));
}

__name($ea8dcbcb9ea1b556$var$openSyntheticLink, "$ea8dcbcb9ea1b556$var$openSyntheticLink");

function $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(props) {
  let router = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();

  var _props_href;

  const href = router.useHref((_props_href = props === null || props === void 0 ? void 0 : props.href) !== null && _props_href !== void 0 ? _props_href : "");
  return {
    href: (props === null || props === void 0 ? void 0 : props.href) ? href : void 0,
    target: props === null || props === void 0 ? void 0 : props.target,
    rel: props === null || props === void 0 ? void 0 : props.rel,
    download: props === null || props === void 0 ? void 0 : props.download,
    ping: props === null || props === void 0 ? void 0 : props.ping,
    referrerPolicy: props === null || props === void 0 ? void 0 : props.referrerPolicy
  };
}

__name($ea8dcbcb9ea1b556$export$7e924b3091a3bd18, "$ea8dcbcb9ea1b556$export$7e924b3091a3bd18");

var $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */new Map();
var $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */new Set();

function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === "undefined") return;

  function isTransitionEvent(event) {
    return "propertyName" in event;
  }

  __name(isTransitionEvent, "isTransitionEvent");

  let onTransitionStart = /* @__PURE__ */__name(e => {
    if (!isTransitionEvent(e) || !e.target) return;
    let transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);

    if (!transitions) {
      transitions = /* @__PURE__ */new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
      e.target.addEventListener("transitioncancel", onTransitionEnd, {
        once: true
      });
    }

    transitions.add(e.propertyName);
  }, "onTransitionStart");

  let onTransitionEnd = /* @__PURE__ */__name(e => {
    if (!isTransitionEvent(e) || !e.target) return;
    let properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
    if (!properties) return;
    properties.delete(e.propertyName);

    if (properties.size === 0) {
      e.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
    }

    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks) cb();

      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  }, "onTransitionEnd");

  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}

__name($bbed8b41f857bcc0$var$setupGlobalEvents, "$bbed8b41f857bcc0$var$setupGlobalEvents");

if (typeof document !== "undefined") {
  if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}

function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
  requestAnimationFrame(() => {
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
  });
}

__name($bbed8b41f857bcc0$export$24490316f764c430, "$bbed8b41f857bcc0$export$24490316f764c430");

function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
  let globalListeners = useRef( /* @__PURE__ */new Map());
  let addGlobalListener = useCallback((eventTarget, type, listener, options) => {
    let fn = (options === null || options === void 0 ? void 0 : options.once) ? function () {
      globalListeners.current.delete(listener);
      listener(...arguments);
    } : listener;
    globalListeners.current.set(listener, {
      type,
      eventTarget,
      fn,
      options
    });
    eventTarget.addEventListener(type, fn, options);
  }, []);
  let removeGlobalListener = useCallback((eventTarget, type, listener, options) => {
    var _globalListeners_current_get;

    let fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
    eventTarget.removeEventListener(type, fn, options);
    globalListeners.current.delete(listener);
  }, []);
  let removeAllGlobalListeners = useCallback(() => {
    globalListeners.current.forEach((value, key) => {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [removeGlobalListener]);
  useEffect(() => {
    return removeAllGlobalListeners;
  }, [removeAllGlobalListeners]);
  return {
    addGlobalListener,
    removeGlobalListener,
    removeAllGlobalListeners
  };
}

__name($03deb23ff14920c4$export$4eaf04e54aa8eed6, "$03deb23ff14920c4$export$4eaf04e54aa8eed6");

function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
  let {
    id,
    "aria-label": label,
    "aria-labelledby": labelledBy
  } = props;
  id = $bdb11010cef70236$export$f680877a34711e37(id);

  if (labelledBy && label) {
    let ids = /* @__PURE__ */new Set([id, ...labelledBy.trim().split(/\s+/)]);
    labelledBy = [...ids].join(" ");
  } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");

  if (!label && !labelledBy && defaultLabel) label = defaultLabel;
  return {
    id,
    "aria-label": label,
    "aria-labelledby": labelledBy
  };
}

__name($313b98861ee5dd6c$export$d6875122194c7b44, "$313b98861ee5dd6c$export$d6875122194c7b44");

function $df56164dff5785e2$export$4338b53315abf666(forwardedRef) {
  const objRef = useRef(null);
  return useMemo(() => ({
    get current() {
      return objRef.current;
    },

    set current(value) {
      objRef.current = value;
      if (typeof forwardedRef === "function") forwardedRef(value);else if (forwardedRef) forwardedRef.current = value;
    }

  }), [forwardedRef]);
}

__name($df56164dff5785e2$export$4338b53315abf666, "$df56164dff5785e2$export$4338b53315abf666");

function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (context && context.ref && ref) {
      context.ref.current = ref.current;
      return () => {
        if (context.ref) context.ref.current = null;
      };
    }
  });
}

__name($e7801be82b4b2a53$export$4debdb1a3f0fa79e, "$e7801be82b4b2a53$export$4debdb1a3f0fa79e");

function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}

__name($6a7db85432448f7f$export$60278871457622de, "$6a7db85432448f7f$export$60278871457622de");

function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
  return !$c87311424ea30a05$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

__name($6a7db85432448f7f$export$29bf1b5f2c56cf63, "$6a7db85432448f7f$export$29bf1b5f2c56cf63");

function $99facab73266f662$export$5add1d006293d136(ref, initialValue, onReset) {
  let resetValue = useRef(initialValue);
  let handleReset = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    if (onReset) onReset(resetValue.current);
  });
  useEffect(() => {
    var _ref_current;

    let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
    form === null || form === void 0 ? void 0 : form.addEventListener("reset", handleReset);
    return () => {
      form === null || form === void 0 ? void 0 : form.removeEventListener("reset", handleReset);
    };
  }, [ref, handleReset]);
}

__name($99facab73266f662$export$5add1d006293d136, "$99facab73266f662$export$5add1d006293d136");

var $b4b717babfbb907b$var$focusableElements = ["input:not([disabled]):not([type=hidden])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "a[href]", "area[href]", "summary", "iframe", "object", "embed", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable^="false"])'];
var $b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR = $b4b717babfbb907b$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$b4b717babfbb907b$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
var $b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR = $b4b717babfbb907b$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');

function $b4b717babfbb907b$export$4c063cf1350e6fed(element) {
  return element.matches($b4b717babfbb907b$var$FOCUSABLE_ELEMENT_SELECTOR);
}

__name($b4b717babfbb907b$export$4c063cf1350e6fed, "$b4b717babfbb907b$export$4c063cf1350e6fed");

function $b4b717babfbb907b$export$bebd5a1431fec25d(element) {
  return element.matches($b4b717babfbb907b$var$TABBABLE_ELEMENT_SELECTOR);
}

__name($b4b717babfbb907b$export$bebd5a1431fec25d, "$b4b717babfbb907b$export$bebd5a1431fec25d");

function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
  let [stateValue, setStateValue] = useState(value || defaultValue);
  let isControlledRef = useRef(value !== void 0);
  let isControlled = value !== void 0;
  useEffect(() => {
    let wasControlled = isControlledRef.current;
    if (wasControlled !== isControlled) console.warn(`WARN: A component changed from ${wasControlled ? "controlled" : "uncontrolled"} to ${isControlled ? "controlled" : "uncontrolled"}.`);
    isControlledRef.current = isControlled;
  }, [isControlled]);
  let currentValue = isControlled ? value : stateValue;
  let setValue = useCallback(function (value2) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
      args[_key5 - 1] = arguments[_key5];
    }

    let onChangeCaller = /* @__PURE__ */__name(function (value3) {
      if (onChange) {
        for (var _len5 = arguments.length, onChangeArgs = new Array(_len5 > 1 ? _len5 - 1 : 0), _key6 = 1; _key6 < _len5; _key6++) {
          onChangeArgs[_key6 - 1] = arguments[_key6];
        }

        if (!Object.is(currentValue, value3)) onChange(value3, ...onChangeArgs);
      }

      if (!isControlled) currentValue = value3;
    }, "onChangeCaller");

    if (typeof value2 === "function") {
      console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");

      let updateFunction = /* @__PURE__ */__name(function (oldValue) {
        for (var _len6 = arguments.length, functionArgs = new Array(_len6 > 1 ? _len6 - 1 : 0), _key7 = 1; _key7 < _len6; _key7++) {
          functionArgs[_key7 - 1] = arguments[_key7];
        }

        let interceptedValue = value2(isControlled ? currentValue : oldValue, ...functionArgs);
        onChangeCaller(interceptedValue, ...args);
        if (!isControlled) return interceptedValue;
        return oldValue;
      }, "updateFunction");

      setStateValue(updateFunction);
    } else {
      if (!isControlled) setStateValue(value2);
      onChangeCaller(value2, ...args);
    }
  }, [isControlled, currentValue, onChange]);
  return [currentValue, setValue];
}

__name($458b0a5536c1a7cf$export$40bfa8c7b0832715, "$458b0a5536c1a7cf$export$40bfa8c7b0832715");

var $14c0b72509d70225$var$state = "default";
var $14c0b72509d70225$var$savedUserSelect = "";
var $14c0b72509d70225$var$modifiedElementMap = /* @__PURE__ */new WeakMap();

function $14c0b72509d70225$export$16a4697467175487(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state === "default") {
      const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(target);
      $14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
      documentObject.documentElement.style.webkitUserSelect = "none";
    }

    $14c0b72509d70225$var$state = "disabled";
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    let property = "userSelect" in target.style ? "userSelect" : "webkitUserSelect";
    $14c0b72509d70225$var$modifiedElementMap.set(target, target.style[property]);
    target.style[property] = "none";
  }
}

__name($14c0b72509d70225$export$16a4697467175487, "$14c0b72509d70225$export$16a4697467175487");

function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
  if ($c87311424ea30a05$export$fedb369cb70207f1()) {
    if ($14c0b72509d70225$var$state !== "disabled") return;
    $14c0b72509d70225$var$state = "restoring";
    setTimeout(() => {
      $bbed8b41f857bcc0$export$24490316f764c430(() => {
        if ($14c0b72509d70225$var$state === "restoring") {
          const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(target);
          if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
          $14c0b72509d70225$var$savedUserSelect = "";
          $14c0b72509d70225$var$state = "default";
        }
      });
    }, 300);
  } else if (target instanceof HTMLElement || target instanceof SVGElement) {
    if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
      let targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
      let property = "userSelect" in target.style ? "userSelect" : "webkitUserSelect";
      if (target.style[property] === "none") target.style[property] = targetOldUserSelect;
      if (target.getAttribute("style") === "") target.removeAttribute("style");
      $14c0b72509d70225$var$modifiedElementMap.delete(target);
    }
  }
}

__name($14c0b72509d70225$export$b0d6fa1ab32e3295, "$14c0b72509d70225$export$b0d6fa1ab32e3295");

var $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = /*#__PURE__*/React__default.createContext({
  register: /* @__PURE__ */__name(() => {}, "register")
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";

var _$8a9cb279dc87e130$export$905e7fc544a71f36 = class _$8a9cb279dc87e130$export$905e7fc544a71f362 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }

  preventDefault() {
    this.defaultPrevented = true;
    this.nativeEvent.preventDefault();
  }

  stopPropagation() {
    this.nativeEvent.stopPropagation();

    this.isPropagationStopped = () => true;
  }

  isPropagationStopped() {
    return false;
  }

  persist() {}

  constructor(type, nativeEvent) {
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type;
  }

};

__name(_$8a9cb279dc87e130$export$905e7fc544a71f36, "$8a9cb279dc87e130$export$905e7fc544a71f36");

var $8a9cb279dc87e130$export$905e7fc544a71f36 = _$8a9cb279dc87e130$export$905e7fc544a71f36;

function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = useRef({
    isFocused: false,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  let dispatchBlur = $8ae05eaa5c114e9c$export$7f54fc3180508a52(e => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  });
  return useCallback(e => {
    if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e.target;

      let onBlurHandler = /* @__PURE__ */__name(e2 => {
        stateRef.current.isFocused = false;
        if (target.disabled) dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e2));

        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      }, "onBlurHandler");

      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          var _stateRef_current_observer;

          (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
          let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
          target.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: relatedTargetEl
          }));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true,
            relatedTarget: relatedTargetEl
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: ["disabled"]
      });
    }
  }, [dispatchBlur]);
}

__name($8a9cb279dc87e130$export$715c682d09d639cc, "$8a9cb279dc87e130$export$715c682d09d639cc");

var $8a9cb279dc87e130$export$fda7da73ab5d4c48 = false;

function $8a9cb279dc87e130$export$cabe61c495ee3649(target) {
  while (target && !$b4b717babfbb907b$export$4c063cf1350e6fed(target)) target = target.parentElement;

  let window2 = $431fbd86ca7dc216$export$f21a1ffae260145a(target);
  let activeElement = window2.document.activeElement;
  if (!activeElement || activeElement === target) return;
  $8a9cb279dc87e130$export$fda7da73ab5d4c48 = true;
  let isRefocusing = false;

  let onBlur = /* @__PURE__ */__name(e => {
    if (e.target === activeElement || isRefocusing) e.stopImmediatePropagation();
  }, "onBlur");

  let onFocusOut = /* @__PURE__ */__name(e => {
    if (e.target === activeElement || isRefocusing) {
      e.stopImmediatePropagation();

      if (!target && !isRefocusing) {
        isRefocusing = true;
        $7215afc6de606d6b$export$de79e2c695e052f3(activeElement);
        cleanup();
      }
    }
  }, "onFocusOut");

  let onFocus = /* @__PURE__ */__name(e => {
    if (e.target === target || isRefocusing) e.stopImmediatePropagation();
  }, "onFocus");

  let onFocusIn = /* @__PURE__ */__name(e => {
    if (e.target === target || isRefocusing) {
      e.stopImmediatePropagation();

      if (!isRefocusing) {
        isRefocusing = true;
        $7215afc6de606d6b$export$de79e2c695e052f3(activeElement);
        cleanup();
      }
    }
  }, "onFocusIn");

  window2.addEventListener("blur", onBlur, true);
  window2.addEventListener("focusout", onFocusOut, true);
  window2.addEventListener("focusin", onFocusIn, true);
  window2.addEventListener("focus", onFocus, true);

  let cleanup = /* @__PURE__ */__name(() => {
    cancelAnimationFrame(raf);
    window2.removeEventListener("blur", onBlur, true);
    window2.removeEventListener("focusout", onFocusOut, true);
    window2.removeEventListener("focusin", onFocusIn, true);
    window2.removeEventListener("focus", onFocus, true);
    $8a9cb279dc87e130$export$fda7da73ab5d4c48 = false;
    isRefocusing = false;
  }, "cleanup");

  let raf = requestAnimationFrame(cleanup);
  return cleanup;
}

__name($8a9cb279dc87e130$export$cabe61c495ee3649, "$8a9cb279dc87e130$export$cabe61c495ee3649");

function _class_apply_descriptor_get(receiver, descriptor) {
  if (descriptor.get) return descriptor.get.call(receiver);
  return descriptor.value;
}

__name(_class_apply_descriptor_get, "_class_apply_descriptor_get");

function _class_extract_field_descriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
  return privateMap.get(receiver);
}

__name(_class_extract_field_descriptor, "_class_extract_field_descriptor");

function _class_private_field_get(receiver, privateMap) {
  var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");

  return _class_apply_descriptor_get(receiver, descriptor);
}

__name(_class_private_field_get, "_class_private_field_get");

function _check_private_redeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

__name(_check_private_redeclaration, "_check_private_redeclaration");

function _class_private_field_init(obj, privateMap, value) {
  _check_private_redeclaration(obj, privateMap);

  privateMap.set(obj, value);
}

__name(_class_private_field_init, "_class_private_field_init");

function _class_apply_descriptor_set(receiver, descriptor, value) {
  if (descriptor.set) descriptor.set.call(receiver, value);else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }

    descriptor.value = value;
  }
}

__name(_class_apply_descriptor_set, "_class_apply_descriptor_set");

function _class_private_field_set(receiver, privateMap, value) {
  var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");

  _class_apply_descriptor_set(receiver, descriptor, value);

  return value;
}

__name(_class_private_field_set, "_class_private_field_set");

function $f6c31cce2adf654f$var$usePressResponderContext(props) {
  let context = useContext($ae1eeba8b9eafd08$export$5165eccb35aaadb5);

  if (context) {
    let _a = context,
        {
      register
    } = _a,
        contextProps = __objRest(_a, ["register"]);

    props = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);
    register();
  }

  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, props.ref);
  return props;
}

__name($f6c31cce2adf654f$var$usePressResponderContext, "$f6c31cce2adf654f$var$usePressResponderContext");

var $f6c31cce2adf654f$var$_shouldStopPropagation = /* @__PURE__ */new WeakMap();

var _$f6c31cce2adf654f$var$PressEvent = class _$f6c31cce2adf654f$var$PressEvent2 {
  continuePropagation() {
    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, false);
  }

  get shouldStopPropagation() {
    return _class_private_field_get(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
  }

  constructor(type, pointerType, originalEvent, state) {
    _class_private_field_init(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
      writable: true,
      value: void 0
    });

    _class_private_field_set(this, $f6c31cce2adf654f$var$_shouldStopPropagation, true);

    var _state_target;

    let currentTarget = (_state_target = state === null || state === void 0 ? void 0 : state.target) !== null && _state_target !== void 0 ? _state_target : originalEvent.currentTarget;
    const rect = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getBoundingClientRect();
    let x,
        y = 0;
    let clientX,
        clientY = null;

    if (originalEvent.clientX != null && originalEvent.clientY != null) {
      clientX = originalEvent.clientX;
      clientY = originalEvent.clientY;
    }

    if (rect) {
      if (clientX != null && clientY != null) {
        x = clientX - rect.left;
        y = clientY - rect.top;
      } else {
        x = rect.width / 2;
        y = rect.height / 2;
      }
    }

    this.type = type;
    this.pointerType = pointerType;
    this.target = originalEvent.currentTarget;
    this.shiftKey = originalEvent.shiftKey;
    this.metaKey = originalEvent.metaKey;
    this.ctrlKey = originalEvent.ctrlKey;
    this.altKey = originalEvent.altKey;
    this.x = x;
    this.y = y;
  }

};

__name(_$f6c31cce2adf654f$var$PressEvent, "$f6c31cce2adf654f$var$PressEvent");

var $f6c31cce2adf654f$var$PressEvent = _$f6c31cce2adf654f$var$PressEvent;
var $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");

function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
  let _a = $f6c31cce2adf654f$var$usePressResponderContext(props),
      {
    onPress,
    onPressChange,
    onPressStart,
    onPressEnd,
    onPressUp,
    isDisabled,
    isPressed: isPressedProp,
    preventFocusOnPress,
    shouldCancelOnPointerExit,
    allowTextSelectionOnPress,
    ref: _
  } = _a,
      domProps = __objRest(_a, ["onPress", "onPressChange", "onPressStart", "onPressEnd", "onPressUp", "isDisabled", "isPressed", "preventFocusOnPress", "shouldCancelOnPointerExit", "allowTextSelectionOnPress", // eslint-disable-next-line @typescript-eslint/no-unused-vars
  "ref"]);

  let [isPressed, setPressed] = useState(false);
  let ref = useRef({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    didFirePressStart: false,
    isTriggeringEvent: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null,
    disposables: []
  });
  let {
    addGlobalListener,
    removeAllGlobalListeners
  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let triggerPressStart = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType) => {
    let state = ref.current;
    if (isDisabled || state.didFirePressStart) return false;
    let shouldStopPropagation = true;
    state.isTriggeringEvent = true;

    if (onPressStart) {
      let event = new $f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
      onPressStart(event);
      shouldStopPropagation = event.shouldStopPropagation;
    }

    if (onPressChange) onPressChange(true);
    state.isTriggeringEvent = false;
    state.didFirePressStart = true;
    setPressed(true);
    return shouldStopPropagation;
  });
  let triggerPressEnd = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function (originalEvent, pointerType) {
    let wasPressed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let state = ref.current;
    if (!state.didFirePressStart) return false;
    state.didFirePressStart = false;
    state.isTriggeringEvent = true;
    let shouldStopPropagation = true;

    if (onPressEnd) {
      let event = new $f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
      onPressEnd(event);
      shouldStopPropagation = event.shouldStopPropagation;
    }

    if (onPressChange) onPressChange(false);
    setPressed(false);

    if (onPress && wasPressed && !isDisabled) {
      let event = new $f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
      onPress(event);
      shouldStopPropagation && (shouldStopPropagation = event.shouldStopPropagation);
    }

    state.isTriggeringEvent = false;
    return shouldStopPropagation;
  });
  let triggerPressUp = $8ae05eaa5c114e9c$export$7f54fc3180508a52((originalEvent, pointerType) => {
    let state = ref.current;
    if (isDisabled) return false;

    if (onPressUp) {
      state.isTriggeringEvent = true;
      let event = new $f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
      onPressUp(event);
      state.isTriggeringEvent = false;
      return event.shouldStopPropagation;
    }

    return true;
  });
  let cancel = $8ae05eaa5c114e9c$export$7f54fc3180508a52(e => {
    let state = ref.current;

    if (state.isPressed && state.target) {
      if (state.didFirePressStart && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
      state.isPressed = false;
      state.isOverTarget = false;
      state.activePointerId = null;
      state.pointerType = null;
      removeAllGlobalListeners();
      if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);

      for (let dispose of state.disposables) dispose();

      state.disposables = [];
    }
  });
  let cancelOnPointerExit = $8ae05eaa5c114e9c$export$7f54fc3180508a52(e => {
    if (shouldCancelOnPointerExit) cancel(e);
  });
  let pressProps = useMemo(() => {
    let state = ref.current;
    let pressProps2 = {
      onKeyDown(e) {
        if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && $d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) {
          var _state_metaKeyEvents;

          if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard($d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent), e.key)) e.preventDefault();
          let shouldStopPropagation = true;

          if (!state.isPressed && !e.repeat) {
            state.target = e.currentTarget;
            state.isPressed = true;
            state.pointerType = "keyboard";
            shouldStopPropagation = triggerPressStart(e, "keyboard");
            let originalTarget = e.currentTarget;

            let pressUp = /* @__PURE__ */__name(e2 => {
              if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e2, originalTarget) && !e2.repeat && $d4ee10de306f2510$export$4282f70798064fe0(originalTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e2)) && state.target) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e2), "keyboard");
            }, "pressUp");

            addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e.currentTarget), "keyup", $ff5963eb1fccf552$export$e08e3b67e392101e(pressUp, onKeyUp), true);
          }

          if (shouldStopPropagation) e.stopPropagation();
          if (e.metaKey && $c87311424ea30a05$export$9ac100e40613ea10()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.set(e.key, e.nativeEvent);
        } else if (e.key === "Meta") state.metaKeyEvents = /* @__PURE__ */new Map();
      },

      onClick(e) {
        if (e && !$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;

        if (e && e.button === 0 && !state.isTriggeringEvent && !$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening) {
          let shouldStopPropagation = true;
          if (isDisabled) e.preventDefault();

          if (!state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || $6a7db85432448f7f$export$60278871457622de(e.nativeEvent))) {
            let stopPressStart = triggerPressStart(e, "virtual");
            let stopPressUp = triggerPressUp(e, "virtual");
            let stopPressEnd = triggerPressEnd(e, "virtual");
            shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
          } else if (state.isPressed && state.pointerType !== "keyboard") {
            let pointerType = state.pointerType || e.nativeEvent.pointerType || "virtual";
            shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createEvent(e.currentTarget, e), pointerType, true);
            state.isOverTarget = false;
            cancel(e);
          }

          state.ignoreEmulatedMouseEvents = false;
          if (shouldStopPropagation) e.stopPropagation();
        }
      }

    };

    let onKeyUp = /* @__PURE__ */__name(e => {
      var _state_metaKeyEvents;

      if (state.isPressed && state.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
        var _state_metaKeyEvents1;

        if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard($d4ee10de306f2510$export$e58f029f0fbfdb29(e), e.key)) e.preventDefault();
        let target = $d4ee10de306f2510$export$e58f029f0fbfdb29(e);
        triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", $d4ee10de306f2510$export$4282f70798064fe0(state.target, $d4ee10de306f2510$export$e58f029f0fbfdb29(e)));
        removeAllGlobalListeners();

        if (e.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && $d4ee10de306f2510$export$4282f70798064fe0(state.target, target) && !e[$f6c31cce2adf654f$var$LINK_CLICKED]) {
          e[$f6c31cce2adf654f$var$LINK_CLICKED] = true;
          $ea8dcbcb9ea1b556$export$95185d699e05d4d7(state.target, e, false);
        }

        state.isPressed = false;
        (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 ? void 0 : _state_metaKeyEvents1.delete(e.key);
      } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
        var _state_target;

        let events = state.metaKeyEvents;
        state.metaKeyEvents = void 0;

        for (let event of events.values()) (_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
      }
    }, "onKeyUp");

    if (typeof PointerEvent !== "undefined") {
      pressProps2.onPointerDown = e => {
        if (e.button !== 0 || !$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;

        if ($6a7db85432448f7f$export$29bf1b5f2c56cf63(e.nativeEvent)) {
          state.pointerType = "virtual";
          return;
        }

        state.pointerType = e.pointerType;
        let shouldStopPropagation = true;

        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e.pointerId;
          state.target = e.currentTarget;
          if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
          shouldStopPropagation = triggerPressStart(e, state.pointerType);
          let target = $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent);
          if ("releasePointerCapture" in target) target.releasePointerCapture(e.pointerId);
          addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e.currentTarget), "pointerup", onPointerUp, false);
          addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e.currentTarget), "pointercancel", onPointerCancel, false);
        }

        if (shouldStopPropagation) e.stopPropagation();
      };

      pressProps2.onMouseDown = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;

        if (e.button === 0) {
          if (preventFocusOnPress) {
            let dispose = $8a9cb279dc87e130$export$cabe61c495ee3649(e.target);
            if (dispose) state.disposables.push(dispose);
          }

          e.stopPropagation();
        }
      };

      pressProps2.onPointerUp = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent)) || state.pointerType === "virtual") return;
        if (e.button === 0) triggerPressUp(e, state.pointerType || e.pointerType);
      };

      pressProps2.onPointerEnter = e => {
        if (e.pointerId === state.activePointerId && state.target && !state.isOverTarget && state.pointerType != null) {
          state.isOverTarget = true;
          triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
        }
      };

      pressProps2.onPointerLeave = e => {
        if (e.pointerId === state.activePointerId && state.target && state.isOverTarget && state.pointerType != null) {
          state.isOverTarget = false;
          triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
          cancelOnPointerExit(e);
        }
      };

      let onPointerUp = /* @__PURE__ */__name(e => {
        if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
          if ($d4ee10de306f2510$export$4282f70798064fe0(state.target, $d4ee10de306f2510$export$e58f029f0fbfdb29(e)) && state.pointerType != null) {
            let clicked = false;
            let timeout = setTimeout(() => {
              if (state.isPressed && state.target instanceof HTMLElement) {
                if (clicked) cancel(e);else {
                  $7215afc6de606d6b$export$de79e2c695e052f3(state.target);
                  state.target.click();
                }
              }
            }, 80);
            addGlobalListener(e.currentTarget, "click", () => clicked = true, true);
            state.disposables.push(() => clearTimeout(timeout));
          } else cancel(e);

          state.isOverTarget = false;
        }
      }, "onPointerUp");

      let onPointerCancel = /* @__PURE__ */__name(e => {
        cancel(e);
      }, "onPointerCancel");

      pressProps2.onDragStart = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        cancel(e);
      };
    } else {
      pressProps2.onMouseDown = e => {
        if (e.button !== 0 || !$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;

        if (state.ignoreEmulatedMouseEvents) {
          e.stopPropagation();
          return;
        }

        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e.currentTarget;
        state.pointerType = $6a7db85432448f7f$export$60278871457622de(e.nativeEvent) ? "virtual" : "mouse";
        let shouldStopPropagation = flushSync(() => triggerPressStart(e, state.pointerType));
        if (shouldStopPropagation) e.stopPropagation();

        if (preventFocusOnPress) {
          let dispose = $8a9cb279dc87e130$export$cabe61c495ee3649(e.target);
          if (dispose) state.disposables.push(dispose);
        }

        addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(e.currentTarget), "mouseup", onMouseUp, false);
      };

      pressProps2.onMouseEnter = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        let shouldStopPropagation = true;

        if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
          state.isOverTarget = true;
          shouldStopPropagation = triggerPressStart(e, state.pointerType);
        }

        if (shouldStopPropagation) e.stopPropagation();
      };

      pressProps2.onMouseLeave = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        let shouldStopPropagation = true;

        if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
          state.isOverTarget = false;
          shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
          cancelOnPointerExit(e);
        }

        if (shouldStopPropagation) e.stopPropagation();
      };

      pressProps2.onMouseUp = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
      };

      let onMouseUp = /* @__PURE__ */__name(e => {
        if (e.button !== 0) return;

        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }

        if (state.target && state.target.contains(e.target) && state.pointerType != null) ;else cancel(e);
        state.isOverTarget = false;
      }, "onMouseUp");

      pressProps2.onTouchStart = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        let touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
        if (!touch) return;
        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e.currentTarget;
        state.pointerType = "touch";
        if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
        let shouldStopPropagation = triggerPressStart($f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
        if (shouldStopPropagation) e.stopPropagation();
        addGlobalListener($431fbd86ca7dc216$export$f21a1ffae260145a(e.currentTarget), "scroll", onScroll, true);
      };

      pressProps2.onTouchMove = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;

        if (!state.isPressed) {
          e.stopPropagation();
          return;
        }

        let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
        let shouldStopPropagation = true;

        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
          if (!state.isOverTarget && state.pointerType != null) {
            state.isOverTarget = true;
            shouldStopPropagation = triggerPressStart($f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
          }
        } else if (state.isOverTarget && state.pointerType != null) {
          state.isOverTarget = false;
          shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);
          cancelOnPointerExit($f6c31cce2adf654f$var$createTouchEvent(state.target, e));
        }

        if (shouldStopPropagation) e.stopPropagation();
      };

      pressProps2.onTouchEnd = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;

        if (!state.isPressed) {
          e.stopPropagation();
          return;
        }

        let touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
        let shouldStopPropagation = true;

        if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
          triggerPressUp($f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
          shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType);
        } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd($f6c31cce2adf654f$var$createTouchEvent(state.target, e), state.pointerType, false);

        if (shouldStopPropagation) e.stopPropagation();
        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        if (state.target && !allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        removeAllGlobalListeners();
      };

      pressProps2.onTouchCancel = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        e.stopPropagation();
        if (state.isPressed) cancel($f6c31cce2adf654f$var$createTouchEvent(state.target, e));
      };

      let onScroll = /* @__PURE__ */__name(e => {
        if (state.isPressed && $d4ee10de306f2510$export$4282f70798064fe0($d4ee10de306f2510$export$e58f029f0fbfdb29(e), state.target)) cancel({
          currentTarget: state.target,
          shiftKey: false,
          ctrlKey: false,
          metaKey: false,
          altKey: false
        });
      }, "onScroll");

      pressProps2.onDragStart = e => {
        if (!$d4ee10de306f2510$export$4282f70798064fe0(e.currentTarget, $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent))) return;
        cancel(e);
      };
    }

    return pressProps2;
  }, [addGlobalListener, isDisabled, preventFocusOnPress, removeAllGlobalListeners, allowTextSelectionOnPress, cancel, cancelOnPointerExit, triggerPressEnd, triggerPressStart, triggerPressUp]);
  useEffect(() => {
    let state = ref.current;
    return () => {
      var _state_target;

      if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295((_state_target = state.target) !== null && _state_target !== void 0 ? _state_target : void 0);

      for (let dispose of state.disposables) dispose();

      state.disposables = [];
    };
  }, [allowTextSelectionOnPress]);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, pressProps)
  };
}

__name($f6c31cce2adf654f$export$45712eceda6fad21, "$f6c31cce2adf654f$export$45712eceda6fad21");

function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
  return target.tagName === "A" && target.hasAttribute("href");
}

__name($f6c31cce2adf654f$var$isHTMLAnchorLink, "$f6c31cce2adf654f$var$isHTMLAnchorLink");

function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
  const {
    key,
    code
  } = event;
  const element = currentTarget;
  const role = element.getAttribute("role");
  return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(element).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
  !((role === "link" || !role && $f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}

__name($f6c31cce2adf654f$var$isValidKeyboardEvent, "$f6c31cce2adf654f$var$isValidKeyboardEvent");

function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
  const {
    targetTouches
  } = event;
  if (targetTouches.length > 0) return targetTouches[0];
  return null;
}

__name($f6c31cce2adf654f$var$getTouchFromEvent, "$f6c31cce2adf654f$var$getTouchFromEvent");

function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
  const changedTouches = event.changedTouches;

  for (let i = 0; i < changedTouches.length; i++) {
    const touch = changedTouches[i];
    if (touch.identifier === pointerId) return touch;
  }

  return null;
}

__name($f6c31cce2adf654f$var$getTouchById, "$f6c31cce2adf654f$var$getTouchById");

function $f6c31cce2adf654f$var$createTouchEvent(target, e) {
  let clientX = 0;
  let clientY = 0;

  if (e.targetTouches && e.targetTouches.length === 1) {
    clientX = e.targetTouches[0].clientX;
    clientY = e.targetTouches[0].clientY;
  }

  return {
    currentTarget: target,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX,
    clientY
  };
}

__name($f6c31cce2adf654f$var$createTouchEvent, "$f6c31cce2adf654f$var$createTouchEvent");

function $f6c31cce2adf654f$var$createEvent(target, e) {
  let clientX = e.clientX;
  let clientY = e.clientY;
  return {
    currentTarget: target,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    altKey: e.altKey,
    clientX,
    clientY
  };
}

__name($f6c31cce2adf654f$var$createEvent, "$f6c31cce2adf654f$var$createEvent");

function $f6c31cce2adf654f$var$getPointClientRect(point) {
  let offsetX = 0;
  let offsetY = 0;
  if (point.width !== void 0) offsetX = point.width / 2;else if (point.radiusX !== void 0) offsetX = point.radiusX;
  if (point.height !== void 0) offsetY = point.height / 2;else if (point.radiusY !== void 0) offsetY = point.radiusY;
  return {
    top: point.clientY - offsetY,
    right: point.clientX + offsetX,
    bottom: point.clientY + offsetY,
    left: point.clientX - offsetX
  };
}

__name($f6c31cce2adf654f$var$getPointClientRect, "$f6c31cce2adf654f$var$getPointClientRect");

function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
  if (a.left > b.right || b.left > a.right) return false;
  if (a.top > b.bottom || b.top > a.bottom) return false;
  return true;
}

__name($f6c31cce2adf654f$var$areRectanglesOverlapping, "$f6c31cce2adf654f$var$areRectanglesOverlapping");

function $f6c31cce2adf654f$var$isOverTarget(point, target) {
  let rect = target.getBoundingClientRect();
  let pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
  return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}

__name($f6c31cce2adf654f$var$isOverTarget, "$f6c31cce2adf654f$var$isOverTarget");

function $f6c31cce2adf654f$var$shouldPreventDefaultUp(target) {
  if (target instanceof HTMLInputElement) return false;
  if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
  if ($f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
  return true;
}

__name($f6c31cce2adf654f$var$shouldPreventDefaultUp, "$f6c31cce2adf654f$var$shouldPreventDefaultUp");

function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
  if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
  return $f6c31cce2adf654f$var$shouldPreventDefaultUp(target);
}

__name($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard, "$f6c31cce2adf654f$var$shouldPreventDefaultKeyboard");

var $f6c31cce2adf654f$var$nonTextInputTypes = /* @__PURE__ */new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);

function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
  return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}

__name($f6c31cce2adf654f$var$isValidInputKey, "$f6c31cce2adf654f$var$isValidInputKey");

var $507fabe10e71c6fb$var$currentModality = null;
var $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */new Set();
var $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */new Map();
var $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
var $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
  Tab: true,
  Escape: true
};

function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers) handler(modality, e);
}

__name($507fabe10e71c6fb$var$triggerChangeHandlers, "$507fabe10e71c6fb$var$triggerChangeHandlers");

function $507fabe10e71c6fb$var$isValidKey(e) {
  return !(e.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}

__name($507fabe10e71c6fb$var$isValidKey, "$507fabe10e71c6fb$var$isValidKey");

function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;

  if ($507fabe10e71c6fb$var$isValidKey(e)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
  }
}

__name($507fabe10e71c6fb$var$handleKeyboardEvent, "$507fabe10e71c6fb$var$handleKeyboardEvent");

function $507fabe10e71c6fb$var$handlePointerEvent(e) {
  $507fabe10e71c6fb$var$currentModality = "pointer";

  if (e.type === "mousedown" || e.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
  }
}

__name($507fabe10e71c6fb$var$handlePointerEvent, "$507fabe10e71c6fb$var$handlePointerEvent");

function $507fabe10e71c6fb$var$handleClickEvent(e) {
  if ($6a7db85432448f7f$export$60278871457622de(e)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}

__name($507fabe10e71c6fb$var$handleClickEvent, "$507fabe10e71c6fb$var$handleClickEvent");

function $507fabe10e71c6fb$var$handleFocusEvent(e) {
  if (e.target === window || e.target === document || $8a9cb279dc87e130$export$fda7da73ab5d4c48 || !e.isTrusted) return;

  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
  }

  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}

__name($507fabe10e71c6fb$var$handleFocusEvent, "$507fabe10e71c6fb$var$handleFocusEvent");

function $507fabe10e71c6fb$var$handleWindowBlur() {
  if ($8a9cb279dc87e130$export$fda7da73ab5d4c48) return;
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}

__name($507fabe10e71c6fb$var$handleWindowBlur, "$507fabe10e71c6fb$var$handleWindowBlur");

function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
  if (typeof window === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(element))) return;
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let focus = windowObject.HTMLElement.prototype.focus;

  windowObject.HTMLElement.prototype.focus = function () {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };

  documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);

  if (typeof PointerEvent !== "undefined") {
    documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }

  windowObject.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
    focus
  });
}

__name($507fabe10e71c6fb$var$setupGlobalFocusEvents, "$507fabe10e71c6fb$var$setupGlobalFocusEvents");

var $507fabe10e71c6fb$var$tearDownWindowFocusTracking = /* @__PURE__ */__name((element, loadListener) => {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
  documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);

  if (typeof PointerEvent !== "undefined") {
    documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else {
    documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }

  $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
}, "$507fabe10e71c6fb$var$tearDownWindowFocusTracking");

function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let loadListener;
  if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);else {
    loadListener = /* @__PURE__ */__name(() => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    }, "loadListener");
    documentObject.addEventListener("DOMContentLoaded", loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}

__name($507fabe10e71c6fb$export$2f1888112f558a7d, "$507fabe10e71c6fb$export$2f1888112f558a7d");

if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d();

function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
  return $507fabe10e71c6fb$var$currentModality !== "pointer";
}

__name($507fabe10e71c6fb$export$b9b3dfddab17db27, "$507fabe10e71c6fb$export$b9b3dfddab17db27");

function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}

__name($507fabe10e71c6fb$export$630ff653c5ada6a9, "$507fabe10e71c6fb$export$630ff653c5ada6a9");

function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
  $507fabe10e71c6fb$var$currentModality = modality;
  $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}

__name($507fabe10e71c6fb$export$8397ddfc504fdb9a, "$507fabe10e71c6fb$export$8397ddfc504fdb9a");

var $507fabe10e71c6fb$var$nonTextInputTypes = /* @__PURE__ */new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);

function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
  let document1 = $431fbd86ca7dc216$export$b204af158042fbac(e === null || e === void 0 ? void 0 : e.target);
  const IHTMLInputElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
  const IHTMLTextAreaElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
  const IHTMLElement = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
  const IKeyboardEvent = typeof window !== "undefined" ? $431fbd86ca7dc216$export$f21a1ffae260145a(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
  isTextInput = isTextInput || document1.activeElement instanceof IHTMLInputElement && !$507fabe10e71c6fb$var$nonTextInputTypes.has(document1.activeElement.type) || document1.activeElement instanceof IHTMLTextAreaElement || document1.activeElement instanceof IHTMLElement && document1.activeElement.isContentEditable;
  return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}

__name($507fabe10e71c6fb$var$isKeyboardFocusEvent, "$507fabe10e71c6fb$var$isKeyboardFocusEvent");

function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
  $507fabe10e71c6fb$var$setupGlobalFocusEvents();
  useEffect(() => {
    let handler = /* @__PURE__ */__name((modality, e) => {
      if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
      fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
    }, "handler");

    $507fabe10e71c6fb$var$changeHandlers.add(handler);
    return () => {
      $507fabe10e71c6fb$var$changeHandlers.delete(handler);
    };
  }, deps);
}

__name($507fabe10e71c6fb$export$ec71b4b83ac08ec3, "$507fabe10e71c6fb$export$ec71b4b83ac08ec3");

function $3ad3f6e1647bc98d$export$80f3e147d781571c(element) {
  const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(element);
  const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);

  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let lastFocusedElement = activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      if ($d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument) === lastFocusedElement && element.isConnected) $7215afc6de606d6b$export$de79e2c695e052f3(element);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(element);
}

__name($3ad3f6e1647bc98d$export$80f3e147d781571c, "$3ad3f6e1647bc98d$export$80f3e147d781571c");

function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
  let {
    isDisabled,
    onFocus: onFocusProp,
    onBlur: onBlurProp,
    onFocusChange
  } = props;
  const onBlur = useCallback(e => {
    if (e.target === e.currentTarget) {
      if (onBlurProp) onBlurProp(e);
      if (onFocusChange) onFocusChange(false);
      return true;
    }
  }, [onBlurProp, onFocusChange]);
  const onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  const onFocus = useCallback(e => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(e.target);
    const activeElement = ownerDocument ? $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument) : $d4ee10de306f2510$export$cd4e5573fbe2b576();

    if (e.target === e.currentTarget && activeElement === $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent)) {
      if (onFocusProp) onFocusProp(e);
      if (onFocusChange) onFocusChange(true);
      onSyntheticFocus(e);
    }
  }, [onFocusChange, onFocusProp, onSyntheticFocus]);
  return {
    focusProps: {
      onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : void 0,
      onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : void 0
    }
  };
}

__name($a1ea59d68270f0dd$export$f8168d8dd8fd66e6, "$a1ea59d68270f0dd$export$f8168d8dd8fd66e6");

function $93925083ecbb358c$export$48d1ea6320830260(handler) {
  if (!handler) return void 0;
  let shouldStopPropagation = true;
  return e => {
    let event = __spreadProps(__spreadValues({}, e), {
      preventDefault() {
        e.preventDefault();
      },

      isDefaultPrevented() {
        return e.isDefaultPrevented();
      },

      stopPropagation() {
        if (shouldStopPropagation) console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");else shouldStopPropagation = true;
      },

      continuePropagation() {
        shouldStopPropagation = false;
      },

      isPropagationStopped() {
        return shouldStopPropagation;
      }

    });

    handler(event);
    if (shouldStopPropagation) e.stopPropagation();
  };
}

__name($93925083ecbb358c$export$48d1ea6320830260, "$93925083ecbb358c$export$48d1ea6320830260");

function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
      onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
    }
  };
}

__name($46d819fcbaf35654$export$8f71654801c2f7cd, "$46d819fcbaf35654$export$8f71654801c2f7cd");

var $f645667febf57a63$export$f9762fab77588ecb = /* @__PURE__ */React__default.createContext(null);

function $f645667febf57a63$var$useFocusableContext(ref) {
  let context = useContext($f645667febf57a63$export$f9762fab77588ecb) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref);

  let _a = context,
      otherProps = __objRest(_a, ["ref"]);

  return otherProps;
}

__name($f645667febf57a63$var$useFocusableContext, "$f645667febf57a63$var$useFocusableContext");

function $f645667febf57a63$export$4c014de7c8940b4c(props, domRef) {
  let {
    focusProps
  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props);
  let {
    keyboardProps
  } = $46d819fcbaf35654$export$8f71654801c2f7cd(props);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(focusProps, keyboardProps);
  let domProps = $f645667febf57a63$var$useFocusableContext(domRef);
  let interactionProps = props.isDisabled ? {} : domProps;
  let autoFocusRef = useRef(props.autoFocus);
  useEffect(() => {
    if (autoFocusRef.current && domRef.current) $3ad3f6e1647bc98d$export$80f3e147d781571c(domRef.current);
    autoFocusRef.current = false;
  }, [domRef]);
  let tabIndex = props.excludeFromTabOrder ? -1 : 0;
  if (props.isDisabled) tabIndex = void 0;
  return {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928(__spreadProps(__spreadValues({}, interactions), {
      tabIndex
    }), interactionProps)
  };
}

__name($f645667febf57a63$export$4c014de7c8940b4c, "$f645667febf57a63$export$4c014de7c8940b4c");

function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let {
    isDisabled,
    onBlurWithin,
    onFocusWithin,
    onFocusWithinChange
  } = props;
  let state = useRef({
    isFocusWithin: false
  });
  let {
    addGlobalListener,
    removeAllGlobalListeners
  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let onBlur = useCallback(e => {
    if (!e.currentTarget.contains(e.target)) return;

    if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
      state.current.isFocusWithin = false;
      removeAllGlobalListeners();
      if (onBlurWithin) onBlurWithin(e);
      if (onFocusWithinChange) onFocusWithinChange(false);
    }
  }, [onBlurWithin, onFocusWithinChange, state, removeAllGlobalListeners]);
  let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  let onFocus = useCallback(e => {
    if (!e.currentTarget.contains(e.target)) return;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(e.target);
    const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);

    if (!state.current.isFocusWithin && activeElement === $d4ee10de306f2510$export$e58f029f0fbfdb29(e.nativeEvent)) {
      if (onFocusWithin) onFocusWithin(e);
      if (onFocusWithinChange) onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e);
      let currentTarget = e.currentTarget;
      addGlobalListener(ownerDocument, "focus", e2 => {
        if (state.current.isFocusWithin && !$d4ee10de306f2510$export$4282f70798064fe0(currentTarget, e2.target)) {
          let event = new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", new ownerDocument.defaultView.FocusEvent("blur", {
            relatedTarget: e2.target
          }));
          event.target = currentTarget;
          event.currentTarget = currentTarget;
          onBlur(event);
        }
      }, {
        capture: true
      });
    }
  }, [onFocusWithin, onFocusWithinChange, onSyntheticFocus, addGlobalListener, onBlur]);
  if (isDisabled) return {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  };
  return {
    focusWithinProps: {
      onFocus,
      onBlur
    }
  };
}

__name($9ab94262bd0047c7$export$420e68273165f4ec, "$9ab94262bd0047c7$export$420e68273165f4ec");

var $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
var $6179b936705e76d3$var$hoverCount = 0;

function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
  $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
  setTimeout(() => {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}

__name($6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents, "$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents");

function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
  if (e.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}

__name($6179b936705e76d3$var$handleGlobalPointerEvent, "$6179b936705e76d3$var$handleGlobalPointerEvent");

function $6179b936705e76d3$var$setupGlobalTouchEvents() {
  if (typeof document === "undefined") return;
  if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  $6179b936705e76d3$var$hoverCount++;
  return () => {
    $6179b936705e76d3$var$hoverCount--;
    if ($6179b936705e76d3$var$hoverCount > 0) return;
    if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
  };
}

__name($6179b936705e76d3$var$setupGlobalTouchEvents, "$6179b936705e76d3$var$setupGlobalTouchEvents");

function $6179b936705e76d3$export$ae780daf29e6d456(props) {
  let {
    onHoverStart,
    onHoverChange,
    onHoverEnd,
    isDisabled
  } = props;
  let [isHovered, setHovered] = useState(false);
  let state = useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false,
    pointerType: "",
    target: null
  }).current;
  useEffect($6179b936705e76d3$var$setupGlobalTouchEvents, []);
  let {
    addGlobalListener,
    removeAllGlobalListeners
  } = $03deb23ff14920c4$export$4eaf04e54aa8eed6();
  let {
    hoverProps,
    triggerHoverEnd
  } = useMemo(() => {
    let triggerHoverStart = /* @__PURE__ */__name((event, pointerType) => {
      state.pointerType = pointerType;
      if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
      state.isHovered = true;
      let target = event.currentTarget;
      state.target = target;
      addGlobalListener($431fbd86ca7dc216$export$b204af158042fbac(event.target), "pointerover", e => {
        if (state.isHovered && state.target && !$d4ee10de306f2510$export$4282f70798064fe0(state.target, e.target)) triggerHoverEnd2(e, e.pointerType);
      }, {
        capture: true
      });
      if (onHoverStart) onHoverStart({
        type: "hoverstart",
        target,
        pointerType
      });
      if (onHoverChange) onHoverChange(true);
      setHovered(true);
    }, "triggerHoverStart");

    let triggerHoverEnd2 = /* @__PURE__ */__name((event, pointerType) => {
      let target = state.target;
      state.pointerType = "";
      state.target = null;
      if (pointerType === "touch" || !state.isHovered || !target) return;
      state.isHovered = false;
      removeAllGlobalListeners();
      if (onHoverEnd) onHoverEnd({
        type: "hoverend",
        target,
        pointerType
      });
      if (onHoverChange) onHoverChange(false);
      setHovered(false);
    }, "triggerHoverEnd");

    let hoverProps2 = {};

    if (typeof PointerEvent !== "undefined") {
      hoverProps2.onPointerEnter = e => {
        if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
        triggerHoverStart(e, e.pointerType);
      };

      hoverProps2.onPointerLeave = e => {
        if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd2(e, e.pointerType);
      };
    } else {
      hoverProps2.onTouchStart = () => {
        state.ignoreEmulatedMouseEvents = true;
      };

      hoverProps2.onMouseEnter = e => {
        if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
        state.ignoreEmulatedMouseEvents = false;
      };

      hoverProps2.onMouseLeave = e => {
        if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd2(e, "mouse");
      };
    }

    return {
      hoverProps: hoverProps2,
      triggerHoverEnd: triggerHoverEnd2
    };
  }, [onHoverStart, onHoverChange, onHoverEnd, isDisabled, state, addGlobalListener, removeAllGlobalListeners]);
  useEffect(() => {
    if (isDisabled) triggerHoverEnd({
      currentTarget: state.target
    }, state.pointerType);
  }, [isDisabled]);
  return {
    hoverProps,
    isHovered
  };
}

__name($6179b936705e76d3$export$ae780daf29e6d456, "$6179b936705e76d3$export$ae780daf29e6d456");

function $298d61e98472621b$export$dcf14c9974fe2767(props, ref) {
  let _a = props,
      {
    elementType = "a",
    onPress,
    onPressStart,
    onPressEnd,
    onClick: deprecatedOnClick,
    isDisabled
  } = _a,
      otherProps = __objRest(_a, ["elementType", "onPress", "onPressStart", "onPressEnd", // @ts-ignore
  "onClick", "isDisabled"]);

  let linkProps = {};
  if (elementType !== "a") linkProps = {
    role: "link",
    tabIndex: !isDisabled ? 0 : void 0
  };
  let {
    focusableProps
  } = $f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  let {
    pressProps,
    isPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPress,
    onPressStart,
    onPressEnd,
    isDisabled,
    ref
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(otherProps, {
    labelable: true
  });
  let interactionHandlers = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps);
  let router = $ea8dcbcb9ea1b556$export$9a302a45f65d0572();
  let routerLinkProps = $ea8dcbcb9ea1b556$export$7e924b3091a3bd18(props);
  return {
    isPressed,
    linkProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, routerLinkProps, __spreadProps(__spreadValues(__spreadValues({}, interactionHandlers), linkProps), {
      "aria-disabled": isDisabled || void 0,
      "aria-current": props["aria-current"],
      onClick: /* @__PURE__ */__name(e => {
        var _pressProps_onClick;

        (_pressProps_onClick = pressProps.onClick) === null || _pressProps_onClick === void 0 ? void 0 : _pressProps_onClick.call(pressProps, e);

        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn("onClick is deprecated, please use onPress");
        }

        if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
        !e.isDefaultPrevented() && $ea8dcbcb9ea1b556$export$efa8c9099e530235(e.currentTarget, e) && props.href) {
          e.preventDefault();
          router.open(e.currentTarget, e, props.href, props.routerOptions);
        }
      }, "onClick")
    }))
  };
}

__name($298d61e98472621b$export$dcf14c9974fe2767, "$298d61e98472621b$export$dcf14c9974fe2767");

var $148a7a147e38ea7f$var$RTL_SCRIPTS = /* @__PURE__ */new Set(["Arab", "Syrc", "Samr", "Mand", "Thaa", "Mend", "Nkoo", "Adlm", "Rohg", "Hebr"]);
var $148a7a147e38ea7f$var$RTL_LANGS = /* @__PURE__ */new Set(["ae", "ar", "arc", "bcc", "bqi", "ckb", "dv", "fa", "glk", "he", "ku", "mzn", "nqo", "pnb", "ps", "sd", "ug", "ur", "yi"]);

function $148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
  if (Intl.Locale) {
    let locale = new Intl.Locale(localeString).maximize();
    let textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
    if (textInfo) return textInfo.direction === "rtl";
    if (locale.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
  }

  let lang = localeString.split("-")[0];
  return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}

__name($148a7a147e38ea7f$export$702d680b21cbd764, "$148a7a147e38ea7f$export$702d680b21cbd764");

var $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");

function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
  let locale = typeof window !== "undefined" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";

  try {
    Intl.DateTimeFormat.supportedLocalesOf([locale]);
  } catch (e) {
    locale = "en-US";
  }

  return {
    locale,
    direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
  };
}

__name($1e5a04cdaf7d1af8$export$f09106e7c6677ec5, "$1e5a04cdaf7d1af8$export$f09106e7c6677ec5");

var $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
var $1e5a04cdaf7d1af8$var$listeners = /* @__PURE__ */new Set();

function $1e5a04cdaf7d1af8$var$updateLocale() {
  $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();

  for (let listener of $1e5a04cdaf7d1af8$var$listeners) listener($1e5a04cdaf7d1af8$var$currentLocale);
}

__name($1e5a04cdaf7d1af8$var$updateLocale, "$1e5a04cdaf7d1af8$var$updateLocale");

function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
  let isSSR = $b5e257d569688ac6$export$535bd6ca7f90a273();
  let [defaultLocale, setDefaultLocale] = useState($1e5a04cdaf7d1af8$var$currentLocale);
  useEffect(() => {
    if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
    return () => {
      $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
      if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
    };
  }, []);
  if (isSSR) return {
    locale: "en-US",
    direction: "ltr"
  };
  return defaultLocale;
}

__name($1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a, "$1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a");

var $18f2051aff69b9bf$var$I18nContext = /* @__PURE__ */React__default.createContext(null);

function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
  let defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
  let context = useContext($18f2051aff69b9bf$var$I18nContext);
  return context || defaultLocale;
}

__name($18f2051aff69b9bf$export$43bb16f9c6d9e3f7, "$18f2051aff69b9bf$export$43bb16f9c6d9e3f7");

function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  let {
    elementType = "button",
    isDisabled,
    onPress,
    onPressStart,
    onPressEnd,
    onPressUp,
    onPressChange,
    preventFocusOnPress,
    allowFocusWhenDisabled,
    // @ts-ignore
    onClick: deprecatedOnClick,
    href,
    target,
    rel,
    type = "button"
  } = props;
  let additionalProps;
  if (elementType === "button") additionalProps = {
    type,
    disabled: isDisabled
  };else additionalProps = {
    role: "button",
    href: elementType === "a" && !isDisabled ? href : void 0,
    target: elementType === "a" ? target : void 0,
    type: elementType === "input" ? type : void 0,
    disabled: elementType === "input" ? isDisabled : void 0,
    "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
    rel: elementType === "a" ? rel : void 0
  };
  let {
    pressProps,
    isPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    isDisabled,
    preventFocusOnPress,
    ref
  });
  let {
    focusableProps
  } = $f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  let buttonProps = $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, pressProps, $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  }));
  return {
    isPressed,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      "aria-current": props["aria-current"],
      onClick: /* @__PURE__ */__name(e => {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn("onClick is deprecated, please use onPress");
        }
      }, "onClick")
    })
  };
}

__name($701a24aa0da5b062$export$ea18c227d4417cc3, "$701a24aa0da5b062$export$ea18c227d4417cc3");

function $55f54f7887471b58$export$51e84d46ca0bc451(props, state, ref) {
  const {
    isSelected
  } = state;
  const {
    isPressed,
    buttonProps
  } = $701a24aa0da5b062$export$ea18c227d4417cc3(__spreadProps(__spreadValues({}, props), {
    onPress: $ff5963eb1fccf552$export$e08e3b67e392101e(state.toggle, props.onPress)
  }), ref);
  return {
    isPressed,
    isSelected,
    isDisabled: props.isDisabled || false,
    buttonProps: $3ef42575df84b30b$export$9d1611c77c2fe928(buttonProps, {
      "aria-pressed": isSelected
    })
  };
}

__name($55f54f7887471b58$export$51e84d46ca0bc451, "$55f54f7887471b58$export$51e84d46ca0bc451");

function $645f2e67b85a24c9$var$isStyleVisible(element) {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
  let {
    display,
    visibility
  } = element.style;
  let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";

  if (isVisible) {
    const {
      getComputedStyle
    } = element.ownerDocument.defaultView;
    let {
      display: computedDisplay,
      visibility: computedVisibility
    } = getComputedStyle(element);
    isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
  }

  return isVisible;
}

__name($645f2e67b85a24c9$var$isStyleVisible, "$645f2e67b85a24c9$var$isStyleVisible");

function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
  return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}

__name($645f2e67b85a24c9$var$isAttributeVisible, "$645f2e67b85a24c9$var$isAttributeVisible");

function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
  return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}

__name($645f2e67b85a24c9$export$e989c0fffaa6b27a, "$645f2e67b85a24c9$export$e989c0fffaa6b27a");

function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  if (!element) return false;
  if (!scope) return false;
  return scope.some(node => node.contains(element));
}

__name($9bf71ea28793e738$var$isElementInScope, "$9bf71ea28793e738$var$isElementInScope");

function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
  let filter = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $b4b717babfbb907b$export$bebd5a1431fec25d : $b4b717babfbb907b$export$4c063cf1350e6fed;
  let rootElement = (root === null || root === void 0 ? void 0 : root.nodeType) === Node.ELEMENT_NODE ? root : null;
  let doc = $431fbd86ca7dc216$export$b204af158042fbac(rootElement);
  let walker = $dfc540311bf7f109$export$4d0f8be8b12a7ef6(doc, root || doc, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node) {
      var _opts_from;

      if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
      if (filter(node) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
      return NodeFilter.FILTER_SKIP;
    }

  });
  if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
  return walker;
}

__name($9bf71ea28793e738$export$2d6ec8fc375ceafa, "$9bf71ea28793e738$export$2d6ec8fc375ceafa");

var _$9bf71ea28793e738$var$Tree = class _$9bf71ea28793e738$var$Tree2 {
  get size() {
    return this.fastMap.size;
  }

  getTreeNode(data) {
    return this.fastMap.get(data);
  }

  addTreeNode(scopeRef, parent, nodeToRestore) {
    let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
    if (!parentNode) return;
    let node = new $9bf71ea28793e738$var$TreeNode({
      scopeRef
    });
    parentNode.addChild(node);
    node.parent = parentNode;
    this.fastMap.set(scopeRef, node);
    if (nodeToRestore) node.nodeToRestore = nodeToRestore;
  }

  addNode(node) {
    this.fastMap.set(node.scopeRef, node);
  }

  removeTreeNode(scopeRef) {
    if (scopeRef === null) return;
    let node = this.fastMap.get(scopeRef);
    if (!node) return;
    let parentNode = node.parent;

    for (let current of this.traverse()) if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;

    let children = node.children;

    if (parentNode) {
      parentNode.removeChild(node);
      if (children.size > 0) children.forEach(child => parentNode && parentNode.addChild(child));
    }

    this.fastMap.delete(node.scopeRef);
  } // Pre Order Depth First


  traverse() {
    var _this = this;

    let node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root;
    return function* () {
      if (node.scopeRef != null) yield node;
      if (node.children.size > 0) for (let child of node.children) yield* __yieldStar(_this.traverse(child));
    }();
  }

  clone() {
    var _node_parent;

    let newTree = new _$9bf71ea28793e738$var$Tree2();

    var _node_parent_scopeRef;

    for (let node of this.traverse()) newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);

    return newTree;
  }

  constructor() {
    this.fastMap = /* @__PURE__ */new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }

};

__name(_$9bf71ea28793e738$var$Tree, "$9bf71ea28793e738$var$Tree");

var $9bf71ea28793e738$var$Tree = _$9bf71ea28793e738$var$Tree;

var _$9bf71ea28793e738$var$TreeNode = class _$9bf71ea28793e738$var$TreeNode2 {
  addChild(node) {
    this.children.add(node);
    node.parent = this;
  }

  removeChild(node) {
    this.children.delete(node);
    node.parent = void 0;
  }

  constructor(props) {
    this.children = /* @__PURE__ */new Set();
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }

};

__name(_$9bf71ea28793e738$var$TreeNode, "$9bf71ea28793e738$var$TreeNode");

var $9bf71ea28793e738$var$TreeNode = _$9bf71ea28793e738$var$TreeNode;
new $9bf71ea28793e738$var$Tree();

function $f7dceffc5ad7768b$export$4e328f61c538687f() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let {
    autoFocus = false,
    isTextInput,
    within
  } = props;
  let state = useRef({
    isFocused: false,
    isFocusVisible: autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()
  });
  let [isFocused, setFocused] = useState(false);
  let [isFocusVisibleState, setFocusVisible] = useState(() => state.current.isFocused && state.current.isFocusVisible);
  let updateState = useCallback(() => setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
  let onFocusChange = useCallback(isFocused2 => {
    state.current.isFocused = isFocused2;
    setFocused(isFocused2);
    updateState();
  }, [updateState]);
  $507fabe10e71c6fb$export$ec71b4b83ac08ec3(isFocusVisible => {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput
  });
  let {
    focusProps
  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6({
    isDisabled: within,
    onFocusChange
  });
  let {
    focusWithinProps
  } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !within,
    onFocusWithinChange: onFocusChange
  });
  return {
    isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}

__name($f7dceffc5ad7768b$export$4e328f61c538687f, "$f7dceffc5ad7768b$export$4e328f61c538687f");

var $e5be200c675c3b3a$export$aca958c65c314e6c = {
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  rangeUnderflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false,
  valueMissing: false,
  valid: true
};

var $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = __spreadProps(__spreadValues({}, $e5be200c675c3b3a$export$aca958c65c314e6c), {
  customError: true,
  valid: false
});

var $e5be200c675c3b3a$export$dad6ae84456c676a = {
  isInvalid: false,
  validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
  validationErrors: []
};
var $e5be200c675c3b3a$export$571b5131b7e65c11 = /*#__PURE__*/createContext({});
var $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();

function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(props) {
  if (props[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
    let {
      realtimeValidation,
      displayValidation,
      updateValidation,
      resetValidation,
      commitValidation
    } = props[$e5be200c675c3b3a$export$a763b9476acd3eb];
    return {
      realtimeValidation,
      displayValidation,
      updateValidation,
      resetValidation,
      commitValidation
    };
  }

  return $e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}

__name($e5be200c675c3b3a$export$fc1a364ae1f3ff10, "$e5be200c675c3b3a$export$fc1a364ae1f3ff10");

function $e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
  let {
    isInvalid,
    validationState,
    name,
    value,
    builtinValidation,
    validate,
    validationBehavior = "aria"
  } = props;
  if (validationState) isInvalid || (isInvalid = validationState === "invalid");
  let controlledError = isInvalid !== void 0 ? {
    isInvalid,
    validationErrors: [],
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
  let clientError = useMemo(() => {
    if (!validate || value == null) return null;
    let validateErrors = $e5be200c675c3b3a$var$runValidate(validate, value);
    return $e5be200c675c3b3a$var$getValidationResult(validateErrors);
  }, [validate, value]);
  if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = void 0;
  let serverErrors = useContext($e5be200c675c3b3a$export$571b5131b7e65c11);
  let serverErrorMessages = useMemo(() => {
    if (name) return Array.isArray(name) ? name.flatMap(name2 => $e5be200c675c3b3a$var$asArray(serverErrors[name2])) : $e5be200c675c3b3a$var$asArray(serverErrors[name]);
    return [];
  }, [serverErrors, name]);
  let [lastServerErrors, setLastServerErrors] = useState(serverErrors);
  let [isServerErrorCleared, setServerErrorCleared] = useState(false);

  if (serverErrors !== lastServerErrors) {
    setLastServerErrors(serverErrors);
    setServerErrorCleared(false);
  }

  let serverError = useMemo(() => $e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages), [isServerErrorCleared, serverErrorMessages]);
  let nextValidation = useRef($e5be200c675c3b3a$export$dad6ae84456c676a);
  let [currentValidity, setCurrentValidity] = useState($e5be200c675c3b3a$export$dad6ae84456c676a);
  let lastError = useRef($e5be200c675c3b3a$export$dad6ae84456c676a);

  let commitValidation = /* @__PURE__ */__name(() => {
    if (!commitQueued) return;
    setCommitQueued(false);
    let error = clientError || builtinValidation || nextValidation.current;

    if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
      lastError.current = error;
      setCurrentValidity(error);
    }
  }, "commitValidation");

  let [commitQueued, setCommitQueued] = useState(false);
  useEffect(commitValidation);
  let realtimeValidation = controlledError || serverError || clientError || builtinValidation || $e5be200c675c3b3a$export$dad6ae84456c676a;
  let displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
  return {
    realtimeValidation,
    displayValidation,

    updateValidation(value2) {
      if (validationBehavior === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value2)) setCurrentValidity(value2);else nextValidation.current = value2;
    },

    resetValidation() {
      let error = $e5be200c675c3b3a$export$dad6ae84456c676a;

      if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
        lastError.current = error;
        setCurrentValidity(error);
      }

      if (validationBehavior === "native") setCommitQueued(false);
      setServerErrorCleared(true);
    },

    commitValidation() {
      if (validationBehavior === "native") setCommitQueued(true);
      setServerErrorCleared(true);
    }

  };
}

__name($e5be200c675c3b3a$var$useFormValidationStateImpl, "$e5be200c675c3b3a$var$useFormValidationStateImpl");

function $e5be200c675c3b3a$var$asArray(v) {
  if (!v) return [];
  return Array.isArray(v) ? v : [v];
}

__name($e5be200c675c3b3a$var$asArray, "$e5be200c675c3b3a$var$asArray");

function $e5be200c675c3b3a$var$runValidate(validate, value) {
  if (typeof validate === "function") {
    let e = validate(value);
    if (e && typeof e !== "boolean") return $e5be200c675c3b3a$var$asArray(e);
  }

  return [];
}

__name($e5be200c675c3b3a$var$runValidate, "$e5be200c675c3b3a$var$runValidate");

function $e5be200c675c3b3a$var$getValidationResult(errors) {
  return errors.length ? {
    isInvalid: true,
    validationErrors: errors,
    validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
  } : null;
}

__name($e5be200c675c3b3a$var$getValidationResult, "$e5be200c675c3b3a$var$getValidationResult");

function $e5be200c675c3b3a$var$isEqualValidation(a, b) {
  if (a === b) return true;
  return !!a && !!b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every((a2, i) => a2 === b.validationErrors[i]) && Object.entries(a.validationDetails).every((_ref11) => {
    let [k, v] = _ref11;
    return b.validationDetails[k] === v;
  });
}

__name($e5be200c675c3b3a$var$isEqualValidation, "$e5be200c675c3b3a$var$isEqualValidation");

function $e5be200c675c3b3a$export$75ee7c75d68f5b0e() {
  let errors = /* @__PURE__ */new Set();
  let isInvalid = false;

  let validationDetails = __spreadValues({}, $e5be200c675c3b3a$export$aca958c65c314e6c);

  for (var _len7 = arguments.length, results = new Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
    results[_key8] = arguments[_key8];
  }

  for (let v of results) {
    var _validationDetails, _key;

    for (let e of v.validationErrors) errors.add(e);

    isInvalid || (isInvalid = v.isInvalid);

    for (let key in validationDetails) (_validationDetails = validationDetails)[_key = key] || (_validationDetails[_key] = v.validationDetails[key]);
  }

  validationDetails.valid = !isInvalid;
  return {
    isInvalid,
    validationErrors: [...errors],
    validationDetails
  };
}

__name($e5be200c675c3b3a$export$75ee7c75d68f5b0e, "$e5be200c675c3b3a$export$75ee7c75d68f5b0e");

function $e93e671b31057976$export$b8473d3665f3a75a(props, state, ref) {
  let {
    validationBehavior,
    focus
  } = props;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.disabled) {
      let errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      ref.current.setCustomValidity(errorMessage);
      if (!ref.current.hasAttribute("title")) ref.current.title = "";
      if (!state.realtimeValidation.isInvalid) state.updateValidation($e93e671b31057976$var$getNativeValidity(ref.current));
    }
  });
  let onReset = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    state.resetValidation();
  });
  let onInvalid = $8ae05eaa5c114e9c$export$7f54fc3180508a52(e => {
    var _ref_current;

    if (!state.displayValidation.isInvalid) state.commitValidation();
    let form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;

    if (!e.defaultPrevented && ref && form && $e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
      var _ref_current1;

      if (focus) focus();else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.focus();
      $507fabe10e71c6fb$export$8397ddfc504fdb9a("keyboard");
    }

    e.preventDefault();
  });
  let onChange = $8ae05eaa5c114e9c$export$7f54fc3180508a52(() => {
    state.commitValidation();
  });
  useEffect(() => {
    let input = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!input) return;
    let form = input.form;
    input.addEventListener("invalid", onInvalid);
    input.addEventListener("change", onChange);
    form === null || form === void 0 ? void 0 : form.addEventListener("reset", onReset);
    return () => {
      input.removeEventListener("invalid", onInvalid);
      input.removeEventListener("change", onChange);
      form === null || form === void 0 ? void 0 : form.removeEventListener("reset", onReset);
    };
  }, [ref, onInvalid, onChange, onReset, validationBehavior]);
}

__name($e93e671b31057976$export$b8473d3665f3a75a, "$e93e671b31057976$export$b8473d3665f3a75a");

function $e93e671b31057976$var$getValidity(input) {
  let validity = input.validity;
  return {
    badInput: validity.badInput,
    customError: validity.customError,
    patternMismatch: validity.patternMismatch,
    rangeOverflow: validity.rangeOverflow,
    rangeUnderflow: validity.rangeUnderflow,
    stepMismatch: validity.stepMismatch,
    tooLong: validity.tooLong,
    tooShort: validity.tooShort,
    typeMismatch: validity.typeMismatch,
    valueMissing: validity.valueMissing,
    valid: validity.valid
  };
}

__name($e93e671b31057976$var$getValidity, "$e93e671b31057976$var$getValidity");

function $e93e671b31057976$var$getNativeValidity(input) {
  return {
    isInvalid: !input.validity.valid,
    validationDetails: $e93e671b31057976$var$getValidity(input),
    validationErrors: input.validationMessage ? [input.validationMessage] : []
  };
}

__name($e93e671b31057976$var$getNativeValidity, "$e93e671b31057976$var$getNativeValidity");

function $e93e671b31057976$var$getFirstInvalidInput(form) {
  for (let i = 0; i < form.elements.length; i++) {
    let element = form.elements[i];
    if (!element.validity.valid) return element;
  }

  return null;
}

__name($e93e671b31057976$var$getFirstInvalidInput, "$e93e671b31057976$var$getFirstInvalidInput");

function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
  let {
    isDisabled = false,
    isReadOnly = false,
    value,
    name,
    children,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    validationState = "valid",
    isInvalid
  } = props;

  let onChange = /* @__PURE__ */__name(e => {
    e.stopPropagation();
    state.setSelected(e.target.checked);
  }, "onChange");

  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let {
    pressProps,
    isPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled
  });
  let {
    pressProps: labelProps,
    isPressed: isLabelPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPress() {
      var _ref_current;

      state.toggle();
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    },

    isDisabled: isDisabled || isReadOnly
  });
  let {
    focusableProps
  } = $f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  $99facab73266f662$export$5add1d006293d136(ref, state.isSelected, state.setSelected);
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: /* @__PURE__ */__name(e => e.preventDefault(), "onClick")
    }),
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, __spreadValues(__spreadProps(__spreadValues({
      "aria-invalid": isInvalid || validationState === "invalid" || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-controls": props["aria-controls"],
      "aria-readonly": isReadOnly || void 0,
      onChange,
      disabled: isDisabled
    }, value == null ? {} : {
      value
    }), {
      name,
      type: "checkbox"
    }), interactions)),
    isSelected: state.isSelected,
    isPressed: isPressed || isLabelPressed,
    isDisabled,
    isReadOnly,
    isInvalid: isInvalid || validationState === "invalid"
  };
}

__name($d2c8e2b0480f3f34$export$cbe85ee05b554577, "$d2c8e2b0480f3f34$export$cbe85ee05b554577");

function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
  let validationState = $e5be200c675c3b3a$export$fc1a364ae1f3ff10(__spreadProps(__spreadValues({}, props), {
    value: state.isSelected
  }));
  let {
    isInvalid,
    validationErrors,
    validationDetails
  } = validationState.displayValidation;
  let {
    labelProps,
    inputProps,
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly
  } = $d2c8e2b0480f3f34$export$cbe85ee05b554577(__spreadProps(__spreadValues({}, props), {
    isInvalid
  }), state, inputRef);
  $e93e671b31057976$export$b8473d3665f3a75a(props, validationState, inputRef);
  let {
    isIndeterminate,
    isRequired,
    validationBehavior = "aria"
  } = props;
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
  });
  let {
    pressProps
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled: isDisabled || isReadOnly,

    onPress() {
      let {
        [$e5be200c675c3b3a$export$a763b9476acd3eb]: groupValidationState
      } = props;
      let {
        commitValidation
      } = groupValidationState ? groupValidationState : validationState;
      commitValidation();
    }

  });
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, pressProps),
    inputProps: __spreadProps(__spreadValues({}, inputProps), {
      checked: isSelected,
      "aria-required": isRequired && validationBehavior === "aria" || void 0,
      required: isRequired && validationBehavior === "native"
    }),
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly,
    isInvalid,
    validationErrors,
    validationDetails
  };
}

__name($406796ff087fe49b$export$e375f10ce42261c5, "$406796ff087fe49b$export$e375f10ce42261c5");

var $1ae600c947479353$export$ec98120685d4f57d = /* @__PURE__ */new WeakMap();

function $d191a55c9702f145$export$8467354a121f1b9f(props) {
  let {
    id,
    label,
    "aria-labelledby": ariaLabelledby,
    "aria-label": ariaLabel,
    labelElementType = "label"
  } = props;
  id = $bdb11010cef70236$export$f680877a34711e37(id);
  let labelId = $bdb11010cef70236$export$f680877a34711e37();
  let labelProps = {};

  if (label) {
    ariaLabelledby = ariaLabelledby ? `${labelId} ${ariaLabelledby}` : labelId;
    labelProps = {
      id: labelId,
      htmlFor: labelElementType === "label" ? id : void 0
    };
  } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");

  let fieldProps = $313b98861ee5dd6c$export$d6875122194c7b44({
    id,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby
  });
  return {
    labelProps,
    fieldProps
  };
}

__name($d191a55c9702f145$export$8467354a121f1b9f, "$d191a55c9702f145$export$8467354a121f1b9f");

function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
  let {
    description,
    errorMessage,
    isInvalid,
    validationState
  } = props;
  let {
    labelProps,
    fieldProps
  } = $d191a55c9702f145$export$8467354a121f1b9f(props);
  let descriptionId = $bdb11010cef70236$export$b4cc09c592e8fdb8([Boolean(description), Boolean(errorMessage), isInvalid, validationState]);
  let errorMessageId = $bdb11010cef70236$export$b4cc09c592e8fdb8([Boolean(description), Boolean(errorMessage), isInvalid, validationState]);
  fieldProps = $3ef42575df84b30b$export$9d1611c77c2fe928(fieldProps, {
    "aria-describedby": [descriptionId, // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
    errorMessageId, props["aria-describedby"]].filter(Boolean).join(" ") || void 0
  });
  return {
    labelProps,
    fieldProps,
    descriptionProps: {
      id: descriptionId
    },
    errorMessageProps: {
      id: errorMessageId
    }
  };
}

__name($2baaea4c71418dea$export$294aa081a6c6f55d, "$2baaea4c71418dea$export$294aa081a6c6f55d");

function $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state) {
  let {
    isDisabled,
    name,
    validationBehavior = "aria"
  } = props;
  let {
    isInvalid,
    validationErrors,
    validationDetails
  } = state.displayValidation;
  let {
    labelProps,
    fieldProps,
    descriptionProps,
    errorMessageProps
  } = $2baaea4c71418dea$export$294aa081a6c6f55d(__spreadProps(__spreadValues({}, props), {
    // Checkbox group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid,
    errorMessage: props.errorMessage || validationErrors
  }));
  $1ae600c947479353$export$ec98120685d4f57d.set(state, {
    name,
    descriptionId: descriptionProps.id,
    errorMessageId: errorMessageProps.id,
    validationBehavior
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let {
    focusWithinProps
  } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin: props.onBlur,
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  return {
    groupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, __spreadValues(__spreadValues({
      role: "group",
      "aria-disabled": isDisabled || void 0
    }, fieldProps), focusWithinProps)),
    labelProps,
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}

__name($1e9fce0cfacc738b$export$49ff6f28c54f1cbe, "$1e9fce0cfacc738b$export$49ff6f28c54f1cbe");

function $3017fa7ffdddec74$export$8042c6c013fd5226() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let {
    isReadOnly
  } = props;
  let [isSelected, setSelected] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.isSelected, props.defaultSelected || false, props.onChange);

  function updateSelected(value) {
    if (!isReadOnly) setSelected(value);
  }

  __name(updateSelected, "updateSelected");

  function toggleState() {
    if (!isReadOnly) setSelected(!isSelected);
  }

  __name(toggleState, "toggleState");

  return {
    isSelected,
    setSelected: updateSelected,
    toggle: toggleState
  };
}

__name($3017fa7ffdddec74$export$8042c6c013fd5226, "$3017fa7ffdddec74$export$8042c6c013fd5226");

function $fba3e38d5ca8983f$export$353b32fc6898d37d(props, state, inputRef) {
  const toggleState = $3017fa7ffdddec74$export$8042c6c013fd5226({
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isSelected: state.isSelected(props.value),

    onChange(isSelected) {
      if (isSelected) state.addValue(props.value);else state.removeValue(props.value);
      if (props.onChange) props.onChange(isSelected);
    }

  });
  let {
    name,
    descriptionId,
    errorMessageId,
    validationBehavior
  } = $1ae600c947479353$export$ec98120685d4f57d.get(state);

  var _props_validationBehavior;

  validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
  let {
    realtimeValidation
  } = $e5be200c675c3b3a$export$fc1a364ae1f3ff10(__spreadProps(__spreadValues({}, props), {
    value: toggleState.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }));
  let nativeValidation = useRef($e5be200c675c3b3a$export$dad6ae84456c676a);

  let updateValidation = /* @__PURE__ */__name(() => {
    state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
  }, "updateValidation");

  useEffect(updateValidation);
  let combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
  let displayValidation = validationBehavior === "native" ? state.displayValidation : combinedRealtimeValidation;

  var _props_isRequired;

  let res = $406796ff087fe49b$export$e375f10ce42261c5(__spreadProps(__spreadValues({}, props), {
    isReadOnly: props.isReadOnly || state.isReadOnly,
    isDisabled: props.isDisabled || state.isDisabled,
    name: props.name || name,
    isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
    validationBehavior,
    [$e5be200c675c3b3a$export$a763b9476acd3eb]: {
      realtimeValidation: combinedRealtimeValidation,
      displayValidation,
      resetValidation: state.resetValidation,
      commitValidation: state.commitValidation,

      updateValidation(v) {
        nativeValidation.current = v;
        updateValidation();
      }

    }
  }), toggleState, inputRef);
  return __spreadProps(__spreadValues({}, res), {
    inputProps: __spreadProps(__spreadValues({}, res.inputProps), {
      "aria-describedby": [props["aria-describedby"], state.isInvalid ? errorMessageId : null, descriptionId].filter(Boolean).join(" ") || void 0
    })
  });
}

__name($fba3e38d5ca8983f$export$353b32fc6898d37d, "$fba3e38d5ca8983f$export$353b32fc6898d37d");

var $884aeceb3d67f00f$export$37b65e5b5444d35c = /* @__PURE__ */new WeakMap();

function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
  let {
    value,
    children,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby
  } = props;
  const isDisabled = props.isDisabled || state.isDisabled;
  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let checked = state.selectedValue === value;

  let onChange = /* @__PURE__ */__name(e => {
    e.stopPropagation();
    state.setSelectedValue(value);
  }, "onChange");

  let {
    pressProps,
    isPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled
  });
  let {
    pressProps: labelProps,
    isPressed: isLabelPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled,

    onPress() {
      var _ref_current;

      state.setSelectedValue(value);
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }

  });
  let {
    focusableProps
  } = $f645667febf57a63$export$4c014de7c8940b4c($3ef42575df84b30b$export$9d1611c77c2fe928(props, {
    onFocus: /* @__PURE__ */__name(() => state.setLastFocusedValue(value), "onFocus")
  }), ref);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let tabIndex = -1;

  if (state.selectedValue != null) {
    if (state.selectedValue === value) tabIndex = 0;
  } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;

  if (isDisabled) tabIndex = void 0;
  let {
    name,
    descriptionId,
    errorMessageId,
    validationBehavior
  } = $884aeceb3d67f00f$export$37b65e5b5444d35c.get(state);
  $99facab73266f662$export$5add1d006293d136(ref, state.selectedValue, state.setSelectedValue);
  $e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior
  }, state, ref);
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: /* @__PURE__ */__name(e => e.preventDefault(), "onClick")
    }),
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, __spreadProps(__spreadValues({}, interactions), {
      type: "radio",
      name,
      tabIndex,
      disabled: isDisabled,
      required: state.isRequired && validationBehavior === "native",
      checked,
      value,
      onChange,
      "aria-describedby": [props["aria-describedby"], state.isInvalid ? errorMessageId : null, descriptionId].filter(Boolean).join(" ") || void 0
    })),
    isDisabled,
    isSelected: checked,
    isPressed: isPressed || isLabelPressed
  };
}

__name($0d5c49892c1215da$export$37b0961d2f4751e2, "$0d5c49892c1215da$export$37b0961d2f4751e2");

function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
  let {
    name,
    isReadOnly,
    isRequired,
    isDisabled,
    orientation = "vertical",
    validationBehavior = "aria"
  } = props;
  let {
    direction
  } = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let {
    isInvalid,
    validationErrors,
    validationDetails
  } = state.displayValidation;
  let {
    labelProps,
    fieldProps,
    descriptionProps,
    errorMessageProps
  } = $2baaea4c71418dea$export$294aa081a6c6f55d(__spreadProps(__spreadValues({}, props), {
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: state.isInvalid,
    errorMessage: props.errorMessage || validationErrors
  }));
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let {
    focusWithinProps
  } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin(e) {
      var _props_onBlur;

      (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
      if (!state.selectedValue) state.setLastFocusedValue(null);
    },

    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });

  let onKeyDown = /* @__PURE__ */__name(e => {
    let nextDir;

    switch (e.key) {
      case "ArrowRight":
        if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";else nextDir = "next";
        break;

      case "ArrowLeft":
        if (direction === "rtl" && orientation !== "vertical") nextDir = "next";else nextDir = "prev";
        break;

      case "ArrowDown":
        nextDir = "next";
        break;

      case "ArrowUp":
        nextDir = "prev";
        break;

      default:
        return;
    }

    e.preventDefault();
    let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(e.currentTarget, {
      from: e.target
    });
    let nextElem;

    if (nextDir === "next") {
      nextElem = walker.nextNode();

      if (!nextElem) {
        walker.currentNode = e.currentTarget;
        nextElem = walker.firstChild();
      }
    } else {
      nextElem = walker.previousNode();

      if (!nextElem) {
        walker.currentNode = e.currentTarget;
        nextElem = walker.lastChild();
      }
    }

    if (nextElem) {
      nextElem.focus();
      state.setSelectedValue(nextElem.value);
    }
  }, "onKeyDown");

  let groupName = $bdb11010cef70236$export$f680877a34711e37(name);
  $884aeceb3d67f00f$export$37b65e5b5444d35c.set(state, {
    name: groupName,
    descriptionId: descriptionProps.id,
    errorMessageId: errorMessageProps.id,
    validationBehavior
  });
  return {
    radioGroupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, __spreadValues(__spreadValues({
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown,
      "aria-invalid": state.isInvalid || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-readonly": isReadOnly || void 0,
      "aria-required": isRequired || void 0,
      "aria-disabled": isDisabled || void 0,
      "aria-orientation": orientation
    }, fieldProps), focusWithinProps)),
    labelProps,
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}

__name($430f30ed08ec25fa$export$62b9571f283ff5c2, "$430f30ed08ec25fa$export$62b9571f283ff5c2");

function $b418ec0c85c52f27$export$d853f7095ae95f88(props, state, ref) {
  let {
    labelProps,
    inputProps,
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly
  } = $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref);
  return {
    labelProps,
    inputProps: __spreadProps(__spreadValues({}, inputProps), {
      role: "switch",
      checked: isSelected
    }),
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly
  };
}

__name($b418ec0c85c52f27$export$d853f7095ae95f88, "$b418ec0c85c52f27$export$d853f7095ae95f88");

function RouterProvider(_ref12) {
  let {
    navigate,
    useHref,
    children
  } = _ref12;

  if (!navigate) {
    return /* @__PURE__ */jsx(Fragment$1, {
      children
    });
  }

  return /* @__PURE__ */jsx($ea8dcbcb9ea1b556$export$323e4fc2fa4753fb, {
    navigate,
    useHref,
    children
  });
}

__name(RouterProvider, "RouterProvider");

var MAX_DEPTH = 5;
var defaultIdsConfig = {
  featureFlags: defaultFeatureFlags
};

function IdsProvider(_ref13) {
  let {
    themeOverrides = coreTheme,
    idsConfigOverrides = defaultIdsConfig,
    routing,
    children
  } = _ref13;
  const mergedTheme = useMemo(() => {
    if (coreTheme && getDepth(coreTheme) > MAX_DEPTH || themeOverrides && getDepth(themeOverrides) > MAX_DEPTH) {
      throw new Error(`Theme depth should not exceed ${MAX_DEPTH} levels`);
    }

    return (0, import_deepmerge2.default)(coreTheme, themeOverrides);
  }, [themeOverrides]);
  const {
    hotkeyDebugFeatureFlag,
    hotkeyDebugValues
  } = idsConfigOverrides;
  const debugOverrideArgs = hotkeyDebugFeatureFlag && hotkeyDebugValues ? {
    debugFlag: hotkeyDebugFeatureFlag,
    values: hotkeyDebugValues
  } : void 0;
  const featureFlagDebugOverrides = useFeatureFlagDebugOverrides(debugOverrideArgs);
  const mergedConfig = useMemo(() => {
    if (defaultIdsConfig && getDepth(defaultIdsConfig) > MAX_DEPTH || idsConfigOverrides && getDepth(idsConfigOverrides) > MAX_DEPTH) {
      throw new Error(`IdsConfig depth should not exceed ${MAX_DEPTH} levels`);
    }

    const merged = (0, import_deepmerge2.default)(defaultIdsConfig, idsConfigOverrides);
    const featureFlagsWithDefaults = Object.keys(defaultFeatureFlags).reduce((acc, current) => {
      if (acc[current] === void 0) {
        acc[current] = defaultFeatureFlags[current];
      }

      return acc;
    }, merged.featureFlags);
    return __spreadProps(__spreadValues({}, merged), {
      featureFlags: __spreadValues(__spreadValues({}, featureFlagsWithDefaults), featureFlagDebugOverrides)
    });
  }, [idsConfigOverrides, featureFlagDebugOverrides]);
  return /* @__PURE__ */jsx(IdsConfigContext.Provider, {
    value: mergedConfig,
    children: /* @__PURE__ */jsx(RouterProvider, {
      navigate: routing == null ? void 0 : routing.navigate,
      useHref: routing == null ? void 0 : routing.useHref,
      children: /* @__PURE__ */jsx(ThemeProvider$1, {
        theme: mergedTheme,
        children: /* @__PURE__ */jsxs(CachedThemeProvider, {
          children: [/* @__PURE__ */jsx(ColorCacheProvider, {
            children
          }), /* @__PURE__ */jsx(MotionGlobalStyles, {}), /* @__PURE__ */jsx(OnPressGlobalStyles, {})]
        })
      })
    })
  });
}

__name(IdsProvider, "IdsProvider");

var ThemeProvider = IdsProvider;

function useOnClickOutside(refs, handler) {
  useEffect(() => {
    const listener = /* @__PURE__ */__name(event => {
      var _a;

      const {
        target
      } = event;

      if (!target || !(target instanceof Element)) {
        return;
      }

      const refsArray = Array.isArray(refs) ? refs : [refs];

      for (const ref of refsArray) {
        if (!ref || ((_a = ref.current) == null ? void 0 : _a.contains(target))) {
          return;
        }
      }

      handler(event);
    }, "listener");

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
}

__name(useOnClickOutside, "useOnClickOutside");

function useRenderChildrenStatus(_ref14) {
  let {
    modalVisible,
    onlyRenderWhenVisible,
    delay = 0
  } = _ref14;
  const [renderChildrenStatus, setRenderChildrenStatus] = useState(modalVisible ? 1 : 0
  /* Hide */
  );
  const childrenVisible = renderChildrenStatus !== 0;
  useEffect(() => {
    if (!onlyRenderWhenVisible) {
      return;
    }

    let timer;

    if (renderChildrenStatus === 1 && !modalVisible) {
      timer = window.setTimeout(() => setRenderChildrenStatus(0
      /* Hide */
      ), delay);
      setRenderChildrenStatus(2
      /* TransitioningToClose */
      );
      return;
    }

    if (modalVisible && renderChildrenStatus === 0) {
      setRenderChildrenStatus(1
      /* Show */
      );
      return;
    }

    return () => {
      timer && window.clearTimeout(timer);
    };
  }, [modalVisible, renderChildrenStatus, setRenderChildrenStatus, delay, onlyRenderWhenVisible]);
  return childrenVisible;
}

__name(useRenderChildrenStatus, "useRenderChildrenStatus");

var hasPassiveEvents = false;

if (typeof window !== "undefined") {
  const passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return void 0;
    }

  };

  const noop = /* @__PURE__ */__name(() => {}, "noop");

  window.addEventListener("testPassive", noop, passiveTestOptions);
  window.removeEventListener("testPassive", noop);
}

var isIosDevice = /* @__PURE__ */__name(() => typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), "isIosDevice");

var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting;
var previousBodyPosition;
var previousBodyPaddingRight;

var allowTouchMove = /* @__PURE__ */__name(el => locks.some(lock => {
  var _a;

  if (!lock.options.allowTouchMove) return false;

  if (!lock.touchMoveAllowed.has(el)) {
    lock.touchMoveAllowed.set(el, lock.options.allowTouchMove(el));
  }

  return (_a = lock.touchMoveAllowed.get(el)) != null ? _a : false;
}), "allowTouchMove");

var preventDefault = /* @__PURE__ */__name(rawEvent => {
  const e = rawEvent || window.event;

  if (e.target && allowTouchMove(e.target)) {
    return true;
  }

  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
}, "preventDefault");

var setOverflowHidden = /* @__PURE__ */__name(options => {
  if (previousBodyPaddingRight === void 0) {
    const reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    const scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (reserveScrollBarGap && scrollBarGap > 0) {
      const computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10) || 0;
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = `${computedBodyPaddingRight + scrollBarGap}px`;
    }
  }

  if (previousBodyOverflowSetting === void 0) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
}, "setOverflowHidden");

var restoreOverflowSetting = /* @__PURE__ */__name(() => {
  if (previousBodyPaddingRight !== void 0) {
    document.body.style.paddingRight = previousBodyPaddingRight;
    previousBodyPaddingRight = void 0;
  }

  if (previousBodyOverflowSetting !== void 0) {
    document.body.style.overflow = previousBodyOverflowSetting;
    previousBodyOverflowSetting = void 0;
  }
}, "restoreOverflowSetting");

var setPositionFixed = /* @__PURE__ */__name(() => window.requestAnimationFrame(() => {
  if (previousBodyPosition === void 0) {
    previousBodyPosition = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left
    };
    const {
      scrollY,
      scrollX
    } = window;
    document.body.style.position = "fixed";
    document.body.style.top = `${-scrollY}px`;
    document.body.style.left = `${-scrollX}px`;
  }
}), "setPositionFixed");

var restorePositionSetting = /* @__PURE__ */__name(() => {
  if (previousBodyPosition !== void 0) {
    const y = -parseInt(document.body.style.top, 10);
    const x = -parseInt(document.body.style.left, 10);
    document.body.style.position = previousBodyPosition.position;
    document.body.style.top = previousBodyPosition.top;
    document.body.style.left = previousBodyPosition.left;
    window.scrollTo(x, y);
    previousBodyPosition = void 0;
  }
}, "restorePositionSetting");

var isTargetElementTotallyScrolled = /* @__PURE__ */__name(targetElement => targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false, "isTargetElementTotallyScrolled");

var handleScroll = /* @__PURE__ */__name((event, targetElement) => {
  const clientY = event.targetTouches[0].clientY - initialClientY;

  if (event.target && allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
}, "handleScroll");

var disableBodyScroll = /* @__PURE__ */__name((targetElement, options) => {
  if (!targetElement) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }

  if (locks.some(lock2 => lock2.targetElement === targetElement)) {
    return;
  }

  const lock = {
    targetElement,
    options: options || {},
    touchMoveAllowed: /* @__PURE__ */new WeakMap()
  };
  locks = [...locks, lock];

  if (isIosDevice()) {
    setPositionFixed();
  } else {
    setOverflowHidden(options);
  }

  if (isIosDevice()) {
    targetElement.ontouchstart = event => {
      if (event.targetTouches.length === 1) {
        initialClientY = event.targetTouches[0].clientY;
      }
    };

    targetElement.ontouchmove = event => {
      if (event.targetTouches.length === 1) {
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? {
        passive: false
      } : void 0);
      documentListenerAdded = true;
    }
  }
}, "disableBodyScroll");

var clearAllBodyScrollLocks = /* @__PURE__ */__name(() => {
  if (isIosDevice()) {
    locks.forEach(lock => {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });

    if (documentListenerAdded) {
      document.removeEventListener("touchmove", preventDefault);
      documentListenerAdded = false;
    }

    initialClientY = -1;
  }

  if (isIosDevice()) {
    restorePositionSetting();
  } else {
    restoreOverflowSetting();
  }

  locks = [];
}, "clearAllBodyScrollLocks");

var enableBodyScroll = /* @__PURE__ */__name(targetElement => {
  if (!targetElement) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }

  locks = locks.filter(lock => lock.targetElement !== targetElement);

  if (isIosDevice()) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener("touchmove", preventDefault);
      documentListenerAdded = false;
    }
  }

  if (locks.length === 0) {
    if (isIosDevice()) {
      restorePositionSetting();
    } else {
      restoreOverflowSetting();
    }
  }
}, "enableBodyScroll");

var bodyScrollLock = {
  disableBodyScroll,
  clearAllBodyScrollLocks,
  enableBodyScroll
};

function IdsExperimentOverride(_ref15) {
  let {
    children,
    featureFlag,
    variant
  } = _ref15;
  const idsConfig = useIdsConfig();
  const configValue = useMemo(() => __spreadProps(__spreadValues({}, idsConfig), {
    featureFlags: __spreadProps(__spreadValues({}, idsConfig.featureFlags), {
      [featureFlag]: variant
    })
  }), [idsConfig, featureFlag, variant]);
  return /* @__PURE__ */jsx(IdsConfigContext.Provider, {
    value: configValue,
    children
  });
}

__name(IdsExperimentOverride, "IdsExperimentOverride");

function mergeRefs() {
  for (var _len8 = arguments.length, refs = new Array(_len8), _key9 = 0; _key9 < _len8; _key9++) {
    refs[_key9] = arguments[_key9];
  }

  return value => {
    refs.forEach(ref => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}

__name(mergeRefs, "mergeRefs");

function useMergeRefs() {
  for (var _len9 = arguments.length, refs = new Array(_len9), _key10 = 0; _key10 < _len9; _key10++) {
    refs[_key10] = arguments[_key10];
  }

  return useMemo(() => mergeRefs(...refs), refs);
}

__name(useMergeRefs, "useMergeRefs");

function useIsPantryEnabled() {
  return useIdsFeatureFlag("pantry") === "variant";
}

__name(useIsPantryEnabled, "useIsPantryEnabled");

function objectEntries(obj) {
  return Object.entries(obj);
}

__name(objectEntries, "objectEntries");

function objectFromEntries(entries) {
  return Object.fromEntries(entries);
}

__name(objectFromEntries, "objectFromEntries");

var BREAKPOINTS = objectFromEntries(objectEntries(responsive_exports.breakpoints).map((_ref16) => {
  let [k, {
    min,
    max
  }] = _ref16;
  const minQuery = typeof min !== "undefined" ? `(min-width: ${min}px)` : "";
  const maxQuery = typeof max !== "undefined" ? `(max-width: ${max}px)` : "";
  return [k, `${minQuery}${minQuery && maxQuery ? " and " : ""}${maxQuery}`];
}));
var BREAKPOINT_PAIRS = objectEntries(BREAKPOINTS);
var BREAKPOINT_MEDIA_KEY_MAP = Object.fromEntries(BREAKPOINT_PAIRS.map((_ref17) => {
  let [k, v] = _ref17;
  return [v, k];
}));

function useBreakpoint() {
  const [match, setMatch] = useState(null);
  const ifMediaMatchSetMatch = useCallback(e => {
    if (e.matches) {
      setMatch(BREAKPOINT_MEDIA_KEY_MAP[e.media] || null);
    }
  }, []);
  useEffect(() => {
    const mediaQueryLists = BREAKPOINT_PAIRS.map((_ref18) => {
      let [, v] = _ref18;
      const mediaQueryList = window.matchMedia(v);
      mediaQueryList.addEventListener("change", ifMediaMatchSetMatch);
      return mediaQueryList;
    });
    mediaQueryLists.forEach(ifMediaMatchSetMatch);
    return () => {
      mediaQueryLists.forEach(mql => mql.removeEventListener("change", ifMediaMatchSetMatch));
    };
  }, [ifMediaMatchSetMatch]);
  return match;
}

__name(useBreakpoint, "useBreakpoint");

function useRequiredContext(context) {
  const contextValue = useContext(context);

  if (!contextValue) {
    throw new Error(`Context ${context.displayName} not provided`);
  }

  return contextValue;
}

__name(useRequiredContext, "useRequiredContext");

function removeDataAttributes(props) {
  const prefix = /^(data-.*)$/;
  const filteredProps = {};

  for (const prop in props) {
    if (!prefix.test(prop)) {
      filteredProps[prop] = props[prop];
    }
  }

  return filteredProps;
}

__name(removeDataAttributes, "removeDataAttributes");

var getResponsiveStyles = /* @__PURE__ */__name(responsive => {
  const responsiveStyles = {};
  Object.entries(responsive).forEach((_ref19) => {
    let [key, val] = _ref19;
    responsiveStyles[responsive_exports.up(key)] = val;
  });
  return responsiveStyles;
}, "getResponsiveStyles");

var Box = forwardRefWithAs( /* @__PURE__ */__name(function Box2(_a, ref) {
  var _b = _a,
      {
    alignSelf,
    as: Component = "div",
    bottom,
    display,
    gridColumnEnd,
    gridColumnStart,
    gridRowEnd,
    gridRowStart,
    flexBasis,
    flexGrow,
    flexShrink,
    height,
    left,
    margin,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    overflow,
    padding,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    position,
    responsive = {},
    right,
    top,
    width,
    zIndex
  } = _b,
      props = __objRest(_b, ["alignSelf", "as", "bottom", "display", "gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart", "flexBasis", "flexGrow", "flexShrink", "height", "left", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "maxHeight", "maxWidth", "minHeight", "minWidth", "overflow", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "position", "responsive", "right", "top", "width", "zIndex"]);

  const responsiveStyles = getResponsiveStyles(responsive);
  return /* @__PURE__ */jsx(Component, __spreadValues({
    ref,
    css: __spreadValues({
      alignSelf,
      bottom,
      display,
      gridColumnEnd,
      gridColumnStart,
      gridRowEnd,
      gridRowStart,
      flexBasis,
      flexGrow,
      flexShrink,
      height,
      left,
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      overflow,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
      position,
      right,
      top,
      width,
      zIndex
    }, responsiveStyles)
  }, props));
}, "Box"));
var mergeProps = $3ef42575df84b30b$export$9d1611c77c2fe928;
var DOMPropNames = /* @__PURE__ */new Set(["id", "role", "tabIndex"]);
var linkPropNames = /* @__PURE__ */new Set(["href", "hrefLang", "target", "rel", "download", "ping", "referrerPolicy"]);
var ariaPropNames = /* @__PURE__ */new Set(["aria-activedescendant", "aria-atomic", "aria-autocomplete", "aria-braillelabel", "aria-brailleroledescription", "aria-busy", "aria-checked", "aria-colcount", "aria-colindex", "aria-colindextext", "aria-colspan", "aria-controls", "aria-current", "aria-describedby", "aria-description", "aria-details", "aria-disabled", "aria-dropeffect", "aria-errormessage", "aria-expanded", "aria-flowto", "aria-grabbed", "aria-haspopup", "aria-hidden", "aria-invalid", "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-level", "aria-live", "aria-modal", "aria-multiline", "aria-multiselectable", "aria-orientation", "aria-owns", "aria-placeholder", "aria-posinset", "aria-pressed", "aria-readonly", "aria-relevant", "aria-required", "aria-roledescription", "aria-rowcount", "aria-rowindex", "aria-rowindextext", "aria-rowspan", "aria-selected", "aria-setsize", "aria-sort", "aria-valuemax", "aria-valuemin", "aria-valuenow", "aria-valuetext"]);
var propRe = /^(data-.*)$/;

function filterDOMProps(props) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    isLink,
    propNames
  } = opts;
  const filteredProps = {};

  for (const prop in props) {
    if (Object.prototype.hasOwnProperty.call(props, prop) && (DOMPropNames.has(prop) || ariaPropNames.has(prop) || isLink && linkPropNames.has(prop) || (propNames == null ? void 0 : propNames.has(prop)) || propRe.test(prop))) {
      const val = props[prop];
      filteredProps[prop] = val;
    }
  }

  return filteredProps;
}

__name(filterDOMProps, "filterDOMProps");

function useKeyboard(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: props.onKeyDown,
      onKeyUp: props.onKeyUp,
      onKeyPress: props.onKeyPress
    }
  };
}

__name(useKeyboard, "useKeyboard");

var FocusableContext = /*#__PURE__*/createContext(null);

function useFocusableContext(ref) {
  const context = useContext(FocusableContext) || {};
  $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref);

  let _a = context,
      otherProps = __objRest(_a, ["ref"]);

  return otherProps;
}

__name(useFocusableContext, "useFocusableContext");

/*#__PURE__*/
forwardRef( /* @__PURE__ */__name(function FocusableProvider2(props, ref) {
  const _a = props,
        {
    children
  } = _a,
        otherProps = __objRest(_a, ["children"]);

  const objRef = $df56164dff5785e2$export$4338b53315abf666(ref);

  const context = __spreadProps(__spreadValues({}, otherProps), {
    ref: objRef
  });

  return /* @__PURE__ */jsx(FocusableContext.Provider, {
    value: context,
    children
  });
}, "FocusableProvider"));

function useFocusable(props, domRef) {
  const {
    focusProps
  } = $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props);
  const {
    keyboardProps
  } = useKeyboard(props);
  const interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(focusProps, keyboardProps);
  const domProps = useFocusableContext(domRef);
  const interactionProps = props.isDisabled ? {} : domProps;
  const autoFocusRef = useRef(props.autoFocus);
  useEffect(() => {
    if (autoFocusRef.current && domRef.current) {
      $3ad3f6e1647bc98d$export$80f3e147d781571c(domRef.current);
    }

    autoFocusRef.current = false;
  }, [domRef]);
  let tabIndex = props.excludeFromTabOrder ? -1 : 0;

  if (props.isDisabled) {
    tabIndex = void 0;
  }

  return {
    focusableProps: $3ef42575df84b30b$export$9d1611c77c2fe928(__spreadProps(__spreadValues({}, interactions), {
      tabIndex
    }), interactionProps)
  };
}

__name(useFocusable, "useFocusable");

/*#__PURE__*/
forwardRef((_a, ref) => {
  var _b = _a,
      {
    children
  } = _b,
      props = __objRest(_b, ["children"]);

  ref = $df56164dff5785e2$export$4338b53315abf666(ref);
  const {
    focusableProps
  } = useFocusable(props, ref);
  const child = Children.only(children);
  useEffect(() => {
    const el = ref.current;

    if (!el || !(el instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(el).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }

    if (!props.isDisabled && !$b4b717babfbb907b$export$4c063cf1350e6fed(el)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }

    if (el.localName !== "button" && el.localName !== "input" && el.localName !== "select" && el.localName !== "textarea" && el.localName !== "a" && el.localName !== "area" && el.localName !== "summary" && el.localName !== "img" && el.localName !== "svg") {
      const role = el.getAttribute("role");

      if (!role) {
        console.warn("<Focusable> child must have an interactive ARIA role.");
      } else if ( // https://w3c.github.io/aria/#widget_roles
      role !== "application" && role !== "button" && role !== "checkbox" && role !== "combobox" && role !== "gridcell" && role !== "link" && role !== "menuitem" && role !== "menuitemcheckbox" && role !== "menuitemradio" && role !== "option" && role !== "radio" && role !== "searchbox" && role !== "separator" && role !== "slider" && role !== "spinbutton" && role !== "switch" && role !== "tab" && role !== "tabpanel" && role !== "textbox" && role !== "treeitem" && // aria-describedby is also announced on these roles
      role !== "img" && role !== "meter" && role !== "progressbar") {
        console.warn(`<Focusable> child must have an interactive ARIA role. Got "${role}".`);
      }
    }
  }, [ref, props.isDisabled]);
  const childRef = child.ref;
  return /*#__PURE__*/cloneElement(child, __spreadProps(__spreadValues({}, $3ef42575df84b30b$export$9d1611c77c2fe928(focusableProps, child.props)), {
    // @ts-expect-error - Fix this type issue at some point
    ref: $5dc95899b306f630$export$c9058316764c140e(childRef, ref)
  }));
});

function useButton(props, ref) {
  let useLegacyButtonBehavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const {
    elementType = "button",
    isDisabled,
    onPress,
    onPressStart,
    onPressEnd,
    onPressUp,
    onPressChange,
    preventFocusOnPress,
    // @ts-ignore - undocumented
    allowFocusWhenDisabled,
    // @ts-ignore
    onClick: deprecatedOnClick,
    href,
    target,
    rel,
    type = useLegacyButtonBehavior ? "submit" : "button"
  } = props;
  let additionalProps;

  if (elementType === "button") {
    additionalProps = {
      type,
      disabled: isDisabled
    };
  } else {
    additionalProps = {
      role: "button",
      href: elementType === "a" && !isDisabled ? href : void 0,
      target: elementType === "a" ? target : void 0,
      type: elementType === "input" ? type : void 0,
      disabled: elementType === "input" ? isDisabled : void 0,
      "aria-disabled": !isDisabled || elementType === "input" ? void 0 : isDisabled,
      rel: elementType === "a" ? rel : void 0
    };
  }

  const {
    pressProps,
    isPressed
  } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    onPressUp,
    isDisabled,
    preventFocusOnPress,
    ref
  });
  const {
    focusableProps
  } = useFocusable(props, ref);

  if (allowFocusWhenDisabled) {
    focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  }

  const buttonProps = mergeProps(focusableProps, useLegacyButtonBehavior ? {} : pressProps, filterDOMProps(props));
  return {
    isPressed,
    // Used to indicate press state for visual
    buttonProps: mergeProps(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      onClick: /* @__PURE__ */__name(e => {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
        }
      }, "onClick")
    })
  };
}

__name(useButton, "useButton");

function hasOnPressHandlers(props) {
  return props.onPress || props.onPressStart || props.onPressEnd || props.onPressUp || props.onPressChange;
}

__name(hasOnPressHandlers, "hasOnPressHandlers");

var useHover = $6179b936705e76d3$export$ae780daf29e6d456;
var DataAttributesMapping = {
  isSelected: "data-selected",
  isFocused: "data-focused",
  isHovered: "data-hovered",
  isPressed: "data-pressed",
  isFocusVisible: "data-focus-visible",
  disabled: "data-disabled",
  loading: "data-loading",
  current: "data-current",
  fullWidth: "data-full-width",
  isIndeterminate: "data-indeterminate",
  isRequired: "data-required",
  isReadOnly: "data-readonly",
  isInvalid: "data-invalid"
};

function mapDataAttributes(pseudoStates) {
  const dataAttributes = {};

  for (const [key, value] of Object.entries(pseudoStates)) {
    if (value === true) {
      const dataAttribute = DataAttributesMapping[key];
      dataAttributes[dataAttribute] = "true";
    }
  }

  return dataAttributes;
}

__name(mapDataAttributes, "mapDataAttributes");

var STYLES = {
  button: {
    // Button CSS Reset
    all: "unset",
    boxSizing: "border-box",
    touchAction: "manipulation",
    cursor: "pointer",
    display: "inline-block",
    // Button Core Styles
    position: "relative",
    textAlign: "center",
    userSelect: "none",
    // For legacy support for `onClick` handling. onPress handles this.
    "&[hidden]": {
      display: "none"
    }
  },
  content: {
    '[data-loading="true"] > &': {
      visibility: "hidden"
    }
  },
  loading: {
    cursor: "default"
  },
  loadingAnimation: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    userSelect: "none",
    width: "100%"
  },
  hover: {},
  active: {},
  disabled: {
    cursor: "default"
  },
  focusRing: {}
};
var additionalButtonHTMLAttributes = /* @__PURE__ */new Set(["form", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "name", "value", "hidden"]);
var ButtonCore = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ButtonCore2(props, ref) {
  const buttonRef = useRef(null);
  const finalRef = useMergeRefs(ref, buttonRef);
  const {
    isHovered,
    hoverProps
  } = useHover(__spreadProps(__spreadValues({}, props), {
    isDisabled: props.disabled || props.loading
  }));

  const _a = props,
        {
    disabled,
    loading,
    styles: styleOverrides,
    onPress,
    loadingAnimation,
    children,
    fullWidth,
    loadingAccessibleLabel
  } = _a,
        domProps = __objRest(_a, ["disabled", "loading", "styles", "onPress", "loadingAnimation", "children", "fullWidth", "loadingAccessibleLabel"]);

  const ElementType = "button";

  const interactionHookProps = __spreadProps(__spreadValues({}, domProps), {
    // We prefer using `disabled` prop instead of custom `isDisabled` prop
    isDisabled: disabled
  });

  const hasNoPressHandlers = !hasOnPressHandlers(props);

  if (props.onClick && !hasNoPressHandlers) {
    throw new Error("ButtonCore cannot have both onClick and onPress handling. Please use onPress if possible or onClick for legacy support.");
  }

  if (props.onMouseUp && !hasNoPressHandlers) {
    throw new Error("ButtonCore cannot have both onMouseUp and onPress handling. Please use onPressUp if possible or onClick + onMouseUp for legacy support.");
  }

  const useLegacyButtonBehavior = hasNoPressHandlers;
  const {
    buttonProps,
    isPressed
  } = useButton(__spreadValues({
    elementType: ElementType,
    onPress: loading ? void 0 : onPress
  }, interactionHookProps), buttonRef, useLegacyButtonBehavior);
  const {
    isFocusVisible,
    focusProps,
    ringStylesOnly
  } = useFocusRing(buttonProps);
  const backwardsCompatibilityProps = {
    onMouseEnter: props.onMouseEnter,
    onMouseOver: props.onMouseOver,
    onMouseMove: props.onMouseMove,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    onMouseOut: props.onMouseOut,
    onDoubleClick: props.onDoubleClick,
    onMouseLeave: props.onMouseLeave
  };
  const combinedProps = mergeProps(backwardsCompatibilityProps, hoverProps, buttonProps, focusProps);
  const tabIndex = props.tabIndex !== void 0 ? props.tabIndex : buttonProps.tabIndex;
  const combinedStyles = combineStyles(STYLES, styleOverrides);
  const filteredDOMProps = filterDOMProps(props, {
    propNames: additionalButtonHTMLAttributes,
    isLink: false
  });
  const styleProps = {
    className: props.className,
    style: useLegacyButtonBehavior ? props.style : __spreadProps(__spreadValues({}, props.style), {
      // When using onPress, don't allow overriding touchAction due to https://github.com/adobe/react-spectrum/issues/7993
      touchAction: ON_PRESS_TOUCH_ACTION
    })
  };
  return /* @__PURE__ */jsxs("button", __spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
    ref: finalRef
  }, filteredDOMProps), combinedProps), styleProps), {
    tabIndex,
    css: [combinedStyles.button, // When using onPress, cascade touch-action style to children
    !useLegacyButtonBehavior ? {
      "& *": {
        touchAction: ON_PRESS_TOUCH_ACTION
      }
    } : {}, fullWidth && {
      width: "100%"
    }, {
      '&[data-focus-visible="true"]::after': [ringStylesOnly, combinedStyles.focusRing],
      '&[data-loading="true"]': combinedStyles.loading
    }, !loading && {
      '&[data-hovered="true"]': combinedStyles.hover,
      [useLegacyButtonBehavior ? "&:active" : '&[data-pressed="true"]']: combinedStyles.active
    }, {
      '&[data-disabled="true"]': combinedStyles.disabled
    }]
  }), mapDataAttributes({
    isHovered,
    isFocusVisible,
    disabled,
    isPressed,
    fullWidth,
    loading
  })), loading && {
    "aria-disabled": true,
    "aria-label": loadingAccessibleLabel != null ? loadingAccessibleLabel : domProps["aria-label"],
    onClick: void 0
  }), {
    children: [/* @__PURE__ */jsx("span", {
      css: combinedStyles.content,
      children
    }), loading && /* @__PURE__ */jsx("span", {
      "aria-hidden": true,
      css: combinedStyles.loadingAnimation,
      children: loadingAnimation
    })]
  }));
}, "ButtonCore"));
var $64fa3d84918910a7$export$c62b8e45d58ddad9 = Symbol("default");

function $64fa3d84918910a7$export$2881499e37b75b9a(_ref20) {
  let {
    values,
    children
  } = _ref20;

  for (let [Context2, value] of values) children = /* @__PURE__ */React__default.createElement(Context2.Provider, {
    value
  }, children);

  return children;
}

__name($64fa3d84918910a7$export$2881499e37b75b9a, "$64fa3d84918910a7$export$2881499e37b75b9a");

function $64fa3d84918910a7$export$fabf2dc03a41866e(context, slot) {
  let ctx = useContext(context);
  if (slot === null) return null;

  if (ctx && typeof ctx === "object" && "slots" in ctx && ctx.slots) {
    let slotKey = slot || $64fa3d84918910a7$export$c62b8e45d58ddad9;

    if (!ctx.slots[slotKey]) {
      let availableSlots = new Intl.ListFormat().format(Object.keys(ctx.slots).map(p => `"${p}"`));
      let errorMessage = slot ? `Invalid slot "${slot}".` : "A slot prop is required.";
      throw new Error(`${errorMessage} Valid slot names are ${availableSlots}.`);
    }

    return ctx.slots[slotKey];
  }

  return ctx;
}

__name($64fa3d84918910a7$export$fabf2dc03a41866e, "$64fa3d84918910a7$export$fabf2dc03a41866e");

function $64fa3d84918910a7$export$29f1550f4b0d4415(props, ref, context) {
  let ctx = $64fa3d84918910a7$export$fabf2dc03a41866e(context, props.slot) || {};

  let _a = ctx,
      {
    ref: contextRef
  } = _a,
      contextProps = __objRest(_a, ["ref"]);

  let mergedRef = $df56164dff5785e2$export$4338b53315abf666(useMemo(() => $5dc95899b306f630$export$c9058316764c140e(ref, contextRef), [ref, contextRef]));
  let mergedProps = $3ef42575df84b30b$export$9d1611c77c2fe928(contextProps, props);

  if ("style" in contextProps && contextProps.style && "style" in props && props.style) {
    if (typeof contextProps.style === "function" || typeof props.style === "function") mergedProps.style = renderProps => {
      let contextStyle = typeof contextProps.style === "function" ? contextProps.style(renderProps) : contextProps.style;

      let defaultStyle = __spreadValues(__spreadValues({}, renderProps.defaultStyle), contextStyle);

      let style = typeof props.style === "function" ? props.style(__spreadProps(__spreadValues({}, renderProps), {
        defaultStyle
      })) : props.style;
      return __spreadValues(__spreadValues({}, defaultStyle), style);
    };else mergedProps.style = __spreadValues(__spreadValues({}, contextProps.style), props.style);
  }

  return [mergedProps, mergedRef];
}

__name($64fa3d84918910a7$export$29f1550f4b0d4415, "$64fa3d84918910a7$export$29f1550f4b0d4415");

var $ee014567cb39d3f0$export$ff05c3ac10437e03 = /* @__PURE__ */createContext(null);

function $587d3ad58be6d31f$export$daff6da51032a415() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let [selectedValues, setValue] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue || [], props.onChange);
  let isRequired = !!props.isRequired && selectedValues.length === 0;
  let invalidValues = useRef( /* @__PURE__ */new Map());
  let validation = $e5be200c675c3b3a$export$fc1a364ae1f3ff10(__spreadProps(__spreadValues({}, props), {
    value: selectedValues
  }));
  let isInvalid = validation.displayValidation.isInvalid;

  var _props_validationState;

  const state = __spreadProps(__spreadValues({}, validation), {
    value: selectedValues,

    setValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      setValue(value);
    },

    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,

    isSelected(value) {
      return selectedValues.includes(value);
    },

    addValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (!selectedValues.includes(value)) setValue(selectedValues.concat(value));
    },

    removeValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) setValue(selectedValues.filter(existingValue => existingValue !== value));
    },

    toggleValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) setValue(selectedValues.filter(existingValue => existingValue !== value));else setValue(selectedValues.concat(value));
    },

    setInvalid(value, v) {
      let s = new Map(invalidValues.current);
      if (v.isInvalid) s.set(value, v);else s.delete(value);
      invalidValues.current = s;
      validation.updateValidation($e5be200c675c3b3a$export$75ee7c75d68f5b0e(...s.values()));
    },

    validationState: (_props_validationState = props.validationState) !== null && _props_validationState !== void 0 ? _props_validationState : isInvalid ? "invalid" : null,
    isInvalid,
    isRequired
  });

  return state;
}

__name($587d3ad58be6d31f$export$daff6da51032a415, "$587d3ad58be6d31f$export$daff6da51032a415");

var $a54cdc5c1942b639$var$instance = Math.round(Math.random() * 1e10);
var $a54cdc5c1942b639$var$i = 0;

function $a54cdc5c1942b639$export$bca9d026f8e704eb(props) {
  let name = useMemo(() => props.name || `radio-group-${$a54cdc5c1942b639$var$instance}-${++$a54cdc5c1942b639$var$i}`, [props.name]);

  var _props_defaultValue;

  let [selectedValue, setSelected] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
  let [lastFocusedValue, setLastFocusedValue] = useState(null);
  let validation = $e5be200c675c3b3a$export$fc1a364ae1f3ff10(__spreadProps(__spreadValues({}, props), {
    value: selectedValue
  }));

  let setSelectedValue = /* @__PURE__ */__name(value => {
    if (!props.isReadOnly && !props.isDisabled) {
      setSelected(value);
      validation.commitValidation();
    }
  }, "setSelectedValue");

  let isInvalid = validation.displayValidation.isInvalid;
  return __spreadProps(__spreadValues({}, validation), {
    name,
    selectedValue,
    setSelectedValue,
    lastFocusedValue,
    setLastFocusedValue,
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isRequired: props.isRequired || false,
    validationState: props.validationState || (isInvalid ? "invalid" : null),
    isInvalid
  });
}

__name($a54cdc5c1942b639$export$bca9d026f8e704eb, "$a54cdc5c1942b639$export$bca9d026f8e704eb");

var $d3e0e05bdfcf66bd$export$c24727297075ec6a = /* @__PURE__ */createContext(null);
var CompositionProvider = $64fa3d84918910a7$export$2881499e37b75b9a;
var useSlottedContext = $64fa3d84918910a7$export$fabf2dc03a41866e;
var useContextProps = $64fa3d84918910a7$export$29f1550f4b0d4415;

function useSlot() {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const [hasSlot, setHasSlot] = useState(initialState);
  const hasRun = useRef(false);
  const ref = useCallback(el => {
    hasRun.current = true;
    setHasSlot(!!el);
  }, []);
  useLayoutEffect(() => {
    if (!hasRun.current) {
      setHasSlot(false);
    }
  }, []);
  return [ref, hasSlot];
}

__name(useSlot, "useSlot");

function useRenderProps(props) {
  const {
    className,
    style,
    children,
    defaultClassName = void 0,
    defaultChildren = void 0,
    defaultStyle,
    values
  } = props;
  return useMemo(() => {
    let computedClassName;
    let computedStyle;
    let computedChildren;

    if (typeof className === "function") {
      computedClassName = className(__spreadProps(__spreadValues({}, values), {
        defaultClassName
      }));
    } else {
      computedClassName = className;
    }

    if (typeof style === "function") {
      computedStyle = style(__spreadProps(__spreadValues({}, values), {
        defaultStyle: defaultStyle || {}
      }));
    } else {
      computedStyle = style;
    }

    if (typeof children === "function") {
      computedChildren = children(__spreadProps(__spreadValues({}, values), {
        defaultChildren
      }));
    } else if (children == null) {
      computedChildren = defaultChildren;
    } else {
      computedChildren = children;
    }

    return {
      className: computedClassName != null ? computedClassName : defaultClassName,
      style: computedStyle || defaultStyle ? __spreadValues(__spreadValues({}, defaultStyle), computedStyle) : void 0,
      children: computedChildren != null ? computedChildren : defaultChildren
    };
  }, [className, style, children, defaultClassName, defaultChildren, defaultStyle, values]);
}

__name(useRenderProps, "useRenderProps");

var VisuallyHidden = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function VisuallyHidden2(props, ref) {
  return /* @__PURE__ */jsx("span", __spreadProps(__spreadValues({
    style: A11Y.visuallyHidden
  }, props), {
    ref
  }));
}, "VisuallyHidden"));
VisuallyHidden.displayName = "VisuallyHidden";

var getStyles = /* @__PURE__ */__name((darkColor, lightColor, _ref21) => {
  let {
    borderRadiusOfComponent,
    contrastBorder,
    inverseColorPalette,
    offsetOverride
  } = _ref21;
  const normalizedOffset = offsetOverride === "0" ? "0px" : offsetOverride;
  const offset = {
    innerRing: `calc(${normalizedOffset || "4px"} * -1)`,
    outerRing: `calc(${normalizedOffset && `(2px + ${normalizedOffset})` || "6px"} * -1)`
  };
  const borderRadius = borderRadiusOfComponent ? `calc(${borderRadiusOfComponent} + ${normalizedOffset || "4px"})` : void 0;
  return __spreadValues({
    position: "relative",
    "&:focus": {
      outline: "none"
    },
    "&.focus-visible::after": {
      border: `2px solid ${inverseColorPalette && !contrastBorder || !inverseColorPalette && contrastBorder ? lightColor : darkColor}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: offset.innerRing,
      bottom: offset.innerRing,
      left: offset.innerRing,
      right: offset.innerRing,
      borderRadius
    }
  }, contrastBorder && {
    "&.focus-visible::before": {
      border: `2px solid ${inverseColorPalette ? lightColor : darkColor}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: offset.outerRing,
      bottom: offset.outerRing,
      left: offset.outerRing,
      right: offset.outerRing,
      borderRadius
    }
  });
}, "getStyles");

function FocusRing(_ref22) {
  let {
    borderRadiusOfComponent,
    children,
    contrastBorder,
    inverseColorPalette,
    offsetOverride
  } = _ref22;
  const child = Children.only(children);
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme.colors.systemGrayscale80, theme.colors.systemGrayscale00, {
    borderRadiusOfComponent,
    contrastBorder,
    inverseColorPalette,
    offsetOverride
  }), [borderRadiusOfComponent, contrastBorder, inverseColorPalette, offsetOverride, theme.colors.systemGrayscale00, theme.colors.systemGrayscale80]);
  return /* @__PURE__ */jsx(ClassNames, {
    children: (_ref23) => {
      let {
        css,
        cx
      } = _ref23;
      return /*#__PURE__*/cloneElement(child, {
        className: cx(css(styles), child.props.className)
      });
    }
  });
}

__name(FocusRing, "FocusRing");

function useFocusRing() {
  let {
    autoFocus,
    borderRadiusOfComponent,
    contrastBorder,
    inverseColorPalette,
    isTextInput,
    offsetOverride
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    focusProps,
    isFocused,
    isFocusVisible
  } = $f7dceffc5ad7768b$export$4e328f61c538687f({
    autoFocus,
    isTextInput,
    within: true
  });
  const {
    isWebView
  } = useIdsConfig();
  const theme = useTheme();
  const result = useMemo(() => {
    const offset = {
      innerRing: `calc(${offsetOverride === "0" ? "0px" : offsetOverride || "4px"} * -1)`,
      outerRing: `calc(${offsetOverride === "0" ? "2px" : offsetOverride && `(2px + ${offsetOverride})` || "6px"} * -1)`
    };
    const borderRadius = borderRadiusOfComponent ? `calc(${borderRadiusOfComponent} + ${offsetOverride || "4px"})` : void 0;
    const ringStylesOnly = {
      border: `2px solid ${inverseColorPalette && !contrastBorder || !inverseColorPalette && contrastBorder ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale80}`,
      content: '""',
      display: "block",
      position: "absolute",
      top: offset.innerRing,
      bottom: offset.innerRing,
      left: offset.innerRing,
      right: offset.innerRing,
      borderRadius
    };

    const allFocusRingCss = __spreadValues({
      position: "relative",
      "&:focus": {
        outline: "none"
      },
      "&.focus-visible::after": __spreadValues({}, ringStylesOnly)
    }, contrastBorder && {
      "&.focus-visible::before": {
        border: `2px solid ${inverseColorPalette ? theme.colors.systemGrayscale00 : theme.colors.systemGrayscale80}`,
        content: '""',
        display: "block",
        position: "absolute",
        top: offset.outerRing,
        bottom: offset.outerRing,
        left: offset.outerRing,
        right: offset.outerRing,
        borderRadius
      }
    });

    return {
      allFocusRingCss,
      ringStylesOnly
    };
  }, [borderRadiusOfComponent, contrastBorder, inverseColorPalette, offsetOverride, theme.colors.systemGrayscale00, theme.colors.systemGrayscale80]);
  const isFocusVisibleWebviewFix = isWebView ? false : isFocusVisible;
  return __spreadValues({
    focusProps,
    isFocused,
    isFocusVisible: isFocusVisibleWebviewFix
  }, result);
}

__name(useFocusRing, "useFocusRing");

var useCheckboxGroupItem = $fba3e38d5ca8983f$export$353b32fc6898d37d;
var useCheckbox = $406796ff087fe49b$export$e375f10ce42261c5;
var useToggleState = $3017fa7ffdddec74$export$8042c6c013fd5226;
var useCheckboxGroupState = $587d3ad58be6d31f$export$daff6da51032a415;
var useCheckboxGroup = $1e9fce0cfacc738b$export$49ff6f28c54f1cbe;
var TextContext = /*#__PURE__*/createContext({});
var TextCore = /*#__PURE__*/forwardRef((p, r2) => {
  const [_a, ..._b] = useContextProps(p, r2, TextContext),
        _c = _a,
        {
    children
  } = _c,
        props = __objRest(_c, ["children"]),
        [ref] = _b;

  const _d = props,
        {
    elementType: Element2 = "span",
    className,
    style
  } = _d,
        rest = __objRest(_d, ["elementType", "className", "style"]);

  return (// @ts-expect-error - To resolve this would double the typchecking impact of
    // our polymorphic Text components in Customers/TDS. Since this component is
    // rarely used directly, we'd prefer to skip type checking for the ref here to
    // double perf.

    /* @__PURE__ */
    jsx(Element2, __spreadProps(__spreadValues({
      className,
      style,
      ref
    }, rest), {
      children
    }))
  );
});
var LabelContext = /*#__PURE__*/createContext({});
var LabelCore = /*#__PURE__*/forwardRef((p, r2) => {
  const [props, ref] = useContextProps(p, r2, LabelContext);

  const _a = props,
        {
    className,
    style,
    children,
    elementType
  } = _a,
        rest = __objRest(_a, ["className", "style", "children", "elementType"]);

  const Element2 = elementType || "label";
  return /* @__PURE__ */jsx(Element2, __spreadProps(__spreadValues({
    className,
    style,
    ref
  }, rest), {
    children
  }));
});
var FieldErrorContext = $ee014567cb39d3f0$export$ff05c3ac10437e03;
var FormContext = $d3e0e05bdfcf66bd$export$c24727297075ec6a;
var VALIDATION_BEHAVIOR_NATIVE = "native";
var DESCRIPTION_SLOT = "description";
var ERROR_MESSAGE_SLOT = "errorMessage";
var CheckboxGroupContext = /*#__PURE__*/createContext(null);
var CheckboxGroupStateContext = /*#__PURE__*/createContext(null);
var CheckboxGroupCore = /*#__PURE__*/forwardRef((p, r2) => {
  var _b;

  const [props, ref] = useContextProps(p, r2, CheckboxGroupContext);
  const state = useCheckboxGroupState(__spreadProps(__spreadValues({}, props), {
    validationBehavior: VALIDATION_BEHAVIOR_NATIVE
  }));
  const [labelRef, label] = useSlot(!props["aria-label"] && !props["aria-labelledby"]);

  const _a = useCheckboxGroup(__spreadProps(__spreadValues({}, props), {
    label,
    validationBehavior: VALIDATION_BEHAVIOR_NATIVE
  }), state),
        {
    groupProps,
    labelProps,
    descriptionProps,
    errorMessageProps
  } = _a,
        validation = __objRest(_a, ["groupProps", "labelProps", "descriptionProps", "errorMessageProps"]);

  const renderProps = useRenderProps(__spreadProps(__spreadValues({}, props), {
    values: {
      isDisabled: state.isDisabled,
      isReadOnly: state.isReadOnly,
      isRequired: props.isRequired || false,
      isInvalid: state.isInvalid,
      state
    },
    defaultClassName: "react-aria-CheckboxGroup"
  }));
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues({}, groupProps), renderProps), {
    ref,
    slot: props.slot || void 0
  }), mapDataAttributes({
    disabled: state.isDisabled,
    isReadOnly: state.isReadOnly,
    isRequired: props.isRequired || false,
    isInvalid: state.isInvalid
  })), {
    children: /* @__PURE__ */jsx(CompositionProvider, {
      values: [[CheckboxGroupStateContext, state], [LabelContext, __spreadProps(__spreadValues({}, labelProps), {
        ref: labelRef,
        elementType: "span"
      })], [TextContext, {
        slots: {
          [DESCRIPTION_SLOT]: descriptionProps,
          [ERROR_MESSAGE_SLOT]: __spreadProps(__spreadValues({}, errorMessageProps), {
            children: (_b = props.invalidText) != null ? _b : validation.validationErrors.length === 0 ? void 0 : validation.validationErrors.join(" ")
          })
        }
      }], [FieldErrorContext, validation] // For future-proofing. We are only supporting native validation for now.
      ],
      children: renderProps.children
    })
  }));
});
var slots = {
  [DESCRIPTION_SLOT]: DESCRIPTION_SLOT,
  [ERROR_MESSAGE_SLOT]: ERROR_MESSAGE_SLOT
};
var CheckboxGroupCoreWithSlots = CheckboxGroupCore;
CheckboxGroupCoreWithSlots.slots = slots;

function filterEventHandlers(props) {
  const filteredProps = {};

  for (const prop in props) {
    if (typeof props[prop] === "function" && // This is a lot faster than a regex.
    prop[0] === "o" && prop[1] === "n" && prop.charCodeAt(2) >=
    /* 'A' */
    65 && prop.charCodeAt(2) <=
    /* 'Z' */
    90) {
      continue;
    }

    const val = props[prop];
    filteredProps[prop] = val;
  }

  return filteredProps;
}

__name(filterEventHandlers, "filterEventHandlers");

var STYLES2 = {
  wrapper: {
    cursor: "pointer",
    boxSizing: "border-box",
    position: "relative",
    '&[data-disabled="true"]': {
      cursor: "default"
    },
    '&[data-readonly="true"]': {
      cursor: "default"
    }
  }
};
var CheckboxContext = /*#__PURE__*/createContext(null);
var CheckboxCore = /*#__PURE__*/forwardRef((p, r2) => {
  const [props, inputRef] = useContextProps(p, r2, CheckboxContext);
  let {
    validationBehavior
  } = useSlottedContext(FormContext) || {};
  validationBehavior = VALIDATION_BEHAVIOR_NATIVE;
  const groupState = useContext(CheckboxGroupStateContext);
  const WILL_NOT_CHANGE_isInGroup = !!groupState;
  const value = props.value;
  const {
    labelProps,
    inputProps,
    isSelected,
    isDisabled,
    isReadOnly,
    isPressed,
    isInvalid
  } = WILL_NOT_CHANGE_isInGroup ? // eslint-disable-next-line react-hooks/rules-of-hooks
  useCheckboxGroupItem(__spreadProps(__spreadValues({}, removeDataAttributes(props)), {
    value,
    // ReactNode type doesn't allow function children.
    children: typeof props.children === "function" ? true : props.children
  }), groupState, inputRef) : // eslint-disable-next-line react-hooks/rules-of-hooks
  useCheckbox(__spreadProps(__spreadValues({}, removeDataAttributes(props)), {
    children: typeof props.children === "function" ? true : props.children,
    validationBehavior
  }), // eslint-disable-next-line react-hooks/rules-of-hooks
  useToggleState(props), inputRef);
  const {
    isFocused,
    isFocusVisible,
    focusProps,
    ringStylesOnly
  } = useFocusRing(props);
  const isInteractionDisabled = isDisabled || isReadOnly;
  const {
    hoverProps,
    isHovered
  } = useHover(__spreadProps(__spreadValues({}, props), {
    isDisabled: isInteractionDisabled
  }));

  const _a = filterEventHandlers(props),
        {
    id,
    styles,
    isIndeterminate,
    isRequired,
    isInvalid: _isInvalid,
    isSelected: _isSelected,
    defaultSelected: _defaultSelected,
    isReadOnly: _isReadOnly,
    isDisabled: _isDisabled,
    validate: _validate,
    style
  } = _a,
        domProps = __objRest(_a, ["id", "styles", "isIndeterminate", "isRequired", "isInvalid", "isSelected", "defaultSelected", "isReadOnly", "isDisabled", "validate", "style"]);

  const renderProps = useRenderProps(__spreadProps(__spreadValues({}, props), {
    values: {
      isSelected,
      isIndeterminate: isIndeterminate || false,
      isPressed,
      isHovered,
      isFocused,
      isFocusVisible,
      isDisabled,
      isReadOnly,
      isInvalid,
      isRequired: isRequired || false
    }
  }));
  const combinedStyles = combineStyles(STYLES2, styles);
  return /* @__PURE__ */jsxs("label", __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, mergeProps(domProps, labelProps, hoverProps, renderProps)), {
    ref: props.labelRef,
    slot: props.slot || void 0,
    style: __spreadProps(__spreadValues({}, style), {
      // When using onPress, don't allow overriding touchAction due to https://github.com/adobe/react-spectrum/issues/7993
      touchAction: ON_PRESS_TOUCH_ACTION
    })
  }), mapDataAttributes({
    isSelected,
    isIndeterminate,
    isPressed,
    isHovered,
    isFocused,
    isFocusVisible,
    disabled: isDisabled,
    isReadOnly,
    isInvalid,
    isRequired
  })), {
    css: [combinedStyles.wrapper, {
      '&[data-focus-visible="true"]::after': ringStylesOnly
    }],
    children: [/* @__PURE__ */jsx(VisuallyHidden, {
      children: /* @__PURE__ */jsx("input", __spreadProps(__spreadValues({}, mergeProps(inputProps, focusProps)), {
        ref: inputRef
      }))
    }), renderProps.children]
  }));
});
var Flex = forwardRefWithAs( /* @__PURE__ */__name(function Flex2(_a, ref) {
  var _b = _a,
      {
    alignContent,
    alignItems,
    flexDirection,
    flexWrap,
    gap,
    justifyContent
  } = _b,
      props = __objRest(_b, ["alignContent", "alignItems", "flexDirection", "flexWrap", "gap", "justifyContent"]);

  return /* @__PURE__ */jsx(Box, __spreadProps(__spreadValues({
    css: {
      alignContent,
      alignItems,
      flexDirection,
      flexWrap,
      justifyContent,
      gap
    },
    ref
  }, props), {
    display: "flex"
  }));
}, "Flex"));
var Grid = forwardRefWithAs( /* @__PURE__ */__name(function Grid2(_a, ref) {
  var _b = _a,
      {
    gap,
    gridTemplateAreas,
    gridTemplateColumns,
    gridTemplateRows,
    gridAutoRows,
    gridAutoColumns,
    gridAutoFlow
  } = _b,
      props = __objRest(_b, ["gap", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows", "gridAutoRows", "gridAutoColumns", "gridAutoFlow"]);

  return /* @__PURE__ */jsx(Box, __spreadProps(__spreadValues({
    css: {
      gap,
      gridTemplateAreas,
      gridTemplateColumns,
      gridTemplateRows,
      gridAutoRows,
      gridAutoColumns,
      gridAutoFlow
    },
    ref
  }, props), {
    display: "grid"
  }));
}, "Grid"));
var InputContext = /*#__PURE__*/createContext({});
var InputCore = /*#__PURE__*/forwardRef((p, r2) => {
  const [props, ref] = useContextProps(p, r2, InputContext);
  const {
    focusProps,
    isFocused,
    isFocusVisible
  } = useFocusRing(__spreadProps(__spreadValues({}, props), {
    isTextInput: true
  }));
  const {
    hoverProps,
    isHovered
  } = useHover(__spreadProps(__spreadValues({}, props), {
    isDisabled: props.disabled
  }));
  const mergedProps = mergeProps(props, focusProps, hoverProps);
  return /* @__PURE__ */jsx("input", __spreadValues(__spreadValues({
    ref
  }, mergedProps), mapDataAttributes({
    isFocused,
    isHovered,
    isFocusVisible,
    disabled: props.disabled
  })));
});
var useLink = $298d61e98472621b$export$dcf14c9974fe2767;
var allowPropagation = {
  onPressStart: /* @__PURE__ */__name(e => {
    e.continuePropagation();
  }, "onPressStart"),
  onPressEnd: /* @__PURE__ */__name(e => {
    e.continuePropagation();
  }, "onPressEnd"),
  onPressUp: /* @__PURE__ */__name(e => {
    e.continuePropagation();
  }, "onPressUp"),
  onPress: /* @__PURE__ */__name(e => {
    e.continuePropagation();
  }, "onPress")
};

function handleLegacyEventPropagation(useLegacyEventPropagation, props) {
  if (!useLegacyEventPropagation) {
    return props;
  }

  return $3ef42575df84b30b$export$9d1611c77c2fe928(props, allowPropagation);
}

__name(handleLegacyEventPropagation, "handleLegacyEventPropagation");

var LinkContext = /*#__PURE__*/createContext({});
var STYLES3 = {
  link: {
    cursor: "pointer",
    position: "relative",
    boxSizing: "border-box",
    color: "unset",
    textDecoration: "unset"
  },
  focusRing: {
    outline: "none"
  },
  hover: {},
  active: {},
  disabled: {
    cursor: "default"
  }
};
var LinkCore = /*#__PURE__*/forwardRef((p, r2) => {
  const [_a, ..._b] = useContextProps(p, r2, LinkContext),
        _c = _a,
        {
    useLegacyEventPropagation
  } = _c,
        props = __objRest(_c, ["useLegacyEventPropagation"]),
        [ref] = _b;

  const ElementType = props.href && !props.disabled ? "a" : "span";
  const {
    linkProps,
    isPressed
  } = useLink(handleLegacyEventPropagation(!!useLegacyEventPropagation, __spreadProps(__spreadValues({}, props), {
    elementType: ElementType,
    isDisabled: props.disabled
  })), ref);
  const {
    hoverProps,
    isHovered
  } = useHover(props);
  const {
    focusProps,
    isFocused,
    isFocusVisible,
    ringStylesOnly
  } = useFocusRing(props);
  const combinedProps = mergeProps(linkProps, hoverProps, focusProps);
  const combinedStyles = combineStyles(STYLES3, props.styles);
  const styleProps = {
    className: props.className,
    style: props.style
  };

  if (hasOnPressHandlers(props) && props.onClick) {
    throw new Error("LinkCore cannot have both onClick and onPress handling. Please use onPress if possible or onClick for legacy support.");
  }

  return /* @__PURE__ */jsx(ElementType, __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({}, combinedProps), styleProps), props.disabled && {
    onClick: void 0
  }), {
    ref
  }), mapDataAttributes({
    isPressed,
    isFocused,
    isFocusVisible,
    isHovered,
    disabled: props.disabled
  })), {
    css: [combinedStyles.link, {
      '&[data-disabled="true"]': combinedStyles.disabled,
      '&[data-focused="true"]': combinedStyles.focusRing,
      '&[data-hovered="true"]': combinedStyles.hover,
      '&[data-pressed="true"]': combinedStyles.active,
      '&[data-focus-visible="true"]::before': [ringStylesOnly, combinedStyles.focusRing],
      '&[data-current="true"]': combinedStyles.focusRing
    }],
    children: props.children
  }));
});
var useRadio = $0d5c49892c1215da$export$37b0961d2f4751e2;
var useRadioGroupState = $a54cdc5c1942b639$export$bca9d026f8e704eb;
var useRadioGroup = $430f30ed08ec25fa$export$62b9571f283ff5c2;
var DESCRIPTION_SLOT2 = "description";
var ERROR_MESSAGE_SLOT2 = "errorMessage";
var RadioButtonGroupContext = /*#__PURE__*/createContext(null);
var RadioButtonGroupStateContext = /*#__PURE__*/createContext(null);
var RadioButtonGroupCore = /*#__PURE__*/forwardRef((p, r2) => {
  var _b;

  const [props, ref] = useContextProps(p, r2, RadioButtonGroupContext);
  const state = useRadioGroupState(__spreadProps(__spreadValues({}, props), {
    validationBehavior: VALIDATION_BEHAVIOR_NATIVE
  }));
  const [labelRef, label] = useSlot(!props["aria-label"] && !props["aria-labelledby"]);

  const _a = useRadioGroup(__spreadProps(__spreadValues({}, removeDataAttributes(props)), {
    label,
    validationBehavior: VALIDATION_BEHAVIOR_NATIVE
  }), state),
        {
    radioGroupProps,
    labelProps,
    descriptionProps,
    errorMessageProps
  } = _a,
        validation = __objRest(_a, ["radioGroupProps", "labelProps", "descriptionProps", "errorMessageProps"]);

  const renderProps = useRenderProps(__spreadProps(__spreadValues({}, props), {
    values: {
      isDisabled: state.isDisabled,
      isReadOnly: state.isReadOnly,
      isRequired: props.isRequired || false,
      isInvalid: state.isInvalid,
      state
    },
    defaultClassName: "react-aria-RadioGroup"
  }));
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues({}, radioGroupProps), renderProps), {
    ref,
    slot: props.slot || void 0
  }), mapDataAttributes({
    disabled: state.isDisabled,
    isReadOnly: state.isReadOnly,
    isRequired: props.isRequired || false,
    isInvalid: state.isInvalid
  })), {
    children: /* @__PURE__ */jsx(CompositionProvider, {
      values: [[RadioButtonGroupStateContext, state], [LabelContext, __spreadProps(__spreadValues({}, labelProps), {
        ref: labelRef,
        elementType: "span"
      })], [TextContext, {
        slots: {
          [DESCRIPTION_SLOT2]: descriptionProps,
          [ERROR_MESSAGE_SLOT2]: __spreadProps(__spreadValues({}, errorMessageProps), {
            children: (_b = props.invalidText) != null ? _b : validation.validationErrors.length === 0 ? void 0 : validation.validationErrors.join(" ")
          })
        }
      }], [FieldErrorContext, validation] // For future-proofing. We are only supporting native validation for now.
      ],
      children: renderProps.children
    })
  }));
});
var slots2 = {
  [DESCRIPTION_SLOT2]: DESCRIPTION_SLOT2,
  [ERROR_MESSAGE_SLOT2]: ERROR_MESSAGE_SLOT2
};
var RadioButtonGroupCoreWithSlots = RadioButtonGroupCore;
RadioButtonGroupCoreWithSlots.slots = slots2;
var STYLES4 = {
  wrapper: {
    cursor: "pointer",
    boxSizing: "border-box",
    position: "relative",
    '&[data-disabled="true"]': {
      cursor: "default"
    },
    '&[data-readonly="true"]': {
      cursor: "default"
    }
  }
};
var RadioButtonContext = /*#__PURE__*/createContext(null);

/*#__PURE__*/
forwardRef((p, r2) => {
  const [props, inputRef] = useContextProps(p, r2, RadioButtonContext);
  const groupState = useContext(RadioButtonGroupStateContext);
  const {
    labelProps,
    inputProps,
    isSelected,
    isDisabled,
    isPressed
  } = useRadio(__spreadProps(__spreadValues({}, removeDataAttributes(props)), {
    children: typeof props.children === "function" ? true : props.children
  }), groupState, inputRef);
  const {
    isFocused,
    isFocusVisible,
    focusProps,
    ringStylesOnly
  } = useFocusRing(props);
  const {
    hoverProps,
    isHovered
  } = useHover(__spreadProps(__spreadValues({}, props), {
    isDisabled
  }));

  const _a = filterEventHandlers(props),
        {
    id,
    styles,
    isDisabled: _isDisabled,
    style
  } = _a,
        domProps = __objRest(_a, ["id", "styles", "isDisabled", "style"]);

  const renderProps = useRenderProps(__spreadProps(__spreadValues({}, props), {
    values: {
      isSelected,
      isPressed,
      isDisabled,
      isHovered,
      isFocused,
      isFocusVisible
    }
  }));
  const combinedStyles = combineStyles(STYLES4, styles);
  return /* @__PURE__ */jsxs("label", __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({}, mergeProps(domProps, labelProps, hoverProps, renderProps)), {
    ref: props.labelRef
  }), renderProps), {
    slot: props.slot || void 0,
    style: __spreadProps(__spreadValues({}, style), {
      // When using onPress, don't allow overriding touchAction due to https://github.com/adobe/react-spectrum/issues/7993
      touchAction: ON_PRESS_TOUCH_ACTION
    })
  }), mapDataAttributes({
    isSelected,
    isPressed,
    disabled: isDisabled,
    isHovered,
    isFocused,
    isFocusVisible
  })), {
    css: [combinedStyles.wrapper, {
      '&[data-focus-visible="true"]::after': ringStylesOnly
    }],
    children: [/* @__PURE__ */jsx(VisuallyHidden, {
      children: /* @__PURE__ */jsx("input", __spreadProps(__spreadValues({}, mergeProps(inputProps, focusProps)), {
        ref: inputRef
      }))
    }), renderProps.children]
  }));
});
var useSwitch = $b418ec0c85c52f27$export$d853f7095ae95f88;
var STYLES5 = {
  wrapper: {
    cursor: "pointer",
    boxSizing: "border-box",
    position: "relative",
    '&[data-disabled="true"]': {
      cursor: "default"
    },
    '&[data-readonly="true"]': {
      cursor: "default"
    }
  }
};
var SwitchContext = /*#__PURE__*/createContext(null);

/*#__PURE__*/
forwardRef((p, r2) => {
  const [props, inputRef] = useContextProps(p, r2, SwitchContext);
  const {
    labelProps,
    inputProps,
    isSelected,
    isPressed,
    isDisabled,
    isReadOnly
  } = useSwitch(__spreadProps(__spreadValues({}, removeDataAttributes(props)), {
    children: typeof props.children === "function" ? true : props.children
  }), useToggleState(props), inputRef);
  const {
    isFocused,
    isFocusVisible,
    focusProps,
    ringStylesOnly
  } = useFocusRing(props);
  const isInteractionDisabled = isDisabled || isReadOnly;
  const {
    hoverProps,
    isHovered
  } = useHover(__spreadProps(__spreadValues({}, props), {
    isDisabled: isInteractionDisabled
  }));

  const _a = filterEventHandlers(props),
        {
    id,
    styles,
    isSelected: _isSelected,
    defaultSelected: _defaultSelected,
    isReadOnly: _isReadOnly,
    isDisabled: _isDisabled,
    style
  } = _a,
        domProps = __objRest(_a, ["id", "styles", "isSelected", "defaultSelected", "isReadOnly", "isDisabled", "style"]);

  const renderProps = useRenderProps(__spreadProps(__spreadValues({}, props), {
    values: {
      isSelected,
      isPressed,
      isHovered,
      isFocused,
      isFocusVisible,
      isDisabled,
      isReadOnly
    }
  }));
  const combinedStyles = combineStyles(STYLES5, styles);
  return /* @__PURE__ */jsxs("label", __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, mergeProps(domProps, labelProps, hoverProps, renderProps)), {
    ref: props.labelRef,
    slot: props.slot || void 0,
    style: __spreadProps(__spreadValues({}, style), {
      // When using onPress, don't allow overriding touchAction due to https://github.com/adobe/react-spectrum/issues/7993
      touchAction: ON_PRESS_TOUCH_ACTION
    })
  }), mapDataAttributes({
    isSelected,
    isPressed,
    isHovered,
    isFocused,
    isFocusVisible,
    disabled: isDisabled,
    isReadOnly
  })), {
    css: [combinedStyles.wrapper, {
      '&[data-focus-visible="true"]::after': ringStylesOnly
    }],
    children: [/* @__PURE__ */jsx(VisuallyHidden, {
      children: /* @__PURE__ */jsx("input", __spreadProps(__spreadValues({}, mergeProps(inputProps, focusProps)), {
        ref: inputRef
      }))
    }), renderProps.children]
  }));
});
var STYLES6 = {
  left: {
    flexShrink: 0
  },
  center: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "inline-block"
  },
  right: {
    flexShrink: 0
  }
};
var outsideSectionProps = {
  flexBasis: 0,
  flexGrow: 1
};
var TextWithIconsLayout = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function TextWithIconsLayout2(_a, ref) {
  var _b = _a,
      {
    children,
    leftSection,
    gap,
    justifyContent = "center",
    rightSection,
    styles: styleOverrides
  } = _b,
      props = __objRest(_b, ["children", "leftSection", "gap", "justifyContent", "rightSection", "styles"]);

  const spaceBetween = justifyContent === "space-between";
  const styles = combineStyles(STYLES6, styleOverrides);
  return /* @__PURE__ */jsxs(Flex, __spreadProps(__spreadValues(__spreadValues({
    justifyContent,
    alignItems: "center",
    height: "100%",
    width: "100%"
  }, {
    gap,
    ref
  }), props), {
    children: [leftSection && /* @__PURE__ */jsx(Flex, __spreadProps(__spreadValues({
      alignItems: "center",
      justifyContent: spaceBetween ? "left" : "right"
    }, outsideSectionProps), {
      css: styles.left,
      as: "span",
      children: leftSection
    })), /* @__PURE__ */jsx("span", {
      css: styles.center,
      children
    }), rightSection && /* @__PURE__ */jsx(Flex, __spreadProps(__spreadValues({
      alignItems: "center",
      justifyContent: spaceBetween ? "right" : "left"
    }, outsideSectionProps), {
      css: styles.right,
      as: "span",
      children: rightSection
    }))]
  }));
}, "TextWithIconsLayout"));
var useToggleButton = $55f54f7887471b58$export$51e84d46ca0bc451;
var STYLES7 = {
  button: {
    // This replaces the huge reset you used to need for an unstyled button.
    all: "unset",
    cursor: "pointer",
    position: "relative",
    boxSizing: "border-box",
    '&[data-full-width="true"]': {
      width: "100%"
    },
    textAlign: "center",
    userSelect: "none",
    "& *": {
      touchAction: ON_PRESS_TOUCH_ACTION
    }
  },
  hover: {},
  active: {},
  disabled: {
    cursor: "default"
  }
};
var ToggleButtonCore = /*#__PURE__*/forwardRef( /* @__PURE__ */__name(function ToggleButtonCore2(props, ref) {
  const buttonRef = useRef(null);
  const finalRef = useMergeRefs(ref, buttonRef);

  const _a = props,
        {
    disabled,
    styles: styleOverrides,
    onPress
  } = _a,
        rest = __objRest(_a, ["disabled", "styles", "onPress"]);

  const state = useToggleState(props);
  const {
    buttonProps,
    isPressed
  } = useToggleButton(__spreadValues({
    isDisabled: disabled,
    elementType: "button",
    onPress
  }, rest), state, buttonRef);
  const {
    allFocusRingCss,
    focusProps,
    isFocusVisible
  } = useFocusRing(buttonProps);
  const {
    children
  } = rest;
  const {
    isHovered,
    hoverProps
  } = useHover(__spreadProps(__spreadValues({}, props), {
    isDisabled: disabled
  }));
  const combinedStyles = combineStyles(STYLES7, styleOverrides);
  const functionAsChildState = useMemo(() => ({
    isFocusVisible,
    isSelected: state.isSelected
  }), [state.isSelected, isFocusVisible]);

  const _b = rest,
        {
    fullWidth,
    defaultSelected,
    isSelected
  } = _b,
        attributes = __objRest(_b, ["fullWidth", "defaultSelected", "isSelected"]);

  const domPropsWithoutEventHandlers = filterEventHandlers(attributes);
  const combinedProps = mergeProps(hoverProps, buttonProps, focusProps);
  const styleProps = {
    className: props.className,
    style: __spreadProps(__spreadValues({}, props.style), {
      // Don't allow overriding touchAction due to https://github.com/adobe/react-spectrum/issues/7993
      touchAction: ON_PRESS_TOUCH_ACTION
    })
  };
  return /* @__PURE__ */jsx("button", __spreadProps(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
    ref: finalRef
  }, domPropsWithoutEventHandlers), combinedProps), styleProps), {
    css: [combinedStyles.button, allFocusRingCss, {
      '&[data-hovered="true"]': combinedStyles.hover,
      '&[data-pressed="true"]': combinedStyles.active,
      '&[data-disabled="true"]': combinedStyles.disabled
    }]
  }), mapDataAttributes({
    isFocusVisible,
    fullWidth,
    isSelected: state.isSelected,
    isHovered,
    isPressed,
    disabled
  })), {
    children: children && /* @__PURE__ */jsx(FunctionOrReactNodeAsChild, {
      args: functionAsChildState,
      children
    })
  }));
}, "ToggleButtonCore"));

var SVGIcon = /* @__PURE__ */__name(_a => {
  var _b = _a,
      {
    component,
    color: colorKey = "systemGrayscale80",
    size
  } = _b,
      rest = __objRest(_b, ["component", "color", "size"]);

  const theme = useTheme();
  const fillColor = theme.colors[colorKey];

  const svgProps = __spreadValues({
    fill: fillColor
  }, !rest["aria-label"] && !rest["aria-labelledby"] && {
    "aria-hidden": true
  });

  if (size) {
    svgProps.width = size;
    svgProps.height = size;
  }

  return /*#__PURE__*/cloneElement(component, __spreadValues(__spreadValues({}, svgProps), rest));
}, "SVGIcon");

var TextAreaContext = /*#__PURE__*/createContext({});
var STYLES8 = {
  textarea: {
    verticalAlign: "top"
  }
};
var TextAreaCore = /*#__PURE__*/forwardRef((p, r2) => {
  const [props, ref] = useContextProps(p, r2, TextAreaContext);
  const {
    focusProps,
    isFocused,
    isFocusVisible
  } = useFocusRing(__spreadValues({
    isTextInput: true
  }, props));
  return /* @__PURE__ */jsx("textarea", __spreadProps(__spreadValues(__spreadValues({
    ref
  }, mergeProps(props, focusProps)), mapDataAttributes({
    isFocused,
    isFocusVisible
  })), {
    css: [STYLES8.textarea]
  }));
});
var useField = $2baaea4c71418dea$export$294aa081a6c6f55d;

function useTextField(props, ref) {
  const {
    inputElementType = "input",
    type = "text"
  } = props;
  const {
    focusableProps
  } = useFocusable(props, ref);
  const {
    labelProps,
    fieldProps,
    descriptionProps,
    errorMessageProps
  } = useField(__spreadProps(__spreadValues({}, props), {
    isInvalid: props.invalid,
    errorMessage: props.invalidText
  }));
  const domProps = filterDOMProps(props);
  const inputOnlyProps = {
    type,
    pattern: props.pattern
  };
  let textAreaOnlyProps = {};

  if (inputElementType === "textarea") {
    textAreaOnlyProps = {
      cols: props.cols,
      rows: props.rows
    };
  }

  return {
    labelProps,
    inputProps: mergeProps(domProps, inputElementType === "input" ? inputOnlyProps : void 0, textAreaOnlyProps, __spreadValues(__spreadValues({
      disabled: props.disabled,
      readOnly: props.readOnly,
      required: props.required,
      "aria-invalid": props.invalid || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-activedescendant": props["aria-activedescendant"],
      "aria-autocomplete": props["aria-autocomplete"],
      "aria-haspopup": props["aria-haspopup"],
      "aria-controls": props["aria-controls"],
      value: props.value,
      defaultValue: props.defaultValue,
      onChange: props.onChange,
      autoComplete: props.autoComplete,
      autoCapitalize: props.autoCapitalize,
      autoCorrect: props.autoCorrect,
      spellCheck: props.spellCheck,
      enterKeyHint: props.enterKeyHint,
      maxLength: props.maxLength,
      minLength: props.minLength,
      name: props.name,
      placeholder: props.placeholder,
      inputMode: props.inputMode,
      // Clipboard events
      onCopy: props.onCopy,
      onCut: props.onCut,
      onPaste: props.onPaste,
      // Composition events
      onCompositionEnd: props.onCompositionEnd,
      onCompositionStart: props.onCompositionStart,
      onCompositionUpdate: props.onCompositionUpdate,
      // Selection events
      onSelect: props.onSelect,
      // Input events
      onBeforeInput: props.onBeforeInput,
      onInput: props.onInput
    }, focusableProps), fieldProps)),
    descriptionProps,
    errorMessageProps,
    invalid: props.invalid
  };
}

__name(useTextField, "useTextField");

var useFocusWithin = $9ab94262bd0047c7$export$420e68273165f4ec;
var DESCRIPTION_SLOT3 = "description";
var ERROR_MESSAGE_SLOT3 = "errorMessage";

function TextFieldCore(p, r2) {
  const inputRef = useRef(null);
  const [inputElementType, setInputElementType] = useState("input");
  const [props, ref] = useContextProps(p, r2, TextFieldCoreContext);
  const [isFocusWithin, setFocusWithin] = useState(false);
  const {
    focusWithinProps
  } = useFocusWithin({
    onFocusWithinChange: /* @__PURE__ */__name(val => setFocusWithin(val), "onFocusWithinChange")
  });
  const {
    isHovered,
    hoverProps
  } = useHover(props);
  const textFieldAria = useTextField(__spreadProps(__spreadValues({}, props), {
    inputElementType
  }), inputRef);
  const inputOrTextAreaRef = useCallback(el => {
    inputRef.current = el;

    if (el) {
      setInputElementType(el instanceof HTMLTextAreaElement ? "textarea" : "input");
    }
  }, []);
  const inputProps = textFieldAria.inputProps;
  const textareaProps = textFieldAria.inputProps;
  return /* @__PURE__ */jsx(CompositionProvider, {
    values: [[InputContext, __spreadProps(__spreadValues({}, inputProps), {
      ref: inputOrTextAreaRef
    })], [TextAreaContext, __spreadProps(__spreadValues({}, textareaProps), {
      ref: inputOrTextAreaRef
    })], [LabelContext, __spreadProps(__spreadValues({}, textFieldAria.labelProps), {
      children: props.label
    })], [TextContext, {
      slots: {
        [DESCRIPTION_SLOT3]: __spreadProps(__spreadValues({}, textFieldAria.descriptionProps), {
          children: props.description
        }),
        [ERROR_MESSAGE_SLOT3]: __spreadProps(__spreadValues({}, textFieldAria.errorMessageProps), {
          children: props.invalidText
        })
      }
    }]],
    children: /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({
      "data-disabled": textFieldAria.inputProps.disabled || void 0,
      "data-invalid": textFieldAria.invalid || void 0,
      "data-readonly": textFieldAria.inputProps.readOnly || void 0,
      "data-required": textFieldAria.inputProps.required || void 0,
      "data-focus-within": isFocusWithin || void 0,
      "data-hovered": isHovered || void 0,
      className: props.className,
      style: props.style
    }, mergeProps(focusWithinProps, hoverProps)), {
      ref,
      children: props.children
    }))
  });
}

__name(TextFieldCore, "TextFieldCore");

var TextFieldCoreFR = /*#__PURE__*/forwardRef(TextFieldCore);
var slots3 = {
  [DESCRIPTION_SLOT3]: DESCRIPTION_SLOT3,
  [ERROR_MESSAGE_SLOT3]: ERROR_MESSAGE_SLOT3
};
TextFieldCoreFR.slots = slots3;
var TextFieldCoreContext = /*#__PURE__*/createContext(null);

function AIPIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.254 15.987c-.623 0-1.004-.355-1.004-.94 0-.167.054-.408.14-.645L5.302 9.15C5.586 8.36 6.064 8 6.832 8c.812 0 1.284.344 1.58 1.15l1.928 5.252c.091.253.129.435.129.64 0 .553-.414.945-.989.945-.569 0-.864-.258-1.036-.892l-.263-.86H5.527l-.263.828c-.188.655-.483.924-1.01.924m1.665-3.239h1.832l-.908-2.986H6.8zm6.483 3.239c-.623 0-.988-.37-.988-1.026V9.026c0-.655.365-1.026.988-1.026s.983.37.983 1.026v5.935c0 .655-.36 1.026-.983 1.026m3.142 0c-.623 0-.988-.37-.988-1.026V9.149c0-.655.365-1.03.988-1.03h2.37c1.664 0 2.792 1.079 2.792 2.744 0 1.654-1.187 2.734-2.911 2.734h-1.268v1.364c0 .655-.36 1.026-.983 1.026m.983-3.873h.854c.838 0 1.332-.435 1.332-1.246 0-.806-.494-1.24-1.32-1.24h-.866z"
      })
    }))
  }, props));
}

__name(AIPIcon, "AIPIcon");

function AccessibilityIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 20q.781-.002 1.52-.144a22 22 0 0 1-.239-.496c-.453-.97-.99-2.302-1.261-3.664l-.02-.098-.02.098c-.272 1.362-.808 2.693-1.261 3.664a22 22 0 0 1-.239.496q.739.143 1.52.144m-3.442-.776q.16-.31.348-.71c.422-.903.886-2.072 1.113-3.21a26 26 0 0 0 .445-3.404 12 12 0 0 1-4.905-1.808c-.42-.269-.785-.538-1.094-.787A8 8 0 0 0 4 12a8 8 0 0 0 4.558 7.224M20 12a8 8 0 0 1-4.558 7.224 20 20 0 0 1-.348-.71c-.422-.903-.886-2.072-1.113-3.21a26 26 0 0 1-.445-3.404 12 12 0 0 0 4.905-1.808c.42-.269.785-.538 1.094-.787.301.842.465 1.75.465 2.695M5.4 7.478A7.99 7.99 0 0 1 12 4a7.99 7.99 0 0 1 6.6 3.478c-.308.271-.723.6-1.238.93C16.112 9.208 14.297 10 12 10s-4.112-.792-5.362-1.592a10 10 0 0 1-1.238-.93M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-13c1.103 0 2-.897 2-2s-.897-2-2-2c-1.104 0-2 .897-2 2s.896 2 2 2"
      })
    }))
  }, props));
}

__name(AccessibilityIcon, "AccessibilityIcon");

function AccountIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3-13a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.563 8.749A7.97 7.97 0 0 1 12 20a7.97 7.97 0 0 1-5.563-2.251 6.002 6.002 0 0 1 11.126 0"
      })
    }))
  }, props));
}

__name(AccountIcon, "AccountIcon");

function AccountOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.983 20.013A9.99 9.99 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.99 9.99 0 0 0 4 8 10 10 0 0 0 2.2 1.253A10 10 0 0 0 12 22a9.97 9.97 0 0 0 5.983-1.987m-2.109-1.012A7.96 7.96 0 0 1 12 20a7.97 7.97 0 0 1-3.874-.999 4.002 4.002 0 0 1 7.748 0m1.69-1.252a6.002 6.002 0 0 0-11.127 0 8 8 0 1 1 11.127 0"
      })]
    }))
  }, props));
}

__name(AccountOutlineIcon, "AccountOutlineIcon");

function AddIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M10.88 13.12V20h2.24v-6.88H20v-2.24h-6.88V4h-2.24v6.88H4v2.24z"
      })
    }))
  }, props));
}

__name(AddIcon, "AddIcon");

var AddIcon_default = AddIcon;

function AddBusinessIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M3.179 6.5h13c.55 0 1-.45 1-1s-.45-1-1-1h-13c-.55 0-1 .45-1 1s.45 1 1 1M15.179 17.5h2v-3h.18c.63 0 1.1-.58.98-1.2l-1-5c-.09-.46-.5-.8-.98-.8H2.999c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2h.18v5c0 .55.45 1 1 1h7c.55 0 1-.45 1-1v-5h4zm-6 1h-5v-4h5z"
      }), /* @__PURE__ */jsx("path", {
        d: "M22.179 18.5h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1"
      })]
    }))
  }, props));
}

__name(AddBusinessIcon, "AddBusinessIcon");

function AdjustmentIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 11.5c-.885 0-2.5.5-2.5 3 0 1.5-.672 2-1.5 2s-1.5-.5-1.5-2c0-4.053 2.5-6 5.5-6 2.436 0 3.903 1.191 5.13 2.597 1.525 1.747 2.328 2.403 3.37 2.403.633 0 1.024-.165 1.297-.48.313-.363.703-1.191.703-3.02 0-1 .672-1.5 1.5-1.5s1.5.5 1.5 1.5c0 2.5-.45 3.843-1.433 4.98-1.023 1.185-2.382 1.52-3.567 1.52-2.594 0-4.246-1.844-5.63-3.43C9.915 11.975 9.2 11.5 8 11.5"
      })
    }))
  }, props));
}

__name(AdjustmentIcon, "AdjustmentIcon");

function AdjustmentsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M7 5h2v6H7V9H3V7h4zM11 9h10V7H11zM15 13h2v2h4v2h-4v2h-2zM13 15H3v2h10z"
      })
    }))
  }, props));
}

__name(AdjustmentsIcon, "AdjustmentsIcon");

function AlarmIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.181 6.046a3 3 0 0 0 .608 1L8.21 2.993a3 3 0 0 0-5.03 3.054m4.965 12.966-2.128 2.99-1.63-1.16 2.14-3.006a8 8 0 1 1 10.953-.009l2.146 3.015-1.63 1.16-2.132-2.996A7.96 7.96 0 0 1 12 20a7.96 7.96 0 0 1-3.854-.988M20.211 7.047A3.002 3.002 0 0 0 19.027 2.2a3 3 0 0 0-3.238.791zM13 7.648v4.465l2.697 2.74-1.425 1.403L11 12.933V7.648z"
      })
    }))
  }, props));
}

__name(AlarmIcon, "AlarmIcon");

function AlcoholIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.304 5.999 1.544-2.47-1.696-1.06-2.206 3.53H5v2l6 6v6l-3 1v1h8v-1l-3-1v-6l6-6v-2z"
      })
    }))
  }, props));
}

__name(AlcoholIcon, "AlcoholIcon");

function AlcoholCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20.487 8.65 17.207 0h-9.5l-3.28 8.65c-.53 1.4-.6 2.97-.02 4.35 1.44 3.41 5.41 3.5 6.79 3.5h.39v4.83L7.217 23v1h10.5v-1l-4.38-1.67V16.5h.39c1.38 0 5.35-.09 6.79-3.5.58-1.38.51-2.95-.02-4.35zm-1.6 3.67c-.52 1.23-1.6 1.98-3.29 2.28-.56.1-1.19.15-1.88.15h-2.56c-.42 0-.82-.03-1.19-.06-.11-.01-.21-.03-.31-.04-.3-.04-.58-.09-.84-.16-.05-.01-.1-.02-.15-.04 2.18-.72 3.74-2.51 5.06-4.02.66-.75 1.28-1.46 1.91-2 .46-.39.96-.48 1.29-.48.86 0 1.6.51 1.91 1.3.27.72.35 1.43.27 2.09-.04.34-.11.67-.24.97zM6.057 9.27l2.86-7.52h7.09l1.72 4.54a3.662 3.662 0 0 0-3.21.81c-2.45 2.09-4.3 5.92-7.82 5.92-.1 0-.2-.02-.29-.03-.15-.21-.28-.43-.38-.67-.38-.9-.36-1.98.04-3.05z"
      })
    }))
  }, props));
}

__name(AlcoholCategoryIcon, "AlcoholCategoryIcon");

function AlcoholCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M6.61 11.27c1.56 0 2.71-1.19 4.41-3.14.71-.81 1.45-1.66 2.28-2.37.99-.84 2.25-1.31 3.55-1.31.74 0 1.46.14 2.12.41L17.12 0h-9.5L4.34 8.65c-.15.4-.27.82-.34 1.24l1.1.83c.33.25.87.55 1.51.55"
      }), /* @__PURE__ */jsx("path", {
        d: "M20.7 12.12a5.69 5.69 0 0 0 .13-1.07c0-.05.01-.09.01-.13 0 .04-.01.08-.01.12a6.3 6.3 0 0 0-.42-2.39 3.79 3.79 0 0 0-3.56-2.45c-.84 0-1.7.29-2.42.9-2.45 2.09-4.3 5.92-7.82 5.92-.95 0-1.83-.35-2.57-.91.06.3.16.6.28.89 1.44 3.41 5.43 3.5 6.8 3.5h.38v4.83L7.13 23v1h10.5v-1l-4.38-1.67V16.5h.38c.7 0 2.08-.03 3.46-.51 1.32-.45 2.63-1.33 3.34-2.99.02-.05.03-.11.05-.17.09-.23.16-.47.21-.71zm.03-.1s.01-.04.02-.07c0 .02-.01.04-.02.07"
      })]
    }))
  }, props));
}

__name(AlcoholCategoryFilledIcon, "AlcoholCategoryFilledIcon");

function AlcoholFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-2c1.849 0 3.55-.627 4.906-1.68l-4.024-4.024v1.501l1.684.43c1.01.257.826 1.773-.214 1.773H9.648c-1.04 0-1.223-1.516-.214-1.773l1.684-.43v-2.524L7.26 9.336a.9.9 0 0 1-.224-.886L5.68 7.094A8 8 0 0 0 12 20M9.214 7.8l-2.12-2.12A8 8 0 0 1 18.32 16.906l-4.545-4.545 2.965-3.025c.556-.567.162-1.536-.624-1.536h-.932l.76-.776a.61.61 0 0 0 0-.848.58.58 0 0 0-.832 0L13.521 7.8z"
      })
    }))
  }, props));
}

__name(AlcoholFreeIcon, "AlcoholFreeIcon");

function AllStoresCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M8 4.5h8v3H8z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 11h-2.5v13H15v-8H9v8H2.5V11H0L4.8 0h14.4zm-7.25 11.25h3V11H4.25v11.25h3v-8h9.5zm4.57-13-3.27-7.5H5.94l-3.27 7.5z"
      })]
    }))
  }, props));
}

__name(AllStoresCategoryIcon, "AllStoresCategoryIcon");

function AllStoresCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 11H0L4.8 0h14.4zm-8-6.5H8v3h8z"
      }), /* @__PURE__ */jsx("path", {
        d: "M2.5 12.75h19V24H15v-8H9v8H2.5z"
      })]
    }))
  }, props));
}

__name(AllStoresCategoryFilledIcon, "AllStoresCategoryFilledIcon");

function AmbientIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
      })
    }))
  }, props));
}

__name(AmbientIcon, "AmbientIcon");

function AnnouncementIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m9 6 11-2v12L9.407 14.074 10 20H7l-.6-6H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
      })
    }))
  }, props));
}

__name(AnnouncementIcon, "AnnouncementIcon");

function AppStoreIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.827 5.138C3.5 5.78 3.5 6.62 3.5 8.3v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V8.3c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.22 3.5 17.38 3.5 15.7 3.5H8.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311m11.486 8.09h1.929a.756.756 0 0 1 0 1.512h-1.057l.74 1.281a.756.756 0 1 1-1.309.756l-2.76-4.783-.053-.091a2.18 2.18 0 0 1 .301-2.5zm-7.231 1.795a1.2 1.2 0 0 0-.49.104l-.517.894a.756.756 0 1 0 1.309.756l.704-1.22a1.22 1.22 0 0 0-1.006-.534m2.35-1.795h2.15a1.093 1.093 0 0 1 1.01 1.511H6.757a.756.756 0 0 1 0-1.51h1.93l2.44-4.227-.753-1.304a.756.756 0 0 1 1.308-.756l.317.549.317-.549a.756.756 0 0 1 1.308.756z"
      })
    }))
  }, props));
}

__name(AppStoreIcon, "AppStoreIcon");

function AppendIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-1-11V7h2v4h4v2h-4v4h-2v-4H7v-2z"
      })
    }))
  }, props));
}

__name(AppendIcon, "AppendIcon");

function AppleIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.911 1.5c.127 1.115-.335 2.232-1.024 3.036-.685.802-1.811 1.426-2.914 1.343-.148-1.09.409-2.226 1.043-2.94.707-.8 1.908-1.401 2.895-1.439m4.078 13.969.011-.032c-.056-.021-2.613-.983-2.639-3.843-.022-2.34 1.921-3.495 2.113-3.61l.012-.006c-1.157-1.635-2.956-1.857-3.594-1.885-.937-.092-1.844.255-2.585.538-.471.18-.875.334-1.177.334-.336 0-.752-.159-1.218-.337-.61-.233-1.305-.5-2.026-.488-1.668.025-3.204.937-4.066 2.382-1.728 2.905-.441 7.213 1.248 9.572.827 1.153 1.808 2.454 3.102 2.405.578-.022.99-.192 1.414-.367.49-.202 1-.412 1.805-.412.77 0 1.256.204 1.723.4.447.186.876.366 1.518.354 1.34-.023 2.191-1.178 3.008-2.337a10.4 10.4 0 0 0 1.351-2.668"
      })
    }))
  }, props));
}

__name(AppleIcon, "AppleIcon");

function ApprovedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.536-13.89 1.414 1.414-6.364 6.364-3.536-3.535 1.414-1.415 2.122 2.122z"
      })
    }))
  }, props));
}

__name(ApprovedIcon, "ApprovedIcon");

var ApprovedIcon_default = ApprovedIcon;

function ArrowCornerIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M9 5v2.24h6.176l-9.468 9.468 1.584 1.584 9.468-9.468V15H19V5z"
      })
    }))
  }, props));
}

__name(ArrowCornerIcon, "ArrowCornerIcon");

function ArrowCornerDownLeftIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m8.824 16.759 9.468-9.468-1.584-1.584-9.468 9.468V9H5v10h10v-2.24z"
      })
    }))
  }, props));
}

__name(ArrowCornerDownLeftIcon, "ArrowCornerDownLeftIcon");

function ArrowDownIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m13.12 15.796 4.088-4.088 1.584 1.584L12 20.084l-6.792-6.792 1.584-1.584 4.088 4.088V4h2.24z"
      })
    }))
  }, props));
}

__name(ArrowDownIcon, "ArrowDownIcon");

var ArrowDownIcon_default = ArrowDownIcon;

function ArrowLeftIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m12.292 6.79-1.584-1.583-6.792 6.792 6.792 6.792 1.584-1.584-4.088-4.088H20v-2.24H8.204z"
      })
    }))
  }, props));
}

__name(ArrowLeftIcon, "ArrowLeftIcon");

var ArrowLeftIcon_default = ArrowLeftIcon;

function ArrowRightIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M15.796 13.119H4v-2.24h11.796l-4.088-4.088 1.584-1.584 6.792 6.792-6.792 6.792-1.584-1.584z"
      })
    }))
  }, props));
}

__name(ArrowRightIcon, "ArrowRightIcon");

var ArrowRightIcon_default = ArrowRightIcon;

function ArrowUpIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M18.792 10.71 12 3.918 5.208 10.71l1.584 1.584 4.088-4.088v11.796h2.24V8.206l4.088 4.088z"
      })
    }))
  }, props));
}

__name(ArrowUpIcon, "ArrowUpIcon");

var ArrowUpIcon_default = ArrowUpIcon;

function BabyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6M3.437 9.344 4 8.518c.564-.826.563-.827.563-.827h-.001l.014.009.079.049q.111.07.35.197c.318.169.801.4 1.438.632 1.272.466 3.155.94 5.557.94s4.285-.474 5.558-.94a12 12 0 0 0 1.437-.632 7 7 0 0 0 .429-.246l.014-.01c0 .001-.002.002.562.828l.563.826-.002.002-.005.003-.011.007-.037.024-.125.078a9 9 0 0 1-.452.256c-.39.206-.956.476-1.686.743-.856.313-1.937.623-3.223.827a504 504 0 0 0 .113 3.234h-6.27a1086 1086 0 0 0 .113-3.234 17.2 17.2 0 0 1-3.223-.827 14 14 0 0 1-1.686-.743 9 9 0 0 1-.614-.358l-.011-.007-.005-.003zm4.631 6.846-.164.2c-1.09 1.331-1.192 3.432-.315 4.919l.423.717 1.722-1.017-.423-.717c-.478-.812-.384-1.995.14-2.634l.017-.02zm6.464 1.448.017.02c.524.64.619 1.823.14 2.635l-.423.716 1.722 1.017.424-.718c.876-1.486.774-3.587-.316-4.918l-.164-.2zM4.562 7.69H4.56L4 8.518z"
      })
    }))
  }, props));
}

__name(BabyIcon, "BabyIcon");

function BabyCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12.54.04c-.16-.03-.33-.04-.48-.04-1.49 0-2.7 1.21-2.7 2.7v1.57c0 .37-.19.72-.51.92-1.05.4-1.79 1.41-1.79 2.6V8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2v-.21c0-1.19-.75-2.19-1.79-2.6-.31-.2-.51-.54-.51-.92V2.85c0-1.34-.9-2.59-2.22-2.81m2.02 15.08v1.75h2.75v1.75h-4.25v1.75h4.25v1.62c0 .14-.11.25-.25.25h-10c-.14 0-.25-.11-.25-.25V19.1c.15 0 .28.02.44.02 2.39 0 3.71-1.76 4.87-3.32.42-.57.82-1.11 1.27-1.56.84-.86 2.47-1.3 3.93-.7v1.57h-2.75zm2.75-3.4c-1.84-.48-3.89-.02-5.18 1.32-.52.54-.97 1.14-1.41 1.73-1.05 1.4-1.95 2.62-3.46 2.62-.16 0-.3-.01-.44-.02V10c0-.14.11-.25.25-.25h10c.14 0 .25.11.25.25v1.72zm-2-3.72h-6.5v-.21c0-.43.26-.81.67-.96l.17-.06.15-.09c.82-.52 1.31-1.42 1.31-2.39V2.72c0-.53.43-.95.95-.95.06 0 .12 0 .19.02.43.07.77.55.77 1.09V4.3c0 .97.49 1.87 1.31 2.39l.15.09.17.06c.41.16.67.53.67.96v.21z"
      })
    }))
  }, props));
}

__name(BabyCategoryIcon, "BabyCategoryIcon");

function BabyCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.08 8c1.1 0 2 .9 2 2h.02v2.53a5.2 5.2 0 0 0-1.76-.82 5 5 0 0 0-.77-.15c-1.66-.19-3.35.38-4.42 1.48-.501.51-.937 1.096-1.362 1.665l-.048.065c-1.04 1.41-1.95 2.62-3.46 2.62q-.124-.001-.235-.01-.104-.009-.205-.01c-.35-.02-.64-.08-.88-.15-.42-.13-.7-.31-.88-.52V10c0-1.1.9-2 2-2v-.21c0-1.19.74-2.2 1.79-2.6.32-.2.51-.55.51-.92V2.7c0-1.49 1.21-2.7 2.7-2.7.15 0 .32.01.48.04 1.32.22 2.22 1.47 2.22 2.81v1.42c0 .38.2.72.51.92 1.04.41 1.79 1.41 1.79 2.6zM9.5 6.83c-.41.15-.67.53-.67.96v.22h6.5V7.8c0-.43-.26-.8-.67-.96l-.17-.06-.15-.09a2.82 2.82 0 0 1-1.31-2.39V2.88c0-.54-.34-1.02-.77-1.09-.06-.02-.12-.02-.18-.02a.95.95 0 0 0-.95.95v1.57c0 .97-.49 1.87-1.31 2.39l-.15.09z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.36 13.3c.35.04.66.14.97.26h-.03c.32.13.61.31.88.53.34.27.64.58.88.97V22c0 1.1-.9 2-2 2h-10c-1.1 0-2-.9-2-2v-3.25c.28.11.56.21.88.27.28.05.57.08.88.1l.027.002c.14.01.272.018.413.018 2.39 0 3.71-1.76 4.87-3.32l.082-.11c.4-.529.776-1.029 1.188-1.45.7-.72 1.83-1.08 2.96-.96m-1.78 3.57h2.5v-1.75h-2.5zm2.7 1.75h-4.2v1.75h4.2z"
      })]
    }))
  }, props));
}

__name(BabyCategoryFilledIcon, "BabyCategoryFilledIcon");

function BackToSchoolCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_1572_136)",
        children: [/* @__PURE__ */jsx("path", {
          d: "M15.313 9.15a1.219 1.219 0 1 0 0-2.437 1.219 1.219 0 0 0 0 2.437"
        }), /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.29.791C13.158.068 14.269 0 15 0v1.75c-.69 0-1.236.09-1.59.386-.158.13-.338.357-.452.77q.221-.09.466-.171c1.16-.378 2.79-.544 4.392.466 1.767 1.114 2.63 3.653 1.3 6.548l-.14.305-.013.03c-.481 1.053-1.127 2.466-1.92 3.619-.356.52-.764 1.018-1.228 1.416h3.748a4.438 4.438 0 0 1 0 8.875H0s.55-.688 1.01-1.75c.331-.763.615-1.718.615-2.75 0-.996-.264-1.9-.58-2.625C.578 15.797 0 15.119 0 15.119h8.185c-.464-.398-.872-.896-1.229-1.416-.792-1.153-1.438-2.566-1.92-3.619l-.013-.03-.14-.305c-1.33-2.895-.465-5.434 1.301-6.548 1.603-1.01 3.232-.844 4.392-.466.208.067.404.143.585.22.149-.95.53-1.665 1.129-2.164M10.035 4.4c-.86-.28-1.902-.357-2.918.283-.89.56-1.677 2.086-.643 4.336l.14.306v.002c.496 1.084 1.086 2.37 1.784 3.386.348.505.696.904 1.037 1.17.337.262.623.362.873.362.271 0 .554-.095.796-.218a2.6 2.6 0 0 0 .338-.206l.011-.008.547-.442.546.441c.009.007.144.11.352.216.241.122.523.217.794.217.25 0 .537-.1.873-.362.341-.266.689-.665 1.037-1.17.698-1.016 1.288-2.3 1.783-3.385l.004-.01.137-.299c1.034-2.25.247-3.775-.643-4.336-1.016-.64-2.058-.563-2.917-.283-.846.275-1.427.723-1.427.723L12 5.544l-.539-.422s-.58-.448-1.426-.723m9.528 12.47H2.92c.186.542.338 1.152.41 1.812H17v1.75H3.317a8.8 8.8 0 0 1-.429 1.813h16.675a2.687 2.687 0 1 0 0-5.375"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_1572_136",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(BackToSchoolCategoryIcon, "BackToSchoolCategoryIcon");

function BackToSchoolCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("g", {
        clipPath: "url(#prefix__clip0_1572_138)",
        children: /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 0c-.731 0-1.842.068-2.71.791-.685.57-1.086 1.427-1.178 2.592-1.062-.823-2.718-1.386-4.772-.091-1.406.886-2.28 3.036-1.029 5.758l.148.323v.002c1.035 2.263 2.624 5.74 4.748 5.744H0s.578.678 1.045 1.75c.316.725.58 1.629.58 2.625 0 1.032-.284 1.987-.614 2.75C.55 23.306 0 23.994 0 23.994h19.563a4.437 4.437 0 1 0 0-8.875h-5.77c2.124-.003 3.713-3.48 4.747-5.744l.149-.325c1.25-2.722.377-4.872-1.029-5.758-2.068-1.304-3.733-.724-4.794.109.08-.742.332-1.09.544-1.265.354-.296.9-.386 1.59-.386zm-1.213 15.119h-3.574c.973-.002 1.787-.66 1.787-.66s.815.659 1.787.66m1.525-5.969a1.219 1.219 0 1 0 0-2.437 1.219 1.219 0 0 0 0 2.437m4.25 7.719H2.922c.185.542.337 1.152.409 1.812H17v1.75H3.317a8.8 8.8 0 0 1-.429 1.813h16.675a2.687 2.687 0 1 0 0-5.375"
        })
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_1572_138",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(BackToSchoolCategoryFilledIcon, "BackToSchoolCategoryFilledIcon");

function BackgroundColorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.126 3 5.944 5.048l1.873 1.081-2.88 4.988L11.665 15l4.062-7.035zm8.437 10.208c0 1.04.807 1.816 1.794 1.791.986-.025 1.715-.811 1.706-1.81q0-.075-.008-.15a1.95 1.95 0 0 0-.287-.854 41 41 0 0 0-.971-1.405 7 7 0 0 1-.483-.78 6.6 6.6 0 0 1-.486.782 36 36 0 0 0-.969 1.403 2 2 0 0 0-.292 1.025zM20 21H4v-4h16z"
      })
    }))
  }, props));
}

__name(BackgroundColorIcon, "BackgroundColorIcon");

function BagIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 4.25v2h3v16h-16v-16h3v-2l2-2h6zm-2 0h-6v2h6z"
      })
    }))
  }, props));
}

__name(BagIcon, "BagIcon");

function BarcodeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M2 5h3v14H2zM7 5h1v14H7zM18 5h-4v14h4zM20 5h2v14h-2zM12 5h-2v14h2z"
      })
    }))
  }, props));
}

__name(BarcodeIcon, "BarcodeIcon");

function BeautyCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M23.93 19.202s-.02-.08-.02-.12c-.51-2.529-3.2-5.508-7.26-6.197L14.9 8.007h-.97v-1.79c0-1.15-.93-2.079-2.07-2.079h-.72c-.61 0-1.11-.51-1.11-1.12V1.76h4.38c.62 0 1.12.5 1.12 1.12v1h1.75v-1A2.88 2.88 0 0 0 14.4 0H6.39v1.75h1.88v1.259c0 .62-.5 1.11-1.11 1.12h-.57c-1.14 0-2.07.929-2.07 2.078v1.79H3.39L.38 16.413c-.48 1.36-.54 2.869.02 4.198C1.79 23.91 5.62 24 6.95 24h13.18c2.14 0 3.87-1.74 3.87-3.898v-.17c0-.23-.03-.48-.07-.73M6.27 6.217c0-.18.14-.33.32-.33h5.26c.18 0 .32.15.32.33v1.79h-5.9zm.68 16.034c-2.66 0-4.28-.76-4.94-2.32-.35-.859-.35-1.899.02-2.928l2.59-7.247h9.04l1.79 4.978c-.24.75-.93 1.3-1.76 1.3h-.81c-2.14 0-3.87 1.739-3.87 3.898v.17c0 .79.24 1.529.64 2.149zm15.3-2.15c0 1.18-.95 2.15-2.12 2.15h-7.25c-1.17 0-2.12-.96-2.12-2.15v-.17c0-1.179.95-2.148 2.12-2.148h.91a3.63 3.63 0 0 0 3.45-2.97c2.9.83 4.64 3.08 4.96 4.659v.04c.04.18.06.32.06.43v.17z"
      })
    }))
  }, props));
}

__name(BeautyCategoryIcon, "BeautyCategoryIcon");

function BeautyCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M13.92 6.21c0-1.15-.93-2.08-2.07-2.08h-.72a1.13 1.13 0 0 1-1.11-1.12V1.75h4.37c.62 0 1.13.5 1.13 1.13v1h1.75v-1A2.88 2.88 0 0 0 14.39 0h-8v1.75h1.88v1.26c0 .61-.5 1.11-1.11 1.12h-.57c-1.14 0-2.07.93-2.07 2.08V8h9.4zM23.93 19.2l-.03-.12c-.51-2.53-3.19-5.5-7.26-6.2l-1.12-3.13H2.76L.38 16.41c-.48 1.36-.54 2.87.02 4.2C1.79 23.91 5.62 24 6.95 24h13.18c2.14 0 3.87-1.74 3.87-3.9v-.17c0-.23-.03-.48-.07-.73m-1.68.9c0 1.19-.95 2.15-2.12 2.15h-7.26c-1.17 0-2.12-.96-2.12-2.15v-.17c0-1.18.95-2.15 2.12-2.15h.92a3.61 3.61 0 0 0 3.44-2.98c2.91.84 4.65 3.09 4.96 4.66v.04c.04.18.06.32.06.43z"
      })
    }))
  }, props));
}

__name(BeautyCategoryFilledIcon, "BeautyCategoryFilledIcon");

function BeerIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M13.5 2h-3l-.482 6.749a.68.68 0 0 1-.196.429l-.313.313A5.15 5.15 0 0 0 8 13.134V21a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7.866a5.16 5.16 0 0 0-1.51-3.643l-.312-.313a.68.68 0 0 1-.196-.43z"
      })
    }))
  }, props));
}

__name(BeerIcon, "BeerIcon");

function BetterIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 8,
        y: 16.5,
        width: 8,
        height: 3,
        rx: 1.5
      }), /* @__PURE__ */jsx("rect", {
        x: 5.5,
        y: 10.5,
        width: 13,
        height: 3,
        rx: 1.5
      }), /* @__PURE__ */jsx("rect", {
        x: 3,
        y: 4.5,
        width: 18,
        height: 3,
        rx: 1.5
      })]
    }))
  }, props));
}

__name(BetterIcon, "BetterIcon");

function BoldIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M5 19.898V4.105h8.421c3.444 0 4.998 1.491 4.998 3.738 0 1.911-.966 3.15-3.78 3.633v.21c3.108.483 4.221 1.848 4.221 3.906 0 2.457-1.827 4.306-5.838 4.306zm7.224-12.412H9.578v2.94h2.667c1.155 0 1.68-.525 1.68-1.512s-.525-1.428-1.701-1.428m.315 5.923H9.578v3.108h2.898c1.26 0 1.848-.505 1.848-1.512 0-1.05-.588-1.597-1.785-1.597"
      })
    }))
  }, props));
}

__name(BoldIcon, "BoldIcon");

function BoostIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M8.5 8.652c2-1.829 2.589-3.327 1.941-6.652 4.47 3.274 3.688 8.64 2.934 11.5 2.745-1.437 3.02-4.025 2.745-5.74 0 0 2.88 1.697 2.88 7.74 0 2.957-2.5 6.5-6.992 6.5C8.826 22 5 19.085 5 15.543c0-3.543 1.75-5.29 3.5-6.89"
      })
    }))
  }, props));
}

__name(BoostIcon, "BoostIcon");

function BugIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.113 5.3 8.872 2.509l-1.744.98L8.35 6.236A6 6 0 0 0 6.34 8.998H4v2h2v2H4v2h2v1q0 .511.083 1H4v2h2.803a6 6 0 0 0 5.197 3c2.22 0 4.16-1.207 5.197-3H20v-2h-2.083q.083-.489.083-1v-1h2v-2h-2v-2h2v-2h-2.341a6 6 0 0 0-2.009-2.762l1.222-2.748-1.744-.98-1.24 2.793A6 6 0 0 0 12 4.998c-.66 0-1.294.106-1.887.303M11 9.999v7h2v-7z"
      })
    }))
  }, props));
}

__name(BugIcon, "BugIcon");

function BulletIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 6 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      })
    }))
  }, props));
}

__name(BulletIcon, "BulletIcon");

var BulletIcon_default = BulletIcon;

function CCPAOptOutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 16.141h4.857l2.215-8.286H7a4.146 4.146 0 0 0-4.143 4.143A4.146 4.146 0 0 0 7 16.141",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.857 7H7a4.97 4.97 0 0 0-5 5c0 2.786 2.214 5 5 5h10.857c2.786 0 5-2.214 5-5s-2.286-5-5-5m-15 5A4.146 4.146 0 0 1 7 7.857h7.071l-2.214 8.286H7A4.146 4.146 0 0 1 2.857 12",
        fill: "#06F"
      }), /* @__PURE__ */jsx("path", {
        d: "M19.286 9.857a.434.434 0 0 1 0 .572L17.786 12l1.571 1.571a.435.435 0 0 1 0 .572.435.435 0 0 1-.571 0l-1.572-1.572-1.57 1.572a.435.435 0 0 1-.572 0 .435.435 0 0 1 0-.572l1.5-1.571L15 10.429a.435.435 0 0 1 0-.572.435.435 0 0 1 .572 0l1.571 1.572 1.572-1.572a.435.435 0 0 1 .57 0",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M10.786 9.927c.143.143.214.429.071.572l-3 3.5c-.071.071-.143.143-.214.143a.44.44 0 0 1-.5-.072L5.572 12.5a.434.434 0 0 1 0-.572.434.434 0 0 1 .57 0l1.287 1.215 2.714-3.215c.143-.142.428-.142.643 0",
        fill: "#06F"
      })]
    }))
  }, props));
}

__name(CCPAOptOutIcon, "CCPAOptOutIcon");

function CaffeineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.578 4.523c-.078.232-.078.52-.078 1.095V8.5A7 7 0 0 0 15.862 13H18a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 18 5h-.507a1.7 1.7 0 0 0-.07-.477 1.5 1.5 0 0 0-.946-.945c-.232-.078-.52-.078-1.095-.078H5.618c-.575 0-.863 0-1.095.078a1.5 1.5 0 0 0-.945.945M17.04 11c.297-.776.46-1.62.46-2.5V7h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zM3.5 19A1.5 1.5 0 0 1 5 17.5h11a1.5 1.5 0 0 1 0 3H5A1.5 1.5 0 0 1 3.5 19"
      })
    }))
  }, props));
}

__name(CaffeineIcon, "CaffeineIcon");

function CaffeineFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-2c1.849 0 3.55-.627 4.906-1.68l-.82-.82H8.382a.882.882 0 1 1 0-1.765h5.939l-1.39-1.39a4.118 4.118 0 0 1-5.43-3.904V8.914l-1.82-1.82A8 8 0 0 0 12 20M8.914 7.5l-1.82-1.82A8 8 0 0 1 18.32 16.906l-3.674-3.674a4 4 0 0 0 .126-.144h1.257a1.47 1.47 0 0 0 1.471-1.47V9.853a1.47 1.47 0 0 0-1.47-1.47h-.299a1 1 0 0 0-.041-.281.88.88 0 0 0-.557-.556c-.136-.046-.305-.046-.643-.046zm6.821 2.941c0 .518-.095 1.014-.27 1.47h.564a.294.294 0 0 0 .294-.293V9.853a.294.294 0 0 0-.294-.294h-.294z"
      })
    }))
  }, props));
}

__name(CaffeineFreeIcon, "CaffeineFreeIcon");

function CallIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M7 4H2c0 11 7 18 18 18v-5l-4-2-2 2c-3-1-6-4-7-7l2-2z"
      }), /* @__PURE__ */jsx("path", {
        d: "M14 6h2.586l-4.293 4.293 1.414 1.414L18 7.414V10h2V4h-6z"
      })]
    }))
  }, props));
}

__name(CallIcon, "CallIcon");

function CameraIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.59 3H9.41l-3 3H2v14h20V6h-4.41zM15 13c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3m-8 0c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5"
      })
    }))
  }, props));
}

__name(CameraIcon, "CameraIcon");

function CarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m17 3 4 8v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2H7v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9l4-8zm.764 6H6.236l2-4h7.528zM19 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M6.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      })
    }))
  }, props));
}

__name(CarIcon, "CarIcon");

function CardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2H2z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 10h20v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm9 4H5v2h6z"
      })]
    }))
  }, props));
}

__name(CardIcon, "CardIcon");

function CarouselIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 3h8v18H8zM2 5h4v14H2zm20 0h-4v14h4z"
      })
    }))
  }, props));
}

__name(CarouselIcon, "CarouselIcon");

function CartIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m6.84 2.68-1.27-.19-.17-.03L2.29 2 2 3.93l3.16.47 2.2 12.84h14.18v-1.95H9l-.34-2 11.92-1.58L22 4.99 6.84 2.69zm1.14 19.27a1.62 1.62 0 1 0 0-3.24 1.62 1.62 0 0 0 0 3.24m11.94 0a1.62 1.62 0 1 0 0-3.24 1.62 1.62 0 0 0 0 3.24"
      })
    }))
  }, props));
}

__name(CartIcon, "CartIcon");

var CartIcon_default = CartIcon;

function CartOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m1.99 3.977 3.184.482 2.19 12.783h14.175v-2H9.05l-.336-1.965 11.873-1.57L22 4.987 2.291 2zm17.618 2.67L7.258 4.775l1.118 6.53L18.92 9.91z"
      }), /* @__PURE__ */jsx("path", {
        d: "M7.98 21.95a1.62 1.62 0 1 0 .001-3.24 1.62 1.62 0 0 0 0 3.24M19.92 21.95a1.62 1.62 0 1 0 .001-3.24 1.62 1.62 0 0 0 0 3.24"
      })]
    }))
  }, props));
}

__name(CartOutlineIcon, "CartOutlineIcon");

function CatIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m20.984 17-9.5 5 .009-4.5-5.165-.363a3 3 0 0 1-2.614-1.98L3 13.163l1.375-1.694a6.2 6.2 0 0 1 4.302-5.035l2.808-.872L12.688 2z"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.688 2c1.833 1.469 6.55 8.008 8.312 14.984-5.284 0-8.312-10.488-8.312-14.984"
      })]
    }))
  }, props));
}

__name(CatIcon, "CatIcon");

function CategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M6.5 22a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M17.07 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M11 2H2v9h9z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.07 13 22 22h-9.86z"
      })]
    }))
  }, props));
}

__name(CategoryIcon, "CategoryIcon");

function CentIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m12.732 18.338-.179.008L12.308 21H9.814l.308-2.877-.168-.046c-1.335-.369-2.39-1.082-3.112-2.091s-1.122-2.331-1.122-3.93c0-1.715.513-3.193 1.442-4.288s2.282-1.822 3.991-2.018l.163-.019L11.605 3h2.498l-.287 2.843.18.038c1.268.271 2.233.848 2.921 1.676.65.78 1.065 1.797 1.248 3.02h-3.172c-.139-.721-.408-1.322-.852-1.752-.483-.467-1.148-.71-2.004-.71-.968 0-1.769.34-2.322 1.012-.55.667-.835 1.636-.835 2.862 0 1.283.309 2.27.876 2.94.57.673 1.381 1 2.325 1q1.284 0 2.026-.708c.457-.437.738-1.057.877-1.82h3.197c-.201 1.5-.747 2.671-1.62 3.494-.918.864-2.22 1.367-3.93 1.443"
      })
    }))
  }, props));
}

__name(CentIcon, "CentIcon");

function ChampagneIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.762 2H9.238L8.04 11.107c-.291 2.216 1.041 4.23 2.96 4.758V20l-3 1v1h8v-1l-3-1v-4.135c1.919-.528 3.251-2.542 2.96-4.758z"
      })
    }))
  }, props));
}

__name(ChampagneIcon, "ChampagneIcon");

function ChatIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.25 2.25a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-3v5l-6-5h-9a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1zm-2 4.004h-14v1.984h14zm-7 3.974h-7v2.033h7z"
      })
    }))
  }, props));
}

__name(ChatIcon, "ChatIcon");

function ChatOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12.974 14.25 3.276 2.73v-2.73h4v-10h-16v10zm5.276 7-6-5h-9a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-3zm0-13h-12v-2h12zm-12 4h6v-2h-6z"
      })
    }))
  }, props));
}

__name(ChatOutlineIcon, "ChatOutlineIcon");

function CheckboxDisabledIndeterminateIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 2H2v20h20zm-4 9H6v2h12z",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(CheckboxDisabledIndeterminateIcon, "CheckboxDisabledIndeterminateIcon");

var CheckboxDisabledIndeterminateIcon_default = CheckboxDisabledIndeterminateIcon;

function CheckboxDisabledSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 2H2v20h20zm-5.207 5.293L10 14.086l-2.793-2.793-1.414 1.414L10 16.914l8.207-8.207z",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(CheckboxDisabledSelectedIcon, "CheckboxDisabledSelectedIcon");

var CheckboxDisabledSelectedIcon_default = CheckboxDisabledSelectedIcon;

function CheckboxDisabledUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 4H4v16h16zM2 2v20h20V2z",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(CheckboxDisabledUnselectedIcon, "CheckboxDisabledUnselectedIcon");

var CheckboxDisabledUnselectedIcon_default = CheckboxDisabledUnselectedIcon;

function CheckboxIndeterminateIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 2H2v20h20zm-4 9H6v2h12z"
      })
    }))
  }, props));
}

__name(CheckboxIndeterminateIcon, "CheckboxIndeterminateIcon");

var CheckboxIndeterminateIcon_default = CheckboxIndeterminateIcon;

function CheckboxSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 2H2v20h20zm-5.207 5.293L10 14.086l-2.793-2.793-1.414 1.414L10 16.914l8.207-8.207z"
      })
    }))
  }, props));
}

__name(CheckboxSelectedIcon, "CheckboxSelectedIcon");

var CheckboxSelectedIcon_default = CheckboxSelectedIcon;

function CheckboxUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 4H4v16h16zM2 2v20h20V2z"
      })
    }))
  }, props));
}

__name(CheckboxUnselectedIcon, "CheckboxUnselectedIcon");

var CheckboxUnselectedIcon_default = CheckboxUnselectedIcon;

function ChevronDownIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 12.52 7.792 8.314 6.208 9.896 12 15.688l5.792-5.792-1.584-1.584z"
      })
    }))
  }, props));
}

__name(ChevronDownIcon, "ChevronDownIcon");

var ChevronDownIcon_default = ChevronDownIcon;

function ChevronLeftIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m11.48 11.999 4.208-4.208-1.584-1.584-5.792 5.792 5.792 5.792 1.584-1.584z"
      })
    }))
  }, props));
}

__name(ChevronLeftIcon, "ChevronLeftIcon");

var ChevronLeftIcon_default = ChevronLeftIcon;

function ChevronRightIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12.52 12.001-4.208 4.208 1.584 1.584 5.792-5.792-5.792-5.792-1.584 1.584z"
      })
    }))
  }, props));
}

__name(ChevronRightIcon, "ChevronRightIcon");

var ChevronRightIcon_default = ChevronRightIcon;

function ChevronUpIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 11.48 4.208 4.208 1.584-1.584L12 8.312l-5.792 5.792 1.584 1.584z"
      })
    }))
  }, props));
}

__name(ChevronUpIcon, "ChevronUpIcon");

var ChevronUpIcon_default = ChevronUpIcon;

function ChildIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 9c1.658 0 3-1.342 3-3s-1.342-3-3-3-3 1.342-3 3 1.342 3 3 3m4.434 3.592c.97-.184 1.811-.412 2.515-.641.812-.264 1.44-.53 1.873-.734a10 10 0 0 0 .677-.35l.012-.008.005-.002.002-.002L21 10l-.518-.855-.018.01-.092.051c-.086.046-.22.116-.402.202-.363.171-.915.405-1.64.641-1.45.472-3.595.951-6.33.951s-4.88-.48-6.33-.95a14 14 0 0 1-1.64-.642 8 8 0 0 1-.494-.253l-.018-.01L3 10c-.519.855-.518.856-.518.856h.002l.005.003.012.008.04.023.136.076c.117.063.284.15.5.251.433.204 1.062.47 1.874.734.704.229 1.545.457 2.515.641L8.5 21h7z"
      })
    }))
  }, props));
}

__name(ChildIcon, "ChildIcon");

function ClearIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m5-11H7v2h10z"
      })
    }))
  }, props));
}

__name(ClearIcon, "ClearIcon");

var ClearIcon_default = ClearIcon;

function CloseIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 10.415 6.292 4.707 4.708 6.291l5.708 5.708-5.708 5.708 1.584 1.584L12 13.583l5.708 5.708 1.584-1.584-5.708-5.708 5.708-5.708-1.584-1.584z"
      })
    }))
  }, props));
}

__name(CloseIcon, "CloseIcon");

var CloseIcon_default = CloseIcon;

function ClosedCaptionsOffIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.001 19.546 3.327 3.043 2.002 4.54l.606.536a1 1 0 0 0-.608.92v11.988a1 1 0 0 0 1 1h15.346l2.33 2.059zm-10.763-6.844.33.291c-.288 1.312-1.21 2.129-2.88 2.129-1.92 0-3.095-1.15-3.095-3.084 0-1.352.598-2.389 1.64-2.876l.997.882c-.768.187-1.242.86-1.235 1.922 0 1.392.712 2.023 1.717 2.023.899 0 1.369-.478 1.53-1.287z"
      }), /* @__PURE__ */jsx("path", {
        d: "M15.475 9.991c-.377 0-.705.094-.97.274l2.757 2.437H18.4a3.5 3.5 0 0 1-.213.816L22 16.888V5.996a1 1 0 0 0-1-.999H8.543l5.015 4.433c.506-.367 1.16-.571 1.933-.571 1.758 0 2.721.987 2.916 2.452h-1.393c-.154-.825-.608-1.319-1.54-1.319"
      })]
    }))
  }, props));
}

__name(ClosedCaptionsOffIcon, "ClosedCaptionsOffIcon");

function ClosedCaptionsOnIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm3.593 6.049c0 1.936 1.175 3.086 3.094 3.086 1.79 0 2.722-.94 2.933-2.422h-1.377C10.08 13.523 9.61 14 8.712 14c-1.005 0-1.717-.632-1.717-2.025-.009-1.264.664-1.977 1.7-1.977.932 0 1.386.494 1.54 1.32h1.393c-.195-1.466-1.159-2.454-2.916-2.454-1.936 0-3.119 1.28-3.119 3.184m6.78 0c0 1.936 1.174 3.086 3.094 3.086 1.79 0 2.721-.94 2.932-2.422h-1.377C16.86 13.523 16.39 14 15.49 14c-1.005 0-1.717-.632-1.717-2.025-.008-1.264.664-1.977 1.7-1.977.932 0 1.386.494 1.54 1.32h1.393c-.195-1.466-1.158-2.454-2.916-2.454-1.936 0-3.119 1.28-3.119 3.184"
      })
    }))
  }, props));
}

__name(ClosedCaptionsOnIcon, "ClosedCaptionsOnIcon");

function CollapseMenuIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M5.5 3A1.5 1.5 0 0 0 4 4.5v15a1.5 1.5 0 0 0 3 0v-15A1.5 1.5 0 0 0 5.5 3M19.218 18.718a1.5 1.5 0 0 1-2.122 0L11.44 13.06a1.5 1.5 0 0 1 0-2.122l5.657-5.657a1.5 1.5 0 1 1 2.122 2.122L14.62 12l4.597 4.596a1.5 1.5 0 0 1 0 2.122"
      })
    }))
  }, props));
}

__name(CollapseMenuIcon, "CollapseMenuIcon");

function ComputerIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 4.867V13H4V4.867zM22 3H2v14h8v2H6v2h12v-2h-4v-2h8z"
      })
    }))
  }, props));
}

__name(ComputerIcon, "ComputerIcon");

function ConfirmIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.792 6.79 9 18.584 3.208 12.79l1.584-1.584L9 15.415 19.208 5.207z"
      })
    }))
  }, props));
}

__name(ConfirmIcon, "ConfirmIcon");

var ConfirmIcon_default = ConfirmIcon;

function ContactSupportIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.18 3.9C7.422 2.75 9.319 2 12 2s4.579.751 5.82 1.9c1.217 1.127 1.68 2.531 1.68 3.6v2.063A2 2 0 0 1 21 11.5v3a2 2 0 0 1-1.5 1.937V17.5c0 .74-.21 1.817-.883 2.752C17.89 21.262 16.69 22 15 22h-3.5a1.5 1.5 0 0 1 0-3H15c.711 0 1.01-.263 1.183-.502.227-.315.317-.738.317-.998v-1.063A2 2 0 0 1 15 14.5v-3a2 2 0 0 1 1.5-1.937V7.5c0-.264-.137-.86-.72-1.4C15.222 5.583 14.119 5 12 5s-3.221.582-3.78 1.1c-.583.54-.72 1.136-.72 1.4v2.063A2 2 0 0 1 9 11.5v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 1.5-1.937V7.5c0-1.069.463-2.473 1.68-3.6"
      })
    }))
  }, props));
}

__name(ContactSupportIcon, "ContactSupportIcon");

function ConvenienceCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M24 13.5c0-4.56-2.32-7.72-2.75-8.25l1-5.25-2.34 1.5L17.75 0 15 1.5 12.5 0 10 1.5 7.25 0 5 1.5 2.75 0l1 5.25C3.32 5.78 1 8.94 1 13.5 1 18.55 2.5 21 2.5 21L2 24h21l-.5-3s1.5-2.45 1.5-7.5M5.97 2.96l1.37-.91 1.82.99.88.48.86-.52 1.6-.96 1.6.96.86.52 2.68-1.46 1.28.88.88.61-.21 1.08H5.41l-.22-1.15zm-.88 3.42h14.82c.17.21 2.34 2.98 2.34 7.12 0 2.98-.56 4.92-.93 5.88H3.68c-.37-.96-.93-2.9-.93-5.88 0-4.14 2.17-6.91 2.34-7.12M4.06 22.26l.16-.96.02-.16h16.5l.03.16.16.96z"
      }), /* @__PURE__ */jsx("path", {
        d: "M9.08 15.86c.72.76 1.72 1.14 2.78 1.14 1.16 0 2.38-.45 3.37-1.35 1.89-1.72 2.2-4.41.69-6.01-.72-.76-1.72-1.14-2.78-1.14-1.16 0-2.38.45-3.37 1.35-1.89 1.72-2.2 4.41-.69 6.01m1.87-4.71c.63-.57 1.43-.9 2.19-.9.61 0 1.15.21 1.51.59.42.45.49 1 .48 1.38-.03.77-.42 1.54-1.07 2.14-.63.57-1.43.9-2.19.9-.61 0-1.15-.21-1.51-.59-.42-.45-.49-1-.48-1.38.03-.77.42-1.54 1.07-2.14"
      })]
    }))
  }, props));
}

__name(ConvenienceCategoryIcon, "ConvenienceCategoryIcon");

function ConvenienceCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20.88 4.62 21.76 0l-2.33 1.5L17.26 0l-2.75 1.5-2.5-1.5-2.5 1.5L6.76 0 4.51 1.5 2.26 0l.88 4.62zM1.99 21.12 1.51 24h21l-.48-2.88zM22.68 19.38c.4-1.23.83-3.19.83-5.88 0-3.21-1.15-5.73-1.98-7.12H2.49C1.66 7.77.51 10.29.51 13.5c0 2.69.43 4.65.83 5.88zm-10.03-9.13c.61 0 1.15.21 1.51.59.42.45.49 1 .48 1.38-.03.77-.42 1.54-1.07 2.14-.63.57-1.43.9-2.19.9-.61 0-1.15-.21-1.51-.59-.42-.45-.49-1-.48-1.38.03-.77.42-1.54 1.07-2.14.63-.57 1.43-.9 2.19-.9"
      })
    }))
  }, props));
}

__name(ConvenienceCategoryFilledIcon, "ConvenienceCategoryFilledIcon");

function CoolIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 8a2 2 0 0 1 2-2h2V4H9a4 4 0 0 0-2.981 6.667l1.49-1.334A2 2 0 0 1 7 8m8 0a2 2 0 1 0 0 4h6v2h-6a4 4 0 0 1 0-8h2v2zm-8 6a2 2 0 1 0 0 4h11v2H7a4 4 0 0 1 0-8h2v2z"
      })
    }))
  }, props));
}

__name(CoolIcon, "CoolIcon");

function CopyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 4h9v13H9zM7 5V2h13v17h-3v3H4V5z"
      })
    }))
  }, props));
}

__name(CopyIcon, "CopyIcon");

function CornerIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("g", {
        clipPath: "url(#prefix__clip0)",
        children: /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.05 5.52h9.9l.028.001q.047 0 .093.005l-.121-.005a1.497 1.497 0 0 1 1.5 1.5v9.9a1.5 1.5 0 0 1-1.5 1.5l-.154-.008a1.5 1.5 0 0 1-1.346-1.493v-6.278L8.111 17.98a1.5 1.5 0 0 1-2.121 0l-.098-.107a1.5 1.5 0 0 1 .098-2.014l7.339-7.34H7.05a1.5 1.5 0 1 1 0-3"
        })
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(CornerIcon, "CornerIcon");

function CropIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 16h13v2h-3v3h-2v-3H6V8H3V6h3V3h2zm8-2V8h-6V6h8v8z"
      })
    }))
  }, props));
}

__name(CropIcon, "CropIcon");

function CutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.837 8.447a1.511 1.511 0 1 0-.085-.045l.001-.003zM8.5 9.985a3.51 3.51 0 1 0-3.62.22l3.109 1.794-3.108 1.795-.129.07a3.51 3.51 0 1 0 3.748.15l1.489-.86 8.392 4.845h2.1l.475-.823L11.989 12l.003-.002-1.999-1.155-.004.002zM18.381 6l-6.388 3.689 2 1.155 6.963-4.021-.475-.823zM5.753 15.6l-.001-.002a1.51 1.51 0 1 0 .085-.046z"
      })
    }))
  }, props));
}

__name(CutIcon, "CutIcon");

function DairyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 2.5a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 0-3zm-.79 4a.71.71 0 0 0-.71.71v.113c0 1.103-.257 2.19-.75 3.177A7.1 7.1 0 0 0 8 13.677V20a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 16 20v-6.323c0-1.103-.257-2.19-.75-3.177a7.1 7.1 0 0 1-.75-3.177V7.21a.71.71 0 0 0-.71-.711z"
      })
    }))
  }, props));
}

__name(DairyIcon, "DairyIcon");

function DairyFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M10.095 6.286c0-.526.427-.953.953-.953h1.904a.952.952 0 1 1 0 1.905h-1.904a.95.95 0 0 1-.953-.952"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M6.989 5.642a8.095 8.095 0 0 1 11.37 11.37l-3.026-3.026v-1.2a3.8 3.8 0 0 0-.754-2.275l-.287-.386a1.9 1.9 0 0 1-.377-1.137V8.57a.95.95 0 0 0-.952-.952h-1.878a.95.95 0 0 0-.952.952v.215zm2.37 5.063L5.642 6.99a8.095 8.095 0 0 0 11.37 11.37l-1.679-1.679v1.034a.95.95 0 0 1-.952.953H9.714a.95.95 0 0 1-.952-.953v-4.962c0-.726.208-1.436.597-2.047"
      })]
    }))
  }, props));
}

__name(DairyFreeIcon, "DairyFreeIcon");

function DashboardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11 3H3v5h8zM11 10H3v11h8zM13 16h8v5h-8zM21 3h-8v11h8z"
      })
    }))
  }, props));
}

__name(DashboardIcon, "DashboardIcon");

function DateIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 3h2v2h3v3H3V5h3V3h2v2h8zM3 10h18v11H3zm5.5 2h-3v2.625h3zm-3 4.375h3V19h-3zm8-4.375h-3v2.625h3zm2 0h3v2.625h-3zm-2 4.375h-3V19h3z"
      })
    }))
  }, props));
}

__name(DateIcon, "DateIcon");

var DateIcon_default = DateIcon;

function DealsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M24 1.28 22.8 0c-.5.47-.99.95-1.45 1.42L13.5 0C9.91 5.52 7.63 8.83 0 13.5L10.34 24C19.75 19.34 24 10.34 24 10.34l-1.42-7.68c.45-.45.93-.92 1.42-1.38m-9.25 17.75-8.19-7.99c3.43-2.82 5.41-5.53 7.77-9.11l5.54 1.01a68 68 0 0 0-1.46 1.58c-.62-.11-1.32.1-1.87.61-.86.81-1.01 2.07-.32 2.83.69.75 1.95.71 2.81-.1.65-.6.89-1.46.68-2.17.38-.42.85-.94 1.38-1.5l1.08 5.87c-.75 1.37-3.17 5.44-7.42 8.97m-4.08 2.82-7.9-8.03q1.305-.87 2.4-1.68l8.18 7.98c-.83.62-1.73 1.2-2.68 1.73"
      })
    }))
  }, props));
}

__name(DealsCategoryIcon, "DealsCategoryIcon");

function DealsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M3.9 10.89c-1.13.84-2.41 1.7-3.9 2.61L10.34 24c1.57-.78 3-1.68 4.29-2.65zM24 1.28 22.8 0c-.51.47-.99.95-1.46 1.42L13.5 0c-2.58 3.97-4.49 6.8-8.2 9.82l10.71 10.44c5.47-4.58 7.99-9.92 7.99-9.92l-1.42-7.68c.46-.46.93-.92 1.42-1.38m-7.46 3.85c.86-.81 2.12-.85 2.81-.1.69.76.55 2.02-.32 2.83-.86.81-2.12.85-2.81.1-.69-.76-.54-2.02.32-2.83"
      })
    }))
  }, props));
}

__name(DealsCategoryFilledIcon, "DealsCategoryFilledIcon");

function DecreaseIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M6 8h12l-6 8z"
      })
    }))
  }, props));
}

__name(DecreaseIcon, "DecreaseIcon");

function DeliveryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5 3.5v2h3v16h-16v-3h8v-2h-10v-2h10v-2h-12v-2h4v-5h3v-2l2-2h6zm-2 0h-6v2h6z"
      })
    }))
  }, props));
}

__name(DeliveryIcon, "DeliveryIcon");

var DeliveryIcon_default = DeliveryIcon;

function DeliveryOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5 5.5v-2l-2-2h-6l-2 2v2h-3v5h-4v2h12v-2h-6v-3h12v12h-12v-1h-2v3h16v-16zm-11 11h6v-2h-10v2h4m9-11v-2h-6v2z"
      })
    }))
  }, props));
}

__name(DeliveryOutlineIcon, "DeliveryOutlineIcon");

function DiamondCartStarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.002 3 5.639 5.639 3 12.002l2.639 6.363L12.002 21l6.363-2.635L21 12.002l-2.635-6.363z",
        fill: "#92FFF8"
      }), /* @__PURE__ */jsx("path", {
        d: "m3 12.002 3.281-2.355.016 4.714z",
        fill: "#22ABBA"
      }), /* @__PURE__ */jsx("path", {
        d: "m12.002 3 2.364 3.297H9.639z",
        fill: "#3CCED6"
      }), /* @__PURE__ */jsx("path", {
        d: "m21 12.002-3.293 2.36V9.638z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.002 21 9.64 17.706h4.727z",
        fill: "#147A99"
      }), /* @__PURE__ */jsx("path", {
        d: "m18.366 18.366-4-.66 3.341-3.344z",
        fill: "#22ABBA"
      }), /* @__PURE__ */jsx("path", {
        d: "m18.366 5.639-.659 4-3.341-3.342z",
        fill: "#DCFFFB"
      }), /* @__PURE__ */jsx("path", {
        d: "m5.639 5.639 4 .658-3.358 3.35z",
        fill: "#3CCED6"
      }), /* @__PURE__ */jsx("path", {
        d: "m9.639 17.707-4 .659.658-4.004z",
        fill: "#147A99"
      }), /* @__PURE__ */jsx("path", {
        d: "m3 12.002 3.297 2.36-.658 4.003z",
        fill: "#3CCED6"
      }), /* @__PURE__ */jsx("path", {
        d: "m14.366 17.707-8.084-8.06.016 4.714 3.341 3.346z",
        fill: "#92FFF8"
      }), /* @__PURE__ */jsx("path", {
        d: "m7.028 9.954.012-.012.004.008z",
        fill: "#DCFFFB"
      }), /* @__PURE__ */jsx("path", {
        d: "m6.281 9.646.016-.008V9.63L9.64 6.297h4.726l3.341 3.341v4.723l-3.341 3.345H9.639l-3.342-3.345z",
        fill: "#6AE9E1"
      }), /* @__PURE__ */jsx("path", {
        d: "m17.706 9.639-7.385 4.036 4.044-7.378z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M9.639 17.707 12.002 21l-6.363-2.635z",
        fill: "#3CCED6"
      })]
    }))
  }, props));
}

__name(DiamondCartStarIcon, "DiamondCartStarIcon");

function DiamondWithBackgroundCartStarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_6197_5246)",
        children: [/* @__PURE__ */jsx("circle", {
          cx: 12,
          cy: 12,
          r: 12,
          fill: "#003D29"
        }), /* @__PURE__ */jsx("path", {
          d: "M12.002 3 5.639 5.639 3 12.002l2.639 6.363L12.002 21l6.363-2.635L21 12.002l-2.635-6.363z",
          fill: "#92FFF8"
        }), /* @__PURE__ */jsx("path", {
          d: "M12.002 21 9.64 17.706h4.727z",
          fill: "#147A99"
        }), /* @__PURE__ */jsx("path", {
          d: "m3 12.002 3.281-2.355.016 4.714z",
          fill: "#22ABBA"
        }), /* @__PURE__ */jsx("path", {
          d: "m12.002 3 2.364 3.297H9.639z",
          fill: "#3CCED6"
        }), /* @__PURE__ */jsx("path", {
          d: "m21 12.002-3.293 2.36V9.638z",
          fill: "#fff"
        }), /* @__PURE__ */jsx("path", {
          d: "m18.366 18.366-4-.66 3.341-3.344z",
          fill: "#22ABBA"
        }), /* @__PURE__ */jsx("path", {
          d: "m18.366 5.639-.659 4-3.341-3.342z",
          fill: "#DCFFFB"
        }), /* @__PURE__ */jsx("path", {
          d: "m5.639 5.639 4 .658-3.358 3.35z",
          fill: "#3CCED6"
        }), /* @__PURE__ */jsx("path", {
          d: "m9.639 17.707-4 .659.658-4.004z",
          fill: "#147A99"
        }), /* @__PURE__ */jsx("path", {
          d: "m3 12.002 3.297 2.36-.658 4.003z",
          fill: "#3CCED6"
        }), /* @__PURE__ */jsx("path", {
          d: "m7.028 9.954.012-.012.004.008z",
          fill: "#DCFFFB"
        }), /* @__PURE__ */jsx("path", {
          d: "m17.706 9.639-7.385 4.036 4.044-7.378z",
          fill: "#fff"
        }), /* @__PURE__ */jsx("path", {
          d: "m6.281 9.646.016-.008V9.63L9.64 6.297h4.726l3.341 3.341v4.723l-3.341 3.345H9.639l-3.342-3.345z",
          fill: "#6AE9E1"
        }), /* @__PURE__ */jsx("path", {
          d: "m14.366 17.707-8.084-8.06.016 4.714 3.341 3.346z",
          fill: "#92FFF8"
        }), /* @__PURE__ */jsx("path", {
          d: "M9.639 17.707 12.002 21l-6.363-2.635z",
          fill: "#3CCED6"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_6197_5246",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(DiamondWithBackgroundCartStarIcon, "DiamondWithBackgroundCartStarIcon");

function DirectionsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 2 10 10-10 10L2 12zm5 9-3-3v2.003h-2.757a3.22 3.22 0 0 0-3.22 3.22v1.68h2v-1.68c0-.67.545-1.22 1.22-1.22H14V14z"
      })
    }))
  }, props));
}

__name(DirectionsIcon, "DirectionsIcon");

function DislikeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m14.8 13.463 1.2-.397V3H6.033A3.25 3.25 0 0 0 2.83 5.608L2.5 7.274C2.17 8.95 2 10.646 2 12.352c0 .942.77 1.706 1.721 1.706h3.963c.73 0 1.321.585 1.321 1.309v3.55c0 1.15.94 2.083 2.101 2.083h.901l.73-5.088c.16-1.14.961-2.082 2.062-2.45M18 13h3V3h-3z"
      })
    }))
  }, props));
}

__name(DislikeIcon, "DislikeIcon");

var DislikeIcon_default = DislikeIcon;

function DogIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.002 1.996c2.022 1.313 4.37 4.195 6.28 8.035.685 1.38 1.23 2.79 1.645 4.03l-8.92 3.61v-1.668H7.032c-.736 0-1.988-.226-2.703-.972-.43-.45-1.34-4.032-1.34-4.032l4.627-1.47s-.088-1.541.31-2.01c.712-.837 4.044-1.535 4.044-1.535zm-.994 17.833v2.178L21 17.942s-.154-.772-.485-1.962z"
      })
    }))
  }, props));
}

__name(DogIcon, "DogIcon");

function DollarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11.069 4.417V2.5h2.193v1.936l.177.024c1.435.198 2.472.725 3.19 1.465.667.689 1.07 1.575 1.248 2.586h-3.02c-.108-.595-.35-1.098-.792-1.458-.482-.392-1.17-.59-2.091-.59-.837 0-1.495.182-1.949.53-.46.356-.687.867-.687 1.467 0 .528.167.968.56 1.302.38.323.952.528 1.723.648l2.195.384c1.663.284 2.726.794 3.376 1.504.647.706.912 1.64.912 2.837 0 1.138-.368 2.14-1.122 2.904-.757.766-1.919 1.312-3.539 1.5l-.18.021v1.94h-2.194v-1.92l-.183-.02c-1.589-.167-2.78-.682-3.604-1.452-.772-.722-1.236-1.683-1.392-2.832h3.174c.105.674.391 1.234.89 1.632.538.43 1.298.65 2.276.65.975 0 1.694-.213 2.173-.6.485-.392.697-.94.697-1.545 0-.55-.145-1.022-.53-1.388-.376-.358-.957-.592-1.772-.733l-2.348-.385h-.002c-1.404-.22-2.423-.672-3.09-1.344-.664-.668-1.003-1.577-1.003-2.762 0-1.157.388-2.148 1.138-2.898.751-.751 1.883-1.276 3.397-1.464z"
      })
    }))
  }, props));
}

__name(DollarIcon, "DollarIcon");

var DollarIcon_default = DollarIcon;

function DonateCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 12.99-.54-.42.01.01-.012-.01c-.32-.252-4.695-3.694-5.758-6.4-.48-1.22-.42-2.49.17-3.49.53-.9 1.43-1.5 2.48-1.64C9.66.86 11 1.35 12.01 2.3c.99-.96 2.33-1.44 3.65-1.27 1.04.14 1.95.74 2.48 1.64.59 1 .65 2.27.17 3.49-1.063 2.706-5.437 6.148-5.758 6.4l-.012.01zM8.58 2.77c-.51.07-.94.35-1.2.79h.01c-.32.54-.33 1.23-.05 1.96.65 1.67 3.23 4.04 4.67 5.23 1.44-1.19 4.02-3.56 4.67-5.23.28-.73.27-1.42-.05-1.96a1.59 1.59 0 0 0-1.2-.79c-1-.13-2.06.41-2.68 1.38l-.74 1.15-.74-1.15c-.56-.87-1.47-1.4-2.38-1.4-.11 0-.21.01-.31.02M21.13 16.46c.82-.25 1.73.01 2.3.66v-.01c.44.5.64 1.16.54 1.83-.11.66-.5 1.24-1.08 1.58l-5.57 3.27c-.85.5-1.83.76-2.81.76-.24 0-.48-.01-.72-.05l-9.42-1.24V25H0v-1.75h2.62v-5.82H0v-1.75h4.37v.37c.52-.13 1.03-.31 1.51-.54l.68-.34c1.24-.6 2.65-.72 3.97-.35l4.73 1.34c.65.18 1.17.65 1.44 1.28.04.1.07.19.09.29zm-4.7 5.83L22 19.02v.01c.17-.1.22-.26.24-.34.01-.09.01-.25-.12-.4a.48.48 0 0 0-.5-.14l-5.24 1.54c-.53.71-1.43 1.09-2.34.93l-4.78-.79.29-1.73 4.77.8c.29.05.59-.1.73-.36.1-.19.06-.34.03-.42a.45.45 0 0 0-.3-.27l-4.73-1.34c-.9-.26-1.87-.17-2.72.25l-.68.33c-.72.35-1.49.61-2.28.78v3.64l9.65 1.27c.83.11 1.69-.06 2.41-.49"
      })
    }))
  }, props));
}

__name(DonateCategoryIcon, "DonateCategoryIcon");

function DonateCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m11.457 12.567.54.42.54-.42.012-.01c.32-.252 4.694-3.693 5.756-6.398.48-1.22.42-2.49-.17-3.49a3.39 3.39 0 0 0-2.479-1.64c-1.31-.179-2.66.31-3.649 1.27-.99-.96-2.33-1.439-3.649-1.27-1.05.14-1.95.74-2.48 1.64-.59 1-.65 2.27-.17 3.49 1.063 2.705 5.437 6.146 5.757 6.398l.012.01zM2.62 15.676H0v9.318h2.62zM21.125 16.446c.82-.24 1.73.02 2.3.66h.01c.45.5.64 1.17.54 1.83-.11.66-.5 1.24-1.08 1.579l-5.57 3.27c-.849.5-1.829.759-2.808.759-.24 0-.48-.02-.72-.05l-9.428-1.24v-7.208c.52-.14 1.03-.31 1.52-.55l.68-.33a5.62 5.62 0 0 1 3.968-.35l4.72 1.34c.72.23 1.139 1 .94 1.74-.2.71-.9 1.16-1.63 1.03l-5-.86-.3 1.72 5 .859c.19.03.37.05.55.05 1.409 0 2.669-.93 3.059-2.34.09-.33.1-.66.09-.98z"
      })
    }))
  }, props));
}

__name(DonateCategoryFilledIcon, "DonateCategoryFilledIcon");

function DoorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 2H6v18H4v2h16v-2h-2zm-4 10h2v2h-2z"
      })
    }))
  }, props));
}

__name(DoorIcon, "DoorIcon");

function DownloadIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11 3h2v9.173l3.243-3.243 1.414 1.414L12 16.001l-5.657-5.657L7.757 8.93 11 12.172zM4 17h2v2h12v-2h2v4H4z"
      })
    }))
  }, props));
}

__name(DownloadIcon, "DownloadIcon");

function EBTIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.099 10.003c.614 0 .849.25.849.72 0 .468-.267.752-.825.752h-1.229v-1.472zM12.237 12.42c.622 0 .905.3.905.8 0 .502-.275.777-.946.777h-1.302V12.42z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm1.5 3.96v6.08h4.398v-1.083H5.866v-1.52h2.62v-.979h-2.62v-1.415h2.951V8.96zm5.028 6.08h2.806c1.487 0 2.183-.695 2.183-1.665 0-.76-.405-1.302-1.48-1.488v-.073c.922-.21 1.27-.695 1.27-1.39 0-.866-.575-1.464-1.868-1.464H9.528zm8.25 0h-1.366V10.1h-1.723V8.96H19.5v1.14h-1.722z"
      })]
    }))
  }, props));
}

__name(EBTIcon, "EBTIcon");

function EBTCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M3.02 2C1.35 2 0 3.35 0 5.02V21h20.98c1.67 0 3.02-1.35 3.02-3.02V2zm19.23 15.98c0 .7-.57 1.27-1.27 1.27H1.75v-10h20.5zM1.75 6v-.98c0-.7.57-1.27 1.27-1.27h19.23V6z"
      }), /* @__PURE__ */jsx("path", {
        d: "M7.25 15.12H4.5v1.75h2.75zM10 11.62H4.5v1.75H10zM14.71 15.99h2.95c.53 0 1.08-.22 1.52-.63.87-.81 1.02-2.07.32-2.83-.35-.38-.84-.55-1.35-.53h-2.9c-.5.03-1.03.24-1.45.63-.87.81-1.02 2.07-.32 2.83.32.35.76.52 1.23.53"
      })]
    }))
  }, props));
}

__name(EBTCategoryIcon, "EBTCategoryIcon");

function EBTCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M3.03 2C1.36 2 0 3.35 0 5.02V6h24V2zM0 21h20.98c1.67 0 3.02-1.35 3.02-3.02V9.25H0zm13.81-8.36c.43-.4.95-.61 1.46-.63h2.9c.51-.02 1 .15 1.35.53.69.75.55 2.02-.32 2.82-.45.42-1 .63-1.53.64h-2.95c-.46-.02-.91-.19-1.23-.54-.69-.75-.55-2.02.32-2.82M4.5 11.62H10v1.76H4.5zm0 3.5h2.75v1.76H4.5z"
      })
    }))
  }, props));
}

__name(EBTCategoryFilledIcon, "EBTCategoryFilledIcon");

function EWGVerifiedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 20a8 8 0 0 0 7.938-7h2.013c-.502 5.053-4.766 9-9.951 9s-9.449-3.947-9.95-9h2.012A8 8 0 0 0 12 20m0-16a8 8 0 0 0-7.938 7H2.049C2.551 5.947 6.815 2 12 2c5.186 0 9.45 3.947 9.952 9h-2.013A8 8 0 0 0 12 4m3.813 7a3.976 3.976 0 0 0-3.843-2.97A3.98 3.98 0 0 0 8 12a3.971 3.971 0 0 0 6.562 3h2.568a5.97 5.97 0 0 1-5.16 2.96C8.67 17.96 6 15.3 6 12s2.68-5.97 5.97-5.97A5.973 5.973 0 0 1 17.856 13H9.57v-2z"
      })
    }))
  }, props));
}

__name(EWGVerifiedIcon, "EWGVerifiedIcon");

function EditIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M16.814 3 21 7.186l-2.512 2.512-4.186-4.186zM12.628 7.186l-8.372 8.372L3 21l5.442-1.256 8.372-8.372z"
      })
    }))
  }, props));
}

__name(EditIcon, "EditIcon");

function EggIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11.95 22C9.584 21.973 5 21.022 5 15.122c0-4.382 1.553-13.016 6.95-13.122H12L12.05 2c5.397.106 6.95 8.741 6.95 13.123 0 5.9-4.584 6.85-6.95 6.876h-.1"
      })
    }))
  }, props));
}

__name(EggIcon, "EggIcon");

function EggFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m3.642-5.011a8.095 8.095 0 0 0 11.37 11.37l-1.104-1.104c-1.095 1.23-2.804 1.495-3.872 1.507h-.071c-1.674-.018-4.917-.66-4.917-4.65 0-1.322.218-3.217.8-4.917zm1.347-1.347L8.697 7.35c.755-1.221 1.814-2.084 3.267-2.111h.072c3.818.072 4.916 5.91 4.916 8.873q-.002.75-.144 1.35l1.55 1.55a8.095 8.095 0 0 0-11.37-11.37"
      })
    }))
  }, props));
}

__name(EggFreeIcon, "EggFreeIcon");

function ElectronicsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M16.56 7.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15.56 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18.56 9.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13.56 10.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.43 7.25v1.63h1.63v1.74H8.43v1.63H6.68v-1.63H5.06V8.88h1.62V7.25z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.63 13.4c.53 1.4.6 2.97.02 4.35h-.01c-1.43 3.4-5.47 3.5-6.87 3.5h-.22L15.05 16h-6l-1.5 5.25h-.22c-1.39 0-5.43-.1-6.86-3.5-.59-1.38-.52-2.95.02-4.35l2.19-7.12c.65-2.1 2.59-3.53 4.78-3.53h9.2c2.2 0 4.13 1.43 4.78 3.53zm-5.76 6.06c2.2-.19 3.57-.97 4.17-2.39v-.01c.38-.9.37-1.98-.04-3.05l-.04-.1-2.19-7.12a3.24 3.24 0 0 0-3.11-2.29h-9.2c-1.44 0-2.69.92-3.11 2.29l-2.19 7.12-.04.12c-.41 1.06-.42 2.14-.04 3.03.6 1.43 1.97 2.21 4.17 2.4l1.13-3.94.36-1.27h8.64l.36 1.27z"
      })]
    }))
  }, props));
}

__name(ElectronicsCategoryIcon, "ElectronicsCategoryIcon");

function ElectronicsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.635 13.4c.53 1.4.6 2.97.02 4.35h-.01c-1.43 3.4-5.47 3.5-6.87 3.5h-.22l-1.5-5.25h-6l-1.5 5.25h-.22c-1.39 0-5.43-.1-6.86-3.5-.59-1.38-.52-2.95.02-4.35l2.19-7.12c.65-2.1 2.59-3.53 4.78-3.53h9.2c2.2 0 4.13 1.43 4.78 3.53zm-8.07-4.65a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m2-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-5.13-1.87V7.25h-1.75v1.63h-1.62v1.74h1.62v1.63h1.75v-1.63h1.63V8.88z"
      })
    }))
  }, props));
}

__name(ElectronicsCategoryFilledIcon, "ElectronicsCategoryFilledIcon");

function ElevatorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 2H6v20h12zm-9.968 9 4-5 4 5zm4 7 4-5h-8z"
      })
    }))
  }, props));
}

__name(ElevatorIcon, "ElevatorIcon");

function EmergencyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M10 3h4v5.536l4.794-2.768 2 3.464L16 12l4.794 2.768-2 3.464L14 15.464V21h-4v-5.536l-4.794 2.768-2-3.464L8 12 3.206 9.232l2-3.464L10 8.536z"
      })
    }))
  }, props));
}

__name(EmergencyIcon, "EmergencyIcon");

function EndCallIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M20 7V2C9 2 2 9 2 20h5l2-4-2-2c1-3 4-6 7-7l2 2z"
      }), /* @__PURE__ */jsx("path", {
        d: "M11.793 18.793 14.586 16l-2.793-2.793 1.414-1.414L16 14.586l2.793-2.793 1.414 1.414L17.414 16l2.793 2.793-1.414 1.414L16 17.414l-2.793 2.793z"
      })]
    }))
  }, props));
}

__name(EndCallIcon, "EndCallIcon");

function ExpandIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 4v2h4.586l-3.793 3.793 1.414 1.414L18 7.414V12h2V4zM6 12H4v8h8v-2H7.414l3.793-3.793-1.414-1.414L6 16.586z"
      })
    }))
  }, props));
}

__name(ExpandIcon, "ExpandIcon");

function ExpandMenuIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M5.5 3A1.5 1.5 0 0 0 4 4.5v15a1.5 1.5 0 0 0 3 0v-15A1.5 1.5 0 0 0 5.5 3M11.78 5.282a1.5 1.5 0 0 1 2.12 0l5.658 5.657a1.5 1.5 0 0 1 0 2.122L13.9 18.718a1.5 1.5 0 1 1-2.122-2.122L16.376 12l-4.597-4.596a1.5 1.5 0 0 1 0-2.122"
      })
    }))
  }, props));
}

__name(ExpandMenuIcon, "ExpandMenuIcon");

function ExpressMultiColorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M22.894 31.791 10.243 4.063q.207-.112.39-.265L14.514.542a2.316 2.316 0 0 1 2.977 0l3.883 3.256c.279.234.608.399.962.482l4.922 1.148a2.316 2.316 0 0 1 1.79 2.265l-.021 5.39c-.002.342.073.68.217.99l2.277 4.876c.447.957.19 2.095-.626 2.767l-4.038 3.329a2.3 2.3 0 0 0-.633.825l-2.183 4.776c-.432.945-1.16 1.12-1.148 1.145",
        fill: "#FFBE1D"
      }), /* @__PURE__ */jsx("path", {
        d: "M10.242 4.062q-.271.146-.573.217L4.747 5.428a2.316 2.316 0 0 0-1.79 2.265l.022 5.39c.001.342-.073.68-.218.99L.484 18.948a2.316 2.316 0 0 0 .626 2.767l4.038 3.329c.271.223.488.505.634.824l2.182 4.777a2.316 2.316 0 0 0 2.653 1.288l4.84-1.174a2.3 2.3 0 0 1 1.092 0l4.84 1.174c.519.126 1.046.066 1.505-.143z",
        fill: "orange"
      }), /* @__PURE__ */jsx("path", {
        d: "M21.344 13.224H17.12a.203.203 0 0 1-.212-.2V6.258c0-.726-1.036-.952-1.38-.3L9.34 18.01c-.24.45.106.977.664.977h4.222c.133 0 .212.1.212.2v6.74c0 .727 1.036.953 1.381.301l6.188-12.052c.212-.426-.133-.952-.664-.952",
        fill: "#343538"
      })]
    }))
  }, props));
}

__name(ExpressMultiColorIcon, "ExpressMultiColorIcon");

function ExpressSingleColorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.388 31.934c.52.126 1.047.066 1.506-.143q-.002-.006.053-.029c.173-.078.737-.33 1.096-1.116l2.182-4.776c.146-.32.362-.602.633-.825l4.038-3.329a2.316 2.316 0 0 0 .626-2.767l-2.277-4.876a2.3 2.3 0 0 1-.217-.99l.022-5.39a2.316 2.316 0 0 0-1.79-2.265L22.337 4.28a2.3 2.3 0 0 1-.962-.482L17.492.542a2.316 2.316 0 0 0-2.977 0l-3.883 3.256a2.3 2.3 0 0 1-.963.481L4.747 5.428a2.316 2.316 0 0 0-1.79 2.265l.022 5.39c.001.342-.073.68-.218.99L.484 18.948a2.316 2.316 0 0 0 .626 2.767l4.038 3.329c.271.223.488.505.634.824l2.182 4.777a2.316 2.316 0 0 0 2.653 1.288l4.84-1.174a2.3 2.3 0 0 1 1.092 0zm-4.267-18.71h4.223c.53 0 .876.526.664.952L15.82 26.23c-.345.65-1.38.425-1.38-.301v-6.74c0-.1-.08-.201-.213-.201h-4.222c-.558 0-.903-.526-.664-.977l6.187-12.053c.345-.651 1.381-.425 1.381.301v6.766c0 .1.08.2.212.2"
      })
    }))
  }, props));
}

__name(ExpressSingleColorIcon, "ExpressSingleColorIcon");

function FaceIDIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 3H3v4h2V5h2zM3 17v4h4v-2H5v-2zM21 3h-4v2h2v2h2zm-2 14h2v4h-4v-2h2zM7 10V7h2v3zm8-3v3h2V7zm-4 4V7h2v6h-3v-2zm-3 4-.626.78.002.001.002.002.008.006.023.019.079.06a9.47 9.47 0 0 0 1.257.773c.804.41 1.967.859 3.255.859s2.45-.448 3.255-.86a9.5 9.5 0 0 0 1.257-.773l.079-.06.023-.018.008-.006.002-.002.002-.001L16 15l-.626-.78h.001l-.009.006-.047.036a7.491 7.491 0 0 1-.975.598c-.661.338-1.499.64-2.344.64s-1.683-.302-2.345-.64a7.5 7.5 0 0 1-1.021-.634l-.009-.007.001.001z"
      })
    }))
  }, props));
}

__name(FaceIDIcon, "FaceIDIcon");

function FacebookBlackIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 2c5.523 0 10 4.477 10 10 0 4.992-3.656 9.129-8.437 9.879V14.89h2.33L16.336 12h-2.773v-1.875c0-.791.386-1.562 1.628-1.562h1.262V6.102s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V12h-2.54v2.89h2.54v6.989C5.656 21.129 2 16.992 2 12 2 6.477 6.477 2 12 2",
        fill: "#000"
      })
    }))
  }, props));
}

__name(FacebookBlackIcon, "FacebookBlackIcon");

function FacebookColorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 2.667c7.364 0 13.333 5.968 13.333 13.333 0 6.656-4.875 12.172-11.25 13.172v-9.318h3.107L21.78 16h-3.698v-2.5c0-1.055.516-2.083 2.172-2.083h1.682V8.135s-1.526-.26-2.984-.26c-3.047 0-5.036 1.846-5.036 5.188V16H10.53v3.854h3.385v9.318c-6.374-1-11.25-6.516-11.25-13.172C2.666 8.635 8.636 2.667 16 2.667",
        fill: "#3A75EA"
      })
    }))
  }, props));
}

__name(FacebookColorIcon, "FacebookColorIcon");

function FacebookGreyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 2c5.523 0 10 4.477 10 10 0 4.992-3.656 9.129-8.437 9.879V14.89h2.33L16.336 12h-2.773v-1.875c0-.791.386-1.562 1.628-1.562h1.262V6.102s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V12h-2.54v2.89h2.54v6.989C5.656 21.129 2 16.992 2 12 2 6.477 6.477 2 12 2",
        fill: "#898F9C"
      })
    }))
  }, props));
}

__name(FacebookGreyIcon, "FacebookGreyIcon");

function FacebookSquareIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.827 5.138C3.5 5.78 3.5 6.62 3.5 8.3v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327h4.28v-6.583h-2.215V11.35h2.215V9.459c0-2.196 1.341-3.391 3.3-3.391.938 0 1.745.07 1.98.1v2.295l-1.359.001c-1.065 0-1.271.506-1.271 1.249v1.638h2.54l-.33 2.566h-2.21V20.5h.47c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V8.3c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.22 3.5 17.38 3.5 15.7 3.5H8.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311"
      })
    }))
  }, props));
}

__name(FacebookSquareIcon, "FacebookSquareIcon");

function FacebookWhiteIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 2c5.523 0 10 4.477 10 10 0 4.992-3.656 9.129-8.437 9.879V14.89h2.33L16.336 12h-2.773v-1.875c0-.791.386-1.562 1.628-1.562h1.262V6.102s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V12h-2.54v2.89h2.54v6.989C5.656 21.129 2 16.992 2 12 2 6.477 6.477 2 12 2",
        fill: "#fff"
      })
    }))
  }, props));
}

__name(FacebookWhiteIcon, "FacebookWhiteIcon");

function FairTradeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 4h7.062v2h-2.11L22 14h-8l3.048-8h-4.056v14H19v2H5v-2h5.992V6h-4.04L10 14H2l3.048-8H2.932V4H10a2 2 0 1 1 4 0m4 5.118L16.902 12h2.196zM4.902 12 6 9.118 7.098 12z"
      })
    }))
  }, props));
}

__name(FairTradeIcon, "FairTradeIcon");

function FastestCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M14 3.667c4.59 0 8.333 3.743 8.333 8.333S18.591 20.333 14 20.333c-3.142 0-5.888-1.754-7.307-4.333H4.832c1.543 3.532 5.066 6 9.168 6 5.524 0 10-4.476 10-10S19.524 2 14 2a10 10 0 0 0-9.168 6H0v2h10V8H6.693C8.113 5.42 10.858 3.667 14 3.667"
      }), /* @__PURE__ */jsx("path", {
        d: "M2 12h8v2H2zM14.875 11.638V6h-1.75v6.362l4.256 4.257 1.238-1.238z"
      })]
    }))
  }, props));
}

__name(FastestCategoryIcon, "FastestCategoryIcon");

function FastestCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.832 8C6.375 4.468 9.898 2 14 2c5.524 0 10 4.476 10 10s-4.476 10-10 10a10 10 0 0 1-9.168-6H10v-2H2v-2h8v-2H0V8zm10.043-2v5.638l3.744 3.743-1.238 1.238-4.256-4.257V6z"
      })
    }))
  }, props));
}

__name(FastestCategoryFilledIcon, "FastestCategoryFilledIcon");

function FatIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.902 3.017a1.384 1.384 0 0 1 2.196 0c1.97 2.519 5.902 8 5.902 11.648a7 7 0 0 1-14 0c0-3.647 3.931-9.13 5.902-11.648"
      })
    }))
  }, props));
}

__name(FatIcon, "FatIcon");

function FatFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m6.32-5.094A8 8 0 0 0 7.094 5.68l2.842 2.841a33 33 0 0 1 1.436-2.183c.323-.452.933-.452 1.256 0C13.754 7.914 16 11.342 16 13.623q0 .454-.081.882zm-1.414 1.414A8 8 0 0 1 5.68 7.095l3.263 3.262C8.398 11.5 8 12.663 8 13.623 8 16.04 9.79 18 12 18c1.22 0 2.312-.598 3.046-1.54z"
      })
    }))
  }, props));
}

__name(FatFreeIcon, "FatFreeIcon");

function FavoriteDarkDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5a3.5 3.5 0 0 0-3.5 3.5c0 2.286 1.225 4.532 2.83 6.47 1.59 1.92 3.444 3.41 4.467 4.166.124.09.28.09.403 0 1.025-.756 2.88-2.245 4.469-4.165C18.274 13.032 19.5 10.786 19.5 8.5a3.5 3.5 0 0 0-6.61-1.604l-.666 1.294a.25.25 0 0 1-.444 0l-.667-1.293A3.5 3.5 0 0 0 8 5M2.5 8.5A5.5 5.5 0 0 1 12 4.726 5.5 5.5 0 0 1 21.5 8.5c0 2.974-1.57 5.67-3.29 7.746-1.736 2.096-3.734 3.697-4.822 4.5a2.33 2.33 0 0 1-2.778 0c-1.088-.804-3.086-2.404-4.82-4.5C4.07 14.17 2.5 11.474 2.5 8.5",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(FavoriteDarkDisabledIcon, "FavoriteDarkDisabledIcon");

function FavoriteDarkFilledUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 4a4.5 4.5 0 0 1 4.5 4.5c0 5.26-5.593 9.882-7.706 11.44a1.33 1.33 0 0 1-1.59 0C9.092 18.382 3.5 13.76 3.5 8.5a4.5 4.5 0 0 1 8.501-2.062A4.49 4.49 0 0 1 16 4",
        fill: "#343538",
        fillOpacity: 0.8
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5a3.5 3.5 0 0 0-3.5 3.5c0 2.286 1.225 4.532 2.83 6.47 1.59 1.92 3.444 3.41 4.467 4.166.124.09.28.09.403 0 1.025-.756 2.88-2.245 4.469-4.165C18.274 13.032 19.5 10.786 19.5 8.5a3.5 3.5 0 0 0-6.61-1.604l-.666 1.294a.25.25 0 0 1-.444 0l-.667-1.293A3.5 3.5 0 0 0 8 5M2.5 8.5A5.5 5.5 0 0 1 12 4.726 5.5 5.5 0 0 1 21.5 8.5c0 2.974-1.57 5.67-3.29 7.746-1.736 2.096-3.734 3.697-4.822 4.5a2.33 2.33 0 0 1-2.778 0c-1.088-.804-3.086-2.404-4.82-4.5C4.07 14.17 2.5 11.474 2.5 8.5",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(FavoriteDarkFilledUnselectedIcon, "FavoriteDarkFilledUnselectedIcon");

function FavoriteDarkSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 4a4.5 4.5 0 0 1 4.5 4.5c0 5.26-5.593 9.882-7.706 11.44a1.33 1.33 0 0 1-1.59 0C9.092 18.382 3.5 13.76 3.5 8.5a4.5 4.5 0 0 1 8.501-2.062A4.49 4.49 0 0 1 16 4"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5a3.5 3.5 0 0 0-3.5 3.5c0 2.286 1.225 4.532 2.83 6.47 1.59 1.92 3.444 3.41 4.467 4.166.124.09.28.09.403 0 1.025-.756 2.88-2.245 4.469-4.165C18.274 13.032 19.5 10.786 19.5 8.5a3.5 3.5 0 0 0-6.61-1.604l-.666 1.294a.25.25 0 0 1-.444 0l-.667-1.293A3.5 3.5 0 0 0 8 5M2.5 8.5A5.5 5.5 0 0 1 12 4.726 5.5 5.5 0 0 1 21.5 8.5c0 2.974-1.57 5.67-3.29 7.746-1.736 2.096-3.734 3.697-4.822 4.5a2.33 2.33 0 0 1-2.778 0c-1.088-.804-3.086-2.404-4.82-4.5C4.07 14.17 2.5 11.474 2.5 8.5",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(FavoriteDarkSelectedIcon, "FavoriteDarkSelectedIcon");

function FavoriteDarkUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5a3.5 3.5 0 0 0-3.5 3.5c0 2.286 1.225 4.532 2.83 6.47 1.59 1.92 3.444 3.41 4.467 4.166.124.09.28.09.403 0 1.025-.756 2.88-2.245 4.469-4.165C18.274 13.032 19.5 10.786 19.5 8.5a3.5 3.5 0 0 0-6.61-1.604l-.666 1.294a.25.25 0 0 1-.444 0l-.667-1.293A3.5 3.5 0 0 0 8 5M2.5 8.5A5.5 5.5 0 0 1 12 4.726 5.5 5.5 0 0 1 21.5 8.5c0 2.974-1.57 5.67-3.29 7.746-1.736 2.096-3.734 3.697-4.822 4.5a2.33 2.33 0 0 1-2.778 0c-1.088-.804-3.086-2.404-4.82-4.5C4.07 14.17 2.5 11.474 2.5 8.5",
        fill: "#fff"
      })
    }))
  }, props));
}

__name(FavoriteDarkUnselectedIcon, "FavoriteDarkUnselectedIcon");

function FavoriteDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5a3.5 3.5 0 0 0-3.5 3.5c0 2.286 1.225 4.532 2.83 6.47 1.59 1.92 3.444 3.41 4.467 4.166.124.09.28.09.403 0 1.025-.756 2.88-2.245 4.469-4.165C18.274 13.032 19.5 10.786 19.5 8.5a3.5 3.5 0 0 0-6.61-1.604l-.666 1.294a.25.25 0 0 1-.444 0l-.667-1.293A3.5 3.5 0 0 0 8 5M2.5 8.5A5.5 5.5 0 0 1 12 4.726 5.5 5.5 0 0 1 21.5 8.5c0 2.974-1.57 5.67-3.29 7.746-1.736 2.096-3.734 3.697-4.822 4.5a2.33 2.33 0 0 1-2.778 0c-1.088-.804-3.086-2.404-4.82-4.5C4.07 14.17 2.5 11.474 2.5 8.5",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(FavoriteDisabledIcon, "FavoriteDisabledIcon");

function FavoriteSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 3a5.5 5.5 0 0 0-5.5 5.5c0 2.974 1.57 5.67 3.29 7.746 1.734 2.096 3.732 3.696 4.82 4.5.83.61 1.948.611 2.778 0 1.088-.803 3.086-2.404 4.821-4.5C19.93 14.17 21.5 11.474 21.5 8.5A5.5 5.5 0 0 0 12 4.726 5.49 5.49 0 0 0 8 3"
      })
    }))
  }, props));
}

__name(FavoriteSelectedIcon, "FavoriteSelectedIcon");

function FavoriteUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5a3.5 3.5 0 0 0-3.5 3.5c0 2.286 1.225 4.532 2.83 6.47 1.59 1.92 3.444 3.41 4.467 4.166.124.09.28.09.403 0 1.025-.756 2.88-2.245 4.469-4.165C18.274 13.032 19.5 10.786 19.5 8.5a3.5 3.5 0 0 0-6.61-1.604l-.666 1.294a.25.25 0 0 1-.444 0l-.667-1.293A3.5 3.5 0 0 0 8 5M2.5 8.5A5.5 5.5 0 0 1 12 4.726 5.5 5.5 0 0 1 21.5 8.5c0 2.974-1.57 5.67-3.29 7.746-1.736 2.096-3.734 3.697-4.822 4.5a2.33 2.33 0 0 1-2.778 0c-1.088-.804-3.086-2.404-4.82-4.5C4.07 14.17 2.5 11.474 2.5 8.5"
      })
    }))
  }, props));
}

__name(FavoriteUnselectedIcon, "FavoriteUnselectedIcon");

function FilterIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M3 3h18v2l-7 6v10h-1.5L10 19v-8L3 5z"
      })
    }))
  }, props));
}

__name(FilterIcon, "FilterIcon");

function FishIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m5.83 14.32-1.621.898C3.227 15.762 2 15.082 2 13.993v-3.305C2 9.6 3.227 8.92 4.209 9.464l1.223.679C8.38 6.565 11.697 6 13.288 6c1.665 0 5.216.617 8.258 4.653a2.226 2.226 0 0 1 0 2.694C18.504 17.383 14.953 18 13.288 18c-1.52 0-4.616-.515-7.459-3.68"
      })
    }))
  }, props));
}

__name(FishIcon, "FishIcon");

function FishFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m6.32-5.094A8 8 0 0 0 7.094 5.68l2.992 2.99c1.15-.548 2.18-.671 2.816-.671 1.165 0 3.65.412 5.78 3.102a1.43 1.43 0 0 1 0 1.796c-.747.944-1.537 1.607-2.3 2.07zm-1.414 1.414A8 8 0 0 1 5.68 7.095L8.376 9.79a9 9 0 0 0-.973.972l-.857-.453C5.859 9.948 5 10.4 5 11.127v2.203c0 .725.859 1.179 1.546.816l1.135-.599C9.67 15.656 11.838 16 12.9 16c.378 0 .894-.043 1.492-.193z"
      })
    }))
  }, props));
}

__name(FishFreeIcon, "FishFreeIcon");

function FlagIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M7 2H5v20h2v-6.812L21 9.5 7 3.813z"
      })
    }))
  }, props));
}

__name(FlagIcon, "FlagIcon");

function FlagAUIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 8a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z",
        fill: "#2E42A5"
      }), /* @__PURE__ */jsx("path", {
        d: "m13 28.5-1.302 1.203.13-1.768-1.753-.267 1.463-1.002-.883-1.537 1.694.52L13 24l.65 1.648 1.695-.518-.883 1.536 1.463 1.002-1.752.267.129 1.768zM26 21l-.868.802.086-1.178-1.168-.179.975-.668-.589-1.024 1.13.346L26 18l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179zM28 13l-.868.802.086-1.178-1.168-.179.975-.668-.589-1.024 1.13.346L28 10l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179zM33 17l-.868.802.086-1.178-1.168-.179.975-.668-.589-1.024 1.13.346L33 14l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179zM29 30l-.868.802.086-1.178-1.168-.179.975-.668-.589-1.024 1.13.346L29 27l.434 1.099 1.13-.346-.59 1.024.976.668-1.168.178.086 1.179zM32.5 22.25l-.882.463.169-.981-.714-.695.986-.144L32.5 20l.44.893.987.143-.714.696.169.982zM22 9.96l-5.929 4.722 1.863 1.312L22 19.347v2.532l-.276.121h-2.606L13 17.128 6.882 22H4.276L4 21.879v-2.532l4.067-3.353 1.862-1.312L4 9.96A1.96 1.96 0 0 1 5.96 8h1.61l5.067 4.263.363.256.363-.256L18.43 8H22z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        d: "M11.25 8h3.5v14h-3.5z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        d: "M22 13.24v3.5H4v-3.5z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        d: "m12 16.5-.015 5.5h2v-5.89L20.827 22H22v-1.713L16.947 16H22v-2h-6.669L22 8.29V8h-2.516l-5.5 4.614V8h-2v5.22L5.432 8.082c-.61.181-1.098.645-1.313 1.239l5.83 4.68H4v2h5.948L4 20.99V22h1.987z",
        fill: "#F50100"
      })]
    }))
  }, props));
}

__name(FlagAUIcon, "FlagAUIcon");

var FlagAUIcon_default = FlagAUIcon;

function FlagBRIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 8a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z",
        fill: "#093"
      }), /* @__PURE__ */jsxs("g", {
        filter: "url(#prefix__filter0_d)",
        fillRule: "evenodd",
        clipRule: "evenodd",
        children: [/* @__PURE__ */jsx("path", {
          d: "m19.927 11.704 12.202 8.503-12.368 7.964-11.952-8.128z",
          fill: "#FFD221"
        }), /* @__PURE__ */jsx("path", {
          d: "m19.927 11.704 12.202 8.503-12.368 7.964-11.952-8.128z",
          fill: "url(#prefix__paint0_linear)"
        })]
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 25.2a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
        fill: "#2E42A5"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m18.38 22.57-.223.118.042-.25-.18-.175.25-.037.111-.226.112.226.25.037-.181.176.042.249zM20.38 22.57l-.223.118.042-.25-.18-.175.25-.037.111-.226.112.226.25.037-.181.176.042.249zM20.38 23.77l-.223.118.042-.25-.18-.175.25-.037.111-.226.112.226.25.037-.181.176.042.249zM19.38 21.57l-.223.118.042-.25-.18-.175.25-.037.111-.226.112.226.25.037-.181.176.042.249zM17.98 20.57l-.223.118.042-.25-.18-.175.25-.037.111-.226.112.226.25.037-.181.176.042.249zM16.58 21.37l-.223.118.042-.25-.18-.175.25-.037.11-.226.113.226.25.037-.181.176.042.249zM21.18 17.97l-.223.118.042-.25-.18-.175.25-.037.111-.226.112.226.25.037-.181.176.042.249z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        d: "M15.986 17.219c3.607.55 6.625 1.866 8.92 3.954a5 5 0 0 1-.853 1.956c-2.143-2.197-5.165-3.537-8.935-4.012a5 5 0 0 1 .868-1.898",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        d: "m16.29 18.603.051-.498c3.093.32 5.746 1.505 7.95 3.552l-.34.366q-3.184-2.956-7.661-3.42",
        fill: "#093"
      }), /* @__PURE__ */jsxs("defs", {
        children: [/* @__PURE__ */jsxs("linearGradient", {
          id: "prefix__paint0_linear",
          x1: 36,
          y1: 32,
          x2: 36,
          y2: 8,
          gradientUnits: "userSpaceOnUse",
          children: [/* @__PURE__ */jsx("stop", {
            stopColor: "#FFC600"
          }), /* @__PURE__ */jsx("stop", {
            offset: 1,
            stopColor: "#FFDE42"
          })]
        }), /* @__PURE__ */jsxs("filter", {
          id: "prefix__filter0_d",
          x: 7.809,
          y: 11.704,
          width: 24.32,
          height: 16.467,
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          children: [/* @__PURE__ */jsx("feFlood", {
            floodOpacity: 0,
            result: "BackgroundImageFix"
          }), /* @__PURE__ */jsx("feColorMatrix", {
            in: "SourceAlpha",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }), /* @__PURE__ */jsx("feOffset", {}), /* @__PURE__ */jsx("feColorMatrix", {
            values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
          }), /* @__PURE__ */jsx("feBlend", {
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow"
          }), /* @__PURE__ */jsx("feBlend", {
            in: "SourceGraphic",
            in2: "effect1_dropShadow",
            result: "shape"
          })]
        })]
      })]
    }))
  }, props));
}

__name(FlagBRIcon, "FlagBRIcon");

var FlagBRIcon_default = FlagBRIcon;

function FlagCAIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 8h16v24H12z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.976 14 20 27h-.6l.368-3.217q-4.035.786-3.701.39.333-.398.526-1.125L13 20.452q.567-.008 1.028-.305.46-.297-.461-2.059l1.813.286.687-.808 1.368 1.552h.615l-.615-3.554 1.103.667zm0 0 1.486 2.23 1.103-.666-.615 3.554h.615l1.368-1.552.686.808 1.814-.286q-.922 1.762-.46 2.059.461.297 1.027.305l-3.593 2.596q.193.727.526 1.125.334.396-3.701-.39L20.599 27H20zM28 8h6a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-6zM4 10a2 2 0 0 1 2-2h6v24H6a2 2 0 0 1-2-2z",
        fill: "#E31D1C"
      })]
    }))
  }, props));
}

__name(FlagCAIcon, "FlagCAIcon");

var FlagCAIcon_default = FlagCAIcon;

function FlagDEIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 24h32v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
        fill: "#FFD018"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 16h32v8H4z",
        fill: "#E31D1C"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v6H4z",
        fill: "#272727"
      })]
    }))
  }, props));
}

__name(FlagDEIcon, "FlagDEIcon");

var FlagDEIcon_default = FlagDEIcon;

function FlagFRIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 8h8a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-8z",
        fill: "#F50100"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 8h12v24H14z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10a2 2 0 0 1 2-2h8v24H6a2 2 0 0 1-2-2z",
        fill: "#2E42A5"
      })]
    }))
  }, props));
}

__name(FlagFRIcon, "FlagFRIcon");

var FlagFRIcon_default = FlagFRIcon;

function FlagJPIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 8a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z",
        fill: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.875 9C5.839 9 5 9.82 5 10.833v18.334C5 30.179 5.84 31 6.875 31h26.25C34.16 31 35 30.18 35 29.167V10.833C35 9.821 34.16 9 33.125 9z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 27.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
        fill: "#E31D1C"
      })]
    }))
  }, props));
}

__name(FlagJPIcon, "FlagJPIcon");

var FlagJPIcon_default = FlagJPIcon;

function FlagUKIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 8a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z",
        fill: "#2E42A5"
      }), /* @__PURE__ */jsx("path", {
        d: "M4 16.5v7h4.97L4 27.452V30a2 2 0 0 0 2 2h3.124l7.765-5.963V32h6.222v-5.963L30.877 32H34a2 2 0 0 0 2-2v-2.548L31.03 23.5H36v-7h-6.693L36 11.36V10a2 2 0 0 0-2-2h-4.347l-6.542 5.308V8H16.89v5.308L10.347 8H6a2 2 0 0 0-2 1.992v1.368l6.693 5.14z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        d: "M4 29.5v.5a2 2 0 0 0 2 2h.71l11.512-9.429L18.195 32h3.555V21.902L33.915 32H34a2 2 0 0 0 2-2v-.936l-8.983-7.35H36v-3.428H24.144l11.47-9.468A2 2 0 0 0 34 8h-2.473l-9.777 7.91V8h-3.555v8.948L6.709 8H6a2 2 0 0 0-1.995 1.857l10.57 8.429H4v3.428h10.575z",
        fill: "#F50100"
      })]
    }))
  }, props));
}

__name(FlagUKIcon, "FlagUKIcon");

var FlagUKIcon_default = FlagUKIcon;

function FlagUSIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z",
        fill: "#F7FCFF"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 22.667v2h32v-2zM4 26.333v2h32v-2zM4 15.333v2h32v-2zM4 30a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2zM4 19v2h32v-2zM6 8a2 2 0 0 0-2 2h32a2 2 0 0 0-2-2zM4 11.667v2h32v-2z",
        fill: "#E31D1C"
      }), /* @__PURE__ */jsx("path", {
        d: "M4 10a2 2 0 0 1 2-2h18v13H4z",
        fill: "#2E42A5"
      }), /* @__PURE__ */jsx("path", {
        d: "m5.722 10.939-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM9.722 10.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM12.996 11.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.283.74h-.842l.645.573zM17.722 10.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM4.996 15.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573zM9.722 14.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM12.996 15.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.283.74h-.842l.645.573zM17.722 14.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM4.996 19.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573zM9.722 18.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM12.996 19.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.283.74h-.842l.645.573zM17.722 18.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM20.996 11.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573zM21.722 14.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM20.996 19.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573zM7.722 12.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM10.996 13.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.283.74h-.842l.645.573zM15.722 12.939l-.726.509.245-.906-.645-.574h.842l.283-.739.331.74h.718l-.564.573.218.906zM6.996 17.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573zM11.722 16.939l-.726.509.245-.906-.645-.574h.842l.283-.739.331.74h.718l-.564.573.218.906zM14.996 17.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.283.74h-.842l.645.573zM19.722 12.939l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906zM18.996 17.448l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573z",
        fill: "#F7FCFF"
      })]
    }))
  }, props));
}

__name(FlagUSIcon, "FlagUSIcon");

var FlagUSIcon_default = FlagUSIcon;

function FlashOffIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m15.236 16.28 5.688 5.031 1.326-1.497L3.575 3.294 2.25 4.794l5.766 5.1L5.79 12.88v1.05h5.67l-1.95 8.32h1.27zM18.709 11.63l-1.076 1.44-2.816-2.49h3.892zM14.989 2.25l-1.645 7.027-2.932-2.594 3.307-4.433z"
      })
    }))
  }, props));
}

__name(FlashOffIcon, "FlashOffIcon");

function FlowersCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m13.64 20.462-.76 1.639v-5.618h.35c1.44 0 5.72-.1 6.97-3.988.4-1.24.28-2.59-.17-3.799L16.75 0l-2.22 3.169L11.9 0 9.35 3.069 7.25 0 3.93 8.636c-.54 1.4-.61 2.98-.03 4.359 1.44 3.408 5.41 3.498 6.79 3.498h.44v5.618l-.76-1.64a5.99 5.99 0 0 0-5.44-3.468H0l2.39 4.788A3.99 3.99 0 0 0 5.97 24h12.06c1.52 0 2.9-.86 3.58-2.21L24 17.004h-4.92a6 6 0 0 0-5.44 3.468zm-2.95-5.718c-.67 0-1.28-.05-1.83-.14l7.43-10.836 2.08 5.548c.35.92.4 1.87.15 2.649-.6 1.87-2.33 2.779-5.3 2.779zM5.56 9.266l2.13-5.528 3.25 4.738-3.81 5.568c-.75-.4-1.3-.97-1.62-1.72-.37-.889-.36-1.998.05-3.048zm.41 12.975c-.86 0-1.63-.48-2.01-1.24l-1.13-2.259h2.09c1.65 0 3.16.97 3.85 2.46l.48 1.039H5.96zM20.04 21a2.23 2.23 0 0 1-2.01 1.24h-3.29l.48-1.04a4.27 4.27 0 0 1 3.85-2.459h2.09l-1.13 2.26z"
      })
    }))
  }, props));
}

__name(FlowersCategoryIcon, "FlowersCategoryIcon");

function FlowersCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19.08 17a5.99 5.99 0 0 0-5.44 3.462l-.76 1.639v-5.618h.35c1.44 0 5.72-.1 6.97-3.988.4-1.24.28-2.59-.17-3.799L16.75 0 8.71 11.495l-1.43-1 6.09-8.726L11.9 0 9.35 3.069 7.25 0 3.93 8.636c-.54 1.4-.61 2.98-.03 4.359 1.44 3.408 5.41 3.498 6.79 3.498h.44v5.618l-.76-1.64a5.99 5.99 0 0 0-5.44-3.468H0l2.39 4.788A3.99 3.99 0 0 0 5.97 24h12.06c1.52 0 2.9-.86 3.58-2.21L24 17.004h-4.92z"
      })
    }))
  }, props));
}

__name(FlowersCategoryFilledIcon, "FlowersCategoryFilledIcon");

function FlyersIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M8.065 2 21 3.303l-1.603 15.92L17 18.98V5H7.763zM11 11H7v3h4zM7 16h4v2H7z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 22V7h12v15zM5 9h8v11H5z"
      })]
    }))
  }, props));
}

__name(FlyersIcon, "FlyersIcon");

function FlyersFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M8.065 2 21 3.303l-1.603 15.92L17 18.98V5H7.763z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 7H3v15h12zm-3 3H6v4h6zm-6 7h6v2H6z"
      })]
    }))
  }, props));
}

__name(FlyersFilledIcon, "FlyersFilledIcon");

function FontColorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.032 2.969 6.272 15h2.816l.848-2.816H14L14.848 15h2.912L14 2.969zm3.616 7.216h-3.392l1.68-5.488zM4 21h16v-4H4z"
      })
    }))
  }, props));
}

__name(FontColorIcon, "FontColorIcon");

function FontStyleIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 3H3v18h18zM10.648 8.24v9.776h2.704V8.24h3.408V5.984H7.24V8.24z"
      })
    }))
  }, props));
}

__name(FontStyleIcon, "FontStyleIcon");

function ForYouCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M21 4.5h-3.25V2.25L15.5 0h-6L7.25 2.25V4.5H4L2 24h21zM9 2.97l1.23-1.22h4.55L16 2.97V4.5H9zm10.42 3.28 1.27 12.38H4.31L5.58 6.25zm-15.48 16 .19-1.88h16.74l.19 1.88H3.93z"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.5 16.25s3.32-2.61 4.06-4.53c.58-1.49-.21-2.78-1.44-2.95-.96-.13-2 .36-2.61 1.33-.61-.97-1.65-1.46-2.61-1.33-1.23.17-2.02 1.46-1.44 2.95.74 1.92 4.06 4.53 4.06 4.53z"
      })]
    }))
  }, props));
}

__name(ForYouCategoryIcon, "ForYouCategoryIcon");

function ForYouCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M21 4.5h-3.25V2.25L15.5 0h-6L7.25 2.25V4.5H4L2.55 18.62h19.9zM9 2.97l1.23-1.22h4.55L16 2.97V4.5H9zm7.56 8.75c-.74 1.92-4.06 4.53-4.06 4.53s-3.31-2.61-4.05-4.53c-.58-1.49.21-2.78 1.44-2.95.96-.13 2 .36 2.61 1.33.62-.97 1.65-1.46 2.62-1.33 1.23.17 2.02 1.46 1.44 2.95M22.63 20.38H2.37L2 24h21z"
      })
    }))
  }, props));
}

__name(ForYouCategoryFilledIcon, "ForYouCategoryFilledIcon");

function FrozenIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m2 8.84 3.134-.842-.84-3.13 1.931-.518.994 3.7 3.335 1.925v-3.85l-2.708-2.71L9.261 2l2.29 2.292L13.847 2l1.413 1.415-2.706 2.703v3.857l3.334-1.925.994-3.7 1.932.519-.84 3.129 3.133.842-.518 1.931-3.695-.992-3.34 1.928 3.34 1.93 3.695-.993.518 1.931-3.134.842.84 3.13-1.93.518-.995-3.7-3.334-1.925v3.85L15.26 20l-1.415 1.414-2.29-2.292-2.296 2.293L7.847 20l2.707-2.703V13.44l-3.335 1.925-.994 3.7-1.931-.519.84-3.129L2 14.575l.519-1.931 3.694.992 3.34-1.928-3.34-1.93-3.694.993z"
      })
    }))
  }, props));
}

__name(FrozenIcon, "FrozenIcon");

function FulfillmentTestingCenterIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 18 18",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M7 13a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M5.707 4.293a1 1 0 0 0-1.414 1.414L6.586 8l-2.293 2.293a1 1 0 1 0 1.414 1.414l2.576-2.576c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm14 2H2v14h14z"
      })]
    }))
  }, props));
}

__name(FulfillmentTestingCenterIcon, "FulfillmentTestingCenterIcon");

function FullscreenIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M9 3H3v6h2V5h4zM9 19H5v-4H3v6h6zM15 19h4v-4h2v6h-6zM15 3v2h4v4h2V3z"
      })
    }))
  }, props));
}

__name(FullscreenIcon, "FullscreenIcon");

function GMOFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M7.198 14.174c1.26 0 1.957-.774 1.957-1.778 0-.417-.225-.65-.62-.65h-.818c-.281 0-.46.146-.46.412 0 .267.181.413.46.413h.243l-.006.059c-.035.34-.322.565-.726.565-.545 0-.9-.46-.9-1.23 0-.753.31-1.187.838-1.187.299 0 .501.112.7.378a.68.68 0 0 0 .58.296c.317 0 .533-.214.533-.524a.65.65 0 0 0-.084-.32c-.25-.445-.888-.808-1.735-.808-1.304 0-2.097.797-2.097 2.182 0 1.404.793 2.192 2.135 2.192"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.938 11.988c0 1.35-.823 2.186-2.13 2.186-1.31 0-2.13-.835-2.13-2.186s.823-2.188 2.13-2.188 2.13.838 2.13 2.188m-2.994 0c0 .73.342 1.196.864 1.196.521 0 .864-.466.864-1.196 0-.732-.346-1.198-.864-1.198-.519 0-.864.466-.864 1.198"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-2c1.849 0 3.55-.627 4.906-1.68l-4.545-4.545c-.085.21-.22.305-.437.305-.223 0-.366-.1-.448-.31l-.58-1.459-.285-.285V13.6c0 .366-.196.574-.542.574-.345 0-.542-.208-.542-.574v-2.658L5.68 7.094A8 8 0 0 0 12 20m.437-8.977L7.094 5.68A8 8 0 0 1 18.32 16.906l-4.008-4.008v-2.284c0-.521-.287-.814-.806-.814-.437 0-.668.173-.844.633zm.728.728.063.063v-.163h-.024z"
      })]
    }))
  }, props));
}

__name(GMOFreeIcon, "GMOFreeIcon");

function GameDayIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m9.048 10.27 1.237-1.238 4.724 4.724-1.238 1.237zM7.815 11.495l-1.237 1.238 4.723 4.723 1.238-1.237zM11.5 7.803l1.238-1.237 4.723 4.724-1.237 1.237z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.21 0h4.98c1 0 1.81.81 1.81 1.81v4.98C24 16.3 16.29 24 6.79 24H1.81C.81 24 0 23.19 0 22.19v-4.98C0 7.7 7.71 0 17.21 0m5.05 6.38V1.8c0-.03-.06-.06-.06-.06h-4.58zM1.76 17.61v4.57c0 .03.06.06.06.06h4.57zm.4-3.84 8.08 8.08h.01c5.76-1.31 10.3-5.85 11.62-11.62l-8.09-8.08A15.5 15.5 0 0 0 2.16 13.77"
      })]
    }))
  }, props));
}

__name(GameDayIcon, "GameDayIcon");

function GameDayFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M23.93 8.07c.03-.42.06-.85.06-1.28V1.81c0-1-.81-1.81-1.81-1.81H17.2c-.43 0-.86.03-1.29.06zM.05 16.26v.009l-.01-.009z"
      }), /* @__PURE__ */jsx("path", {
        d: "m.05 16.269 8.04 7.661c-.43.04-.86.07-1.3.07H1.81C.81 24 0 23.19 0 22.19v-4.98c0-.237.016-.469.033-.704z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M.71 12.33C2.35 6.75 6.74 2.36 12.32.71h.01l10.96 10.95c-1.64 5.58-6.04 9.97-11.62 11.62zm5.86.41 4.72 4.72 1.24-1.24-4.72-4.72zm2.46-2.47 4.72 4.72 1.24-1.24-4.72-4.72zM11.5 7.8l4.72 4.72 1.24-1.24-4.72-4.72z"
      })]
    }))
  }, props));
}

__name(GameDayFilledIcon, "GameDayFilledIcon");

function GearIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m21.1 6.95-2.165.418a8.4 8.4 0 0 0-2.304-2.3L17.05 2.9q-1.035-.57-2.19-.9l-1.235 1.826a8.4 8.4 0 0 0-3.248.004L9.14 2c-.77.21-1.5.52-2.19.9l.421 2.18a8.4 8.4 0 0 0-2.288 2.292L2.9 6.95Q2.33 7.985 2 9.14l1.837 1.242a8.4 8.4 0 0 0 0 3.236L2 14.86c.21.77.52 1.5.9 2.19l2.183-.422a8.4 8.4 0 0 0 2.288 2.292L6.95 21.1q1.035.57 2.19.9l1.237-1.83a8.4 8.4 0 0 0 3.248.003L14.86 22c.77-.21 1.5-.52 2.19-.9l-.419-2.168a8.4 8.4 0 0 0 2.304-2.3l2.165.418q.57-1.035.9-2.19l-1.82-1.23a8.4 8.4 0 0 0 0-3.26L22 9.14c-.21-.77-.52-1.5-.9-2.19M15.34 12a3.33 3.33 0 1 1-6.66 0 3.33 3.33 0 0 1 6.66 0"
      })
    }))
  }, props));
}

__name(GearIcon, "GearIcon");

var GearIcon_default = GearIcon;

function GiftIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.988 3.311q.14-.176.303-.341c.65-.65 1.5-.97 2.35-.97h.01c.85 0 1.7.32 2.35.97A3.304 3.304 0 0 1 17.514 7H21v4h-8V7h-2v4H3V7h3.462a3.304 3.304 0 0 1 .513-4.03c.65-.65 1.5-.97 2.35-.97h.01c.85 0 1.7.32 2.35.97q.164.165.303.341M3 13v9h8v-9zm10 9h8v-9h-8zM8.384 4.39a1.307 1.307 0 0 0 .002 1.853c.497.489 1.28.707 2.229.707q.18 0 .352-.01.01-.162.01-.336c0-.947-.219-1.733-.706-2.22A1.3 1.3 0 0 0 9.335 4h-.01c-.347 0-.68.128-.936.384zm7.208 0c.508.503.517 1.33-.002 1.853-.497.489-1.28.707-2.229.707q-.18 0-.352-.01A6 6 0 0 1 13 6.604c-.001-.947.218-1.733.706-2.22.255-.256.588-.384.935-.384h.01c.348 0 .68.128.936.384z"
      })
    }))
  }, props));
}

__name(GiftIcon, "GiftIcon");

function GiftOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.291 2.97q-.164.165-.303.341a4 4 0 0 0-.303-.341c-.65-.65-1.5-.97-2.35-.97h-.01c-.85 0-1.7.32-2.35.97A3.304 3.304 0 0 0 6.462 7H3v15h18V7h-3.486a3.304 3.304 0 0 0-.513-4.03c-.65-.65-1.5-.97-2.35-.97h-.01c-.85 0-1.7.32-2.35.97M19 9h-6v2h6zM5 9v2h6V9zm3.386-2.758a1.307 1.307 0 0 1-.002-1.852l.005-.006c.256-.256.589-.384.936-.384h.01c.347 0 .68.128.936.384.487.487.706 1.273.705 2.22q0 .173-.01.336-.17.01-.351.01c-.949 0-1.732-.218-2.23-.708m7.204 0c.519-.522.51-1.349.002-1.852l-.005-.006A1.3 1.3 0 0 0 14.651 4h-.01c-.347 0-.68.128-.935.384-.488.487-.707 1.273-.706 2.22q0 .173.01.336.17.01.351.01c.95 0 1.732-.218 2.23-.708M19 13v7h-6v-7zm-8 0v7H5v-7z"
      })
    }))
  }, props));
}

__name(GiftOutlineIcon, "GiftOutlineIcon");

function GiftsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M23.5 5.5h-3.39c1.37-.73 2.16-1.43 2.23-1.49l-1.17-1.3s-1.03.9-2.76 1.66c.34-1.16.07-2.46-.85-3.37-.66-.67-1.54-1-2.41-1s-1.76.33-2.42 1c-.19.18-.34.38-.48.58-.13-.2-.29-.4-.47-.58-.67-.67-1.54-1-2.42-1S7.61.33 6.95 1c-.92.91-1.19 2.21-.85 3.37-1.72-.76-2.74-1.64-2.76-1.66l-1.17 1.3c.07.06.87.76 2.24 1.49H1v6h2.38L2.5 24h19.75l-1.09-12.5h2.34zm-9.54-3.26c.32-.32.74-.49 1.19-.49s.86.17 1.18.49.49.73.49 1.17-.18.86-.49 1.17c-.54.54-1.39.92-2.51.92h-.69c0-.95.01-2.45.83-3.26m-2.59 20.01H4.38l.75-10.75h6.24zm0-12.5H2.76v-2.5h8.63v2.5zm-.7-4.26c-1.12 0-1.96-.37-2.5-.91-.31-.31-.49-.73-.49-1.17s.18-.86.49-1.17a1.68 1.68 0 0 1 2.37 0c.82.82.83 2.31.83 3.25v.01h-.7zm2.44 16.76V11.5h6.28l.94 10.75zm8.63-12.5h-8.62v-2.5h8.62z"
      })
    }))
  }, props));
}

__name(GiftsCategoryIcon, "GiftsCategoryIcon");

function GiftsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M2.5 24h8.87l.01-11.62H3.32zM13.13 12.38 13.12 24h9.13l-1.02-11.62zM20.11 5.5c1.37-.73 2.16-1.43 2.23-1.49l-1.17-1.3s-1.03.9-2.76 1.66c.34-1.16.07-2.46-.85-3.37-.66-.67-1.54-1-2.41-1s-1.76.33-2.42 1c-.19.18-.34.38-.48.58-.13-.2-.29-.4-.47-.58-.67-.67-1.54-1-2.42-1S7.61.33 6.95 1c-.92.91-1.19 2.21-.85 3.37-1.72-.76-2.74-1.64-2.76-1.66l-1.17 1.3c.07.06.87.76 2.24 1.49H1v5.12h10.38V5.5h-.7c-1.12 0-1.96-.37-2.5-.91-.31-.31-.49-.73-.49-1.17s.18-.86.49-1.17a1.68 1.68 0 0 1 2.37 0c.82.82.83 2.31.83 3.25h1.75c0-.94.01-2.44.83-3.25.32-.32.74-.49 1.19-.49s.86.17 1.18.49.49.73.49 1.17-.18.86-.49 1.17c-.54.54-1.39.92-2.51.92h-.69v5.12H23.5V5.51h-3.39z"
      })
    }))
  }, props));
}

__name(GiftsCategoryFilledIcon, "GiftsCategoryFilledIcon");

function GlutenIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.997 9.758c1.297 0 2.348-2.293 2.348-3.629S13.294 2.5 11.997 2.5 9.65 4.793 9.65 6.13c0 1.335 1.05 3.628 2.347 3.628m1.389 4.029c.916.886 3.337-.017 4.315-.962s1.913-3.285.996-4.17c-.917-.886-3.338.017-4.315.962s-1.913 3.284-.996 4.17m-7.016-.962c.978.945 3.4 1.848 4.316.962s-.018-3.225-.996-4.17-3.399-1.848-4.315-.962c-.917.885.018 3.225.995 4.17m7.016 7.313c.916.886 3.337-.017 4.315-.962s1.913-3.284.996-4.17-3.338.017-4.315.962-1.913 3.284-.996 4.17m-7.016-.962c.978.945 3.4 1.848 4.316.962s-.018-3.225-.996-4.17-3.399-1.848-4.315-.962.018 3.225.995 4.17"
      })
    }))
  }, props));
}

__name(GlutenIcon, "GlutenIcon");

function GlutenFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2m0 18.095c-4.467 0-8.095-3.628-8.095-8.095 0-1.895.647-3.629 1.733-5.01l1.724 1.724a4.35 4.35 0 0 0-1.829 1.648 1.07 1.07 0 0 0-.162.562v2.505c0 .79.639 1.428 1.429 1.428h6.705l3.504 3.505A8.07 8.07 0 0 1 12 20.095m6.362-3.085L16.2 14.856h1.038c.79 0 1.429-.638 1.429-1.428v-2.486c0-.21-.058-.42-.172-.59a4.46 4.46 0 0 0-3.543-2.067v1.257c0 .276-.342.39-.514.171l-1.105-1.428h-.885V9.57c0 .267-.343.39-.505.181l-1.181-1.466H9.629L6.99 5.638A8.07 8.07 0 0 1 12 3.905c4.467 0 8.095 3.628 8.095 8.095a8.07 8.07 0 0 1-1.733 5.01"
      })
    }))
  }, props));
}

__name(GlutenFreeIcon, "GlutenFreeIcon");

function GoldCartStarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m14.323 9.6 7.003 2.1-7.003 2.1-2.16 7.8-2.16-7.8L3 11.7l7.003-2.1 2.16-7.8z",
        fill: "#ECAA01"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.162 1.8v9.9h9.164l-7.003-2.1z",
        fill: "#FFDC23"
      }), /* @__PURE__ */jsx("path", {
        d: "M3 11.7h9.162l-2.159 2.1z",
        fill: "#FF7009"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.163 21.6v-9.9l-2.16 2.1z",
        fill: "#C22F00"
      })]
    }))
  }, props));
}

__name(GoldCartStarIcon, "GoldCartStarIcon");

function GoldWithBackgroundCartStarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_6197_4885)",
        children: [/* @__PURE__ */jsx("circle", {
          cx: 12,
          cy: 12,
          r: 12,
          fill: "#003D29"
        }), /* @__PURE__ */jsx("path", {
          d: "m14.323 9.6 7.003 2.1-7.003 2.1-2.16 7.8-2.16-7.8L3 11.7l7.003-2.1 2.16-7.8z",
          fill: "#ECAA01"
        }), /* @__PURE__ */jsx("path", {
          d: "M12.162 1.8v9.9h9.164l-7.003-2.1z",
          fill: "#FFDC23"
        }), /* @__PURE__ */jsx("path", {
          d: "M3 11.7h9.162l-2.159 2.1z",
          fill: "#FF7009"
        }), /* @__PURE__ */jsx("path", {
          d: "M12.163 21.6v-9.9l-2.16 2.1z",
          fill: "#C22F00"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_6197_4885",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(GoldWithBackgroundCartStarIcon, "GoldWithBackgroundCartStarIcon");

function GoogleIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.28 10.273h-9.06v3.67h5.215c-.486 2.332-2.519 3.67-5.214 3.67-3.181 0-5.744-2.504-5.744-5.613S9.04 6.386 12.22 6.386A5.7 5.7 0 0 1 15.8 7.64l2.828-2.764C16.905 3.407 14.695 2.5 12.22 2.5 6.83 2.5 2.5 6.732 2.5 12s4.33 9.5 9.72 9.5c4.861 0 9.28-3.454 9.28-9.5 0-.561-.088-1.166-.22-1.727"
      })
    }))
  }, props));
}

__name(GoogleIcon, "GoogleIcon");

function GoogleColorIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M28.667 16.292c0-.861-.071-1.727-.223-2.574H16.255v4.878h6.98a5.86 5.86 0 0 1-2.583 3.849v3.165h4.164c2.445-2.206 3.85-5.464 3.85-9.318",
        fill: "#4285F4"
      }), /* @__PURE__ */jsx("path", {
        d: "M16.255 28.668c3.485 0 6.424-1.122 8.566-3.058l-4.164-3.165c-1.159.772-2.654 1.21-4.397 1.21-3.371 0-6.23-2.23-7.255-5.227H4.708v3.263c2.194 4.277 6.662 6.977 11.547 6.977",
        fill: "#34A853"
      }), /* @__PURE__ */jsx("path", {
        d: "M9 18.428a7.45 7.45 0 0 1 0-4.85v-3.263H4.708a12.45 12.45 0 0 0 0 11.376z",
        fill: "#FBBC04"
      }), /* @__PURE__ */jsx("path", {
        d: "M16.255 8.347a7.1 7.1 0 0 1 4.957 1.899l3.69-3.617a12.56 12.56 0 0 0-8.647-3.295c-4.885 0-9.353 2.7-11.547 6.982L9 13.578c1.021-3.002 3.884-5.231 7.255-5.231",
        fill: "#EA4335"
      })]
    }))
  }, props));
}

__name(GoogleColorIcon, "GoogleColorIcon");

function GrabIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M15 4.88a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
      }), /* @__PURE__ */jsx("path", {
        d: "M15 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M15 12.88a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
      }), /* @__PURE__ */jsx("path", {
        d: "M15 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M15 20.88a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
      }), /* @__PURE__ */jsx("path", {
        d: "M15 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M9 4.88a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
      }), /* @__PURE__ */jsx("path", {
        d: "M9 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M9 12.88a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
      }), /* @__PURE__ */jsx("path", {
        d: "M9 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M9 20.88a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
      }), /* @__PURE__ */jsx("path", {
        d: "M9 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
      })]
    }))
  }, props));
}

__name(GrabIcon, "GrabIcon");

function GraphIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19 4h-2v16h2zM13 8h2v12h-2zM11 12H9v8h2zM7 16H5v4h2z"
      })
    }))
  }, props));
}

__name(GraphIcon, "GraphIcon");

function GraphAltIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M18 4h-2v16h2zM11 9h2v11h-2zM6 14h2v6H6z"
      })
    }))
  }, props));
}

__name(GraphAltIcon, "GraphAltIcon");

function GraphAltMediumIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M13 9h-2v11h2zM8 14H6v6h2z"
      }), /* @__PURE__ */jsx("path", {
        fillOpacity: 0.24,
        d: "M16 4h2v16h-2z"
      })]
    }))
  }, props));
}

__name(GraphAltMediumIcon, "GraphAltMediumIcon");

function GraphAltMinimumIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M6 14h2v6H6z"
      }), /* @__PURE__ */jsx("path", {
        d: "M18 4h-2v16h2zM13 9h-2v11h2z",
        fillOpacity: 0.24
      })]
    }))
  }, props));
}

__name(GraphAltMinimumIcon, "GraphAltMinimumIcon");

function GraphDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M18 5.5a1.5 1.5 0 0 1 3 0v14a1.5 1.5 0 0 1-3 0zM13 9.5a1.5 1.5 0 0 1 3 0v10a1.5 1.5 0 0 1-3 0zM8 12.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0zM3 15.5a1.5 1.5 0 0 1 3 0v4a1.5 1.5 0 0 1-3 0z",
        fill: "#fff"
      })
    }))
  }, props));
}

__name(GraphDarkIcon, "GraphDarkIcon");

function GraphMediumIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M15 8h-2v12h2zM9 12h2v8H9zM5 16h2v4H5z"
      }), /* @__PURE__ */jsx("path", {
        fillOpacity: 0.24,
        d: "M17 4h2v16h-2z"
      })]
    }))
  }, props));
}

__name(GraphMediumIcon, "GraphMediumIcon");

function GraphMediumDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        opacity: 0.3,
        x: 18,
        y: 4,
        width: 3,
        height: 17,
        rx: 1.5,
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M13 9.5a1.5 1.5 0 0 1 3 0v10a1.5 1.5 0 0 1-3 0zM8 12.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0zM3 15.5a1.5 1.5 0 0 1 3 0v4a1.5 1.5 0 0 1-3 0z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(GraphMediumDarkIcon, "GraphMediumDarkIcon");

function GraphMinimumIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M5 16h2v4H5z"
      }), /* @__PURE__ */jsx("path", {
        d: "M19 4h-2v16h2zM13 8h2v12h-2zM9 12h2v8H9z",
        fillOpacity: 0.24
      })]
    }))
  }, props));
}

__name(GraphMinimumIcon, "GraphMinimumIcon");

function GraphMinimumDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        opacity: 0.3,
        x: 13,
        y: 8,
        width: 3,
        height: 13,
        rx: 1.5,
        fill: "#fff"
      }), /* @__PURE__ */jsx("rect", {
        opacity: 0.3,
        x: 18,
        y: 4,
        width: 3,
        height: 17,
        rx: 1.5,
        fill: "#fff"
      }), /* @__PURE__ */jsx("rect", {
        opacity: 0.3,
        x: 8,
        y: 11,
        width: 3,
        height: 10,
        rx: 1.5,
        fill: "#fff"
      }), /* @__PURE__ */jsx("rect", {
        x: 3,
        y: 14,
        width: 3,
        height: 7,
        rx: 1.5,
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(GraphMinimumDarkIcon, "GraphMinimumDarkIcon");

function GraphPartialIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M11 12H9v8h2zM7 16H5v4h2z"
      }), /* @__PURE__ */jsx("path", {
        d: "M19 4h-2v16h2zM15 8h-2v12h2z",
        fillOpacity: 0.24
      })]
    }))
  }, props));
}

__name(GraphPartialIcon, "GraphPartialIcon");

function GraphPartialDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        opacity: 0.3,
        x: 18,
        y: 4,
        width: 3,
        height: 17,
        rx: 1.5,
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        opacity: 0.3,
        d: "M13 9.5a1.5 1.5 0 0 1 3 0v10a1.5 1.5 0 0 1-3 0z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M8 12.5a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("rect", {
        x: 3,
        y: 14,
        width: 3,
        height: 7,
        rx: 1.5,
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(GraphPartialDarkIcon, "GraphPartialDarkIcon");

function GridIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M2.5 2.5h8v8h-8zM13.5 2.5h8v8h-8zM2.5 13.5h8v8h-8zM13.5 13.5h8v8h-8z"
      })
    }))
  }, props));
}

__name(GridIcon, "GridIcon");

function GroceryCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M22.34 18.64c-.44-.11-.86-.22-1.28-.34-1.19-.34-2.3-.74-3.35-1.19.04-.02.08-.04.12-.07 2.25-1.39 3.95-3.03 5.25-4.79.04-.05.07-.1.11-.15.26-.36.5-.72.73-1.09.03-.05.05-.09.08-.14l-.93-1.52-.64-1.03c-1 .39-1.97.7-2.93.97-2.83.79-5.47 1.09-7.86 1.09-1.36 0-2.63-.1-3.81-.26C5.51 7.57 4.5 5.5 4.5 5.5l1-5.5H.75l.5 5.5S0 7.66 0 11c0 4.51 2.83 13 15.5 13 2.65 0 4.96-.5 6.99-1.32.05-.02.09-.04.14-.06.47-.19.94-.4 1.37-.62v-3c-.51-.1-1.02-.2-1.5-.32-.06-.01-.11-.03-.16-.04m-1.9-7.82.67 1.09c-1.15 1.4-2.53 2.62-4.21 3.65-.37.24-.75.46-1.12.66-2.42-1.25-4.4-2.71-5.99-4.14.61.04 1.22.06 1.84.06 2.95 0 5.89-.46 8.8-1.31zM21 21.37c-1.72.59-3.54.89-5.5.89-5.04 0-8.8-1.41-11.17-4.19-2.39-2.81-2.58-6.11-2.58-7.06 0-2.78 1.01-4.62 1.01-4.62l.12-.2.05.09C3.15 6.73 8.1 16.59 21 20.12v1.26z"
      })
    }))
  }, props));
}

__name(GroceryCategoryIcon, "GroceryCategoryIcon");

function GroceryCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m4.5 5.5 1-5.5H.75l.5 5.5S0 7.66 0 11c0 4.51 2.83 13 15.5 13 3.33 0 6.13-.78 8.5-2v-3C9.79 16.34 4.5 5.5 4.5 5.5"
      }), /* @__PURE__ */jsx("path", {
        d: "m24 10.87-1.58-2.55c-4.4 1.7-8.45 2.17-11.9 2.04a26.6 26.6 0 0 0 8.94 5.55c1.97-1.51 3.45-3.22 4.54-5.04"
      })]
    }))
  }, props));
}

__name(GroceryCategoryFilledIcon, "GroceryCategoryFilledIcon");

function GroupIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M9 13c3.302 0 6.008 2.464 6 6H3c-.006-3.534 2.7-6 6-6M17 19h4c.008-3.536-2.698-6-6-6q-.3 0-.594.027C15.996 14.448 17.004 16.532 17 19M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M13.236 10.657C13.72 9.887 14 8.977 14 8c0-.654-.125-1.278-.354-1.85a2.5 2.5 0 1 1-.41 4.508"
      })
    }))
  }, props));
}

__name(GroupIcon, "GroupIcon");

var GroupIcon_default = GroupIcon;

function GroupAddIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M14 19c.008-3.536-2.698-6-6-6-3.3 0-6.006 2.466-6 6zM17 7h2v3h3v2h-3v3h-2v-3h-3v-2h3z"
      })
    }))
  }, props));
}

__name(GroupAddIcon, "GroupAddIcon");

function GuaranteeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.534 4.201 12 2 9.466 4.201 6.122 3.91l-.756 3.27-2.877 1.73L3.8 12l-1.31 3.09 2.877 1.73.756 3.27 3.344-.291L12 22l2.534-2.201 3.344.291.756-3.27 2.876-1.73L20.2 12l1.31-3.09-2.876-1.73-.756-3.27zM11.1 15.604l5.847-5.858-1.416-1.412-4.474 4.482-2.373-2.234-1.37 1.456z"
      })
    }))
  }, props));
}

__name(GuaranteeIcon, "GuaranteeIcon");

function HalalIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.513 7.303c.255-1.911 3.098-1.638 2.984.286a29 29 0 0 1-.186 2.025l-.011.311c-.076 2.967.715 4.608 2.226 5.173.92.345 1.624.447 2.18.295l-.235-.405-.278-.467-.229-.36-.132.088a1.5 1.5 0 1 1-1.664-2.496c1.309-.873 1.738-1.065 2.733-.696.72.268 1.009.495 1.836 1.867l.128.216a1.5 1.5 0 0 1 2.01 1.95c-1.327 3.106-4.015 4.086-7.4 2.818-1.315-.492-2.307-1.324-2.994-2.47-1.004 1.61-2.382 2.633-4.156 3.027a1.5 1.5 0 1 1-.65-2.928c1.886-.42 3.15-2.396 3.65-6.21q.047-.966.188-2.024M4.496 18.5c-3.238 0-4.58-4.037-2.557-6.06a1.5 1.5 0 1 1 2.122 2.12c-.225.225.012.94.435.94 1.125 0 1.609-1.845.794-6.373l-.122-.649-.136-.67a1.5 1.5 0 0 1 2.936-.617c1.51 7.175.638 11.309-3.472 11.309m5.004-8c0-.529-.056-.745-.343-1.322a1.5 1.5 0 0 1 2.686-1.337c.485.974.657 1.643.657 2.659a1.5 1.5 0 1 1-3 0"
      })
    }))
  }, props));
}

__name(HalalIcon, "HalalIcon");

function HardSeltzerIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 2a1 1 0 0 0-1 1h6.5a1 1 0 0 0-1-1zM9.2 3h5.6l.72.982c.312.425.48.941.48 1.473v7.013l-8 3.238V5.455c0-.532.168-1.048.48-1.473zM8 18.546v-.683l8-3.237v3.92c0 .53-.168 1.047-.48 1.472L14.8 21h.45a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-1-1h.45l-.72-.982A2.5 2.5 0 0 1 8 18.545M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      })
    }))
  }, props));
}

__name(HardSeltzerIcon, "HardSeltzerIcon");

function HelpIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.871-8.21h-1.918c-.256-1.293.057-2.103 1.492-2.799.867-.412 1.08-.853 1.08-1.379 0-.739-.469-1.307-1.535-1.307-1.023 0-1.549.54-1.606 1.549H8.21C8.324 7.794 9.688 6.5 12.104 6.5c2.516 0 3.681 1.293 3.681 2.942 0 1.208-.583 1.947-1.976 2.714-.824.44-.994.768-.937 1.635m.47 2.516c0 .71-.555 1.194-1.379 1.194-.853 0-1.393-.455-1.393-1.208 0-.696.569-1.194 1.393-1.194.81 0 1.379.47 1.379 1.208"
      })
    }))
  }, props));
}

__name(HelpIcon, "HelpIcon");

function HelpOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M10.953 13.79h1.918c-.056-.866.114-1.193.938-1.634 1.393-.767 1.976-1.506 1.976-2.714 0-1.649-1.165-2.942-3.68-2.942-2.417 0-3.781 1.293-3.895 3.354h2.174c.057-1.009.583-1.55 1.606-1.55 1.066 0 1.535.57 1.535 1.308 0 .526-.213.967-1.08 1.379-1.435.696-1.748 1.506-1.492 2.8M11.962 17.5c.824 0 1.379-.483 1.379-1.194 0-.739-.569-1.208-1.379-1.208-.824 0-1.393.498-1.393 1.194 0 .753.54 1.208 1.393 1.208"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m8-10a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
      })]
    }))
  }, props));
}

__name(HelpOutlineIcon, "HelpOutlineIcon");

function HiddenIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.001 19.562 3.327 3.043 2 4.541l3.433 3.036c-1.937 1.678-3.044 3.66-3.348 4.248-.057.112-.086.173-.086.173s3.22 7 10 7c1.889 0 3.501-.543 4.845-1.327l3.831 3.389zm-7.113-3.622-1.934-1.71a2.6 2.6 0 0 1-.954.182c-1.38 0-2.5-1.082-2.5-2.414q.002-.38.114-.723l-1.933-1.71A4.7 4.7 0 0 0 7 11.998c0 2.666 2.239 4.828 5 4.828a5.1 5.1 0 0 0 2.888-.886"
      }), /* @__PURE__ */jsx("path", {
        d: "M17 11.998q0 .234-.023.461l2.953 2.612c1.391-1.597 2.07-3.073 2.07-3.073s-3.25-7-10-7a9.3 9.3 0 0 0-2.93.467l2.02 1.785q.442-.079.91-.08c2.761 0 5 2.162 5 4.828"
      })]
    }))
  }, props));
}

__name(HiddenIcon, "HiddenIcon");

var HiddenIcon_default = HiddenIcon;

function HomeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 2 2 10v11h7v-5a3 3 0 1 1 6 0v5h7V10z"
      })
    }))
  }, props));
}

__name(HomeIcon, "HomeIcon");

function HomeGoodsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M16.612 12.385v-2.09c0-1.101-.87-2.002-1.951-2.062v-2.09l2.93 2.51 1.141-1.33-1.83-1.57h1.76V0H7.158L5.157 4.002l4.001 3v1.221c-1.09.06-1.95.96-1.95 2.061v2.091c-2.211.61-3.622 2.951-2.932 5.292L6.157 24h11.505l1.88-6.333c.691-2.34-.72-4.682-2.93-5.292zM7.467 22.26l-1.511-5.082c-.23-.76-.08-1.56.39-2.2.23-.31.53-.561.86-.731.27-.14.57-.21.88-.24.091 0 .171-.03.261-.03h7.133c.09 0 .17.02.26.03.31.03.61.11.88.24.33.17.63.41.86.73.471.64.621 1.44.391 2.201l-1.51 5.082zm1.48-11.965c0-.14.1-.24.23-.29.03-.01.06-.04.09-.04h5.263s.06.03.09.04c.13.04.23.14.23.29v1.931H8.938v-1.93zm7.964-6.292H12.91v4.211h-2v-2.09l-.701-.53L7.378 3.47l.86-1.73h8.674z"
      })
    }))
  }, props));
}

__name(HomeGoodsCategoryIcon, "HomeGoodsCategoryIcon");

function HomeGoodsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M9.16 8.22c-1.09.06-1.95.96-1.95 2.06v1.08h9.41v-1.08c0-1.1-.87-2-1.95-2.06V6.13l2.93 2.51 1.14-1.32-1.83-1.57h1.76V0H7.17l-2 4 4 3v1.22zM16.91 4h-4v4.21h-2V6.12l-.7-.53-2.83-2.12.86-1.73h8.67zM18.07 13.11H5.75c-1.32 1.02-2 2.79-1.47 4.56L6.16 24h11.5l1.88-6.33c.52-1.77-.16-3.53-1.47-4.56"
      })
    }))
  }, props));
}

__name(HomeGoodsCategoryFilledIcon, "HomeGoodsCategoryFilledIcon");

function HomeOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10.961V19h4v-3a4 4 0 0 1 8 0v3h4v-8.039l-8-6.4zM12 2 2 10v11h8v-5a2 2 0 1 1 4 0v5h8V10z"
      })
    }))
  }, props));
}

__name(HomeOutlineIcon, "HomeOutlineIcon");

function HyperlinkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 17.657 1.414-1.414 1.414 1.414-1.414 1.414a6 6 0 0 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 0 0 12 17.657m0-11.314-1.414 1.415L9.17 6.343l1.415-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.415-1.415-1.415L17.658 12A4 4 0 1 0 12 6.343m2.121 2.122-5.657 5.657 1.415 1.414 5.656-5.657z"
      })
    }))
  }, props));
}

__name(HyperlinkIcon, "HyperlinkIcon");

function IdentificationCardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm6.064 7.194a2 2 0 1 0-2.127 0A3 3 0 0 0 5 15h6a3 3 0 0 0-1.936-2.806M19 9h-6v2h6zm0 4h-6v2h6z"
      })
    }))
  }, props));
}

__name(IdentificationCardIcon, "IdentificationCardIcon");

function ImageIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 3h18v18H3zm8 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m8 1.5v9H5l5-5 3 2.5z"
      })
    }))
  }, props));
}

__name(ImageIcon, "ImageIcon");

function InStorePricesCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m11.13 8.13-.34-.24-.01-.02a.898.898 0 0 0-1.03 1.47l1.38.96 1.76 1.22.66.47 1.71 1.2c1.2.84 1.49 2.49.65 3.69-.51.74-1.33 1.13-2.17 1.13-.28 0-.57-.05-.85-.15v1.3h-1.75v-2.39l-3.93-2.75 1-1.44 2.93 2.05 1.76 1.22.34.24a.9.9 0 0 0 1.25-.22.89.89 0 0 0-.22-1.25l-1.37-.96-1.76-1.22-2.38-1.66c-.58-.41-.97-1.01-1.09-1.71s.03-1.4.44-1.98c.69-.98 1.94-1.34 3.03-.97V4.4h1.75v2.81l3.93 2.75-1 1.44-2.93-2.05z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m20.933 8.303-.45-4.786-4.786-.45L12 0 8.303 3.067l-4.786.45-.45 4.786L0 12l3.067 3.697.45 4.786 4.786.45L12 24l3.697-3.067 4.786-.45.45-4.786L24 12zM12 2.274l2.995 2.485 3.881.365.365 3.88L21.726 12l-2.485 2.995-.365 3.881-3.88.365L12 21.726l-2.995-2.485-3.881-.365-.365-3.88L2.274 12l2.485-2.995.365-3.881 3.88-.365z"
      })]
    }))
  }, props));
}

__name(InStorePricesCategoryIcon, "InStorePricesCategoryIcon");

function InStorePricesCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.697 3.067 4.786.45.45 4.786L24 12l-3.067 3.697-.45 4.786-4.786.45L12 24l-3.697-3.067-4.786-.45-.45-4.786L0 12l3.067-3.697.45-4.786 4.786-.45L12 0zM11.13 8.13l-.34-.24-.01-.02a.898.898 0 0 0-1.03 1.47l1.38.96 1.76 1.22.66.47 1.71 1.2c1.2.84 1.49 2.49.65 3.69-.51.74-1.33 1.13-2.17 1.13-.28 0-.57-.05-.85-.15v1.3h-1.75v-2.39l-3.93-2.75 1-1.44 2.93 2.05 1.76 1.22.34.24a.9.9 0 0 0 1.25-.22.89.89 0 0 0-.22-1.25l-1.37-.96-1.76-1.22-2.38-1.66c-.58-.41-.97-1.01-1.09-1.71s.03-1.4.44-1.98c.69-.98 1.94-1.34 3.03-.97V4.4h1.75v2.81l3.93 2.75-1 1.44-2.93-2.05z"
      })
    }))
  }, props));
}

__name(InStorePricesCategoryFilledIcon, "InStorePricesCategoryFilledIcon");

function IncreaseIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M18 16H6l6-8z"
      })
    }))
  }, props));
}

__name(IncreaseIcon, "IncreaseIcon");

function InformationIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m1.5-14.765c0 .706-.53 1.203-1.492 1.203-.995 0-1.508-.465-1.508-1.235 0-.69.53-1.203 1.508-1.203.979 0 1.492.481 1.492 1.235M10.75 18v-8h2.5v8z"
      })
    }))
  }, props));
}

__name(InformationIcon, "InformationIcon");

var InformationIcon_default = InformationIcon;

function InformationOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.008 8.439c.963 0 1.492-.498 1.492-1.204C13.5 6.481 12.987 6 12.008 6S10.5 6.513 10.5 7.203c0 .77.513 1.236 1.508 1.236M10.75 10v8h2.5v-8z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m8-10a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
      })]
    }))
  }, props));
}

__name(InformationOutlineIcon, "InformationOutlineIcon");

var InformationOutlineIcon_default = InformationOutlineIcon;

function InsightIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12.01 2A6 6 0 0 1 18 7.986V8q0 .377-.045.741a5.8 5.8 0 0 1-1.091 2.774 6 6 0 0 1-.328.413c-.78 1.003-1.35 2.212-1.54 3.44l-5.992.628a7.44 7.44 0 0 0-1.488-4.01 6 6 0 0 1-.718-.993 5.8 5.8 0 0 1-.75-2.223A6 6 0 0 1 6 8v-.005q0-.11.004-.22A6 6 0 0 1 12 2zM9 17.499l6-.623v1.5L9 19zM14 19.984l-4 .436v.492a1 1 0 0 0 1.084.997l2-.17a1 1 0 0 0 .916-.995z"
      })
    }))
  }, props));
}

__name(InsightIcon, "InsightIcon");

function InstacartIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      viewBox: "0 0 48 106",
      fill: "none"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M25.733 105.5 42.27 69.161c6.928-17.284-4.055-30.744-18.288-30.744C9.75 38.417-1.23 51.889 5.7 69.16L22.233 105.5zM40.821 9.971c-2.575 0-4.413 1.126-6.113 3.562l-4.884 7.03V.5H18.147v20.074l-4.888-7.037c-1.699-2.426-3.536-3.562-6.114-3.562-3.89 0-6.478 2.873-6.495 6.415 0 3.029 1.418 5.003 4.428 6.93l18.91 12.18 18.9-12.173c3.009-1.941 4.439-3.917 4.429-6.931-.01-3.552-2.6-6.425-6.496-6.425"
      })
    }))
  }, props));
}

__name(InstacartIcon, "InstacartIcon");

var InstacartIcon_default = InstacartIcon;

function InstagramIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h7.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311c.327.642.327 1.482.327 3.162v7.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 18.22 3.5 17.38 3.5 15.7zm8.5-.8a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m5 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      })
    }))
  }, props));
}

__name(InstagramIcon, "InstagramIcon");

function InventoryBetterIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20 6H4v2h16zM6 11h12v2H6zM9 16h6v2H9z"
      })
    }))
  }, props));
}

__name(InventoryBetterIcon, "InventoryBetterIcon");

function InventoryBetterDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 8,
        y: 16.5,
        width: 8,
        height: 3,
        rx: 1.5,
        fill: "#F8F8FF"
      }), /* @__PURE__ */jsx("rect", {
        x: 5.5,
        y: 10.5,
        width: 13,
        height: 3,
        rx: 1.5,
        fill: "#F8F8FF"
      }), /* @__PURE__ */jsx("rect", {
        x: 3,
        y: 4.5,
        width: 18,
        height: 3,
        rx: 1.5,
        fill: "#F8F8FF"
      })]
    }))
  }, props));
}

__name(InventoryBetterDarkIcon, "InventoryBetterDarkIcon");

function InventoryGoodIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M18 11H6v2h12zM15 16H9v2h6z"
      }), /* @__PURE__ */jsx("path", {
        fillOpacity: 0.24,
        d: "M4 6h16v2H4z"
      })]
    }))
  }, props));
}

__name(InventoryGoodIcon, "InventoryGoodIcon");

function InventoryGoodDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 8,
        y: 16.5,
        width: 8,
        height: 3,
        rx: 1.5,
        fill: "#F8F8FF"
      }), /* @__PURE__ */jsx("rect", {
        x: 5.5,
        y: 10.5,
        width: 13,
        height: 3,
        rx: 1.5,
        fill: "#F8F8FF"
      }), /* @__PURE__ */jsx("rect", {
        x: 3,
        y: 4.5,
        width: 18,
        height: 3,
        rx: 1.5,
        fill: "#595B61"
      })]
    }))
  }, props));
}

__name(InventoryGoodDarkIcon, "InventoryGoodDarkIcon");

function InventoryLowIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M9 16h6v2H9z"
      }), /* @__PURE__ */jsx("path", {
        d: "M20 6H4v2h16zM18 11H6v2h12z",
        fillOpacity: 0.24
      })]
    }))
  }, props));
}

__name(InventoryLowIcon, "InventoryLowIcon");

function InventoryLowDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 8,
        y: 16.5,
        width: 8,
        height: 3,
        rx: 1.5,
        fill: "#F8F8FF"
      }), /* @__PURE__ */jsx("rect", {
        x: 5.5,
        y: 10.5,
        width: 13,
        height: 3,
        rx: 1.5,
        fill: "#595B61"
      }), /* @__PURE__ */jsx("rect", {
        x: 3,
        y: 4.5,
        width: 18,
        height: 3,
        rx: 1.5,
        fill: "#595B61"
      })]
    }))
  }, props));
}

__name(InventoryLowDarkIcon, "InventoryLowDarkIcon");

function IssueIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 21 12 3 2 21zm-9.137-5.42h-1.73c-.158-2.4-.262-4.378-.262-6.043V9h2.254v.537c0 1.658-.117 3.614-.26 6.012zm.432 2.32c0 .654-.498 1.1-1.284 1.1-.8 0-1.31-.42-1.31-1.114 0-.642.537-1.1 1.31-1.1s1.284.432 1.284 1.113"
      })
    }))
  }, props));
}

__name(IssueIcon, "IssueIcon");

var IssueIcon_default = IssueIcon;

function ItalicIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.242 4h9.313v3h-2.886L12.9 17h2.858v3H6.445v-3H9.31l1.769-10H8.242z"
      })
    }))
  }, props));
}

__name(ItalicIcon, "ItalicIcon");

function ItemIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.066 7.347c.1-.769.31-1.328.623-1.766.451-.633 1.226-1.166 2.627-1.633l-.632-1.897c-1.599.533-2.824 1.25-3.623 2.367-.619.867-.916 1.884-1.018 3.042C10.266 6.774 9.048 6 7.5 6 4.509 6 2.554 8.964 3.08 13.273 3.618 17.583 7.045 21.9 10 21.5c.618-.082 1.491-.262 2-.708.51.445 1.382.626 2 .708 2.964.4 6.391-3.917 6.919-8.227.527-4.318-1.437-7.218-4.42-7.273-1.476-.029-2.653.678-3.433 1.347"
      })
    }))
  }, props));
}

__name(ItemIcon, "ItemIcon");

function KetoIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 14.5c0-4.866-2.5-12-7-12s-7 7.134-7 12a7 7 0 1 0 14 0m-4.002-.105a3 3 0 1 0-5.996.21 3 3 0 0 0 5.996-.21"
      })
    }))
  }, props));
}

__name(KetoIcon, "KetoIcon");

function KeyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.383 4.844a.04.04 0 0 1-.055-.003c-1.17-1.169-3.122-1.112-4.36.127-1.24 1.238-1.296 3.19-.127 4.36a.04.04 0 0 1 .003.055c-1.074 1.437-1.012 3.423.224 4.659 1.364 1.364 3.642 1.298 5.087-.148l.37-.37 1.264 1.265h2.268v2.268l.017.017h2.269v2.269L17 20h3v-3l-6.475-6.475.37-.37c1.445-1.445 1.51-3.723.146-5.087-1.235-1.236-3.22-1.298-4.658-.224m.551 2.828a1.6 1.6 0 1 1-2.262 2.263 1.6 1.6 0 0 1 2.262-2.263"
      })
    }))
  }, props));
}

__name(KeyIcon, "KeyIcon");

function KosherIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m3.764-14.25c.218.203.332.46.332.759 0 .368-.191.702-.503 1l-2.136 2.023 2.516 3.605h.001q.287.405.44.73.162.334.164.678a.96.96 0 0 1-.327.722c-.218.206-.505.296-.83.296-.297 0-.563-.062-.78-.207l-.004-.003a1.7 1.7 0 0 1-.49-.525 26 26 0 0 1-.304-.507l-2.06-3.17-1.248 1.196v1.817c0 .422-.095.785-.334 1.04l-.002.002c-.229.24-.525.357-.866.357a1.17 1.17 0 0 1-.587-.16 1.14 1.14 0 0 1-.437-.438l-.006-.01a1.4 1.4 0 0 1-.133-.504 9 9 0 0 1-.02-.7V8.334c0-.412.088-.767.309-1.021l.002-.003c.223-.25.523-.37.872-.37.345 0 .643.12.868.366.239.251.334.61.334 1.028v2.64l3.27-3.41q.274-.287.485-.442l.003-.003c.181-.126.404-.178.645-.178.323 0 .606.097.826.31"
      })
    }))
  }, props));
}

__name(KosherIcon, "KosherIcon");

function LegalIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 5H3v14h18V8h-8z"
      })
    }))
  }, props));
}

__name(LegalIcon, "LegalIcon");

function LikeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m14.8 10.537 1.2.397V21H6.033a3.25 3.25 0 0 1-3.202-2.608l-.33-1.666C2.17 15.05 2 13.354 2 11.648c0-.942.77-1.706 1.721-1.706h3.963c.73 0 1.321-.585 1.321-1.309v-3.55c0-1.15.94-2.083 2.101-2.083h.901l.73 5.088c.16 1.14.961 2.082 2.062 2.45M18 11h3v10h-3z"
      })
    }))
  }, props));
}

__name(LikeIcon, "LikeIcon");

var LikeIcon_default = LikeIcon;

function LinkedInIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20.52 2c.816 0 1.48.646 1.48 1.442v17.115c0 .796-.664 1.443-1.48 1.443H3.475C2.661 22 2 21.353 2 20.557V3.442C2 2.646 2.661 2 3.475 2zm-1.477 17.042v-5.234c0-2.57-.555-4.547-3.558-4.547-1.444 0-2.412.791-2.807 1.542h-.04V9.498H9.793v9.544h2.963v-4.72c0-1.246.235-2.452 1.779-2.452 1.522 0 1.541 1.424 1.541 2.53v4.642zM7.933 9.498h-2.97v9.544h2.97zM6.449 4.753a1.72 1.72 0 1 0-.003 3.44 1.72 1.72 0 0 0 .003-3.44"
      })
    }))
  }, props));
}

__name(LinkedInIcon, "LinkedInIcon");

function ListIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M10 6h10v2H10zM7 11H4v2h3zM20 11H10v2h10zM10 16h10v2H10zM7 16H4v2h3zM7 6H4v2h3z"
      })
    }))
  }, props));
}

__name(ListIcon, "ListIcon");

function ListAddIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 8H4V6h10zm-3 5H4v-2h7zm-7 5h10v-2H4zm12-5h-2v-2h2V9h2v2h2v2h-2v2h-2z"
      })
    }))
  }, props));
}

__name(ListAddIcon, "ListAddIcon");

function LocalCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.897 10.879a7 7 0 0 1-.746-1.67 7.152 7.152 0 1 1 12.945 1.687L15.727 15H20l4 9H0l4-9h4.276zM12.841 20l1.732-3H18.7l2.223 5H3.078L5.3 17h4.13l1.732 3zm-.84-2.546 4.377-7.582.015-.025a5 5 0 0 0 .544-1.211 5.152 5.152 0 1 0-9.334 1.199l.013.021zm-.103-7.324a2.98 2.98 0 1 0 .208-5.956 2.98 2.98 0 0 0-.208 5.956"
      })
    }))
  }, props));
}

__name(LocalCategoryIcon, "LocalCategoryIcon");

function LocalCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.029 10.033a6.76 6.76 0 0 1-.817-3.476 6.794 6.794 0 1 1 12.58 3.794L12.798 19h-1.595l-5.002-8.665q-.09-.15-.173-.302m8.95-2.777a2.98 2.98 0 1 1-5.956-.208 2.98 2.98 0 0 1 5.956.208M4 15h2.586l3.463 6h3.905l3.463-6H20l4 9H0z"
      })
    }))
  }, props));
}

__name(LocalCategoryFilledIcon, "LocalCategoryFilledIcon");

function LocationIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M22 2 2 10l8 4 4 8z"
      })
    }))
  }, props));
}

__name(LocationIcon, "LocationIcon");

function LocationOffIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m16.037 16.91 4.734 4.157 1.32-1.502L3.285 3.046 1.965 4.55l4.278 3.757L2 10.004l8 4 4 8zM22 2.004l-4.388 10.968-7.207-6.33z"
      })
    }))
  }, props));
}

__name(LocationOffIcon, "LocationOffIcon");

function LockedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 7a3 3 0 1 1 6 0v2H9zM7 9V7a5 5 0 0 1 10 0v2h3v13H4V9zm7 5a2 2 0 0 1-1 1.732V19h-2v-3.268A2 2 0 0 1 12 12a2 2 0 0 1 2 2"
      })
    }))
  }, props));
}

__name(LockedIcon, "LockedIcon");

var LockedIcon_default = LockedIcon;

function LogInIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M3 13v-2h9.173L8.93 7.757l1.414-1.414L16.001 12l-5.657 5.657-1.414-1.415L12.172 13zM17 20v-2h2V6h-2V4h4v16z"
      })
    }))
  }, props));
}

__name(LogInIcon, "LogInIcon");

function LogOutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M10.07 7.757 8.656 6.343 2.999 12l5.657 5.657 1.414-1.415L6.828 13H16v-2H6.827zM17 20v-2h2V6h-2V4h4v16z"
      })
    }))
  }, props));
}

__name(LogOutIcon, "LogOutIcon");

function LoveIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 20.755s-7.797-6.088-9.546-10.556c-1.36-3.489.5-6.497 3.398-6.887 2.26-.3 4.699.84 6.148 3.099 1.45-2.27 3.879-3.41 6.148-3.1 2.899.39 4.758 3.4 3.398 6.888C19.806 14.667 12 20.755 12 20.755"
      })
    }))
  }, props));
}

__name(LoveIcon, "LoveIcon");

function LoveOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.648 4.846c-1.388-1.2-3.14-1.754-4.796-1.534-2.898.39-4.758 3.398-3.398 6.887C4.204 14.667 12 20.755 12 20.755s7.807-6.088 9.546-10.556c1.36-3.489-.5-6.497-3.398-6.887-1.664-.227-3.414.325-4.8 1.53-.505.438-.961.963-1.348 1.569a7.2 7.2 0 0 0-1.352-1.565m1.353 13.323a60 60 0 0 0 2.736-2.46c1.05-1.006 2.126-2.124 3.033-3.238.925-1.136 1.589-2.166 1.913-2.997.96-2.464-.373-3.988-1.802-4.18h-.004c-1.418-.194-3.117.512-4.191 2.193l-1.682 2.633-1.687-2.63c-1.073-1.67-2.785-2.383-4.2-2.196-1.427.193-2.759 1.716-1.8 4.177.326.834.992 1.864 1.917 3 .908 1.114 1.985 2.232 3.034 3.239A60 60 0 0 0 12 18.169"
      })
    }))
  }, props));
}

__name(LoveOutlineIcon, "LoveOutlineIcon");

function LowCholesterolIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5 8a4.5 4.5 0 0 0-8.499-2.062A4.5 4.5 0 0 0 3.5 8c0 6.074 5.597 10.851 7.707 12.436a1.31 1.31 0 0 0 1.584 0C14.901 18.851 20.5 14.074 20.5 8M6.439 10.44a1.5 1.5 0 0 1 2.121-.001l1.943 1.94 5.436-5.44a1.5 1.5 0 1 1 2.122 2.122l-6.497 6.5a1.5 1.5 0 0 1-2.121 0l-3.003-3a1.5 1.5 0 0 1-.001-2.121"
      })
    }))
  }, props));
}

__name(LowCholesterolIcon, "LowCholesterolIcon");

function LowGlycemicIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 14.03c-2.527-.568-4-2.58-4-5.686C6.5 4.688 8.594 2.53 12 2.53c2.21 0 3.906.992 4.555 2.274.148.289.203.53.203.789 0 .726-.5 1.218-1.235 1.218-.578 0-1.007-.226-1.359-.742-.539-.851-1.21-1.234-2.156-1.234-1.625 0-2.586 1.273-2.586 3.469 0 2.234 1.062 3.586 2.71 3.586 1.298 0 2.204-.766 2.282-1.899l.008-.172h-1.117c-.657 0-1.094-.351-1.094-.984s.43-.984 1.094-.984h2.453c.906 0 1.43.539 1.43 1.492v.078c0 2.34-1.308 4.13-3.688 4.632v2.444h1.002a1 1 0 0 1 .768 1.64l-2.5 3a1 1 0 0 1-1.536 0l-2.5-3a1 1 0 0 1 .768-1.64h.998z"
      })
    }))
  }, props));
}

__name(LowGlycemicIcon, "LowGlycemicIcon");

function LowSodiumIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 16.498h-.998a1 1 0 0 0-.768 1.64l2.5 3a1 1 0 0 0 1.536 0l2.5-3a1 1 0 0 0-.768-1.64H13.5v-2.533c1.657-.483 2.742-1.687 2.742-3.335 0-1.72-1.172-2.82-3.414-3.243l-1.164-.218c-1.336-.258-1.812-.578-1.812-1.203 0-.688.726-1.188 1.843-1.188.907 0 1.664.297 2.047 1 .367.563.742.758 1.297.758.727 0 1.242-.484 1.242-1.203 0-.235-.047-.477-.148-.711-.469-1.164-1.945-2.086-4.39-2.086C8.772 2.536 7 3.973 7 6.239c0 1.773 1.094 2.75 3.5 3.211l1.156.219c1.227.234 1.735.562 1.735 1.156 0 .664-.61 1.133-1.649 1.133-.828 0-1.453-.274-1.82-.977-.336-.547-.727-.773-1.352-.773-.718.008-1.203.453-1.203 1.117 0 .234.04.422.117.617.434 1.133 1.514 1.888 3.016 2.153z"
      })
    }))
  }, props));
}

__name(LowSodiumIcon, "LowSodiumIcon");

function LoyaltyCardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm15 10v-2H7v2zm-4.182-7.362L12 7l-.82 1.638-1.809.273 1.304 1.286-.3 1.803L12 11.159l1.625.841-.3-1.803 1.304-1.286z"
      })
    }))
  }, props));
}

__name(LoyaltyCardIcon, "LoyaltyCardIcon");

function MailIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12 12 2 4h20z"
      }), /* @__PURE__ */jsx("path", {
        d: "m12 14.561 10-8V20H2V6.56z"
      })]
    }))
  }, props));
}

__name(MailIcon, "MailIcon");

function MailOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4h20v16H2zm18 4.161-8 6.4-8-6.4V18h16zM4.5 6l7.5 6 7.5-6z"
      })
    }))
  }, props));
}

__name(MailOutlineIcon, "MailOutlineIcon");

function MapIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m7 4.668-3 .877V18.35l5.01-1.43V4.096L7 4.678zm-5-.622V21l7-2 6.125 3L22 20V3l-6.875 2L9 2zM19.992 18.51V18.5L20 18.5V5.665l-.008.002v-.019l-2.416.722-.451.131v.004l-2 .597v12.84z"
      })
    }))
  }, props));
}

__name(MapIcon, "MapIcon");

function MarkdownIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 2H5v12H2l10 8 10-8h-3zM7.465 6.97c0 1.25.82 1.96 2 1.96 1.15 0 1.98-.77 1.98-1.96 0-1.26-.81-1.97-1.97-1.97-1.17 0-2.01.78-2.01 1.97m6.52-1.84-5.66 7.78h1.71l5.67-7.78zm-1.43 5.95c0 1.24.82 1.95 2 1.95 1.15 0 1.98-.77 1.98-1.96 0-1.26-.81-1.96-1.97-1.96-1.17 0-2.01.77-2.01 1.97"
      })
    }))
  }, props));
}

__name(MarkdownIcon, "MarkdownIcon");

function MarkerIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.714 12.561a7.1 7.1 0 0 1-.86-3.659 7.152 7.152 0 1 1 13.242 3.994L12.84 22h-1.679l-5.265-9.121a7 7 0 0 1-.183-.318m9.266-3.305a2.98 2.98 0 1 1-5.956-.208 2.98 2.98 0 0 1 5.956.208"
      })
    }))
  }, props));
}

__name(MarkerIcon, "MarkerIcon");

var MarkerIcon_default = MarkerIcon;

function MealsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M10.756 6.604C10.807 3.684 9.52 2 7.256 2H7C4.736 2 3.45 3.685 3.5 6.604c-.043 2.494.888 4.087 2.57 4.499L5.47 22H8.8l-.613-10.898c1.682-.413 2.612-2.005 2.569-4.498M18.756 7.84l.013.012h-.997L17.342 2h-.991l-.431 5.852h-.983l.012-.013V2.013h-.913l-.81 5.646-.003.032c-.012.116-.023.223-.023.341 0 1.12.708 2.122 1.762 2.508l.847.308-.036.648-.065 1.09h.003L15.181 22h3.331l-.52-9.415h.005l-.075-1.276-.026-.46.847-.309a2.68 2.68 0 0 0 1.762-2.508c0-.118-.01-.225-.022-.34l-.003-.033-.81-5.646h-.914z"
      })
    }))
  }, props));
}

__name(MealsIcon, "MealsIcon");

function MenuIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20 6H4v2h16zM4 11h16v2H4zM4 16h16v2H4z"
      })
    }))
  }, props));
}

__name(MenuIcon, "MenuIcon");

function MenuCollapseIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M6 3v18h2V3zM18 7.792 13.794 12 18 16.208l-1.584 1.584L10.625 12l5.792-5.792z"
      })
    }))
  }, props));
}

__name(MenuCollapseIcon, "MenuCollapseIcon");

function MenuExpandIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M6 3v18h2V3zM10.625 7.792 14.833 12l-4.208 4.208 1.584 1.584L18 12l-5.792-5.792z"
      })
    }))
  }, props));
}

__name(MenuExpandIcon, "MenuExpandIcon");

function MicrophoneIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12 2a4 4 0 0 0-4 4v5a4 4 0 0 0 8 0V6a4 4 0 0 0-4-4"
      }), /* @__PURE__ */jsx("path", {
        d: "M6 10v1a6 6 0 0 0 12 0v-1h2v1a8 8 0 0 1-7 7.938v3.118h-2v-3.118A8 8 0 0 1 4 11v-1z"
      })]
    }))
  }, props));
}

__name(MicrophoneIcon, "MicrophoneIcon");

function MicrophoneOffIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m3.29 3.047-.005-.004-1.32 1.502L8 9.846V11a4 4 0 0 0 5.525 3.7l1.612 1.415A6 6 0 0 1 6 11v-1H4v1a8 8 0 0 0 7 7.938v3.118h2v-3.118a7.96 7.96 0 0 0 3.691-1.457l4.08 3.583 1.318-1.501L3.288 3.048zM19.243 14.4A8 8 0 0 0 20 11v-1h-2v1a6 6 0 0 1-.344 2.007zM15.966 11.522Q16 11.266 16 11V6a4 4 0 0 0-7.788-1.289z"
      })
    }))
  }, props));
}

__name(MicrophoneOffIcon, "MicrophoneOffIcon");

function MoneyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.916-4h-1.608v-1.2c-2.005-.211-3.06-1.306-3.218-2.901h2.215c.093.883.673 1.41 1.847 1.41s1.648-.513 1.648-1.2c0-.632-.33-1.014-1.319-1.186l-1.45-.237c-1.767-.277-2.638-1.147-2.638-2.664 0-1.49 1.003-2.585 2.915-2.822V6h1.608v1.213c1.82.25 2.677 1.345 2.875 2.756h-2.123c-.105-.791-.567-1.266-1.675-1.266-1.002 0-1.503.435-1.503 1.108 0 .593.37.936 1.306 1.081l1.358.238c2.083.356 2.756 1.292 2.756 2.808 0 1.464-.95 2.611-2.994 2.849z"
      })
    }))
  }, props));
}

__name(MoneyIcon, "MoneyIcon");

function MoneyOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.916 18h-1.608v-1.2c-2.005-.211-3.06-1.306-3.218-2.901h2.215c.093.883.673 1.41 1.847 1.41s1.648-.513 1.648-1.2c0-.632-.33-1.014-1.319-1.186l-1.45-.237c-1.767-.277-2.638-1.147-2.638-2.664 0-1.49 1.003-2.585 2.915-2.822V6h1.608v1.213c1.82.25 2.677 1.345 2.875 2.756h-2.123c-.105-.791-.567-1.266-1.675-1.266-1.002 0-1.503.435-1.503 1.108 0 .593.37.936 1.306 1.081l1.358.238c2.083.356 2.756 1.292 2.756 2.808 0 1.464-.95 2.611-2.994 2.849z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
      })]
    }))
  }, props));
}

__name(MoneyOutlineIcon, "MoneyOutlineIcon");

function MoonIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M21 12.95a7.02 7.02 0 1 1-9.927-9.927A9.026 9.026 0 1 0 21 12.95"
      })
    }))
  }, props));
}

__name(MoonIcon, "MoonIcon");

function MuteIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 3 6.444 8H2v8h4.444L12 21zM20.293 15.707 18 13.414l-2.293 2.293-1.414-1.414L16.586 12l-2.293-2.293 1.414-1.414L18 10.586l2.293-2.293 1.414 1.414L19.414 12l2.293 2.293z"
      })
    }))
  }, props));
}

__name(MuteIcon, "MuteIcon");

function NestedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M4 4h2v10h10.175l-3.243-3.243 1.415-1.414L20.003 15l-5.656 5.657-1.415-1.414L16.176 16H4z"
      })
    }))
  }, props));
}

__name(NestedIcon, "NestedIcon");

function NewCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M11.5 8.25A5.7 5.7 0 0 1 9.25 6 5.7 5.7 0 0 1 7 8.25a5.7 5.7 0 0 1 2.25 2.25 5.7 5.7 0 0 1 2.25-2.25M14 8.5l.15.365A9.3 9.3 0 0 0 18 13.25a9.3 9.3 0 0 0-3.85 4.385L14 18l-.15-.365A9.3 9.3 0 0 0 10 13.25a9.3 9.3 0 0 0 3.85-4.385z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m20.483 3.517.45 4.786L24 12l-3.067 3.697-.45 4.786-4.786.45L12 24l-3.697-3.067-4.786-.45-.45-4.786L0 12l3.067-3.697.45-4.786 4.786-.45L12 0l3.697 3.067zM14.995 4.76 12 2.274 9.005 4.759l-3.881.365-.365 3.88L2.274 12l2.485 2.995.365 3.881 3.88.365L12 21.726l2.995-2.485 3.881-.365.365-3.88L21.726 12l-2.485-2.995-.365-3.881z"
      })]
    }))
  }, props));
}

__name(NewCategoryIcon, "NewCategoryIcon");

function NewCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m20.483 3.517-4.786-.45L12 0 8.303 3.067l-4.786.45-.45 4.786L0 12l3.067 3.697.45 4.786 4.786.45L12 24l3.697-3.067 4.786-.45.45-4.786L24 12l-3.067-3.697zM11.5 8.25A5.7 5.7 0 0 1 9.25 6 5.7 5.7 0 0 1 7 8.25a5.7 5.7 0 0 1 2.25 2.25 5.7 5.7 0 0 1 2.25-2.25m2.5.25.15.365A9.3 9.3 0 0 0 18 13.25a9.3 9.3 0 0 0-3.85 4.385L14 18l-.15-.365A9.3 9.3 0 0 0 10 13.25a9.3 9.3 0 0 0 3.85-4.385z"
      })
    }))
  }, props));
}

__name(NewCategoryFilledIcon, "NewCategoryFilledIcon");

function NoCardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.001 19.562 3.327 3.043 2.002 4.541l.606.537a1 1 0 0 0-.608.92v2h3.91l2.26 2H2v8a1 1 0 0 0 1 1h15.346l2.33 2.062zM11 13.998H5v2h6z"
      }), /* @__PURE__ */jsx("path", {
        d: "M14.196 9.998 22 16.902V9.998zM8.543 4.998l3.391 3H22v-2a1 1 0 0 0-1-1z"
      })]
    }))
  }, props));
}

__name(NoCardIcon, "NoCardIcon");

function NotificationIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11 2h2v2.083c2.838.476 5 2.944 5 5.917v4c0 1 1 2 2 2v2H4v-2c1 0 2-1 2-2v-4a6 6 0 0 1 5-5.917zM12 22a3 3 0 0 1-2.83-2h5.66A3 3 0 0 1 12 22"
      })
    }))
  }, props));
}

__name(NotificationIcon, "NotificationIcon");

function NotificationOffIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m17.283 18 3.488 3.064 1.32-1.503L3.285 3.043l-1.32 1.502 4.278 3.758A6 6 0 0 0 6 10v4c0 1-1 2-2 2v2zM18 10v3.309L8.602 5.054A6 6 0 0 1 11 4.083V2h2v2.083c2.838.476 5 2.944 5 5.917M12 22a3 3 0 0 1-2.83-2h5.66A3 3 0 0 1 12 22"
      })
    }))
  }, props));
}

__name(NotificationOffIcon, "NotificationOffIcon");

function NotifierIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2"
      }), /* @__PURE__ */jsx("path", {
        d: "M14.904 14.56h-1.812V7.48h-1.416l-2.112.588v1.14h1.776v5.352H9.528V16h5.376z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(NotifierIcon, "NotifierIcon");

function NumberedListIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19.742 6h-10v2h10zM9.742 11h10v2h-10zM9.742 16h10v2h-10zM5.126 11h1.296V6.416H5.39v.102c0 .492-.21.684-.678.684h-.516v.804h.93zM7.23 16.992V18H3.75v-.78c0-.564.162-.93.81-1.308l1.086-.636c.246-.15.306-.282.306-.444 0-.252-.156-.414-.462-.414-.312 0-.504.168-.498.564H3.774c.048-1.002.696-1.566 1.752-1.566 1.134 0 1.65.576 1.644 1.386-.006.57-.252.894-.84 1.236l-1.086.636c-.192.114-.276.198-.3.318z"
      })
    }))
  }, props));
}

__name(NumberedListIcon, "NumberedListIcon");

function NutFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.863 11.485 2.44 5.06a1.5 1.5 0 1 1 2.122-2.122l16 16a1.5 1.5 0 0 1-2.122 2.122l-2.418-2.419A4.25 4.25 0 0 1 12 21.5c-2.347 0-4.249-1.89-4.249-4.222q0-.396.07-.773c.09-.64.283-1.159.48-1.69.286-.777.583-1.578.583-2.815q0-.28-.02-.515m-.17-7.414 6.637 6.638c.09-.372.214-.66.342-.958.28-.649.578-1.343.578-3.042q0-.06-.004-.119c-.07-2.27-1.945-4.09-4.247-4.09a4.25 4.25 0 0 0-3.307 1.57"
      })
    }))
  }, props));
}

__name(NutFreeIcon, "NutFreeIcon");

function NutsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.78 7.22a4 4 0 0 1-.03-.498C7.75 4.39 9.652 2.5 11.999 2.5c2.302 0 4.177 1.82 4.247 4.09q.004.06.004.119c0 1.699-.299 2.393-.578 3.042-.245.569-.475 1.103-.475 2.249 0 1.276.285 2.085.558 2.863.252.717.495 1.406.495 2.408q0 .03-.002.06c-.029 2.307-1.92 4.169-4.249 4.169-2.347 0-4.249-1.89-4.249-4.222q0-.396.07-.773c.09-.64.283-1.159.48-1.69.286-.777.583-1.578.583-2.815 0-1.114-.241-1.649-.498-2.22-.265-.59-.548-1.218-.606-2.56"
      })
    }))
  }, props));
}

__name(NutsIcon, "NutsIcon");

function OfficeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2h12v10h5v9.99l-9 .005V16H8v5.998L4 22zm2 2h3v3H6zm3 5H6v3h3zm2-5h3v3h-3zm3 5h-3v3h3zm1 7h3v3h-3z"
      })
    }))
  }, props));
}

__name(OfficeIcon, "OfficeIcon");

function OfficeCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M21.35 10h-1.36l1.26-3.53-1.4-5.34-4.26 3.37-1.96 5.5h-.19L9.77 0 3 2.88 5.62 10H3.35l2 14h14zM6.87 22.25l-1.5-10.5h13.96l-.02.15-1.48 10.35zm10.2-16.69 1.76-1.39.58 2.23-1.28 3.61h-2.64l1.58-4.44zM8.76 2.33 11.58 10H7.49l-.12-.33 1.79-.76-.68-1.61-1.71.73-.43-1.17 1.74-.74-.68-1.61-1.66.71-.51-1.38 3.54-1.51z"
      })
    }))
  }, props));
}

__name(OfficeCategoryIcon, "OfficeCategoryIcon");

function OfficeCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19.85 1.13 15.59 4.5 13.63 10h-.19L9.77 0 3 2.88 5.62 10H3.35l2 14h14l2-14h-1.36l1.26-3.53zM8.77 2.33 11.59 10H7.5l-.12-.33 1.79-.76-.68-1.61-1.71.73-.43-1.17 1.74-.74-.68-1.61-1.66.71-.51-1.38 3.54-1.51zM15.49 10l1.58-4.44 1.76-1.39.58 2.23-1.28 3.61h-2.64z"
      })
    }))
  }, props));
}

__name(OfficeCategoryFilledIcon, "OfficeCategoryFilledIcon");

function OmegasIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 11a5 5 0 1 1 6.37 4.81L13.072 20h6.93v-4H18.5l-.5 2h-2.82l.14-.836a7 7 0 1 0-6.64 0l.14.836H6l-.5-2H4v4h6.929l-.3-4.19A5 5 0 0 1 7 11"
      })
    }))
  }, props));
}

__name(OmegasIcon, "OmegasIcon");

function OpenInIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2H2v20h20v-8h-2v6H4V4h6zm12 0v8h-2V5.414L8.367 17.047l-1.414-1.414L18.586 4H14V2z"
      })
    }))
  }, props));
}

__name(OpenInIcon, "OpenInIcon");

function OpenNowCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m11.58 16.78 3.88-3.67.58.62.62.66-5.12 4.83-2.85-2.85 1.01-1.02.23-.22z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7 1.64c0 .3-.09.58-.23.82L19.82 9h4.24v15h-24V9H4.3l6.35-6.54c-.14-.24-.23-.52-.23-.82 0-.91.73-1.64 1.64-1.64s1.64.73 1.64 1.64M1.81 10.75v11.5h20.5v-11.5zM17.39 9l-5.33-5.49L6.73 9z"
      })]
    }))
  }, props));
}

__name(OpenNowCategoryIcon, "OpenNowCategoryIcon");

function OpenNowCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M24.06 9h-4.24l-6.35-6.54c.14-.24.23-.52.23-.82C13.7.73 12.97 0 12.06 0s-1.64.73-1.64 1.64c0 .3.09.58.23.82L4.3 9H.06v15h24zm-7.4 5.39-5.12 4.83-2.85-2.85 1.24-1.24 1.65 1.65 3.88-3.67.58.62.62.65zm-4.6-10.87 5.33 5.49H6.74l5.33-5.49z"
      })
    }))
  }, props));
}

__name(OpenNowCategoryFilledIcon, "OpenNowCategoryFilledIcon");

function OptionsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M19 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      })
    }))
  }, props));
}

__name(OptionsIcon, "OptionsIcon");

var OptionsIcon_default = OptionsIcon;

function OrderIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3h14v18h-1l-2-2-2 2-2-2-2 2-2-2-2 2H5zm3 8h8v2H8zm8-5H8v2h8z"
      })
    }))
  }, props));
}

__name(OrderIcon, "OrderIcon");

function OrderIssueIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 3H5v18h1l2-2 2 2 2-2 2 2 2-2 2 2h1zm-6.137 9.58h-1.73c-.158-2.4-.263-4.378-.263-6.043V6h2.255v.537c0 1.658-.117 3.614-.26 6.012zm.432 2.32c0 .654-.498 1.1-1.284 1.1-.8 0-1.311-.42-1.311-1.114 0-.642.537-1.1 1.31-1.1.774 0 1.285.432 1.285 1.113"
      })
    }))
  }, props));
}

__name(OrderIssueIcon, "OrderIssueIcon");

function OrganicIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M4.303 13.347c-1.336-4.442 1.9-9.27 6.631-9.892L22 2l-1.455 11.066c-.622 4.731-5.45 7.967-9.892 6.63l-4.067-1.223a19 19 0 0 0-1.65 3.377l-1.873-.7c1.814-4.863 4.965-8.011 7.65-9.937A22 22 0 0 1 14.31 9.11c-4.346.796-7.799 3.472-9.698 5.264z"
      })
    }))
  }, props));
}

__name(OrganicIcon, "OrganicIcon");

function OtherPetsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 5h12v1.475l.198.265.012.017.052.074q.072.103.201.309c.17.274.4.674.63 1.167.466.996.907 2.32.907 3.729 0 2.19-.678 3.743-1.335 4.74A6.8 6.8 0 0 1 17.638 18H6.362l-.13-.124a6.8 6.8 0 0 1-.897-1.1C4.678 15.779 4 14.226 4 12.036c0-1.41.441-2.733.906-3.73a11 11 0 0 1 .832-1.475l.052-.074.011-.015V6.74l.001-.001L6 6.475zm14-2H4v2.831a13.179 13.179 0 0 0-.906 1.63C2.559 8.608 2 10.231 2 12.036c0 2.63.822 4.56 1.665 5.84.42.637.842 1.11 1.166 1.427a7 7 0 0 0 .526.465l.04.03.003.002L6 21h12l.6-1.2.004-.003.02-.014.019-.015q.047-.036.124-.1a7 7 0 0 0 .402-.365c.325-.318.747-.79 1.166-1.427.843-1.28 1.665-3.21 1.665-5.84 0-1.806-.559-3.428-1.094-4.575A13 13 0 0 0 20 5.831zm-9.5 7C8.25 10 7 12.25 7 12.25s1.25 2.25 3.5 2.25 3.25-1.35 3.25-1.35L16 14.5V10l-2.25 1.35S12.75 10 10.5 10"
      })
    }))
  }, props));
}

__name(OtherPetsIcon, "OtherPetsIcon");

function PageIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.813 3H5v18h14V9.18zM12 5v5h5z"
      })
    }))
  }, props));
}

__name(PageIcon, "PageIcon");

function PaleoIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M11.086 8.992v3.344h1.172c1.336 0 1.93-.438 1.93-1.672 0-1.062-.586-1.672-1.641-1.672z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m-.922-5.148c0 .882-.469 1.39-1.297 1.39-.82 0-1.281-.5-1.281-1.39V8.766C8.5 7.492 8.969 7 10.188 7h2.742c2.336 0 3.812 1.422 3.812 3.617 0 2.336-1.5 3.64-3.945 3.64h-1.719z"
      })]
    }))
  }, props));
}

__name(PaleoIcon, "PaleoIcon");

function ParkingIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm3.913 4.702V16.5h1.977v-3.007h1.662c2.14 0 3.323-1.111 3.323-2.913 0-1.732-.972-2.878-3.183-2.878zm1.977 1.603h1.708c.925 0 1.358.48 1.358 1.322 0 .865-.515 1.287-1.37 1.287H10.89z"
      })
    }))
  }, props));
}

__name(ParkingIcon, "ParkingIcon");

function PasskeyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11.1 10.1a4.05 4.05 0 1 0 0-8.1 4.05 4.05 0 0 0 0 8.1M19.337 14.686a3 3 0 1 0-2.674 0v6.017L18 22l1.337-1.297v-.568l-1.011-.981 1.011-.981v-.015l-1.011-.981 1.011-.981zM14.663 15.723A4.99 4.99 0 0 1 13 12.124 8.1 8.1 0 0 0 3 20h11.663z"
      })
    }))
  }, props));
}

__name(PasskeyIcon, "PasskeyIcon");

function PauseIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M10 4H5v16h5zM19 4h-5v16h5z"
      })
    }))
  }, props));
}

__name(PauseIcon, "PauseIcon");

var PauseIcon_default = PauseIcon;

function PauseDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M3.515 3.515 2.1 4.929l2.9 2.9v12.17h5v-7.17l4 4v3.17h3.17l1.9 1.9 1.414-1.414zM14 11.171l5 5V4h-5zM6.829 4 10 7.17V4z"
      })
    }))
  }, props));
}

__name(PauseDisabledIcon, "PauseDisabledIcon");

function PaymentAmericanExpressIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#1F72CD",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m7.171 15.714-3.743 8.282h4.48l.556-1.32h1.27l.555 1.32h4.932v-1.008l.44 1.008h2.55l.44-1.029v1.03h10.256l1.247-1.287 1.168 1.286 5.267.011-3.754-4.129 3.754-4.164h-5.186l-1.214 1.263-1.13-1.263H17.9l-.958 2.138-.98-2.138H11.49v.974l-.497-.974zm15.315 1.176h5.89l1.801 1.946 1.86-1.946h1.801l-2.737 2.987 2.737 2.953h-1.883l-1.801-1.969-1.869 1.969h-5.799zm1.455 2.316V18.12h3.675l1.603 1.735-1.674 1.744H23.94v-1.184h3.213v-1.21zM8.038 16.89h2.184l2.482 5.616V16.89h2.393l1.917 4.027 1.767-4.027h2.38v5.943h-1.448l-.012-4.656-2.112 4.656h-1.295l-2.124-4.656v4.656h-2.98l-.564-1.332H7.574l-.564 1.331H5.413zm.057 3.38L9.1 17.895l1.005 2.373z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(PaymentAmericanExpressIcon, "PaymentAmericanExpressIcon");

function PaymentApplePayIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        d: "M29.784 26.407c1.32 0 1.942-.51 2.485-2.057l2.378-6.752H33.27l-1.594 5.217h-.028l-1.595-5.217h-1.416l2.294 6.43-.123.39c-.207.663-.543.918-1.141.918-.107 0-.314-.011-.398-.023v1.06c.079.022.415.034.515.034",
        fill: "#000"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.83 22.946c-.358.69-1.147 1.127-1.998 1.127-1.259 0-2.137-.76-2.137-1.904 0-1.132.85-1.784 2.422-1.88l1.69-.102V19.7c0-.72-.464-1.11-1.292-1.11-.683 0-1.181.357-1.282.9h-1.22c.04-1.144 1.103-1.977 2.54-1.977 1.55 0 2.558.822 2.558 2.096v4.396h-1.253v-1.06zm-2.815-.81c0 .538.459.889 1.18.889.918 0 1.612-.59 1.612-1.416v-.499l-1.505.096c-.845.052-1.287.374-1.287.93M16.215 24.005v-8.83h3.273c1.69 0 2.87 1.177 2.87 2.9 0 1.721-1.202 2.91-2.915 2.91H17.57v3.02zm2.915-7.675h-1.561v3.506h1.555c1.18 0 1.852-.64 1.852-1.756s-.671-1.75-1.846-1.75",
        fill: "#000"
      }), /* @__PURE__ */jsx("path", {
        d: "M11.721 16.817c-.778-.046-1.444.447-1.813.447-.375 0-.94-.424-1.555-.413-.8.011-1.545.47-1.953 1.2-.84 1.462-.219 3.626.593 4.815.397.59.873 1.235 1.5 1.212.593-.022.828-.39 1.544-.39.722 0 .929.39 1.555.38.65-.012 1.058-.59 1.455-1.179.454-.668.638-1.32.65-1.354-.012-.011-1.254-.493-1.265-1.943-.011-1.212.98-1.79 1.024-1.824-.56-.838-1.433-.928-1.735-.951M11.234 16.035c-.335.402-.873.72-1.41.674-.067-.544.196-1.121.504-1.478.336-.414.923-.708 1.399-.731.056.566-.162 1.121-.493 1.535",
        fill: "#000"
      })]
    }))
  }, props));
}

__name(PaymentApplePayIcon, "PaymentApplePayIcon");

function PaymentDiscoverIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.455 16.984c1.242 0 1.925.552 1.925 1.596a1.494 1.494 0 0 1-1.242 1.597l1.676 2.271h-1.303l-1.428-2.21h-.125v2.21h-1.055v-5.464zm-.497 2.517h.31c.684 0 .994-.307.994-.86 0-.49-.31-.798-.993-.798h-.31zM29.24 22.448h2.98v-.92h-1.925v-1.474h1.863v-.921h-1.863v-1.228h1.925v-.921h-2.98zM26.135 20.668l-1.428-3.684h-1.118l2.298 5.587h.558l2.298-5.587h-1.118zM13.531 19.747c0 1.535 1.242 2.824 2.794 2.824.497 0 .931-.123 1.366-.307v-1.228c-.31.369-.745.614-1.242.614-.993 0-1.8-.737-1.8-1.72v-.122c-.062-.982.745-1.842 1.738-1.903.497 0 .994.245 1.304.614V17.29c-.372-.246-.87-.307-1.304-.307-1.614-.123-2.856 1.166-2.856 2.763M11.606 19.071c-.62-.245-.807-.368-.807-.675.062-.369.373-.676.745-.614.31 0 .621.184.87.43l.558-.737c-.434-.369-.993-.614-1.552-.614-.87-.062-1.614.614-1.676 1.473v.062c0 .737.31 1.166 1.303 1.473.249.062.497.185.745.308.187.122.311.306.311.552 0 .43-.373.798-.745.798h-.062c-.497 0-.931-.307-1.118-.736l-.683.675c.373.675 1.118 1.044 1.863 1.044.993.061 1.8-.676 1.863-1.658v-.184c-.062-.737-.373-1.105-1.615-1.597M8.005 22.448h1.056v-5.464H8.005zM3.1 16.984h1.863c1.49.061 2.67 1.29 2.608 2.763 0 .798-.373 1.535-.994 2.087-.559.43-1.242.676-1.925.614H3.1zm1.366 4.543c.497.062 1.056-.122 1.428-.43.373-.368.559-.86.559-1.412 0-.49-.186-.982-.559-1.35-.372-.308-.931-.492-1.428-.43h-.31v3.622z",
        fill: "#000"
      }), /* @__PURE__ */jsx("path", {
        d: "m16 33 23-7v4c0 2-1.5 3-3 3z",
        fill: "#FD6020"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.802 16.857c-1.552 0-2.856 1.228-2.856 2.824 0 1.535 1.242 2.825 2.856 2.886 1.614.062 2.856-1.228 2.918-2.824-.062-1.597-1.303-2.886-2.918-2.886",
        fill: "#FD6020"
      })]
    }))
  }, props));
}

__name(PaymentDiscoverIcon, "PaymentDiscoverIcon");

function PaymentEBTIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        d: "M20.857 11.133a1.34 1.34 0 0 0-.503-.338c-.69-.264-1.435.137-1.705.887a.4.4 0 0 0-.102-.042 1.13 1.13 0 0 0-1.118.19c.149 1.046.27 1.891.419 2.884.01-.01.606-.306 1.36-.18.01-.232-.018-.348-.046-.57.344-.317.484-.423.848-.37.167-.633.568-1.806.847-2.46",
        fill: "#40BB61"
      }), /* @__PURE__ */jsx("path", {
        d: "M23.892 13.601c.23-.54.495-.692.594-.753.428-.255 1.022-.285 1.462-.397.187-1.843-.11-3.125-1.242-3.4A1.8 1.8 0 0 0 24.31 9c-.451 0-.88.183-1.298.52.198.193.627.671.682 1.19a3.6 3.6 0 0 0-.967-.936 7 7 0 0 0-.627.743c.077.081 1 1.038 1.088 1.842-.428-.651-.978-1.16-1.341-1.466-.209.336-.418.703-.616 1.11.297.305 1.078 1.17 1.188 1.965-.561-.804-1.155-1.232-1.452-1.405-.242.53-.473 1.11-.681 1.71a.8.8 0 0 1 .022.448c.319.02.571.092.846.244.253.143.44.316.726.693-.385.54-.55.6-.693.682.187.336.33.62.385 1.231.34-.04.473-.01.56 0 .44-.997 1.155-2.616 1.76-3.97",
        fill: "#F47216"
      }), /* @__PURE__ */jsx("path", {
        d: "M16.01 15.247s.82-1.002-.253-1.656a.815.815 0 0 1 .999.706c.094.792-.747.95-.747.95m-.715-4.304a.815.815 0 0 1 .998.707c.084.79-.746.949-.746.949s.82-1.002-.252-1.656m.967 5.264a3.1 3.1 0 0 1 1.166-1.319l-.777-4.916v-.01c0-.01-.01-.032-.042-.053-.053-.053-.179-.148-.536-.158a242 242 0 0 1-3.175-.18h-.01c-.021.01-.053.021-.084.042-.063.043-.095.074-.106.19 0 .095.064.707.158 1.509.095.823.231 1.867.357 2.912.074.548.137 1.097.2 1.593.673-.138 1.083.147 1.083.147l-.589-5.01a.19.19 0 1 1 .379-.043l.64 5.38s.085.085.127.137c.641-.337 1.125-.232 1.209-.221m-5.12-5.39c.064.695.106 1.043.106 1.043s-.053.212.462.338c.221.053.431.106.61.137-.263.18-.62.454-.799.834l.095 1.034s.031.242.462.337c.242.053.484.106.663.137-.148.074-.59.317-.894.697.641.126.936.516 1.051.59h.021l-.757-6.129c-.241.148-.788.485-1.02.981",
        fill: "#6243A4"
      }), /* @__PURE__ */jsx("path", {
        d: "M24.897 22.136v1.23h.944c.408 0 .696-.24.696-.61 0-.44-.288-.61-.805-.62zm-1.908 4.02c-.248 0-.457-.1-.546-.34l-.259-.75h-1.65l-.268.75c-.08.23-.258.34-.516.34h-.02a.6.6 0 0 1-.408-.15.52.52 0 0 1-.159-.39c0-.14.07-.33.11-.44l1.4-3.72.06.02-.06-.02c.1-.27.309-.38.587-.37h.258c.249-.01.517.08.636.44l1.302 3.65c.04.11.11.3.11.44a.564.564 0 0 1-.577.54m-3.955-.73c0 .22-.05.41-.169.54s-.298.2-.536.2h-.03c-.328 0-.477-.1-.616-.32l-1.78-2.83v2.56c0 .19-.049.34-.158.44-.1.1-.248.15-.427.15a.62.62 0 0 1-.428-.15c-.109-.1-.159-.25-.159-.44v-3.78c0-.23.06-.41.19-.53.128-.12.317-.17.556-.17.238 0 .467.1.596.31l1.789 2.91v-2.64c0-.19.05-.34.159-.44.099-.1.248-.15.427-.15a.62.62 0 0 1 .427.15c.11.1.16.25.16.44zm8.656-3.13.596-3.39c-.05-.01-.1-.01-.15-.01-.228 0-.466.09-.645.17-.18.09-.308.17-.318.17s-.388-.62-.934-.72c-.05-.01-.09-.01-.14-.01-.477 0-.993.42-.983.42-.01 0-.348-.65-.904-.79h-.02c-.04-.01-.08-.01-.12-.01-.258 0-.506.1-.685.21-.18.1-.299.21-.308.21.01 0-.388-.69-.905-.79-.06-.01-.109-.01-.169-.01-.238 0-.477.09-.655.17-.18.09-.299.17-.299.17-.02 0-.417-.61-.924-.71-.05-.01-.09-.01-.139-.01-.218 0-.447.09-.606.18-.169.09-.278.18-.288.18s-.388-.62-.934-.72c-.04-.01-.09-.01-.14-.01-.476 0-.993.42-.983.42-.01 0-.348-.65-.904-.79h-.02c-.04-.01-.08-.01-.12-.01-.258 0-.506.1-.685.21-.18.1-.298.21-.308.21.01 0-.388-.69-.905-.79-.06-.01-.109-.02-.169-.02-.238 0-.477.09-.655.17-.18.09-.299.17-.299.17-.02 0-.427-.62-.924-.71l-.983 5.61c.04-.03.07-.05.109-.08.367-.24.854-.34 1.322-.34.864.01 1.887.47 1.897 1.17 0 .31-.268.49-.556.49s-.407-.21-.566-.37c-.16-.17-.368-.33-.855-.34-.487.01-.716.21-.716.5 0 .14.08.22.21.3.128.07.307.12.476.16l.904.21c1.014.23 1.292.86 1.282 1.43 0 .45-.169.84-.506 1.12-.338.28-.845.44-1.501.44-1.391 0-2.037-.7-2.047-1.27 0-.3.219-.51.517-.51.328 0 .457.25.626.45.169.21.377.41.904.41.537 0 .805-.29.805-.57 0-.17-.07-.35-.417-.44l-1.213-.28c-.526-.13-.835-.36-1.003-.62l-.696 3.98c-.12.65-.02 1.2.864 1.38l14.032 2.579c.08.01.149.02.218.02a1.15 1.15 0 0 0 1.143-.95l1.163-6.64c-.05.06-.1.12-.15.17-.297.28-.724.45-1.261.45h-1.143v1.23c0 .18-.06.33-.169.44a.6.6 0 0 1-.437.17.6.6 0 0 1-.437-.17.6.6 0 0 1-.17-.44v-3.68c0-.25.07-.43.19-.55.129-.109.298-.149.496-.149h1.65c.467 0 .884.11 1.202.37.229.19.388.44.457.76m-6.887 1.89h1.093l-.537-1.68z",
        fill: "#024D36"
      }), /* @__PURE__ */jsx("path", {
        d: "M21.429 15.478c-.155-.204-.473-.45-.859-.45-.53 0-.636.256-.646.246.125-.337.309-.858.241-1.021-.087-.235-.347-.02-.347-.02s.058.397-.039.98a.6.6 0 0 0-.202-.092c-1.08-.307-2.238.224-2.72 1.327.145.092.3.214.444.398.29-.153.569-.235.83-.235.076 0 .154.01.23.02.329.062.647.256.927.562.26-.132.52-.204.752-.204.077 0 .154.01.231.02.376.072.685.317.916.562.03-.01.058-.02.087-.04v-.01a2.75 2.75 0 0 0-.627-1.676c.377 0 .627-.143.782-.367",
        fill: "#C02123"
      }), /* @__PURE__ */jsx("path", {
        d: "m27.644 14.866-3.058-1.279-.072-.031c.155-.378.3-.44.868-.566l1.198-.262.785 1.09c.362.566.434.67.28 1.048m-3.378 2.873h.01zm5.269-3.942-.806-1.206c.041-.115.103-.251.145-.356.103-.241-.186-.262-.186-.262l-1.55-.116s-.248-.031-.351.252a6 6 0 0 0-.093.241l-1.343.315c-.734.126-.92.24-1.116.734l-1.663 4.109c.186.105.361.252.537.45.3-.156.599-.24.888-.24.073 0 .135 0 .207.01h.02c.01 0 .032.01.042.01h.01c.259.064.6.22.94.609.31-.158.61-.241.889-.241h.103l.91-1.919-.61 1.982c.3.094.589.272.847.545.31-.147.6-.21.868-.21.082 0 .175.01.258.02l.041.011 1.374-3.386c.207-.492.114-.629-.361-1.352",
        fill: "#00ADEF"
      })]
    }))
  }, props));
}

__name(PaymentEBTIcon, "PaymentEBTIcon");

function PaymentFSAHSAIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        d: "M10.163 9.374h5.762v1.755h-3.78v1.704h3.563v1.652h-3.562v3.108h-1.983zM19.945 17.717c-2.158 0-3.305-1.043-3.46-2.726h2.066c.052.723.506 1.157 1.425 1.157.878 0 1.27-.382 1.27-.888 0-.496-.238-.744-.909-.847l-1.208-.175c-1.683-.228-2.406-1.012-2.406-2.386 0-1.383 1.074-2.602 3.222-2.602 2.106 0 3.108 1.064 3.242 2.623h-2.024c-.062-.64-.371-1.053-1.27-1.053-.805 0-1.187.361-1.187.867 0 .465.268.702.877.795l1.26.176c1.776.247 2.396 1.094 2.396 2.395 0 1.498-1.136 2.664-3.294 2.664M23.512 17.594l2.437-8.22h2.984l2.427 8.22h-2.148l-.475-1.684h-2.685l-.464 1.683zm2.891-3.253h1.983l-1.002-3.563zM9.054 30.637v-8.22h1.982v3.016h3.79v-3.016h1.993v8.22h-1.993v-3.439h-3.79v3.439zM21.054 30.76c-2.158 0-3.304-1.042-3.46-2.725h2.066c.052.723.506 1.156 1.425 1.156.878 0 1.27-.382 1.27-.888 0-.495-.237-.743-.909-.846l-1.208-.176c-1.683-.227-2.406-1.012-2.406-2.385 0-1.384 1.074-2.602 3.222-2.602 2.107 0 3.108 1.063 3.243 2.622h-2.024c-.062-.64-.372-1.053-1.27-1.053-.806 0-1.188.361-1.188.867 0 .465.268.703.878.796l1.26.175c1.776.248 2.395 1.095 2.395 2.396 0 1.497-1.136 2.664-3.294 2.664M24.621 30.637l2.437-8.22h2.985l2.426 8.22h-2.148l-.475-1.683h-2.684l-.465 1.683zm2.892-3.253h1.982l-1.001-3.562zM8 19.767h25v.544H8z",
        fill: "#242529"
      })]
    }))
  }, props));
}

__name(PaymentFSAHSAIcon, "PaymentFSAHSAIcon");

function PaymentFreshFundsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        y: 6,
        width: 40,
        height: 28,
        rx: 4,
        fill: "#003121"
      }), /* @__PURE__ */jsx("path", {
        d: "M9.366 19v-6.368h4.232V13.8l-1.304-.624c-.408-.2-.64-.24-1.128-.24h-.392v2.688h.456c.416 0 .592-.024 1.024-.176l.864-.304v1.272l-.872-.312c-.44-.152-.624-.176-1.016-.176h-.456V19zM14.104 19v-4.824h1.208v1.272h.056c.232-.944.552-1.352 1.032-1.352a1 1 0 0 1 .312.048v1.096a2.8 2.8 0 0 0-.568-.056c-.496 0-.792.264-.792 1.032V19zM19.353 19.096c-1.632 0-2.472-1.016-2.472-2.432 0-1.568 1.04-2.584 2.4-2.584 1.2 0 1.992.744 2.088 1.944h-3.264v.072c0 1.56.712 2.16 1.744 2.16.896 0 1.344-.464 1.392-1.36h.208c0 1.424-.744 2.2-2.096 2.2m-.128-4.728c-.6 0-1.024.4-1.104 1.384h1.976c.056-.96-.264-1.384-.872-1.384M23.81 19.096c-1.217 0-1.945-.552-2.033-1.44h1.12c-.016.8.336 1.152.976 1.152.56 0 .848-.296.848-.744 0-.392-.16-.648-.76-.816l-.648-.184c-.928-.264-1.36-.728-1.36-1.488 0-.848.68-1.496 1.816-1.496 1.104 0 1.736.568 1.792 1.288h-1.04c.032-.664-.256-1-.832-1-.512 0-.816.272-.816.68 0 .376.2.576.72.728l.72.208c1.016.28 1.344.752 1.336 1.536-.008.952-.76 1.576-1.84 1.576M26.323 19v-6.768h1.248v2.84h.048c.28-.616.76-.992 1.6-.992 1.096 0 1.632.64 1.632 1.616V19h-1.248v-3.168c0-.688-.304-1.056-.952-1.056-.68 0-1.08.4-1.08 1.288V19zM7.913 27v-6.368h4.232V21.8l-1.304-.624c-.408-.2-.64-.24-1.128-.24H9.32v2.688h.456c.416 0 .592-.024 1.024-.176l.864-.304v1.272l-.872-.312c-.44-.152-.624-.176-1.016-.176H9.32V27zM14.196 27.096c-1.096 0-1.632-.68-1.632-1.632v-3.288h1.248v3.152c0 .696.296 1.072.92 1.072.656 0 1.04-.408 1.04-1.304v-2.92h1.248V27h-1.24v-.92h-.048c-.288.656-.736 1.016-1.536 1.016M17.901 27v-4.824h1.24v.904h.048c.28-.624.76-1 1.608-1 1.096 0 1.632.64 1.632 1.616V27h-1.248v-3.168c0-.688-.304-1.056-.952-1.056-.68 0-1.08.4-1.08 1.288V27zM25.052 27.096c-1.192 0-1.984-.88-1.984-2.456 0-1.648.984-2.56 2.192-2.56.656 0 1.16.312 1.44.856h.048v-2.704h1.24V27h-1.232v-.968H26.7c-.344.704-.904 1.064-1.648 1.064m.504-.616c.656 0 1.24-.552 1.24-1.976 0-1.384-.552-1.984-1.224-1.984-.68 0-1.12.584-1.12 1.944 0 1.456.456 2.016 1.104 2.016M30.622 27.096c-1.216 0-1.944-.552-2.032-1.44h1.12c-.016.8.336 1.152.976 1.152.56 0 .848-.296.848-.744 0-.392-.16-.648-.76-.816l-.648-.184c-.928-.264-1.36-.728-1.36-1.488 0-.848.68-1.496 1.816-1.496 1.104 0 1.736.568 1.792 1.288h-1.04c.032-.664-.256-1-.832-1-.512 0-.816.272-.816.68 0 .376.2.576.72.728l.72.208c1.016.28 1.344.752 1.336 1.536-.008.952-.76 1.576-1.84 1.576",
        fill: "#C3C969"
      })]
    }))
  }, props));
}

__name(PaymentFreshFundsIcon, "PaymentFreshFundsIcon");

function PaymentGenericIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12.917c.69 0 1.25.56 1.25 1.25v4.583h4.583c.65 0 1.184.496 1.245 1.13l.005.12c0 .69-.56 1.25-1.25 1.25H21.25v4.583a1.25 1.25 0 0 1-1.13 1.245l-.12.005c-.69 0-1.25-.56-1.25-1.25V21.25h-4.583a1.25 1.25 0 0 1-1.245-1.13l-.005-.12c0-.69.56-1.25 1.25-1.25h4.583v-4.583c0-.65.496-1.184 1.13-1.245z"
      })]
    }))
  }, props));
}

__name(PaymentGenericIcon, "PaymentGenericIcon");

function PaymentGooglePayIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.892 24.384V20.86h1.781q1.095-.002 1.85-.743l.12-.125a2.575 2.575 0 0 0-.12-3.552 2.52 2.52 0 0 0-1.85-.756h-2.86v8.7zm0-4.593v-3.039H20.7c.388 0 .757.153 1.031.43a1.57 1.57 0 0 1 .034 2.158 1.39 1.39 0 0 1-1.065.451zM27.674 18.896q-.693-.657-1.89-.659c-1.024 0-1.795.389-2.304 1.159l.951.617q.524-.79 1.427-.79c.382 0 .75.145 1.039.409.281.25.442.61.442.992v.256c-.415-.235-.938-.36-1.581-.36-.75 0-1.353.18-1.802.548-.449.367-.677.853-.677 1.47a1.87 1.87 0 0 0 .637 1.457c.422.389.958.583 1.587.583.744 0 1.334-.34 1.782-1.02h.047v.826h1.032v-3.67c0-.77-.228-1.38-.69-1.818m-2.927 4.392a.91.91 0 0 1-.355-.729q.002-.489.435-.811.444-.325 1.099-.326.905-.01 1.407.409-.002.707-.536 1.228c-.322.333-.757.52-1.213.52a1.3 1.3 0 0 1-.837-.291",
        fill: "#3C4043"
      }), /* @__PURE__ */jsx("path", {
        d: "m30.682 27 3.604-8.569h-1.173l-1.668 4.274h-.02l-1.708-4.274h-1.172l2.364 5.571L29.57 27z",
        fill: "#3C4043"
      }), /* @__PURE__ */jsx("path", {
        d: "M15.168 20.097q0-.512-.08-1.013h-4.549v1.922h2.606a2.32 2.32 0 0 1-.964 1.52v1.248h1.554c.91-.867 1.433-2.15 1.433-3.677",
        fill: "#4285F4"
      }), /* @__PURE__ */jsx("path", {
        d: "M10.54 24.981c1.299 0 2.398-.444 3.195-1.207l-1.554-1.249c-.436.305-.992.479-1.642.479-1.26 0-2.324-.881-2.706-2.06H6.232v1.29c.817 1.685 2.485 2.747 4.307 2.747",
        fill: "#34A853"
      }), /* @__PURE__ */jsx("path", {
        d: "M7.833 20.944a3.1 3.1 0 0 1 0-1.915v-1.284H6.232a5.11 5.11 0 0 0 0 4.482z",
        fill: "#FBBC04"
      }), /* @__PURE__ */jsx("path", {
        d: "M10.54 16.968a2.55 2.55 0 0 1 1.848.75l1.38-1.43a4.57 4.57 0 0 0-3.229-1.297c-1.822 0-3.49 1.068-4.307 2.754l1.601 1.29c.382-1.186 1.447-2.067 2.706-2.067",
        fill: "#EA4335"
      })]
    }))
  }, props));
}

__name(PaymentGooglePayIcon, "PaymentGooglePayIcon");

function PaymentInstacartMastercardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        y: 6,
        width: 40,
        height: 28,
        rx: 4,
        fill: "#003121"
      }), /* @__PURE__ */jsx("path", {
        d: "M20 25.744c4.549 0 8.278 3.395 8.268 8.268H11.73c-.009-4.87 3.72-8.268 8.268-8.268",
        fill: "#FF7009"
      }), /* @__PURE__ */jsx("path", {
        d: "M26.82 14.219c-1.046 0-1.79.455-2.477 1.443l-1.98 2.845v-8.12h-4.725v8.12l-1.98-2.845c-.688-.988-1.432-1.443-2.477-1.443-1.576 0-2.626 1.164-2.63 2.598-.005 1.228.574 2.028 1.795 2.814L20 24.563l7.655-4.932c1.22-.786 1.799-1.586 1.795-2.814-.005-1.434-1.055-2.598-2.63-2.598",
        fill: "#0AAD0A"
      })]
    }))
  }, props));
}

__name(PaymentInstacartMastercardIcon, "PaymentInstacartMastercardIcon");

function PaymentMastercardIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        d: "M20.286 25.894a7.91 7.91 0 0 0 2.74-6.005 7.91 7.91 0 0 0-2.74-6.004A7.72 7.72 0 0 1 25.344 12c4.307 0 7.799 3.532 7.799 7.89 0 4.356-3.492 7.888-7.799 7.888-1.93 0-3.697-.71-5.058-1.884",
        fill: "#F9A000"
      }), /* @__PURE__ */jsx("path", {
        d: "M23.026 19.89c0 4.356-3.492 7.888-7.799 7.888s-7.799-3.532-7.799-7.889S10.92 12 15.228 12c4.306 0 7.798 3.532 7.798 7.89",
        fill: "#ED0006"
      }), /* @__PURE__ */jsx("path", {
        d: "M20.286 14a7.91 7.91 0 0 1 2.74 6.005 7.91 7.91 0 0 1-2.74 6.004 7.91 7.91 0 0 1-2.74-6.004A7.91 7.91 0 0 1 20.286 14",
        fill: "#FF5E00"
      })]
    }))
  }, props));
}

__name(PaymentMastercardIcon, "PaymentMastercardIcon");

function PaymentOTCMedicareIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        d: "M3 11a2 2 0 0 1 2-2h30a2 2 0 0 1 2 2v9H3z",
        fill: "#1A2F54"
      }), /* @__PURE__ */jsx("path", {
        d: "M3 22h34v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
        fill: "#F1611E"
      }), /* @__PURE__ */jsx("path", {
        d: "M14.01 10.75q1.196.615 1.808 1.75c.828 1.54.62 3.511-.544 4.827-1.248 1.41-3.286 1.844-5.05 1.21-2.112-.757-3.2-2.928-2.668-5.078.753-2.79 3.954-3.96 6.453-2.709m-3.572 5.426a2 2 0 0 0 1.583.576c1.681-.117 2.407-2.014 1.647-3.376a2.08 2.08 0 0 0-2.464-.959c-1.571.508-1.909 2.667-.766 3.758m20.585-2.886a.015.015 0 0 1-.02-.002c-.542-.687-1.311-1.103-2.203-.914-.699.148-1.233.716-1.44 1.379-.413 1.327.28 2.947 1.835 2.98.802.019 1.377-.392 1.861-.985a.03.03 0 0 1 .015-.009q.01-.001.017.004l1.702 1.21.005.007v.004l-.002.004c-.873 1.19-1.96 1.798-3.452 1.85-2.135.073-3.975-1.296-4.373-3.412-.357-1.893.456-3.712 2.158-4.648a4.5 4.5 0 0 1 1.848-.495c1.513-.076 2.866.447 3.759 1.697l.001.006-.003.005zm-6.796-2.761-.003 1.88v.005l-.004.005-.005.003-.006.001h-2.445a.02.02 0 0 0-.01.005.02.02 0 0 0-.005.01v6.205a.015.015 0 0 1-.016.016h-2.27a.02.02 0 0 1-.01-.005.02.02 0 0 1-.005-.01v-6.205a.015.015 0 0 0-.015-.015h-2.43a.02.02 0 0 1-.01-.005.02.02 0 0 1-.005-.01l-.003-1.405.003-.568q0-.006.005-.01a.02.02 0 0 1 .01-.005h7.206a.015.015 0 0 1 .015.015zM31.223 26.407q0 .018.013.005l1.107-1.208.012-.01.015-.002h1.102q.023-.006.036.003l.004.005.002.006a.02.02 0 0 1-.004.012l-1.28 1.32-.005.01q0 .008.003.012l.387.594.953 1.463q.008.012-.007.012h-1.11l-.013-.004-.01-.01-.86-1.373-.004-.005-.006-.002a.01.01 0 0 0-.012.005l-.316.333a.04.04 0 0 0-.012.028v1.013a.015.015 0 0 1-.015.015h-.954a.02.02 0 0 1-.01-.005.02.02 0 0 1-.006-.01v-4.652q0-.005.004-.008l.008-.003h.958a.016.016 0 0 1 .016.015zM9.016 24.641l.002-.483q0-.006.004-.011a.02.02 0 0 1 .011-.005h.953q.006 0 .011.005a.02.02 0 0 1 .005.011l.002 2.223-.002 2.236a.01.01 0 0 1-.004.009l-.008.003h-.824a.03.03 0 0 1-.023-.012L7.007 25.82q-.02-.027-.02.007v2.79a.01.01 0 0 1-.004.009l-.008.003h-.957a.02.02 0 0 1-.012-.005l-.004-.01L6 27.577v-2.515l.002-.905a.015.015 0 0 1 .016-.016h.884a.03.03 0 0 1 .025.013l2.068 2.707q.021.03.021-.007zm7.15-.31-.001.847q0 .006.004.01a.02.02 0 0 0 .011.005h.775q.006 0 .01.005a.02.02 0 0 1 .005.01l.003.583-.003.223a.02.02 0 0 1-.005.01.02.02 0 0 1-.01.005h-.775a.015.015 0 0 0-.015.015v.936q-.005.266.002.528c.012.457.537.322.782.194h.01l.003.004.001.005v.761a.03.03 0 0 1-.013.022 1.6 1.6 0 0 1-1.088.162c-.826-.159-.675-1.087-.677-1.691v-.92a.016.016 0 0 0-.016-.016h-.382l-.01-.004a.02.02 0 0 1-.005-.01l-.002-.308.002-.498q0-.007.005-.011a.02.02 0 0 1 .01-.005h.383a.016.016 0 0 0 .016-.015v-.713l.004-.129q0-.006.005-.011a.02.02 0 0 1 .011-.005q.48-.012.96.011m-2.31 1.393q.376.535.386 1.195l-.016.322a.016.016 0 0 1-.017.015h-2.352l-.005.001-.004.003a.01.01 0 0 0-.002.01c.186.814 1.152.793 1.647.303a.018.018 0 0 1 .023 0l.544.477a.016.016 0 0 1 .002.022q-.39.471-.993.59c-.962.19-1.876-.27-2.147-1.244a2.1 2.1 0 0 1-.027-.86q.116-.612.576-1.029c.692-.589 1.815-.533 2.385.195m-.575.897c-.107-.944-1.3-.928-1.446-.002v.006q0 .003.003.005a.01.01 0 0 0 .01.005h1.421l.005-.001.004-.003.003-.005zm12.759-1.113q.46.36.626.92.172.67-.126 1.288c-.833 1.58-3.366 1.196-3.531-.652q-.045-.718.4-1.273c.67-.78 1.807-.862 2.63-.283m-1.054 2.35a.9.9 0 0 0 .332-.115.9.9 0 0 0 .263-.24 1 1 0 0 0 .154-.33.99.99 0 0 0-.323-1 .9.9 0 0 0-.314-.167.86.86 0 0 0-.945.326.98.98 0 0 0-.176.697 1 1 0 0 0 .113.352q.09.163.232.28.141.116.314.168a.9.9 0 0 0 .35.028m4.587-2.611v.376l-.003.51a.02.02 0 0 1-.005.01.02.02 0 0 1-.01.005q-.249.013-.33.034c-.665.173-.787.8-.752 1.396v1.04l-.004.008-.008.003h-.95a.016.016 0 0 1-.016-.016l-.001-.85v-2.347l.005-.205q0-.008.006-.013a.02.02 0 0 1 .013-.005h.939a.015.015 0 0 1 .015.015v.6q0 .072.029.005c.188-.442.562-.708 1.051-.679q.008 0 .012.005a.02.02 0 0 1 .005.012zm5.427.566a.67.67 0 0 1-.674.672.675.675 0 0 1-.674-.672.67.67 0 0 1 .674-.672.675.675 0 0 1 .674.672m-.139 0a.53.53 0 0 0-.534-.532.535.535 0 0 0-.535.532.53.53 0 0 0 .535.533.536.536 0 0 0 .534-.533M20.686 25.776l.46 1.464q.004.015.009 0l.408-1.51.148-.523.007-.01.011-.004h.934q.003 0 .007.002a.01.01 0 0 1 .007.01v.007l-.16.54-.892 2.872a.04.04 0 0 1-.038.028h-.838a.027.027 0 0 1-.025-.018l-.642-2.043q-.01-.03-.02 0l-.654 2.049-.006.009-.01.003h-.85a.025.025 0 0 1-.024-.018l-.531-1.724-.352-1.156-.167-.546v-.005l.002-.005.005-.004h.965a.024.024 0 0 1 .023.016l.1.359.443 1.65q.004.015.009 0l.532-1.704.105-.323.007-.01a.02.02 0 0 1 .013-.004h.807q.009 0 .016.005a.03.03 0 0 1 .01.014z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M34.448 25.877a1 1 0 0 1 .188.288l-.002.005-.004.003-.005.002h-.15a.02.02 0 0 1-.021-.014c-.055-.112-.117-.281-.265-.275a.02.02 0 0 0-.012.005.02.02 0 0 0-.004.011v.253a.02.02 0 0 1-.02.02h-.115a.02.02 0 0 1-.02-.02l.001-.684q0-.006.005-.011a.02.02 0 0 1 .011-.006c.151-.003.607-.057.567.225q-.018.13-.151.185l-.003.002-.002.004v.004zm-.061-.283a.5.5 0 0 0-.2-.015.015.015 0 0 0-.014.015v.15q0 .007.004.01a.02.02 0 0 0 .01.006c.107.006.284.017.243-.124a.06.06 0 0 0-.043-.042",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(PaymentOTCMedicareIcon, "PaymentOTCMedicareIcon");

function PaymentPayPalIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        d: "M24.45 13.434q.021-.118.04-.23.33.173.558.43c.5.57.597 1.38.408 2.35-.452 2.322-1.999 3.124-3.975 3.124h-.305a.49.49 0 0 0-.485.415l-.025.133-.384 2.438-.02.103a.49.49 0 0 1-.485.414h-2.04a.294.294 0 0 1-.29-.34l.756-4.793a.56.56 0 0 1 .552-.473h1.15c2.259 0 4.027-.917 4.544-3.571M30.313 23.94l-.73 4.642a.148.148 0 0 0 .146.171h.734a.25.25 0 0 0 .244-.209l.72-4.558a.148.148 0 0 0-.146-.172h-.822a.15.15 0 0 0-.146.126",
        fill: "#179BD7"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.217 23.815h1.778c.595 0 1.043.157 1.296.453.23.27.306.657.227 1.148-.177 1.123-.853 1.69-2.024 1.69h-.563a.25.25 0 0 0-.244.209l-.204 1.292a.17.17 0 0 1-.17.146H21.4a.148.148 0 0 1-.147-.171l.72-4.559a.25.25 0 0 1 .243-.208m.928 2.303c.471 0 .959 0 1.056-.638q.053-.334-.087-.496c-.156-.183-.46-.183-.78-.183h-.123a.15.15 0 0 0-.146.125l-.189 1.192zM28.459 25.46h.85c.092 0 .161.08.147.17l-.46 2.914a.25.25 0 0 1-.244.209h-.767a.148.148 0 0 1-.146-.172l.038-.236s-.42.487-1.179.487c-.441 0-.812-.127-1.072-.433-.283-.332-.398-.81-.317-1.308.157-1 .96-1.712 1.9-1.712.411 0 .822.09 1.006.357l.06.086.037-.238a.15.15 0 0 1 .147-.125m-1.297 2.47a.95.95 0 0 0 .96-.814c.038-.235-.013-.449-.143-.602s-.326-.232-.568-.232a.95.95 0 0 0-.954.82c-.04.236.008.448.133.598.127.15.325.23.572.23",
        fill: "#179BD7"
      }), /* @__PURE__ */jsx("path", {
        d: "M23.948 12.989a4 4 0 0 0-.502-.112q-.466-.074-1.014-.074h-3.073a.49.49 0 0 0-.484.414l-.654 4.14-.019.121a.56.56 0 0 1 .552-.473h1.15c2.26 0 4.028-.917 4.545-3.571q.022-.118.04-.23a2.8 2.8 0 0 0-.54-.216",
        fill: "#222D65"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.314 23.815H9.537a.25.25 0 0 0-.245.208l-.719 4.559a.148.148 0 0 0 .147.171h.849a.25.25 0 0 0 .244-.209l.194-1.23a.25.25 0 0 1 .244-.208h.563c1.17 0 1.846-.567 2.023-1.69.08-.491.003-.877-.227-1.148-.252-.296-.7-.453-1.296-.453m.206 1.665c-.098.638-.585.638-1.056.638h-.269l.188-1.192a.15.15 0 0 1 .147-.125h.123c.32 0 .624 0 .78.183.094.11.122.272.087.496m5.109-.02h-.852a.15.15 0 0 0-.146.124l-.038.239-.06-.087c-.183-.267-.594-.357-1.005-.357-.94 0-1.744.713-1.9 1.712-.082.499.034.976.317 1.308.26.306.63.433 1.072.433.758 0 1.178-.487 1.178-.487l-.038.236a.148.148 0 0 0 .146.172h.767a.25.25 0 0 0 .244-.209l.46-2.914a.148.148 0 0 0-.145-.17m-1.187 1.656a.95.95 0 0 1-.96.813c-.248 0-.445-.08-.572-.23-.126-.149-.174-.361-.134-.598a.95.95 0 0 1 .954-.819c.242 0 .439.08.568.232.13.153.181.367.144.602m4.866-1.657h.855c.12 0 .19.134.122.233l-2.846 4.107a.25.25 0 0 1-.203.106h-.854a.148.148 0 0 1-.121-.234l.886-1.25-.942-2.766a.148.148 0 0 1 .14-.196h.84c.11 0 .206.072.238.176l.5 1.67 1.18-1.738a.25.25 0 0 1 .204-.108",
        fill: "#253B80"
      }), /* @__PURE__ */jsx("path", {
        d: "M18.875 13.218a.49.49 0 0 1 .484-.415h3.073q.548 0 1.014.074.133.021.258.05a4 4 0 0 1 .36.098q.23.075.426.18c.154-.982-.002-1.65-.532-2.254-.584-.666-1.64-.951-2.99-.951h-3.92a.56.56 0 0 0-.554.473l-1.633 10.35a.337.337 0 0 0 .333.39h2.42z",
        fill: "#253B80"
      })]
    }))
  }, props));
}

__name(PaymentPayPalIcon, "PaymentPayPalIcon");

function PaymentVenmoIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        y: 6,
        width: 40,
        height: 28,
        rx: 4,
        fill: "#008CFF"
      }), /* @__PURE__ */jsx("rect", {
        x: 0.25,
        y: 6.25,
        width: 39.5,
        height: 27.5,
        rx: 3.75,
        stroke: "#000",
        strokeOpacity: 0.12,
        strokeWidth: 0.5,
        fill: "#008CFF"
      }), /* @__PURE__ */jsx("path", {
        d: "M15.794 27 13.6 13.762l4.79-.486 1.207 9.439c1.765-3.024 3.154-6.337 1.895-8.847l4.4-.868c2.544 4.39-2.415 10.898-4.621 14z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(PaymentVenmoIcon, "PaymentVenmoIcon");

function PaymentVisaIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 0.5,
        y: 6.5,
        width: 39,
        height: 27,
        rx: 3.5,
        fill: "#fff",
        stroke: "#E8E9EB"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 25.127h-2.494l-1.87-7.136c-.09-.328-.278-.619-.555-.755a8.1 8.1 0 0 0-2.287-.756v-.274h4.019c.554 0 .97.413 1.04.892l.97 5.148 2.493-6.04h2.425zm5.128 0h-2.356l1.94-8.921h2.356zm4.988-6.45c.07-.48.485-.755.97-.755a4.4 4.4 0 0 1 2.287.412l.416-1.921A6 6 0 0 0 24.14 16c-2.287 0-3.95 1.236-3.95 2.95 0 1.306 1.178 1.99 2.01 2.403.9.412 1.247.687 1.177 1.098 0 .617-.693.892-1.385.892-.832 0-1.664-.206-2.425-.55l-.416 1.923c.832.342 1.732.48 2.564.48 2.564.068 4.157-1.166 4.157-3.02 0-2.333-3.257-2.47-3.257-3.499m9.631-2.471 1.87 8.921H31.97l-.277-1.303h-2.98l-.484 1.303h-2.425l3.463-8.235c.139-.412.555-.686.97-.686zm-.97 5.765-.692-3.363-1.248 3.363z",
        fill: "#172B85"
      })]
    }))
  }, props));
}

__name(PaymentVisaIcon, "PaymentVisaIcon");

function PeanutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.78 7.22a4 4 0 0 1-.03-.498C7.75 4.39 9.652 2.5 11.999 2.5c2.302 0 4.177 1.82 4.247 4.09q.004.06.004.119c0 1.699-.299 2.393-.578 3.042-.245.569-.475 1.103-.475 2.249 0 1.276.285 2.085.558 2.863.252.717.495 1.406.495 2.408q0 .03-.002.06c-.029 2.307-1.92 4.169-4.249 4.169-2.347 0-4.249-1.89-4.249-4.222q0-.396.07-.773c.09-.64.283-1.159.48-1.69.286-.777.583-1.578.583-2.815 0-1.114-.241-1.649-.498-2.22-.265-.59-.548-1.218-.606-2.56"
      })
    }))
  }, props));
}

__name(PeanutIcon, "PeanutIcon");

function PeanutFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8.095a8.06 8.06 0 0 0-5.011 1.737l2.43 2.43C9.796 6.866 10.81 6 12 6c1.511 0 2.736 1.392 2.736 3.11a3.4 3.4 0 0 1-.555 1.878c-.318.476-.318 1.262 0 1.738q.087.13.16.269l4.017 4.016A8.095 8.095 0 0 0 12 3.905m-2.023 7.42c.146.457.093 1.025-.158 1.401a3.4 3.4 0 0 0-.555 1.878c0 1.718 1.225 3.11 2.736 3.11 1.12 0 2.083-.765 2.507-1.86l2.504 2.504a8.095 8.095 0 0 1-11.37-11.37z"
      })
    }))
  }, props));
}

__name(PeanutFreeIcon, "PeanutFreeIcon");

function PercentIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.314 7.7c0 1.231-.42 2.148-1.072 2.758-.655.612-1.56.931-2.553.931-1.07 0-1.989-.33-2.64-.946C3.402 9.829 3 8.913 3 7.701c0-1.23.43-2.146 1.095-2.757.668-.613 1.589-.932 2.594-.932 1.059 0 1.961.325 2.598.937.636.61 1.027 1.527 1.027 2.752m-5.269 0c0 .59.14 1.073.428 1.41.292.344.714.51 1.216.51.485 0 .9-.175 1.19-.518.287-.339.432-.82.432-1.401 0-.592-.145-1.078-.431-1.42-.29-.346-.706-.52-1.191-.52-.514 0-.936.171-1.226.521-.285.343-.418.83-.418 1.419"
      }), /* @__PURE__ */jsx("path", {
        d: "M19.17 4.244 7.728 19.748H4.872L16.314 4.244z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 16.292c0 1.23-.425 2.146-1.083 2.756-.66.613-1.57.932-2.564.932-1.069 0-1.983-.33-2.628-.945-.643-.614-1.04-1.531-1.04-2.744 0-1.23.426-2.146 1.086-2.756.662-.613 1.578-.932 2.582-.932 1.07 0 1.978.325 2.618.937.637.611 1.029 1.527 1.029 2.752m-5.269 0c0 .597.133 1.08.416 1.417.289.342.707.501 1.206.501.495 0 .911-.173 1.2-.518.284-.34.423-.82.423-1.4 0-.592-.145-1.078-.432-1.42-.29-.346-.705-.52-1.19-.52-.505 0-.922.172-1.209.522-.281.343-.414.83-.414 1.417"
      })]
    }))
  }, props));
}

__name(PercentIcon, "PercentIcon");

var PercentIcon_default = PercentIcon;

function PescetarianIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 16.898V19c0 1.393 1.733 2.034 2.639.976l2.36-2.753C18.592 16.401 21.5 13.914 21.5 12S18.592 7.6 15.499 6.777l-2.36-2.753C12.233 2.967 10.5 3.607 10.5 5v2.102C8.683 7.8 7.04 9.01 6.165 10.248L4.9 9.3c-.99-.741-2.4-.036-2.4 1.2v3c0 1.236 1.411 1.942 2.4 1.2l1.265-.949c.875 1.239 2.518 2.45 4.335 3.147M17 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      })
    }))
  }, props));
}

__name(PescetarianIcon, "PescetarianIcon");

function PetsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M23.076 8.35c-.41-1.32-1.33-2.33-2.51-2.84-.07-.76-.34-1.49-.8-2.14-.87-1.23-2.28-1.97-3.76-1.97-.33 0-.65.04-.96.11a4.54 4.54 0 0 0-3.4-1.51c-1.34 0-2.56.57-3.4 1.51-.31-.07-.64-.11-.96-.11-1.49 0-2.89.74-3.76 1.97-.46.65-.73 1.38-.8 2.14-1.18.51-2.1 1.52-2.51 2.84-.4 1.28-.23 2.58.4 3.65-.63 1.07-.8 2.37-.4 3.65.41 1.32 1.33 2.33 2.51 2.84.07.76.34 1.49.8 2.14.87 1.23 2.28 1.97 3.76 1.97.33 0 .65-.04.96-.11.84.94 2.06 1.51 3.4 1.51s2.56-.57 3.4-1.51c.31.07.64.11.96.11 1.49 0 2.89-.74 3.76-1.97.46-.65.73-1.38.8-2.14 1.18-.51 2.1-1.52 2.51-2.84.4-1.28.23-2.58-.4-3.65.63-1.07.8-2.37.4-3.65m-1.91 4.54c.39.66.48 1.46.23 2.24-.25.81-.8 1.43-1.53 1.75l-.95.41-.1 1.03c-.05.47-.21.91-.49 1.3-.54.77-1.41 1.23-2.33 1.23-.2 0-.39-.02-.58-.06l-1-.22-.68.77c-.53.6-1.28.93-2.09.93s-1.56-.33-2.09-.93l-.68-.77-1 .22c-.19.04-.38.06-.58.06-.92 0-1.79-.46-2.33-1.23-.28-.39-.44-.83-.49-1.3l-.1-1.03-.95-.41c-.74-.32-1.28-.94-1.53-1.75-.24-.78-.16-1.57.23-2.24l.53-.89-.53-.89c-.39-.66-.48-1.46-.23-2.24.25-.81.8-1.43 1.53-1.75l.95-.41.1-1.03c.05-.47.21-.91.49-1.3.54-.77 1.41-1.23 2.33-1.23.2 0 .39.02.58.06l1 .22.68-.77c.53-.6 1.28-.93 2.09-.93s1.56.33 2.09.93l.68.77 1-.22c.19-.04.38-.06.58-.06.92 0 1.79.46 2.33 1.23.28.39.44.83.49 1.3l.1 1.03.95.41c.74.32 1.28.94 1.53 1.75.24.78.16 1.57-.23 2.24l-.53.89z"
      }), /* @__PURE__ */jsx("path", {
        d: "M13.716 12a15 15 0 0 1-1.03-.96 1.47 1.47 0 0 0-1.04-.43c-.37 0-.76.14-1.04.43-.29.29-.65.63-1.07 1-.88.77-2.7 1.67-3.05 2.58-.74 1.91.27 3.55 1.84 3.76.13.02.26.03.4.03.59 0 1.18-.17 1.72-.5.38-.23.8-.35 1.22-.35s.84.12 1.22.35c.53.33 1.13.5 1.72.5.13 0 .26 0 .39-.03 1.57-.21 2.58-1.86 1.84-3.76-.36-.93-2.2-1.85-3.1-2.63zm1.48 4.36c-.07.12-.2.26-.45.3-.05 0-.11.01-.16.01-.27 0-.54-.08-.8-.24-.65-.4-1.39-.61-2.14-.61s-1.49.21-2.14.61c-.26.16-.53.24-.79.24-.05 0-.11 0-.16-.01a.62.62 0 0 1-.46-.3c-.15-.26-.15-.63 0-1.04.19-.25.9-.73 1.32-1.02.44-.3.89-.61 1.27-.93.34-.3.66-.59.97-.89.29.29.6.57.93.85.37.32.82.63 1.26.93.41.28 1.17.8 1.37 1.06.15.41.15.79 0 1.05zM9.686 9.41c.83-.12 1.39-.65 1.19-1.91-.24-1.26-1.06-2.19-1.88-2.02-.83.12-1.31 1.29-1.07 2.54.2 1.26.94 1.57 1.77 1.39zM7.196 12.1c.74-.4 1.08-1.09.46-2.2-.66-1.1-1.74-1.7-2.46-1.26-.74.4-.8 1.66-.14 2.76.62 1.12 1.42 1.15 2.14.7M13.596 9.41c.82.17 1.56-.13 1.77-1.39.24-1.26-.24-2.42-1.07-2.54-.82-.17-1.64.77-1.88 2.02-.2 1.26.35 1.79 1.19 1.91zM18.086 8.64c-.72-.44-1.8.16-2.46 1.26-.62 1.12-.28 1.81.46 2.2.72.44 1.52.41 2.14-.7.66-1.1.6-2.36-.14-2.76"
      })]
    }))
  }, props));
}

__name(PetsCategoryIcon, "PetsCategoryIcon");

function PetsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M23.081 8.35c-.41-1.32-1.33-2.33-2.51-2.84a4.6 4.6 0 0 0-.8-2.14 4.62 4.62 0 0 0-4.73-1.86 4.54 4.54 0 0 0-3.4-1.51c-1.34 0-2.55.57-3.4 1.51-.31-.07-.63-.1-.96-.1-1.48 0-2.89.73-3.76 1.96a4.6 4.6 0 0 0-.8 2.14c-1.18.51-2.1 1.52-2.51 2.84-.39 1.28-.23 2.58.4 3.65-.63 1.07-.79 2.37-.4 3.65.41 1.32 1.33 2.33 2.51 2.84.08.76.35 1.49.8 2.14a4.62 4.62 0 0 0 3.76 1.96c.33 0 .65-.03.96-.1.85.94 2.06 1.51 3.4 1.51s2.56-.57 3.4-1.51a4.623 4.623 0 0 0 4.73-1.86c.45-.65.72-1.38.8-2.14 1.18-.51 2.1-1.52 2.51-2.84.39-1.28.23-2.58-.4-3.65.63-1.07.79-2.37.4-3.65m-10.67-.85c.24-1.26 1.06-2.19 1.88-2.02.83.12 1.31 1.29 1.07 2.54-.2 1.26-.94 1.57-1.77 1.39-.83-.12-1.39-.65-1.19-1.91zm-3.42-2.02c.82-.17 1.64.77 1.88 2.02.2 1.26-.35 1.79-1.19 1.91-.82.17-1.56-.13-1.77-1.39-.24-1.26.24-2.42 1.07-2.54zm-3.93 5.92c-.66-1.1-.6-2.36.14-2.76.72-.44 1.8.16 2.46 1.26.62 1.12.28 1.81-.46 2.2-.72.44-1.52.41-2.14-.7m9.91 6.99c-.71.1-1.46-.07-2.11-.48-.76-.47-1.68-.47-2.44 0-.65.4-1.4.57-2.11.48-1.57-.21-2.58-1.86-1.84-3.76.35-.92 2.17-1.81 3.05-2.58.42-.37.78-.71 1.07-1 .57-.58 1.51-.58 2.09 0 .28.28.62.61 1.03.96.9.78 2.74 1.69 3.1 2.63.74 1.91-.27 3.55-1.84 3.76zm3.25-6.99c-.62 1.12-1.42 1.15-2.14.7-.74-.4-1.08-1.09-.46-2.2.66-1.1 1.74-1.7 2.46-1.26.74.4.8 1.66.14 2.76"
      })
    }))
  }, props));
}

__name(PetsCategoryFilledIcon, "PetsCategoryFilledIcon");

function PharmacyCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M21 4.25c-1.1 0-2-.9-2-2V0H6v2.25c0 1.1-.9 2-2 2V8.5h1.5V24h14V8.5H21zM5.75 5.57c1.19-.63 2-1.88 2-3.32v-.5h9.5v.5c0 1.44.81 2.69 2 3.32v1.18H5.75zm1.5 6.68h5.41c.09 0 .15.04.2.11s.06.15.03.23l-2.06 5.75a.26.26 0 0 1-.24.17H7.25zm10.5 10H7.25v-2h3.34c.84 0 1.6-.53 1.88-1.32l2.06-5.75c.47-1.3-.5-2.68-1.88-2.68H7.24v-2h10.5v13.75z"
      })
    }))
  }, props));
}

__name(PharmacyCategoryIcon, "PharmacyCategoryIcon");

function PharmacyCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19.59 3.66C19.22 3.3 19 2.8 19 2.25V0H6v2.25a2 2 0 0 1-2 2v2.63h17V4.25c-.55 0-1.05-.23-1.41-.59M5.5 8.62V24h14V8.62zm5.33 9.71a.26.26 0 0 1-.24.17H7.25v-6.25h5.41c.09 0 .15.04.2.11s.06.15.03.23l-2.06 5.75z"
      })
    }))
  }, props));
}

__name(PharmacyCategoryFilledIcon, "PharmacyCategoryFilledIcon");

function PhoneIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.97 2h9.05c1.1 0 1.98.88 1.98 1.971v16.058c0 1.09-.89 1.971-1.98 1.971H7.97C6.88 22 6 21.12 6 20.029V3.971C6 2.881 6.88 2 7.97 2M17 6v12H8V6z"
      })
    }))
  }, props));
}

__name(PhoneIcon, "PhoneIcon");

function PhotoIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), {
      children: [/* @__PURE__ */jsx("circle", {
        cx: 12,
        cy: 12,
        r: 10,
        fill: "url(#prefix__pattern0)"
      }), /* @__PURE__ */jsxs("defs", {
        children: [/* @__PURE__ */jsx("pattern", {
          id: "prefix__pattern0",
          patternContentUnits: "objectBoundingBox",
          width: 1,
          height: 1,
          children: /* @__PURE__ */jsx("use", {
            xlinkHref: "#prefix__image0",
            transform: "scale(.001)"
          })
        }), /* @__PURE__ */jsx("image", {
          id: "prefix__image0",
          width: 1e3,
          height: 1e3,
          xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAPoCAYAAABNo9TkAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAADxbSURBVHgB7d1NkFXnmdjxVy4tIjQVEtlSqmJgoGpQqgZaeDNI1LQqA965ezYpy2RaNXJZWYwgw0LWwuCvhWUbtJC1kEJLG7lGKZFh8M7d3hkWIiWLlVGLxYhUQQBlIdlKMRXQUunnXK5ovppu+t7bzznv71d13YjYiU03N/d/nvfjvs//cOTzAgAAAKymz79UAAAAgFUn0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKADAABAAgIdAAAAEhDoAAAAkIBABwAAgAQEOgAAACQg0AEAACABgQ4AAAAJCHQAAABIQKBTAAAAWH0CHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJCAQAcAAIAEBDoAAAAkINABAAAgAYEOAAAACQh0AAAASECgAwAAQAICHQAAABIQ6AAAAJDA/QUAAFrswsd/LJevXC0XPomvn13758+a3+t9nX9d7f164X9mMWsfXDP/euDarx8oa9esaX694ZGHvvg/2/DIl8uGh7/8xa/j9wFW4r7P/3Dk8wIAAIlFUM+dvzj/9dMyd+5iE9tz5y/dNbRHKQI9Aj6ivYn3+dfYxnVlbNM68Q4sxecCHQCANJpJ+Hx0nzxztgnxXoR/2vx+m/Wn7eNbNzfBPrZxffN7AAsIdAAAVk+E9+yp0/Mxfmk+yj9svtaiP2GfeHzbtUn7+gJUTaADADA6EeQR4RHl8cq0RH21RbCPb3m0mbLHVxN2qI5ABwBguCLKj5z4XZl973SzZL3ty9VHJSI9pusT27eJdaiDQIfwb/7TnlKDw/ueKVM7d5Ra7H31H5oPhLTDwg+fC09Mbn7dvNbc8LV/cnLvUCYfXCGbiPDpmRPl5AcfNkvXWZnYtx7/f7hYh0773DVrAKSw0mWuN1931HtdP03ZCcowfAsn5aJ8sGJbwIFzx8qBN481k/WpXU80se69DbpFoAPQCRH4i0V+fIiNQ5gi2uMgpvh1xLxDmWDlYko+PXO8OXnd8vXhi4cf8Yr3tYj0/bsnTNWhIwQ6AFWIaGgmemfm/2HB1od+uDfXHjVXHzlJGZbCtHz19b4H7zav/lS9pq1s0EUCHYCq9cP95sCID7sR7M2dxe4rhi/095bHxNy0PI/++9iho7PNRF2oQzsJdAC4jf6H3YiQ4PojahdbSOLvQ0zNhXle8X3a++pbX4S69ytoF4EOAEsQH3qPfNxbShp6y+HXl4nHH2s+ADuoia6Kn/2Ivf7PPu3QD/WIcxN1aA+BDgD3IE5Ujlc/Wvr7P02r6ApL2bvh5om6UIfcBDoADMDCfezN3vUI9p1POHCO1hHm3bQw1N/+3t95b4KkBDoADFh/uh6BE9P0mFhFrJusk11cl7b3tbcWvbKQdovv7ZMv/Lx5X3I9G+Qj0AFgiHr7d2eaV0zW90zusgyedPrTVdel1SO258T3O96T4gXk8KUCAIxETNUjgh577oe9GPpADLH6pn99vJmoivP6xIOZA28ea96TrJqAHEzQAWAVxPQqXv0Tlk3VGTVTc/riZyEiff/uyeb9CFg9Ah0AVlE/koI9oYxKTM0P/dOsQ+C4QWzFiZU9h/c9430IVokl7gCQREzUY4o1+aNX3DnNUESQxwOhA788Js65rVhRMfnjV8rsqd8XYPQEOgAkEx+Q+3vVhTqD0j+9288UdxM/K08feqO5kg0YLYEOAEn1l78LdVbqyPF3mzh3EBjLEUveY0WPnxsYHYEOAMkJdVYiIivuNreknXvRX/Iu0mE0BDoAtIRQZzn6+80tU2aletsjfmZfOoyAQAeAlumHuiXL3En8XMTU04McBuXylc+afenTM8cLMDwCHQBaau7cxWaaHrEu1Onrx/ncuUsFBu3Am8esyoAhEugA0HIxJY3lpz40049zD2wYpjjXwPsNDIdAB4AOiOWn8aE5JuonP/iwUB9xziiJdBgOgQ4AHdKPNMve6yLOWQ0iHQZPoANAB8Wyd4eE1UGcs5pEOgyWQAeAjuqf9m6a3l3inAxEOgyOQAeAjutP091h3C1xz7k4JwuRDoMh0AGgAhFxcYexD9DdEd9PcU4mEelHjttWAysh0AGgIv2T3oVdu8X38eQZp/WTz97X3ipz5y4W4N4IdACoTMR53JvuALl2mv71cSshSM3WC7h3Ah0AKhT3psfhcUKvXebOXSoHfnmsQGbx/hKRHuckAMsj0AGgYrFUOqbppl35NecIvPR6gTaIn9cDb/6qAMsj0AGgcjGVtSQ1v4gd3yPaJLbRTM8cL8DSCXQA4It96a5iyylWOvje0EYH3jzm0DhYBoEOADRi36ir2PKJhye+J7TZ0y+9YT86LJFABwBuENNaQZhHbD+ANus9ZPpNAe5OoAMAt4hIj1PeWV3xfbDvnC6YnvmtbRqwBAIdALitOOBp8keuSlotlrbTNfHQz/sJLE6gAwB3dPLMh+4zXiXinK6Jcy5cvQaLE+gAwKL617CJ9NGJ1Qvxgq6Jn+uTH3xYgNsT6ADAXYn00TI9p8v2vmapO9yJQAcAlkSkj0ZMGB0MR5fFz/f0zIkC3EqgAwBLJtKHz/ScGsSp7t5H4FYCHQBYloj0pw+9URg816pRCwfGwe0JdABg2eJ0d/ekD1YEy5ETvytQCwfGwa0EOgBwT+LDteXYgzN76vem51THewjc6P4CAHCPYkl22L97orAyQmVw1j64pmx4+KEytmld2fDIl5vX2jVrel8ffKD598Svbyf2Rcdqht6r9+t4cHLhkz802zvin+fOXyoMRqzGiSn6+NZHCyDQAYAVikgf2/TVMrH9a4V74+T2excxPr5l8/zr0SbI4xW/t5L/++72n49wj1iPVwRmfL3wie/fvYqHUzMCHRoCHQBYsdiP/s7L6+84lWRx0zPHC0sXQR4PhGLqGkE+as1Dgfn/t+O15693Nb/XxPr8JDi2Kpw8c7awdKbocJ1ABwBWLJb9xvVr77z8/RVNL2sUYRJxx+L6UT6164mUP2P96X0Ee6yGiOg89I+zJutLZIoOPQIdABiIiJK4fm3mxecLS+fk9juLEJ/a+fgX0/K2iJUkU4/smP/vvqN5ABNbGHyfFxcPNOI9xCocaucUdwBgYOJDtruNly5WHsyeOl24UYR5HDz4/usvloPPfqvVS5/jv/vhfd+e/9/y0/lgf6JwZ7Z6gEAHAAZseua3zT5c7i7+nOLAMXoWhvn+3ZOd2i4Rk2GhvrhYaeDvA7WzxB2g5TY8/OX5Cc3m0lYLT66+8Mmnt/we7eTQuKU5cvzdQk/sMY+A7frPTD/UY7Juj/qNYkVJbAXYM7mrQK0EOkDL9T/sdc3C+4e/+Hr16rV7iOe/nv/IpCWx+J49/dLr85H+g8Lt9Q4Sc9p3f2peW5TF/vTYWx/XFFrafd3se6cFOlUT6ACk1L+LeLFp2sK7iC988ofer4V7GvH9iP3oB5/9ZuFWsV+/dmMb15W39z9X7UqLtQ8+MP/346nm9HfT9B5XrlE7gQ5Aay28i3ihJtib6eQ/z3/QOzsf7a6wWi2xH31i+2M+bN9G7cvbY0oacUpvmj6+5dEy+aNXRHopzcGJ3jOolUPiAOicmEZNPL6tOf35nV/8oPzv//5yeft7zzUHM8WefUZr72tvWdVwk9gCUPPy9jgATpzfKFYRxPvVxPZtpXYOi6NmAh2AzotJewR7c4LyGz9tTlE++J2nmkOpGL5YzXDo6G8K19W8vD3iPPacc6tY8h5L/mv/84kHWLESCmok0AGoTkyq9vz1rjLz4nebWD+87xmxPmSx1D32ldITB2HVSJwvjT+n3hQdaiTQAahaxHrs/+zHumXww2Op+3Vz5y+W2sSec3G+dBHp8d5Uq9iH7v2CGgl0ALimf2VdLIM3VR88S917aly+Gw+97Dlfvprfhyxzp1YCHQBu4+apOoMRS93nztU3PV6otv3nEeczLz5fuDdv799T7aqemKJDbQQ6ACzii6m6UB+YuBu9ZrXtxY9l7bXecz4IcXBcPOCIwy5rYx86NRLoALAEQn1wYoI8PXO81KqmFQQx+Z3aVe8+6kGJ95/9u79RahPL3GNrDNREoAPAMvRD/Z2Xv+8wuRU4dHSm2gOg5s5/VGoRe6gZjD2TX69yP7pl7tRGoAPAPRjbtP6Lw+SE+vLFZGx65kSpTfzvruXBxPiWR8v41kcLgxMPB2tb6u56Rmoj0AFgBXqHyT1v2fs9iAPjalu+WtPy9rhWjcGKFTx7JneWmtR2qCIIdABYof6yd9P05Ylp8qGjs6UmtVwbFX8PJh7fVhi8uB+9pveZ3nVrdd/8QF0EOgAMiGn68sUpzTUtYb3wSR0rBsa31nl396js/88TpSYnz5wtUAuBDgAD1J+mx9VSLE1NU/RaJoHxsIrhiT/fmqboJujURKADwBDEMtR3Xv6BJe9LEHtMa5miX776Wem6uLfb4XDDV9MefxN0aiLQAWBIxjata5a8i/S7q2WKfuHjT0vXjW1cXxi+uF++lhPd4zDJWq9lpD4CHQCGKJa8v/OLH5SJ7Q7MWkwtU/QaIiMeTDF8sVKhphPda7vxgXoJdAAYsvgg/fb+5+xLv4uuT9FrCYx4KMVoxF3ztZg7X8cNCCDQAWBEYl+6SL+zrk/Rawn0sY0m6KMSe/1rWbFQyxWFINABYIRE+uKOnPhdAZaulu0zlrhTC4EOACMm0u8s7kXv6j7tGk5wZ/RqWeZuiTu1EOgAsApE+p1Nz5woXeQUaoYhlrnXcJq7vz/UQqADwCqJSJ/auaNwo+mZ3/owDsswvmVz6brLVz6zzJ0qCHQAWEUHn33KoVo3iQ/i9qK3V3z/GK1alrl7cEcNBDoArKL+FWwbHnY11UKz750utNPlqyJq1Ko5yd0+dCog0AFglcW90RHpNewjXaquX7nWZa7DGr2xTesL0A0CHQASiAnY/t3fKFw3e8oUvY0E+ujFSpwaHvDZg04NBDoAJLFn8usOjVugy1euddnc+YuF0dvwyEOl6wQ6NRDoAJBIHBpnP3pPHDZmit4+8X2zPWH0HDYJ3SDQASCRWKp6eN8zhZ4jx7tzmntNZwycPHO2MFp13IXuhgC6T6ADQDLjWx8teyZ3FXqHxXVlmfvaNQ+UWsRd9oxWPNzrOoFODe4vAEA6+3dPNleNXfjEnsu4E70LDyxqCKi+/jL3eNjEaIxtXF/Gt2wuXTa26asFuk6gA0BCEXOxH/3pl14vtYsHFd0I9Lqu0Tt0dLbMCPSRmXh8W/MC2s0SdwBIKj5sd30ithRdWeZeW6DH9y1O4gdg6QQ6ACR28NlvFXrL3NuupiXufQfePOaqPIBlEOgAkNjYpnUOjCu9Ze5dsOGRuq7Qi73oe199qwCwNAIdAJKLA+NqWx59s+4sc69vih532U/PHC8A3J1AB4DkIur2TO4stYvQa7uxjetKjWKp+5Hj9qMD3I1AB4AW2DP5dVP0Dz4sbVfz9/DAL4+VuXMXCwB3JtABoAViij6184lSs05M0DfVOUEPsR/9yRd+bpIOsAiBDgAtUfthcRF4bZ+ib3i4rkPibmfva281d6QDcCuBDgAtESeA134v+skzZ0ubjW1aXyjzgT7TnO7uCjaAGwl0AGiRONG9Zm2foMdWhdrPEug7cuLdZsl7F84WABgUgQ4ALTK+9dFqTwIPXbhubWzjVws9Fz7+Y5n88SvNND1+DVA7gQ4ALTPx+LZSs7lzl0qbWeZ+q5imR6jHV4CaCXQAaJm4cq1m7d+HXu8KiMXEBD0m6Y8990OhDlRLoANAy8Q+5poPi2v7nuXxLY8W7kyoAzUT6ADQQlO7dpRazZ2/WNosTuOPF4tbGOrTM8ftUQeqINABoIUmtn+t2tPA4z70uXPtjvTar8tbjgjzA28ea0I9gt2p70CXCXQAaKFY5l7zaeBt34cep/GzfP3D5Pqx3vYHNQA3u78AAK0Uy9zbHqr3qu1hFisgSnmrcG9iqn7k43ebYI/tAhPbt5WpnU84IR9oPRN0AGipXuTVae7cR6XNaj/ob5Ai1mOP+pMv/NwyeKD1TNABoKX6kVfjFD0Oirt85Wqr9+HHMvdaV0AMy8LJevxsxN+Pice3NSfnO5gPaAOBDgAtVnPkRYyNbWpvoMey7ENHZwvDEQ9wZk+dbl4hAj1CfeLxx8rYxvWCHUhJoANAi/Xu1K4z8ubOX2r1nuP4717rCojVsHC6HsY2rWtCXbADmQh0AGixmKDHUt6YFtZm7tylUnaWVrPMffXEz0+8bg728a2bLYkHVo1AB4CWi+vWaoy8mIi23Z7Jr1vmnsTNwR6BPrZxXfMQJVY6OCEeGAWBDgAtV+sUNpa4t13NB/1lFw+A4tXfwx4rVXrB3puwx8S9zYcUAjkJdABouVr3oUc8tf0k97B/92SZ/PErhdziZ+3kmQ+bV//vm33swKAJdABouZqX3l6+8lnrA73mcwTazrJ4YNAEOgC0XCyTjjDowp7s5Yo46sLUcs/kTnvRO+BOy+LjLvZ+uAMsRqADQAfEh/8aA/3CJ9343xyHxU3PnDBF75gbl8X3xJaU/j52wQ7cTKADQAfEXtj+1K4mXXkoEasgTNHrcPM+9gh1E3agT6ADQAfUejhVl1YNmKLXaeGEPZbEx971CHZ3sUOdBDoAdEDvJPf6XPj409IVpujEw5lYCdNfDRMrY5oJ+/ZtputQCYEOAB1Q7QT9kz+ULokp+pHjv+vM3npWpn9K/PTM8Wa63gv1zc1Xd7BDN32pAACdUGOkxzVrXVoSHlP0g88+VeBm8XMe17ntffWt8qd/+0KZ/NErzT/XeDgkdJkJOgB0RK0nuXfhLvSFevuPN5eTZ84WuJOFe9djGfzUrifsW4cOEOgA0BExfa1RPJToWpQc3vft8uQLP3dgHEuyMNZj+Xs85JnauaMA7WOJOwB0RK2Ts5igd018L/fv/kaB5YoD5mIZ/GPP/bD5OnfuYgHaQ6ADQEdUG+hXuzlljgPjYqk73ItYWRJ71GMlxpMv/Kz5tRUZkJ9AB4COqPVU5y7vu4+l7k7rZqXiJPjeVP1HzVcHy0FeAh0AOiIOiatRF5e498WqiIPf+WaBQeifBB/L358+9Ho5+cGHBchFoAMArdb1ZbtTu3aUPZO7CgxS7FWf/PErTaxHtAM5CHQA6AjXK3VX3I1e6woJhiuWu/cPlRPqsPoEOgB0SI37lS98/Gmpwdv7nysbHvYQhuEQ6pCDQAeADqn1LvQaxAqJmRefd2gcQ7Uw1F3RBqMn0AGAVuvyIXE3ayL9JyKd4YtQjyvanPoOoyXQAaBDNjz8UKlNV+9Bv5OxTevK4b9/psAo9E99P3R0tgDDJ9ABAFpm4vFtIp2ROnR0pgl1V7PBcAl0AIAWiuvXItItd2dUYql7XM124M1fdf56Q1gtAh0AOsRVa3WJSLcnnVGbnvltsz/dIXIweAIdAGi12g+wij3p77z8fVewMVL9Q+TsTYfBEugAAC3Xv4JNpDNqsTf9yRd+5qR3GBCBDgDQARHp7/ziB2Vq5xMFRmnu3KVmb7ol77ByAh0AoCPWPvhAObzv22X/7okCo9Rf8j49c7wA906gAwB0zP7dk83hcZa8M2oH3jxmXzqsgEAHAOig8a2PNvvSLXln1GJf+t5X3yrA8gl0AOiQy1c+K7VxtdydxZ9NLHk/vO8Z03RG6siJd5vD49yXDssj0AGgQ3wY5namdu4wTWfk+ofHeV+CpRPoAAAVME1nNYh0WB6BDgBQkf40fc/krgKjINJh6QQ6AHTI5av17UFfu2ZNYXlimn7w2afK+6//1LJ3RiIi/cCbvyrA4gQ6AHRIjYfExd3f3Jv+sndXsjEKcXCcSIfFCXQA6JAaA52ViyvZ3n/jp/anM3TTM7+dfx0vwO0JdADokBr3eJqgD07sT++H+tjGdQWG4cCbx8rJDz4swK0EOgB0xIWP/1hqJNAHL0L9nV/8oFn6PrF9W4FBe/ql16t9z4LFCHQA6IhaT0iOfdQMRyx9f3v/cw6TY+BiO87eV98qwI0EOgB0hP3nDEv/MLkIdfvUGZSTZz50aBzcRKADQEdc+KTO5aIm6KMTf9b9feqx/N1UnZWKQ+PsR4frBDoAdES1e9Ddg74qYvn7wqn6+JbNBe7F3tfeqnaLDtxMoANARzgkjtXQn6rPvPjdJtYPfucpJ8CzLPHeNT1zogACHQA6o9ZAt8Q9j/he7PnrXc0J8BHr+3dPiHWW5NDRGae6QxHoANAZl6/WeUicQM8pvi/7d09+EesxWbcMnsU41R1Kub8AAJ0wd+5SqY3l7e3Qn6zHK6akcXr37Hun57+etfeYL8TPRRwYF+cbQK0EOgB0wNy5i6VGGx7+SqFdmj3rj+xo9q2HCLLZU7+f/3q2zJ2v7yETNzrwy2PlnZd/UKBWAh0AOuDCJ5+WGpmgt19MS/sT05iux0qQfrDXenVgzeL7f+TEu188wIHaCHQA6IBaJ+hjmxxA1iUxXY/XxOPbmn9euBw+wk2w1+HQ0VmBTrUEOgB0QI37z4MD4rrt5uXw8XM+d/5isyzehL274sHM7KnTZWL7tgK1EegA0AG1hsqGhwV6TWLFRLz6wb5wSXwv3u1h74rpXx8X6FRJoANAy12+8lnFE/SHCvW6eUl8nAgffxf6p4HPnf/IKfEt5UR3aiXQAaDlat1/HsY2rS/Qt/bBNdcPndvd+70m1K9Fu33s7RJ70WcEOpUR6ADQchEeNRrbKM65u36wxx3swbL49oj3tlgBEQ9eoBYCHQBaLiaENXLFGvfiTsvi+8F+8szZQh7TMyfK/t0TBWoh0AGg5WKfbY1cscYg3LAs/prmlPhre6AF++pqHkAKdCoi0AGgxeLDa62HYI1vsTeV4bjdPnbBvjocFkdtBDoAtFit+8+DE9wZlYXBHg/E4g72WBLvLvbRiIciAp1aCHQAaLFa958HJ7izGmJJfOxf7+9hj0Pn4kHZkePvmq4PyZET79qHTjUEOgC0VC8M6gwCJ7iTRRw4N/XIjjK1c0czXZ89dbrMvne6+cpgxHtdvOLPGrpOoANAS9W8vH1s01cLZBPT9Qh1sT548We4Z3JXga77UgEAWik++NfK8nay68f62/ufK++//tNyeN8zZcPDJsD3qub3O+pigg4ALXT5ymdVT+XGt2wu0BYLl8HHuRGxp/rIid8Vlm7u/MUCNTBBB4AWihOka7X2wQdM0GmtOI388L5vN1P1WLJtqr408VCy5kMxqYdAB4AWqnp5uwPi6ICYqh989qky8+LzzQnlQv3u5s5fKtB1Ah0AWiZOM656eftWy9vpjgj1/bsnm1B3CNriTNCpgUAHgJap+fT2ML7l0QJd05+ox9L3ie3bCrcyQacGAh0AWubQ0dlSs7FN6wp0VYR6nPzu1PdbxeqhuL4OukygA0CLxBLP+JBaq5iex/VV0HVx4nssexfpNzr5wdkCXSbQAaBFar+ayf5zahLT9Pff+Km96Qtc+KTeB5TUQaADQEvE5DzuT66Z/efUKPamx0nvlDJ3zn3odJtAB4CWqH3vedx/HndIQ43ipHeRHoH+UYEuE+gA0AKm56bnINJLuXzVIXF0m0AHgBaofXoeXD0FvUiveU96zYdkUgeBDgDJmZ73WN4OPRHpYxvrvW5QpNNlAh0AkjM97y1vjxOtgd55DHFXeq0EOl0m0AEgMdPznqmdTxTgunhgVet+dFet0WUCHQASO/DmsYLl7XA7eya/Pj9NX1Nqc/nKZwW66v4CAKQUk/PZU6dL7TIvb48VDo8998PSdXEPd80Hk2UVS933TO6sbhvM5StOcqe7TNABIKH4AGrveY/l7atPEOUVU/TamKDTZQIdABKKOHcQUo/l7avPz2JeMUUf37K51MQDI7pMoANAMic/+LBMzxwv5D+9vZaT5efOfVTIa2L71wrQDQIdABKJSeXe194q9FjensPlqyaWmU08vq3U5MLHnxboKoEOAIlY2n5dLN2d2rWjZFfDFD1+Ji0rzit+Bms8zR26SKADQBLTvz7uzvMFJra3YyoYDxJqMHfuUiGv2vahQ1cJdABIICaUB37pzvOF2nKt14aHK9mHfl6gZ1bLgyLoOoEOAKss4nzyx68UrhvbuL6MbVpf2qCWMJp973Qhr1oOLISuE+gAsMqeful1+85vsmdyZ2mLak5yP3+xkNfaNfagQxcIdABYRXtffcve3pvEkvE2HA7XV0ugX77yWXMFIDmt/RNL3KELBDoArJJDR2ccCncb41vbddjV2MZ1pRazpyxzBxgmgQ4AqyDiPK5U41b7d0+WNqnpeisPlPKyTQa6QaADwIiJ8zub2vlE65aM13QHtWXuZODEerpMoAPACInzxbVtet634ZGHSi0sc8+ppgm6QKfLBDoAjMiBN4+J80W0cXreV9M+9FjmfvnK1UIuNQW6K+XoMoEOAEMWMROntU/PHC/c2dTO9pzcfrO4t70Wscx9euZEIZe58x+VWtR07gP1EegAMEQx1Zr88SsO17qL8S2PlvGtj5a22vDv6proTc/81hQ9kXifqen7EVcxQlcJdAAYkrjfPOLcPed3t3/3RGmzeMBQE1P0XE6eqevgPnvQ6TKBDgBDMP3r4+XJF37m6qMliL3nbZ6ehwiG2vbFmqLncfKDs6Um9qDTZQIdAAYoguXpQ2+UA788Vliatp7cfrPxLZtLTWKKfujobwqrr7YJukCnywQ6AAxI3A/95As/L7Onfl9Ymjaf3H6zmg6K64sp+ty5i4XVE+db1LRSp8a/Z9RFoAPACsXUPK5Qi/3mlrQvT1em52F8a10T9L69r71VWD1Hjtd1AOWGRx4q0GUCHQBWIPaaP/bcj1yhdg8izru0VHVs0/oqr3+KQxAPvPmrwujFA8GTZ+rafz62aV2BLhPoAHAPYjn75I9eafaaOyhr+eKapFje3jVjG79aahRL3ePvBKN16OhsqU1tNyZQH4EOAMvQ3Gs+H+axnL22g5kGKa5V6+JBTxPbv1ZqFUvdbfEYndh7Hq/amKDTdQIdAJYgwmPvq2+Vx577oTBfoWZ6vmtH6aKJx7eVWsXfkadfet2KkhGIP+Map+fx3lHjNhLqItABYBH9pewR5jVOq4Zh5sXnS1fFqoCar4CK/ehxzSDDFXFe42oF03NqINAB4Db6YW4p+2B17WC425nYXu8UPcTfl1htwnDEwZS1HkpZ+98t6nB/AQAaMf2bPXW6+fBrme7gxfLUPZM7S9dFRNR+qn9/tcnhfc8UBqc5Mf+Xx0qtxrc6II7uE+gAVC1C/MiJ35XZ906blA9ZxFoN+0cjIuJ/Z+0PeSLS585fLDM/ed6+4QGIOI8VPbWKB3w1bx+hHgIdgOrE3s2YlIvy0dkzuauq6VdcIVf7FD1EVD75ws+bSBdX964f5zU/9BnfurlADQQ6AJ0XH2ojxE9+cLYJc1dBjVZMvuJatZpY5n5dczXhfFwefPabVV9Dd6+OHH+3ucKudlM7u3nzA9xMoAPQOREEEeQxdep/ZfXUsrR9Icvcb9RcwXbojeaQwNoe1qzEgTePedAzb+2DD9h/TjUEOgCtFfETH/znzl9qIrx5zf9aFOURQVbrB+s4EK/Gu6oXc+joTLM33ZL3xfXvlPdwscfp7dREoAOQUkT25SufNV970f1Z86G1/88XPv5UiCdX49L2hca3xIMJgX6z+Hv82HM/bJYsx8+HUL8u3tOmZ064SeImlrdTE4EO0HJxSvLeV/+htFWEdrh8tRfkvd+zR7ztIs5nXny+1CxWDoxv2VxOnjlbuFVM0mMLShwgGK/azZ76fTnw5q+8/90k3kssb6cmAh2g5SJq45owyMRktCcORRPodxYx2t9nHT8zsZS5tvMKTn7wYbMVwo0St+f0dmoj0AGAgYp951O7LEkN8edw6J9mLVe+iwj1va++1TzUia0BXX/A01/KHqsITMwXF+8nUBOBDgAMTCzpdkr3dXH6tMPili5i9cjH7zbhGqE+teuJzkzVm/Mzzl1qVgvEqgoPbe4ufgasxKE2Ah0AGIjYK3p437cLN9oz+fVmWirIlieWfPeXfUekTzy+rXXBFt/z2VOnm2Xss6fe9zOwTM4moEYCHQBYsZhwxqFwpl23iin6xPbHnBWxAhG58Qpjm9Y1oR57k+Nrpul6rACIhwoxKe9/5d7EA794KAO1EegAwIod3ve34nwRsY9WoA9GRG9/qXiIn7uxjeuacI/X2jVrel+HFO79KyDjBo24hWLu3EVXPw6BrTLUSqADACsS8RmnlXNnEZGxTLs/BWZwYmodr5v/bCPQNzzyUBPssYohXgsfIt3ugVKEdz+yF/464vvCJ3+84fcYnpieO2iSWgl0AOCeRZybdC3NwWefEugj1DuUTUy3kfcUavalAgBwD6Z27vBBehliYju184kC3JnpObUT6ADAssVy7cP7niksT6w46MKVYTAsHvpRO4EOACxLHMglzu9NTNHjXnTgVr27703PqZtABwCWLOI8rlMzBb53cS+6Pz+4lQd/INABgCUS54MRp4nv3/2NAly3Z3KXqxqhCHQAYAnE+WDFFH18y+YC9A6Gi0AHBDoAcBfifDgOPvutAvQOhjM9hx6BDgDcUUx5xflwjG1aZ2pI9eLqQQfDwXUCHQC4rbjnfObF74rzIYpr12J5L9Qofvbj7wBwnUAHAG4RH5qdqDx8cWCcP2dqFT/7lrbDjQQ6AHCDiPPYE8pojG99tBx89psFahLvM/GzD9xIoAMAjVjKfvjvnxHnq8Cp7tRkYvs27zNwBwIdAGj2gs785HmHNa2iw/u+bb8/nRfvNQeffaoAtyfQAaBy/ZPa41RxVk/sxX37e39XoKviAVS819h3Dncm0AGgYnHNV5zU7gNzDrEn19Jfuurwvr/1XgN3cX8BAKoTk6yD3/mmJe0JxeFZFz7+tBw58W6Broif64ntXyvA4gQ6AFRmbOO68vb+50yyEos9unPnLpa585cKtJ2bIWDpLHEHgIr0lrTbA5pd3I/ePER52PeJdhPnsDwCHQAq0D+lPSazTgpvh3iI0jxMEem0VDwQFOewPAIdADou7hx+5xffbw4go12ak93nJ+keqtA2Uzt3uE4N7oFAB4COiqh7e//fCbyWi+vvYvWD7yFtEcvaD+97pgDLJ9ABoINiaen7r7/o1OSOEOm0hT3nsDICHQA6xF7z7hLpZCfOYeUEOgB0QERbfDB+/42f2mveYSKdjOLn8fDfPyPOYQDcgw4ALTe184lmcuXqtDpEpL/z8vfL5I9eKRc++WOB1RSrduKci/i5BFbOBB0AWmp8y+Zmmnp437fFeWVcwUYGYxvXNT+H4hwGxwQdAFomoixOSLaUvW4R6e/84gfl6UPT5eSZswVGKQ6idI0aDJ5AB4CWiDCPPZ5Tu3YUCGsffGB+gvndcujozPxrtsCwxX7zg9/5pvchGBKBDgDJCXPuJs4giFg/dPQ35fKVqwWGIZa0x35zW2pgeAQ6ACQVe8yndu4Q5izJnsmvN/feOzyOYbCkHUZDoANAMhHmMRG1x5zl6u9LjyXv0zPHC6yUMy9gtAQ6ACQQ+zontj/WTMx9EGYlYql7TDrjZO1D/zhrms49i6018bAQGB2BDgCrKMJ8z+TOZvlo/BoGpXnYs+XRZpp+5MTvCixVrOJxfSOsDoEOACMWIT628auWsTN0EVgRWvFzZprO3cRy9oP/5ZvNWQbA6hDoADAiMZWKD75Tu54wLWekTNNZjJU8kIdAB4Ahue++mGB+pfzNXz3eBJLloqym/jQ9Vm7819f+oZz84Gz5vFC72GcuzCEPgQ4AA3Jf8y/3zU8q/6z85fy0MiaWlrCTTYT6r3/y3flJ+rvlpaO/KRc+/oNQr9DUzieahzUeHEIuAh0AViCm5GsffLCMbfz35Rt/8bUy8fg2H3hphVjVES+hXo9/8ycPlqm/2l6em/y69ylISqADwDL0p+Tx4XbiL8bKN7Z/rbnOyvJQ2kqod1u8Z62dD/PnJv7KUnZoAYEOAItYGOTjf/5n5S+39paumz7RNUK9W2J1Tzw8/Jv/uMPBlNAiAh0Arrnv2r/0l6yPbVxXtm5aXya2b/Phlmr0Q332vdPl9dnflpNn/lf5/HOp3hb3XTsH43vfco0jtJFAB6A6933xi/uu3Ul+PcbHNq5vpk5QuzhPIV4XPv7j/ER9pgl1U/WcYloe1zjG4ZSWsUO7CXQAOum+G37RC/END//bXojPR3gsUY8Qt1QdFhd/R/7bvm83v47l7/9j/hWxPj9WF+urqH9AZewtd2MEdIdAB6BV7rvDLyIi1q75V/MR/uX5Xz9U1j/8lbL2Tx5oJuLxzyZKsHL95e8xVT955kOxPmIR5Rse+coXB1SKcugegQ6lt1+L7onvqu9tO0Q8r33wgRt+L6bdva9fvvbveaD86/j3rVnThHf8fv8/ZwoOoxV/56YeEevD1j+kMvaUx/L1iWu3RgDddd/nfzjiPRQAgBW7fOVqOfnB2fKbU7/v7Vn/5I+CfRluvsbxL7f8h/kp+WYrgKAenwt0AACGoj9d/817p8vc+Y8E+wL3LfiXsY1fbQ55c2sEVE+gAwAwGhHsc+culf955p/ng/3S/Ov/zE/dr5Qo9i5/IF0Y4zEdH//zP2sOq4zl6vES5MA1Ah0AgNUTwd6E+/mL5YP5X1++evVauF8t/XJvw4fVhRHePx9j7E+/2hxS2b/C0YGVwF0IdAAA8olAj3i/fOWzJt7/Jf55fuoeLnzyf5uov+7zG77c9Mtlu++2/3D9dxfeGhEhvv6RL/eubpyPcAdXAisg0AEAaKeI+Aj4fqzHr2MCf/n/9b72/cu1f9+drL8pqBcG9sIbI3ovE3BgaAQ6AAAAJPD5lwoAAACw6gQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEACAh0AAAASEOgAAACQgEAHAACABAQ6AAAAJCDQAQAAIAGBDgAAAAkIdAAAAEhAoAMAAEAC98+/Pi8AAAB3dl8Bhu7/A5AWgKziuJIEAAAAAElFTkSuQmCC"
        })]
      })]
    }))
  }, props));
}

__name(PhotoIcon, "PhotoIcon");

function PickupIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 3H4v2c.801 0 1.281.32 1.698.706L3 12v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2h10v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2.698-6.294C18.72 5.32 19.2 5 20 5zM7.319 7 6 10.077V15h3V9h6v6h3v-4.923L16.681 7z"
      })
    }))
  }, props));
}

__name(PickupIcon, "PickupIcon");

var PickupIcon_default = PickupIcon;

function PickupCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M24 7.01h-2.59L19.37 2.9c.66-.57 1.5-.9 2.38-.9h.04V0H2.2v2h.04c.89 0 1.73.33 2.39.91L2.6 7.01H0v1.85l1.31.76-.62 1.26v.02H.68l-.21.42c-.31.63-.47 1.31-.47 2.01V24h4.51v-2.95h14.97V24h4.51V13.33c0-.69-.16-1.38-.46-2l-.16-.33s-.03-.07-.04-.11l-.62-1.25v-.02L24 8.87zM6.17 3.75h11.68l3.17 6.41-1.28 3.44c-.15.39-.52.65-.94.65h-.49l-.48-5.31h-3.1l-.3-3.11H6.35l-.81 8.42H5.2c-.42 0-.79-.26-.94-.65L3 10.17l3.18-6.41zm6.63 10.5.32-3.56h3.12l.32 3.56zm-1.28-5.31-.48 5.31H7.3l.64-6.67h4.91l.13 1.36zM1.75 19.3v-5.5c0-.47.08-.93.21-1.38l.66 1.78c.4 1.08 1.43 1.8 2.58 1.8h13.61c1.14 0 2.18-.72 2.58-1.79l.66-1.79c.13.44.2.9.2 1.35v5.53z"
      })
    }))
  }, props));
}

__name(PickupCategoryIcon, "PickupCategoryIcon");

function PickupCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M18.162 12.495H5.718l.63-6.667h8.096l.3 3.108h3.089z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 7.007v1.85h-.01l-1.3.749.02.04.61 1.24a1 1 0 0 0 .04.11l.16.33c.3.619.46 1.309.46 1.998V24h-4.508v-2.949H4.508V24H0V13.324c0-.7.16-1.379.47-2.009l.21-.42.63-1.279L0 8.856V7.007h2.599l2.03-4.098a3.6 3.6 0 0 0-2.39-.91H2.2V0h19.592v2h-.04c-.88 0-1.72.329-2.38.899l2.04 4.108zm-6.147-3.259H6.177l-.01.01-3.178 6.408 1.27 3.428c.15.39.519.65.939.65h13.604c.42 0 .79-.26.94-.65l1.28-3.438z"
      })]
    }))
  }, props));
}

__name(PickupCategoryFilledIcon, "PickupCategoryFilledIcon");

function PickupOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 3H4v2c.801 0 1.281.32 1.698.706L3 12v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2h10v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2.698-6.294C18.72 5.32 19.2 5 20 5zm-5 12h4v-2.59L16.681 7H7.32L5 12.41V15h4V9h6zm-2 0h-2v-4h2z"
      })
    }))
  }, props));
}

__name(PickupOutlineIcon, "PickupOutlineIcon");

function PinIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M17 2H7v3h2l-1 6a2 2 0 0 0-2 2v1h4l2 8 2-8h4v-1a2 2 0 0 0-2-2l-1-6h2z"
      })
    }))
  }, props));
}

__name(PinIcon, "PinIcon");

function PinOffIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m13.763 14.947 6.913 6.115 1.325-1.498L3.327 3.044 2 4.544l6.166 5.454L8 11a2 2 0 0 0-2 2v1h4l2 8zM18 13v.365L7 3.635V2h10v3h-2l1 6a2 2 0 0 1 2 2"
      })
    }))
  }, props));
}

__name(PinOffIcon, "PinOffIcon");

function PinterestIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 12a9.505 9.505 0 0 0 6.038 8.85c-.083-.752-.158-1.908.033-2.729.173-.741 1.114-4.722 1.114-4.722S9.4 12.83 9.4 11.99c0-1.321.765-2.307 1.719-2.307.81 0 1.202.608 1.202 1.338 0 .815-.52 2.033-.787 3.163-.224.945.474 1.717 1.407 1.717 1.688 0 2.986-1.78 2.986-4.35 0-2.275-1.634-3.866-3.968-3.866-2.703 0-4.29 2.028-4.29 4.123 0 .816.315 1.692.707 2.168a.28.28 0 0 1 .066.272c-.072.3-.232.946-.264 1.078-.041.174-.137.21-.317.127-1.187-.553-1.929-2.287-1.929-3.68 0-2.997 2.178-5.75 6.277-5.75 3.296 0 5.857 2.349 5.857 5.487 0 3.274-2.065 5.91-4.93 5.91-.962 0-1.867-.5-2.177-1.091 0 0-.477 1.813-.592 2.258-.215.825-.794 1.86-1.18 2.49A9.5 9.5 0 1 0 2.5 12"
      })
    }))
  }, props));
}

__name(PinterestIcon, "PinterestIcon");

function PlaceholderIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("circle", {
        cx: 12,
        cy: 12,
        r: 10,
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(PlaceholderIcon, "PlaceholderIcon");

function PlaceholderDarkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("circle", {
        cx: 12,
        cy: 12,
        r: 10,
        fill: "#343538"
      })
    }))
  }, props));
}

__name(PlaceholderDarkIcon, "PlaceholderDarkIcon");

var PlaceholderDarkIcon_default = PlaceholderDarkIcon;

function PlacementIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 3h6.714v2H5v4.714H3zm18 0h-6.714v2H19v4.714h2zm-6.714 18H21v-6.714h-2V19h-4.714zM3 21h6.714v-2H5v-4.714H3zm9-5.571a3.429 3.429 0 1 0 0-6.858 3.429 3.429 0 0 0 0 6.858"
      })
    }))
  }, props));
}

__name(PlacementIcon, "PlacementIcon");

function PlatinumCartStarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M19.2 4.8H4.8v14.4h14.4z",
        fill: "#3940C4"
      }), /* @__PURE__ */jsx("path", {
        d: "M17.696 17.696V6.304H6.302v11.392z",
        fill: "#5D5FEF"
      }), /* @__PURE__ */jsx("path", {
        d: "M16.192 16.192V7.808H7.806v8.384z",
        fill: "#959CF4"
      }), /* @__PURE__ */jsx("path", {
        d: "M14.902 14.903V9.097H9.095v5.806zM4.8 4.8l1.504 1.504h11.392L19.2 4.8z",
        fill: "#959CF4"
      }), /* @__PURE__ */jsx("path", {
        d: "M17.696 6.304 19.2 4.8v14.4l-1.504-1.504z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M14.903 14.903H9.097V9.097L7.808 7.808v8.384h8.384z",
        fill: "#272D93"
      }), /* @__PURE__ */jsx("path", {
        d: "M9.097 9.097h5.806v5.806l1.289 1.289V7.808H7.808z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(PlatinumCartStarIcon, "PlatinumCartStarIcon");

function PlatinumWithBackgroundCartStarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_6197_5081)",
        children: [/* @__PURE__ */jsx("circle", {
          cx: 12,
          cy: 12,
          r: 12,
          fill: "#003D29"
        }), /* @__PURE__ */jsx("path", {
          d: "M19.2 4.8H4.8v14.4h14.4z",
          fill: "#3940C4"
        }), /* @__PURE__ */jsx("path", {
          d: "M17.696 17.696V6.304H6.302v11.392z",
          fill: "#5D5FEF"
        }), /* @__PURE__ */jsx("path", {
          d: "M16.192 16.192V7.808H7.806v8.384z",
          fill: "#959CF4"
        }), /* @__PURE__ */jsx("path", {
          d: "M14.902 14.903V9.097H9.095v5.806zM4.8 4.8l1.504 1.504h11.392L19.2 4.8z",
          fill: "#959CF4"
        }), /* @__PURE__ */jsx("path", {
          d: "M17.696 6.304 19.2 4.8v14.4l-1.504-1.504z",
          fill: "#fff"
        }), /* @__PURE__ */jsx("path", {
          d: "M14.903 14.903H9.097V9.097L7.808 7.808v8.384h8.384z",
          fill: "#272D93"
        }), /* @__PURE__ */jsx("path", {
          d: "M9.097 9.097h5.806v5.806l1.289 1.289V7.808H7.808z",
          fill: "#fff"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_6197_5081",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(PlatinumWithBackgroundCartStarIcon, "PlatinumWithBackgroundCartStarIcon");

function PlayIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M7 21V3l14 9z"
      })
    }))
  }, props));
}

__name(PlayIcon, "PlayIcon");

var PlayIcon_default = PlayIcon;

function PlayStoreIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 5.135q0-.133.021-.258L13.073 12 6.02 19.123A1.6 1.6 0 0 1 6 18.865zm1.608 15.228c.221-.015.446-.082.658-.208l8.111-4.817-1.897-1.916zM15.887 12l2.263 2.286 1.678-.996a1.5 1.5 0 0 0 0-2.58l-1.678-.996zm.49-3.338L8.266 3.845a1.5 1.5 0 0 0-.658-.208l6.872 6.942z"
      })
    }))
  }, props));
}

__name(PlayStoreIcon, "PlayStoreIcon");

function PlusIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M14.969 2.846a1.71 1.71 0 0 1 2.062 0l3.767 2.826c.173.13.368.227.576.284l4.51 1.248c.735.203 1.256.87 1.286 1.648l.186 4.773c.009.22.057.436.143.638l1.857 4.382a1.81 1.81 0 0 1-.459 2.056l-3.534 3.125a1.8 1.8 0 0 0-.398.511l-2.194 4.218a1.73 1.73 0 0 1-1.858.915l-4.593-.877a1.7 1.7 0 0 0-.64 0l-4.593.877a1.73 1.73 0 0 1-1.858-.915l-2.194-4.218a1.8 1.8 0 0 0-.398-.51L3.103 20.7a1.81 1.81 0 0 1-.46-2.056l1.858-4.382c.086-.202.134-.418.143-.638l.186-4.773a1.77 1.77 0 0 1 1.286-1.648l4.51-1.248c.208-.057.403-.154.576-.284z",
        fill: "#fff"
      }), /* @__PURE__ */jsx("path", {
        d: "M13.89 14.613V9.977l4.223.006v4.63h4.637l-.01 4.222h-4.627v4.64H13.89v-4.64H9.25v-4.222z",
        fill: "#750046"
      })]
    }))
  }, props));
}

__name(PlusIcon, "PlusIcon");

function PlusBadgeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M14.553 9.873c.592-.85 1.233-1.243 2.134-1.243 1.358 0 2.262 1.002 2.267 2.236.004 1.057-.496 1.745-1.547 2.422l-6.597 4.244-6.597-4.244c-1.05-.677-1.55-1.365-1.546-2.422.004-1.234.909-2.236 2.267-2.236.9 0 1.542.392 2.134 1.243l1.706 2.448V5.333h4.072v6.988zM17.936 25.665c.008-4.194-3.206-7.116-7.127-7.116s-7.133 2.924-7.125 7.116z",
        fill: "#750046"
      }), /* @__PURE__ */jsx("path", {
        d: "M29.333 15.879H25.03v-4.297h-3.462v4.297h-4.302v3.425h4.302v4.297h3.462v-4.297h4.302z",
        fill: "#EC269A"
      })]
    }))
  }, props));
}

__name(PlusBadgeIcon, "PlusBadgeIcon");

function PlusBadgeGrayscale80Icon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M14.342 9.873c.593-.85 1.234-1.242 2.135-1.242 1.358 0 2.262 1.001 2.267 2.235.004 1.057-.496 1.745-1.547 2.422L10.6 17.532l-6.597-4.244c-1.05-.677-1.55-1.365-1.546-2.422.004-1.234.909-2.235 2.267-2.235.9 0 1.542.391 2.134 1.242l1.706 2.448V5.333h4.072v6.988zM17.726 25.665c.008-4.194-3.206-7.116-7.127-7.116s-7.133 2.924-7.125 7.116zM29.123 15.879H24.82v-4.297h-3.462v4.297h-4.302v3.425h4.302v4.297h3.462v-4.297h4.302z",
        fill: "#242529"
      })
    }))
  }, props));
}

__name(PlusBadgeGrayscale80Icon, "PlusBadgeGrayscale80Icon");

function PrescriptionIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.541 2.148A5.7 5.7 0 0 0 16.247 2c-1.47 0-2.95.56-4.07 1.69l-8.49 8.485a5.747 5.747 0 0 0 0 8.136A5.76 5.76 0 0 0 7.758 22c1.47 0 2.95-.56 4.07-1.69l4.246-4.242.005.005 4.24-4.248a5.71 5.71 0 0 0 1.687-4.066 5.73 5.73 0 0 0-1.687-4.07l-.004-.003a5.7 5.7 0 0 0-2.773-1.538m-2.879 12.51-4.244 4.243c-.71.71-1.65 1.1-2.66 1.1s-1.95-.39-2.66-1.1-1.1-1.649-1.1-2.658c0-1.01.39-1.95 1.1-2.659l4.244-4.243z"
      })
    }))
  }, props));
}

__name(PrescriptionIcon, "PrescriptionIcon");

function PrivacyOptOutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      id: "prefix__Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: 0,
      y: 0,
      viewBox: "0 0 30 14",
      xmlSpace: "preserve",
      width: "1em",
      height: "1em"
    }, props), {
      children: [/* @__PURE__ */jsx("g", {
        id: "prefix__final---dec.11-2020_1_",
        children: /* @__PURE__ */jsx("g", {
          id: "prefix___x30_208-our-toggle_2_",
          transform: "translate(-1275 -200)",
          children: /* @__PURE__ */jsx("path", {
            d: "M7.4 12.8h6.8l3.1-11.6H7.4C4.2 1.2 1.6 3.8 1.6 7s2.6 5.8 5.8 5.8",
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#fff"
            },
            transform: "translate(1275 200)",
            id: "prefix__Final-Copy-2_2_"
          })
        })
      }), /* @__PURE__ */jsx("g", {
        id: "prefix__final---dec.11-2020",
        children: /* @__PURE__ */jsx("g", {
          id: "prefix___x30_208-our-toggle",
          transform: "translate(-1275 -200)",
          children: /* @__PURE__ */jsxs("g", {
            id: "prefix__Final-Copy-2",
            transform: "translate(1275 200)",
            children: [/* @__PURE__ */jsx("path", {
              d: "M22.6 0H7.4c-3.9 0-7 3.1-7 7s3.1 7 7 7h15.2c3.9 0 7-3.1 7-7s-3.2-7-7-7m-21 7c0-3.2 2.6-5.8 5.8-5.8h9.9l-3.1 11.6H7.4c-3.2 0-5.8-2.6-5.8-5.8",
              style: {
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "#06f"
              }
            }), /* @__PURE__ */jsx("path", {
              id: "prefix__x",
              d: "M24.6 4c.2.2.2.6 0 .8L22.5 7l2.2 2.2c.2.2.2.6 0 .8s-.6.2-.8 0l-2.2-2.2-2.2 2.2c-.2.2-.6.2-.8 0s-.2-.6 0-.8L20.8 7l-2.2-2.2c-.2-.2-.2-.6 0-.8s.6-.2.8 0l2.2 2.2L23.8 4c.2-.2.6-.2.8 0",
              style: {
                fill: "#fff"
              }
            }), /* @__PURE__ */jsx("path", {
              id: "prefix__y",
              d: "M12.7 4.1c.2.2.3.6.1.8L8.6 9.8c-.1.1-.2.2-.3.2-.2.1-.5.1-.7-.1L5.4 7.7c-.2-.2-.2-.6 0-.8s.6-.2.8 0L8 8.6l3.8-4.5c.2-.2.6-.2.9 0",
              style: {
                fill: "#06f"
              }
            })]
          })
        })
      })]
    }))
  }, props));
}

__name(PrivacyOptOutIcon, "PrivacyOptOutIcon");

function ProbioticIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m4.835 12.717 7.882-7.882a4.56 4.56 0 0 1 6.448 6.449l-7.881 7.88a4.56 4.56 0 0 1-6.449-6.448m6.076-1.802 2.178 2.182 3.954-3.935a1.56 1.56 0 1 0-2.205-2.205z"
      })
    }))
  }, props));
}

__name(ProbioticIcon, "ProbioticIcon");

function PromotionIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13 21 8-8L11 3H6L3 6v5zM8.5 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
      })
    }))
  }, props));
}

__name(PromotionIcon, "PromotionIcon");

function PromotionOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M8.5 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m21 13-8 8L3 11V6l3-3h5zM5 6.828v3.344l8 8L18.172 13l-8-8H6.828z"
      })]
    }))
  }, props));
}

__name(PromotionOutlineIcon, "PromotionOutlineIcon");

function Prop65Icon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M2.691 21h19.114a.691.691 0 0 0 .599-1.039l-9.557-16.58a.691.691 0 0 0-1.197 0l-9.557 16.58A.693.693 0 0 0 2.69 21",
        fill: "#000"
      }), /* @__PURE__ */jsx("path", {
        d: "m12.309 5.085 8.38 14.468H3.928z",
        fill: "#FF0"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.249 18.347c.532 0 .964-.405.964-.904 0-.5-.432-.904-.964-.904-.533 0-.965.404-.965.904s.432.904.965.904M12.857 15.427l.71-6.266a1.27 1.27 0 0 0-.668-1.258 1.36 1.36 0 0 0-1.457.1c-.422.312-.61.838-.478 1.336l.738 6.219c.023.2.156.372.347.452s.411.055.578-.065a.56.56 0 0 0 .23-.518",
        fill: "#000"
      })]
    }))
  }, props));
}

__name(Prop65Icon, "Prop65Icon");

function QRIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 11V3h8v8zm2-6h4v4H5zM3 21v-8h8v8zm2-6h4v4H5zM13 3v8h8V3zm6 2h-4v4h4z"
      }), /* @__PURE__ */jsx("path", {
        d: "M16 13h-3v3h3v2h-3v3h3v-3h2v3h3v-3h-3v-2h3v-3h-3v3h-2z"
      })]
    }))
  }, props));
}

__name(QRIcon, "QRIcon");

function RadioDisabledSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-10 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(RadioDisabledSelectedIcon, "RadioDisabledSelectedIcon");

var RadioDisabledSelectedIcon_default = RadioDisabledSelectedIcon;

function RadioDisabledUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(RadioDisabledUnselectedIcon, "RadioDisabledUnselectedIcon");

var RadioDisabledUnselectedIcon_default = RadioDisabledUnselectedIcon;

function RadioSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-10 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
      })
    }))
  }, props));
}

__name(RadioSelectedIcon, "RadioSelectedIcon");

var RadioSelectedIcon_default = RadioSelectedIcon;

function RadioUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
        fill: "#72767E"
      })
    }))
  }, props));
}

__name(RadioUnselectedIcon, "RadioUnselectedIcon");

var RadioUnselectedIcon_default = RadioUnselectedIcon;

function RatingIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m12 2.488 3.11 6.23L22 9.758l-4.96 4.89 1.14 6.86-6.18-3.2-6.18 3.2 1.14-6.86L2 9.758l6.88-1.04z"
      })
    }))
  }, props));
}

__name(RatingIcon, "RatingIcon");

function RatingEmptyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.11 8.718 12 2.488l-3.12 6.23L2 9.758l4.96 4.89-1.14 6.86 6.18-3.2 6.18 3.2-1.14-6.86L22 9.758zm2.64 2.422-3.966-.6-1.787-3.58-1.793 3.58-3.955.599 2.854 2.814-.655 3.942L12 16.056l3.552 1.84-.655-3.943z"
      })
    }))
  }, props));
}

__name(RatingEmptyIcon, "RatingEmptyIcon");

function RatingPartialIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 2.488 3.11 6.23L22 9.758l-4.96 4.89 1.14 6.86-6.18-3.2-6.18 3.2 1.14-6.86L2 9.758l6.88-1.04zm1.784 8.053 3.966.598-2.392 2.36H8.642l-2.393-2.36 3.955-.598 1.793-3.58z"
      })
    }))
  }, props));
}

__name(RatingPartialIcon, "RatingPartialIcon");

function ReadyMealsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M17.504 6.802a.375.375 0 0 1-.75 0V3.25a.75.75 0 0 0-1.5 0v3.552a.375.375 0 0 1-.75 0V3.25a.75.75 0 0 0-1.5 0v5.822a2 2 0 0 0 1.957 2l-.457 8.844h.003l-.003.084a1.5 1.5 0 1 0 2.998-.084h.002l-.457-8.845a2 2 0 0 0 1.957-2V3.203a.75.75 0 0 0-1.5 0zM9.032 10.859C12.81 9.778 10.405 2.5 8 2.5s-4.81 7.278-1.032 8.359L6.5 19.916h.002L6.5 20a1.5 1.5 0 1 0 2.998-.084H9.5z"
      })
    }))
  }, props));
}

__name(ReadyMealsIcon, "ReadyMealsIcon");

function ReadyMealsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.87 7.45v.61h-1.75v-.61c0-1-.35-2-.97-2.79A6.34 6.34 0 0 1 8.81.78V0h1.75v.78c0 1.01.35 2 .97 2.79a6.36 6.36 0 0 1 1.34 3.88"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 9.5h17.5l1.91 7.62H24v1.75h-1.67l-1.58 5.12H3.25l-1.58-5.12H0v-1.75h1.34zm16.14 1.75H4.63l-1.47 5.88h5.85v-.62c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v.62h5.85zm-14.85 11h14.91l1.04-3.38H3.5z"
      }), /* @__PURE__ */jsx("path", {
        d: "M3.95 2.03c.2.95.6 1.86 1.2 2.63.62.79.97 1.79.97 2.79h1.75c0-1.4-.48-2.77-1.34-3.88a4.5 4.5 0 0 1-.78-1.55h-1.8zM15.15 4.66c-.6-.77-1-1.68-1.2-2.63v-.01h1.8c.16.56.42 1.09.78 1.55a6.36 6.36 0 0 1 1.34 3.88h-1.75c0-1-.35-2-.97-2.79"
      })]
    }))
  }, props));
}

__name(ReadyMealsCategoryIcon, "ReadyMealsCategoryIcon");

function ReadyMealsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12.87 7.45v.61h-1.75v-.61c0-1-.35-2-.97-2.79A6.34 6.34 0 0 1 8.81.78V0h1.75v.78c0 1.01.35 2 .97 2.79a6.36 6.36 0 0 1 1.34 3.88M24 18v-.88h-1.34L20.75 9.5H3.25l-1.91 7.62H0v1.75h9v-2.38c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2.38h8.99v-.88zM21.78 20.63H2.21L3.25 24h17.5zM3.95 2.03c.2.95.6 1.86 1.2 2.63.62.79.97 1.79.97 2.79h1.75c0-1.4-.48-2.77-1.34-3.88a4.5 4.5 0 0 1-.78-1.55h-1.8zM15.15 4.66c-.6-.77-1-1.68-1.2-2.63v-.01h1.8c.16.56.42 1.09.78 1.55a6.36 6.36 0 0 1 1.34 3.88h-1.75c0-1-.35-2-.97-2.79"
      })
    }))
  }, props));
}

__name(ReadyMealsCategoryFilledIcon, "ReadyMealsCategoryFilledIcon");

function ReceiptIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 3H5v18h1l2-2 2 2 2-2 2 2 2-2 2 2h1V3h-1l-2 2-2-2-2 2-2-2-2 2zm7 7V8H7v2zm4 0V8h-2v2zm-4 5v-2H7v2zm4 0v-2h-2v2z"
      })
    }))
  }, props));
}

__name(ReceiptIcon, "ReceiptIcon");

function RecipesIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M17 3v8l-3-3-3 3V3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14v-2H6a1 1 0 1 1 0-2h15V3z"
      })
    }))
  }, props));
}

__name(RecipesIcon, "RecipesIcon");

function RecipesOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 3v14H6a1 1 0 1 0 0 2h14v2H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zM5 6a1 1 0 0 1 1-1h5v6l3-3 3 3V5h2v10H6c-.35 0-.687.06-1 .17z"
      })
    }))
  }, props));
}

__name(RecipesOutlineIcon, "RecipesOutlineIcon");

function RecurringIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 3h2v2h3v3H3V5h3V3h2v2h8zM3 10h18v11H3zm9 7.569a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      })
    }))
  }, props));
}

__name(RecurringIcon, "RecurringIcon");

function RedWineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.002 2H6.998l-.956 7.18C5.66 12.041 7.923 14.585 11 14.954V20l-4 1v1h10v-1l-4-1v-5.046c3.077-.369 5.34-2.913 4.958-5.773z"
      })
    }))
  }, props));
}

__name(RedWineIcon, "RedWineIcon");

function RefreshIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20 4v6h-6l2.243-2.243a6 6 0 1 0 1.395 6.295l1.88.684a8 8 0 1 1-1.861-8.393z"
      })
    }))
  }, props));
}

__name(RefreshIcon, "RefreshIcon");

function RefundIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M7.631 18.702a8 8 0 0 1-3.149-3.966l1.88-.684a6 6 0 1 0 1.395-6.295L10 10H4V4l2.343 2.343a8 8 0 1 1 1.288 12.359"
      })
    }))
  }, props));
}

__name(RefundIcon, "RefundIcon");

function RemoveIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M7.757 9.172l1.415-1.415L12 10.586l2.829-2.829 1.414 1.415L13.414 12l2.829 2.828-1.414 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12z"
      })
    }))
  }, props));
}

__name(RemoveIcon, "RemoveIcon");

var RemoveIcon_default = RemoveIcon;

function ReplaceIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19.518 9.264a8 8 0 0 0-13.175-2.92L4 4v6h6L7.757 7.757a6 6 0 0 1 9.881 2.19zM16.243 16.243 14 14h6v6l-2.343-2.343a8 8 0 0 1-13.175-2.92l1.88-.685a6 6 0 0 0 9.88 2.19"
      })
    }))
  }, props));
}

__name(ReplaceIcon, "ReplaceIcon");

function RestaurantCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.63.993 17.189 0l-1.896 2.75c-.844-.626-1.928-.989-3.08-.989-1.565 0-2.996.666-3.88 1.75-2.606.127-5.152 1.997-5.695 4.565L0 15h2.333l1.19-3.123L5.158 24h13.684l1.635-12.123L21.667 15H24l-2.661-6.986A5 5 0 0 0 19.952 5.5l2.191-1.557-1.014-1.427-2.684 1.908a6 6 0 0 0-1.798-.553zM19.517 8a3.5 3.5 0 0 0-1.02-1.465L16.434 8zM4.483 8c.57-1.534 2.274-2.746 4.134-2.746q.07 0 .14.002l.498.015.267-.42c.482-.761 1.476-1.34 2.69-1.34 1.335 0 2.394.696 2.815 1.56l.24.492h.546q.469.001.898.094L13.414 8zm2.205 14.25L5.002 9.75h13.996l-1.686 12.5z"
      })
    }))
  }, props));
}

__name(RestaurantCategoryIcon, "RestaurantCategoryIcon");

function RestaurantCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.63.993 17.189 0l-1.896 2.75c-.844-.626-1.928-.989-3.08-.989-1.565 0-2.996.666-3.88 1.75-2.606.127-5.152 1.997-5.695 4.565L0 15h2.333l1.19-3.123L5.158 24h13.684l1.635-12.123L21.667 15H24l-2.661-6.986A5 5 0 0 0 19.952 5.5l2.191-1.557-1.014-1.427-2.684 1.908a6 6 0 0 0-1.798-.553zM19.517 8a3.5 3.5 0 0 0-1.02-1.465L16.434 8zM4.483 8c.57-1.534 2.274-2.746 4.134-2.746q.07 0 .14.002l.498.015.267-.42c.482-.761 1.476-1.34 2.69-1.34 1.335 0 2.394.696 2.815 1.56l.24.492h.546q.469.001.898.094L13.414 8z"
      })
    }))
  }, props));
}

__name(RestaurantCategoryFilledIcon, "RestaurantCategoryFilledIcon");

function RestaurantDinnerCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M7.911 8.936a2.056 2.056 0 1 1 3.041 2.766 2.056 2.056 0 0 1-3.041-2.766"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.255 16.177 3.77 22.89c-1.577.684-3.225-.809-2.7-2.446L6.255 4.276c-.4-.611-.486-1.4-.128-2.091l.364-.7C6.937.625 7.938.2 8.842.547a26 26 0 0 1 14.02 12.77c.434.877.093 1.924-.738 2.441l-.69.43c-.689.43-1.525.385-2.18-.011M17 13.357c.297.483.578.987.85 1.521l-5.317 2.305a2.233 2.233 0 1 0-3.473 1.506l-5.987 2.595a.23.23 0 0 1-.14.023.27.27 0 0 1-.127-.067.27.27 0 0 1-.079-.12.23.23 0 0 1 .009-.141l.75-2.34a1.92 1.92 0 1 0 1.14-3.555l3.12-9.73a26 26 0 0 1 7.015 5.152 1.86 1.86 0 1 0 2.239 2.852m.093-2.892a28 28 0 0 1 2.9 4.045.48.48 0 0 0 .28.219.28.28 0 0 0 .234-.025l.69-.43a.22.22 0 0 0 .098-.12.1.1 0 0 0 .005-.037.1.1 0 0 0-.007-.026A24.25 24.25 0 0 0 8.217 2.181a.1.1 0 0 0-.026-.004.1.1 0 0 0-.038.008.22.22 0 0 0-.11.106l-.363.7a.28.28 0 0 0-.006.238c.031.083.09.162.17.22q.23.091.454.188c2.449 1.06 4.424 2.525 6.528 4.442.87.794 1.613 1.576 2.268 2.386"
      })]
    }))
  }, props));
}

__name(RestaurantDinnerCategoryIcon, "RestaurantDinnerCategoryIcon");

function RestaurantDinnerCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.07 20.444 6.163 4.563a29.9 29.9 0 0 1 8.465 6.013 1.86 1.86 0 1 0 2.4 2.748 30 30 0 0 1 2.004 2.949L3.77 22.89c-1.577.684-3.225-.809-2.7-2.446m2.88-4.488a1.507 1.507 0 1 1 2.23 2.03 1.507 1.507 0 0 1-2.23-2.03m4.939-.844a1.915 1.915 0 1 1 2.832 2.577 1.915 1.915 0 0 1-2.832-2.577m1.926-6.314a2.056 2.056 0 1 0-2.767 3.042 2.056 2.056 0 0 0 2.767-3.042"
      }), /* @__PURE__ */jsx("path", {
        d: "M20.815 15.855A31.7 31.7 0 0 0 6.399 2.743a.44.44 0 0 1-.226-.233.27.27 0 0 1-.002-.225L7.019.423a.22.22 0 0 1 .105-.111.1.1 0 0 1 .032-.009q.004-.001.02.005c3.334 1.313 6.508 3.456 9.198 5.908 2.665 2.43 4.959 5.45 6.55 8.703a.1.1 0 0 1 .01.03q.002.012-.007.04a.22.22 0 0 1-.099.12l-1.525.929a.27.27 0 0 1-.228.023.44.44 0 0 1-.26-.206"
      })]
    }))
  }, props));
}

__name(RestaurantDinnerCategoryFilledIcon, "RestaurantDinnerCategoryFilledIcon");

function RestaurantLunchCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.046 2.75C7.86 2.75 5.27 4.104 3.65 6.013 2.073 7.871 1.516 10.15 1.148 11.77a2.87 2.87 0 0 0-1.023 2.2v1.062c0 .628.201 1.208.542 1.681a1.875 1.875 0 0 0 .458 2.978v.435A3.875 3.875 0 0 0 5 24h14a3.875 3.875 0 0 0 3.875-3.875v-.435a1.875 1.875 0 0 0 .458-2.978 2.86 2.86 0 0 0 .542-1.68v-1.064c0-.88-.396-1.67-1.02-2.197-.27-1.656-.807-3.911-2.378-5.759-1.625-1.91-4.247-3.262-8.43-3.262M2.997 12.843h3.205l4.243 3.313H3a1.125 1.125 0 0 1-1.125-1.125v-1.063c0-.62.502-1.123 1.122-1.125m10.728 3.313 4.08-3.313h3.198c.62.002 1.122.505 1.122 1.125v1.063c0 .622-.504 1.125-1.125 1.125zm7.22-5.063c-.292-1.332-.796-2.764-1.802-3.947-.682-.803-1.629-1.528-2.978-2.015l-2.743 3.232-1.335-1.133 2.183-2.57a14.6 14.6 0 0 0-2.381-.16l.024.02L8.65 8.364 7.317 7.23l2.127-2.505c-2.18.412-3.549 1.346-4.46 2.42-1.001 1.18-1.517 2.603-1.872 3.948zM9.087 12.875l3.01 2.35 2.894-2.35zm-6.211 7.25v-.219h18.25v.219A2.125 2.125 0 0 1 19 22.25H5a2.125 2.125 0 0 1-2.125-2.125"
      })
    }))
  }, props));
}

__name(RestaurantLunchCategoryIcon, "RestaurantLunchCategoryIcon");

function RestaurantLunchCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.567 3.131-3.48 4.1 1.335 1.132 3.938-4.639c1.314.573 2.331 1.365 3.117 2.288 1.571 1.848 2.107 4.103 2.378 5.76a2.87 2.87 0 0 1 1.02 2.196v1.063c0 .628-.201 1.208-.542 1.681a1.875 1.875 0 0 1-.458 2.978v.03H1.125v-.03a1.875 1.875 0 0 1-.458-2.978 2.86 2.86 0 0 1-.542-1.68v-1.064c0-.882.397-1.671 1.023-2.199.368-1.619.925-3.898 2.502-5.756 1.494-1.761 3.813-3.05 7.45-3.239L7.317 7.23 8.65 8.363l4.724-5.565q1.188.091 2.192.333m5.436 9.712h-3.198l-4.08 3.313H21c.621 0 1.125-.503 1.125-1.125v-1.063c0-.62-.502-1.123-1.122-1.125m-14.8 0H2.996a1.125 1.125 0 0 0-1.122 1.125v1.063c0 .622.504 1.125 1.125 1.125h7.445zm5.893 2.382-3.01-2.35h5.904z"
      }), /* @__PURE__ */jsx("path", {
        d: "M1.365 21.47h21.27A3.88 3.88 0 0 1 19 24H5a3.88 3.88 0 0 1-3.635-2.53"
      })]
    }))
  }, props));
}

__name(RestaurantLunchCategoryFilledIcon, "RestaurantLunchCategoryFilledIcon");

function RetailCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("g", {
        clipPath: "url(#prefix__clip0_4323_32025)",
        children: /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 6V4a4 4 0 1 1 8 0v2h4l.222 4h5.611L24 24H0L1 6zm13.25 5.75h-2.5V14a1.25 1.25 0 1 0 2.5 0zm-4.25 0V14a3 3 0 1 0 6 0v-2.25h1.223l.875 10.5H11.902l.875-10.5zM15.47 10l-.126-2.25H2.656L2.086 18H10.5l.667-8zm-4.22-6v2h-4.5V4a2.25 2.25 0 0 1 4.5 0"
        })
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_4323_32025",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(RetailCategoryIcon, "RetailCategoryIcon");

function RetailCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_4323_32026)",
        children: [/* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13 6h4l.125 2.25H9.556L8.744 18H2.086l-.236 4.25h6.54L8.244 24H0L1 6h4V4a4 4 0 1 1 8 0zm-1.75 0V4a2.25 2.25 0 0 0-4.5 0v2z"
        }), /* @__PURE__ */jsx("path", {
          d: "M15.75 10v4a1.25 1.25 0 1 0 2.5 0v-4z"
        }), /* @__PURE__ */jsx("path", {
          d: "M20 14v-4h2.833L24 24H10l1.167-14H14v4a3 3 0 1 0 6 0"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_4323_32026",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(RetailCategoryFilledIcon, "RetailCategoryFilledIcon");

function ReturnIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M8.243 3.758 4 8l4.243 4.243V9H14.5a3.5 3.5 0 0 1 0 7H6v2h8.5a5.5 5.5 0 0 0 0-11H8.243z"
      })
    }))
  }, props));
}

__name(ReturnIcon, "ReturnIcon");

function RouteIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m10.77 13.154-6.274-2.241c-1.35-.482-1.32-2.402.045-2.84l14-4.5c1.184-.381 2.29.76 1.872 1.932l-5 14c-.49 1.373-2.455 1.31-2.855-.093z"
      })
    }))
  }, props));
}

__name(RouteIcon, "RouteIcon");

function SafetyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2c-2 2-5 4-9 4 0 12 5 15 9 16 4-1 9-4 9-16-4 0-7-2-9-4m-1 9V7h2v4h4v2h-4v4h-2v-4H7v-2z"
      })
    }))
  }, props));
}

__name(SafetyIcon, "SafetyIcon");

function SaveIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19 3H5v18h1.5l5.5-4.91L17.5 21H19z"
      })
    }))
  }, props));
}

__name(SaveIcon, "SaveIcon");

function SaveDarkSelectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.163 3.819C5 4.139 5 4.559 5 5.4v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V5.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C17.861 3 17.441 3 16.6 3H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 5v14.117c0 .254 0 .465.002.644q.238-.117.577-.287l2.811-1.405.051-.026c.187-.095.573-.292 1.006-.373a3 3 0 0 1 1.106 0c.433.08.82.278 1.006.373l.051.026 2.811 1.406.577.286c.002-.179.002-.39.002-.644V5H7M5.164 3.82C5 4.139 5 4.559 5 5.4v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V5.4c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656C17.861 3 17.441 3 16.6 3H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(SaveDarkSelectedIcon, "SaveDarkSelectedIcon");

function SaveDarkSelectedDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.163 3.319C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#C7C8CD"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4.5v14.117c0 .254 0 .465.002.644q.238-.117.577-.287l2.811-1.405.051-.026c.187-.095.573-.292 1.006-.373a3 3 0 0 1 1.106 0c.433.08.82.278 1.006.373l.051.026 2.811 1.406.577.286c.002-.179.002-.39.002-.644V4.5H7M5.164 3.32C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(SaveDarkSelectedDisabledIcon, "SaveDarkSelectedDisabledIcon");

function SaveDarkUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.163 3.319C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#343538",
        fillOpacity: 0.8
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4.5v14.117c0 .254 0 .465.002.644q.238-.117.577-.287l2.811-1.405.051-.026c.187-.095.573-.292 1.006-.373a3 3 0 0 1 1.106 0c.433.08.82.278 1.006.373l.051.026 2.811 1.406.577.286c.002-.179.002-.39.002-.644V4.5H7M5.164 3.32C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(SaveDarkUnselectedIcon, "SaveDarkUnselectedIcon");

function SaveDarkUnselectedDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4.5v14.117c0 .254 0 .465.002.644q.238-.117.577-.287l2.811-1.405.051-.026c.187-.095.573-.292 1.006-.373a3 3 0 0 1 1.106 0c.433.08.82.278 1.006.373l.051.026 2.811 1.406.577.286c.002-.179.002-.39.002-.644V4.5H7M5.164 3.32C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(SaveDarkUnselectedDisabledIcon, "SaveDarkUnselectedDisabledIcon");

function SaveOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 13.409 5 4.464V5H7v12.873zM6.5 21H5V3h14v18h-1.5L12 16.09z"
      })
    }))
  }, props));
}

__name(SaveOutlineIcon, "SaveOutlineIcon");

function SaveSelectedDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.163 3.319C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(SaveSelectedDisabledIcon, "SaveSelectedDisabledIcon");

function SaveUnselectedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4.5v14.117c0 .254 0 .465.002.644q.238-.117.577-.287l2.811-1.405.051-.026c.187-.095.573-.292 1.006-.373a3 3 0 0 1 1.106 0c.433.08.82.278 1.006.373l.051.026 2.811 1.406.577.286c.002-.179.002-.39.002-.644V4.5H7M5.164 3.32C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656"
      })
    }))
  }, props));
}

__name(SaveUnselectedIcon, "SaveUnselectedIcon");

function SaveUnselectedDisabledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4.5v14.117c0 .254 0 .465.002.644q.238-.117.577-.287l2.811-1.405.051-.026c.187-.095.573-.292 1.006-.373a3 3 0 0 1 1.106 0c.433.08.82.278 1.006.373l.051.026 2.811 1.406.577.286c.002-.179.002-.39.002-.644V4.5H7M5.164 3.32C5 3.639 5 4.059 5 4.9v13.717c0 1.285 0 1.928.27 2.316a1.5 1.5 0 0 0 1.01.624c.468.069 1.043-.219 2.193-.794l2.811-1.405c.263-.131.394-.197.532-.223a1 1 0 0 1 .368 0c.138.026.27.092.532.223l2.81 1.405c1.15.575 1.726.863 2.193.794a1.5 1.5 0 0 0 1.01-.624c.271-.387.271-1.03.271-2.316V4.9c0-.84 0-1.26-.163-1.581a1.5 1.5 0 0 0-.656-.656c-.32-.163-.74-.163-1.581-.163H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656",
        fill: "#C7C8CD"
      })
    }))
  }, props));
}

__name(SaveUnselectedDisabledIcon, "SaveUnselectedDisabledIcon");

function ScaleIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 3v3h12V3h2v5H4V3zm-.882 7h13.764L20 21H4zM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      })
    }))
  }, props));
}

__name(ScaleIcon, "ScaleIcon");

function ScanIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M9 3H3v6h2V5h4z"
      }), /* @__PURE__ */jsx("path", {
        d: "M7 7h2v10H7zM11 7h1v10h-1zM17 7h-3v10h3z"
      }), /* @__PURE__ */jsx("path", {
        d: "M3 15h2v4h4v2H3zM21 15h-2v4h-4v2h6zM15 3h6v6h-2V5h-4z"
      })]
    }))
  }, props));
}

__name(ScanIcon, "ScanIcon");

function ScooterIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12.73 4h1.73c.935 0 1.788.38 2.41 1H20c0 .525-.078 1.045-.228 1.53s-.372.927-.65 1.298c-.276.367-.601.659-.96.86l.364 2.075q.019.113.034.225l.347 2.035a3.5 3.5 0 1 1-3.762 4.477h-6.29A3.502 3.502 0 0 1 2 16.5 3.5 3.5 0 0 1 5.5 13v-3h6.3c.87 0 1.52.81 1.32 1.66l-.88 3.84h.68c2.215 0 3.94-1.98 3.661-4.216l-.04-.236h.004l-.67-3.829C15.747 6.5 15.141 6 14.46 6h-1.73z"
      })
    }))
  }, props));
}

__name(ScooterIcon, "ScooterIcon");

function SearchIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.496 17.618a8 8 0 1 1 2.121-2.121l3.944 3.942-2.122 2.122zM17 11a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
      })
    }))
  }, props));
}

__name(SearchIcon, "SearchIcon");

var SearchIcon_default = SearchIcon;

function SendIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m4.242 13.838 5.637-1.833-5.637-1.833L2 3.5l20 8.505L2 20.5z"
      })
    }))
  }, props));
}

__name(SendIcon, "SendIcon");

function ShareIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.116.855a1.25 1.25 0 0 1 1.768 0l3.5 3.5a1.25 1.25 0 0 1-1.768 1.768L13.25 4.757v10.982a1.25 1.25 0 0 1-2.5 0V4.757L9.384 6.123a1.25 1.25 0 1 1-1.768-1.768z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 9.739c0-.69.56-1.25 1.25-1.25H7a1.25 1.25 0 1 1 0 2.5H5.75v10h12.5v-10H17a1.25 1.25 0 0 1 0-2.5h2.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25z"
      })]
    }))
  }, props));
}

__name(ShareIcon, "ShareIcon");

function ShareAndroidIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M18 9a3 3 0 1 0-2.977-2.63l-6.94 3.47a3 3 0 1 0 0 4.319l6.94 3.47a3 3 0 1 0 .895-1.789l-6.94-3.47a3 3 0 0 0 0-.74l6.94-3.47C16.456 8.68 17.19 9 18 9"
      })
    }))
  }, props));
}

__name(ShareAndroidIcon, "ShareAndroidIcon");

function ShareiOSIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M7.75 6 12 2l4.25 4H13v11h-2V6z"
      }), /* @__PURE__ */jsx("path", {
        d: "M9 8H4v13h16V8h-5v2h3v9H6v-9h3z"
      })]
    }))
  }, props));
}

__name(ShareiOSIcon, "ShareiOSIcon");

function ShellfishIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M3.335 11.122a1.25 1.25 0 0 1-.236-1.335c3.275-7.714 14.496-7.714 17.8-.013.197.459.101.99-.244 1.353l-5.728 6.032.707 1.493c.297.628-.168 1.348-.871 1.348H9.252c-.698 0-1.163-.709-.877-1.336l.688-1.505z"
      })
    }))
  }, props));
}

__name(ShellfishIcon, "ShellfishIcon");

function ShellfishFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m3.642-5.011a8.095 8.095 0 0 0 11.37 11.37l-2.659-2.66-.154.167.531 1.147a.727.727 0 0 1-.654 1.035h-4.14a.727.727 0 0 1-.66-1.026l.517-1.156L5.49 11.23a.97.97 0 0 1-.178-1.025c.35-.843.821-1.566 1.379-2.168zm1.347-1.347L8.17 6.824c3.524-2.155 8.667-1.03 10.515 3.372a.97.97 0 0 1-.183 1.038l-2.853 3.07 2.708 2.707a8.095 8.095 0 0 0-11.37-11.37"
      })
    }))
  }, props));
}

__name(ShellfishFreeIcon, "ShellfishFreeIcon");

function ShopperOrderAIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#E97300"
      }), /* @__PURE__ */jsx("path", {
        d: "m9.138 17 .645-1.83h4.38l.645 1.83h2.355L13.158 6.35h-2.31L6.843 17zm2.85-7.95 1.47 4.155h-2.97l1.47-4.155z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderAIcon, "ShopperOrderAIcon");

function ShopperOrderALargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#E97300"
      }), /* @__PURE__ */jsx("path", {
        d: "m16.184 26.667.86-2.44h5.84l.86 2.44h3.14l-5.34-14.2h-3.08l-5.34 14.2zm3.8-10.6 1.96 5.54h-3.96l1.96-5.54z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderALargeIcon, "ShopperOrderALargeIcon");

function ShopperOrderBIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#6A6AD7"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.832 17c2.31 0 3.495-1.185 3.495-3.015 0-1.14-.66-1.98-1.635-2.355.915-.405 1.485-1.245 1.485-2.355 0-1.62-1.095-2.925-3.54-2.925h-4.5V17zm-.06-4.395c.93 0 1.35.495 1.35 1.215 0 .75-.42 1.215-1.35 1.215h-2.505v-2.43zm-.15-4.29c.96 0 1.35.525 1.35 1.155 0 .765-.51 1.155-1.35 1.155h-2.355v-2.31z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderBIcon, "ShopperOrderBIcon");

function ShopperOrderBLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#6A6AD7"
      }), /* @__PURE__ */jsx("path", {
        d: "M21.11 26.667c3.08 0 4.66-1.58 4.66-4.02 0-1.52-.88-2.64-2.18-3.14 1.22-.54 1.98-1.66 1.98-3.14 0-2.16-1.46-3.9-4.72-3.9h-6v14.2zm-.08-5.86c1.24 0 1.8.66 1.8 1.62 0 1-.56 1.62-1.8 1.62h-3.34v-3.24zm-.2-5.72c1.28 0 1.8.7 1.8 1.54 0 1.02-.68 1.54-1.8 1.54h-3.14v-3.08z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderBLargeIcon, "ShopperOrderBLargeIcon");

function ShopperOrderCIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#14A4A4"
      }), /* @__PURE__ */jsx("path", {
        d: "M6.793 11.66c0 3.33 2.295 5.535 5.355 5.535 2.655 0 4.755-1.575 5.16-4.17h-2.34c-.315 1.335-1.395 2.085-2.82 2.085-1.95 0-3.045-1.35-3.045-3.45s1.095-3.45 3.045-3.45c1.425 0 2.505.75 2.82 2.085h2.34c-.405-2.595-2.505-4.17-5.16-4.17-3.06 0-5.355 2.205-5.355 5.535",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderCIcon, "ShopperOrderCIcon");

function ShopperOrderCLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#14A4A4"
      }), /* @__PURE__ */jsx("path", {
        d: "M13.057 19.547c0 4.44 3.06 7.38 7.14 7.38 3.54 0 6.34-2.1 6.88-5.56h-3.12c-.42 1.78-1.86 2.78-3.76 2.78-2.6 0-4.06-1.8-4.06-4.6s1.46-4.6 4.06-4.6c1.9 0 3.34 1 3.76 2.78h3.12c-.54-3.46-3.34-5.56-6.88-5.56-4.08 0-7.14 2.94-7.14 7.38",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderCLargeIcon, "ShopperOrderCLargeIcon");

function ShopperOrderDIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#78523D"
      }), /* @__PURE__ */jsx("path", {
        d: "M11.354 17c3.63 0 5.61-2.235 5.61-5.325s-1.98-5.325-5.61-5.325H7.53V17zm3.3-5.325c0 1.995-1.035 3.315-3.36 3.315H9.72V8.36h1.575c2.325 0 3.36 1.32 3.36 3.315",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderDIcon, "ShopperOrderDIcon");

function ShopperOrderDLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#78523D"
      }), /* @__PURE__ */jsx("path", {
        d: "M19.14 26.667c4.84 0 7.48-2.98 7.48-7.1s-2.64-7.1-7.48-7.1h-5.1v14.2zm4.4-7.1c0 2.66-1.38 4.42-4.48 4.42h-2.1v-8.84h2.1c3.1 0 4.48 1.76 4.48 4.42",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderDLargeIcon, "ShopperOrderDLargeIcon");

function ShopperOrderEIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#458604"
      }), /* @__PURE__ */jsx("path", {
        d: "M15.665 15.39H10.19v-2.385h5.25v-2.01h-5.25V8.76h5.475V6.75H8V17.4h7.665z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderEIcon, "ShopperOrderEIcon");

function ShopperOrderELargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#458604"
      }), /* @__PURE__ */jsx("path", {
        d: "M24.887 24.52h-7.3v-3.18h7v-2.68h-7v-2.98h7.3V13h-10.22v14.2h10.22z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderELargeIcon, "ShopperOrderELargeIcon");

function ShopperOrderFIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#C88705"
      }), /* @__PURE__ */jsx("path", {
        d: "M10.69 17.65v-4.395h4.65v-2.01h-4.65V9.01h4.875V7H8.5v10.65z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderFIcon, "ShopperOrderFIcon");

function ShopperOrderFLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#C88705"
      }), /* @__PURE__ */jsx("path", {
        d: "M18.253 27.533v-5.86h6.2v-2.68h-6.2v-2.98h6.5v-2.68h-9.42v14.2z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderFLargeIcon, "ShopperOrderFLargeIcon");

function ShopperOrderGIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#AE1D1C"
      }), /* @__PURE__ */jsx("path", {
        d: "M17 10.98h-4.605v1.965h2.49c-.3 1.44-1.41 2.13-3.03 2.13-1.92 0-3.045-1.44-3.045-3.54s1.095-3.45 3.045-3.45c1.365 0 2.4.675 2.745 1.905h2.355C16.49 7.5 14.45 6 11.855 6 8.795 6 6.5 8.205 6.5 11.535s2.235 5.505 5.205 5.505c1.56 0 2.73-.585 3.345-1.455v1.29H17z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderGIcon, "ShopperOrderGIcon");

function ShopperOrderGLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#AE1D1C"
      }), /* @__PURE__ */jsx("path", {
        d: "M26.667 18.64h-6.14v2.62h3.32c-.4 1.92-1.88 2.84-4.04 2.84-2.56 0-4.06-1.92-4.06-4.72s1.46-4.6 4.06-4.6c1.82 0 3.2.9 3.66 2.54h3.14c-.62-3.32-3.34-5.32-6.8-5.32-4.08 0-7.14 2.94-7.14 7.38s2.98 7.34 6.94 7.34c2.08 0 3.64-.78 4.46-1.94v1.72h2.6z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderGLargeIcon, "ShopperOrderGLargeIcon");

function ShopperOrderHIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#2B78C6"
      }), /* @__PURE__ */jsx("path", {
        d: "M16.385 6.5h-2.19v4.245H9.74V6.5H7.55v10.65h2.19v-4.395h4.455v4.395h2.19z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderHIcon, "ShopperOrderHIcon");

function ShopperOrderHLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#2B78C6"
      }), /* @__PURE__ */jsx("path", {
        d: "M25.847 12.667h-2.92v5.66h-5.94v-5.66h-2.92v14.2h2.92v-5.86h5.94v5.86h2.92z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderHLargeIcon, "ShopperOrderHLargeIcon");

function ShopperOrderJIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#7635B9"
      }), /* @__PURE__ */jsx("path", {
        d: "M12.705 14.215c0 1.02-.525 1.695-1.515 1.695-.915 0-1.5-.555-1.5-1.515 0-.45.045-.72.045-.72h-2.19s-.045.27-.045.72c0 2.19 1.5 3.45 3.69 3.45 2.265 0 3.705-1.455 3.705-3.69V7h-2.19z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderJIcon, "ShopperOrderJIcon");

function ShopperOrderJLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#7635B9"
      }), /* @__PURE__ */jsx("path", {
        d: "M20.94 22.953c0 1.36-.7 2.26-2.02 2.26-1.22 0-2-.74-2-2.02 0-.6.06-.96.06-.96h-2.92s-.06.36-.06.96c0 2.92 2 4.6 4.92 4.6 3.02 0 4.94-1.94 4.94-4.92v-9.54h-2.92z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderJLargeIcon, "ShopperOrderJLargeIcon");

function ShopperOrderKIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12",
        fill: "#0F884B"
      }), /* @__PURE__ */jsx("path", {
        d: "m17.04 17.65-4.215-6.225L16.875 7h-2.85c-3.54 4.245-4.335 5.07-4.335 5.07V7H7.5v10.65h2.19v-2.805l1.62-1.77 3.03 4.575z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderKIcon, "ShopperOrderKIcon");

function ShopperOrderKLargeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("rect", {
        x: 4,
        y: 4,
        width: 32,
        height: 32,
        rx: 16,
        fill: "#0F884B"
      }), /* @__PURE__ */jsx("path", {
        d: "m26.72 27.533-5.62-8.3 5.4-5.9h-3.8c-4.72 5.66-5.78 6.76-5.78 6.76v-6.76H14v14.2h2.92v-3.74l2.16-2.36 4.04 6.1z",
        fill: "#fff"
      })]
    }))
  }, props));
}

__name(ShopperOrderKLargeIcon, "ShopperOrderKLargeIcon");

function ShownIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.086 11.827C2.03 11.938 2 12 2 12s3.22 7 10 7 10-7 10-7-3.25-7-10-7c-6.108 0-9.358 5.749-9.914 6.827m9.914 5c2.761 0 5-2.16 5-4.827s-2.239-4.828-5-4.828S7 9.334 7 12s2.239 4.828 5 4.828m0-7.24c-1.38 0-2.5 1.08-2.5 2.413s1.12 2.414 2.5 2.414 2.5-1.082 2.5-2.414-1.12-2.414-2.5-2.414"
      })
    }))
  }, props));
}

__name(ShownIcon, "ShownIcon");

var ShownIcon_default = ShownIcon;

function SortIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M4.416 9.413 7 6.828v12.17h2V6.827l2.584 2.585L13 7.999 8 3 3.001 7.999zM19.583 14.584l-2.584 2.585V5h-2v12.169l-2.585-2.585L11 16 16 20.997 20.997 16z"
      })
    }))
  }, props));
}

__name(SortIcon, "SortIcon");

function SortAscendingIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M4.416 9.413 7 6.828v12.17h2V6.827l2.584 2.585L13 7.999 8 3 3.001 7.999z"
      }), /* @__PURE__ */jsx("path", {
        d: "M19.586 14.587 17 17.172V5.002h-2v12.17l-2.584-2.585-1.414 1.414L16 21 21 16.001z",
        fillOpacity: 0.24
      })]
    }))
  }, props));
}

__name(SortAscendingIcon, "SortAscendingIcon");

function SortDescendingIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M4.416 9.413 7 6.828v12.17h2V6.827l2.584 2.585L13 7.999 8 3 3.001 7.999z",
        fillOpacity: 0.24
      }), /* @__PURE__ */jsx("path", {
        d: "M19.586 14.587 17 17.172V5.002h-2v12.17l-2.584-2.585-1.414 1.414L16 21 21 16.001z"
      })]
    }))
  }, props));
}

__name(SortDescendingIcon, "SortDescendingIcon");

function SoyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M15.775 4.751a2.24 2.24 0 0 0-1.639-1.675c-1.396-.362-2.782.61-2.863 2.006l-.098 1.696a3.5 3.5 0 0 1-.392 1.415l-.791 1.516c-.652 1.248.047 2.76 1.443 3.122a2.33 2.33 0 0 0 2.285-.657l.54-.583c1.529-1.65 2.153-3.906 1.682-6.074zM7.728 20.89a2.33 2.33 0 0 0 2.318-.536 2.16 2.16 0 0 0-.363-3.402l-1.468-.93a3.65 3.65 0 0 1-1.07-1.036l-.962-1.422c-.791-1.17-2.494-1.34-3.516-.35a2.15 2.15 0 0 0-.554 2.243l.251.743c.712 2.107 2.42 3.758 4.595 4.447zM21.695 12.78c.429.72.404 1.611-.065 2.307l-.442.655c-1.25 1.856-3.34 3.024-5.627 3.145l-.807.042a2.3 2.3 0 0 1-2.097-1.099c-.722-1.21-.112-2.758 1.261-3.195l1.667-.531c.485-.154.931-.404 1.311-.733l1.309-1.132c1.077-.932 2.767-.67 3.49.542"
      })
    }))
  }, props));
}

__name(SoyIcon, "SoyIcon");

function SoyFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M11.034 17.234a1.46 1.46 0 0 1-1.485.355l-.492-.161a4.6 4.6 0 0 1-2.943-2.944l-.161-.492A1.459 1.459 0 0 1 8.56 12.74l.616.94c.178.274.412.507.685.686l.94.616c.775.507.888 1.597.233 2.252"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8.095a8.06 8.06 0 0 0-5.011 1.737l4.19 4.19.327-.648c.147-.291.233-.61.251-.936l.063-1.123a1.459 1.459 0 0 1 2.884-.218l.107.506a4.6 4.6 0 0 1-1.078 4.02l-.345.386q-.052.06-.111.111l1.2 1.201.105-.034c.31-.102.596-.268.84-.485l.838-.75a1.459 1.459 0 0 1 2.194 1.885l-.283.434a4.6 4.6 0 0 1-1.318 1.326l1.505 1.504A8.095 8.095 0 0 0 12 3.905m.726 10.167a1.459 1.459 0 0 0 1.324 2.218l.517-.028q.16-.009.32-.029l2.124 2.125a8.095 8.095 0 0 1-11.37-11.37z"
      })]
    }))
  }, props));
}

__name(SoyFreeIcon, "SoyFreeIcon");

function SparkleIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m14.5 5 2.121 5.737L22 13l-5.379 2.263L14.5 21l-2.121-5.737L7 13l5.379-2.263zM6 3l1.131 2.869L10 7 7.131 8.131 6 11 4.869 8.131 2 7l2.869-1.131zM6 16l2.5 2.5L6 21l-2.5-2.5z"
      })
    }))
  }, props));
}

__name(SparkleIcon, "SparkleIcon");

function SpeedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12.79 10.33 14.74 2h-1.27L5.54 12.63v1.05h5.67L9.26 22h1.27l7.93-10.62v-1.05z"
      })
    }))
  }, props));
}

__name(SpeedIcon, "SpeedIcon");

var SpeedIcon_default = SpeedIcon;

function SportsCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.04 16c.78 0 1.49-.48 1.79-1.2L18 0h6l-8.53 20.48A5.72 5.72 0 0 1 10.19 24H4c-2.21 0-4-1.79-4-4s1.79-4 4-4zm9.28-9.34 2.05-4.91h-2.22l-2.04 4.91zM8.11 17.75H3.99c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h4.12zm1.92 0h-.16v4.5h.32c1.6 0 3.04-.96 3.66-2.44l4.75-11.4h-2.21l-2.95 7.07a3.68 3.68 0 0 1-3.41 2.27"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.87 6.97v3.06h-.01c0 1.92-1.95 3.47-4.37 3.47s-4.38-1.55-4.38-3.47V6.97c0-1.92 1.96-3.47 4.38-3.47s4.38 1.55 4.38 3.47m-7 2.76v.3h-.01c0 .81 1.09 1.72 2.63 1.72s2.62-.91 2.62-1.72v-.3c-.73.44-1.64.71-2.62.71s-1.89-.27-2.62-.71m2.62-4.48c-1.54 0-2.62.91-2.62 1.72 0 .3.14.61.4.88.44.47 1.24.84 2.22.84s1.77-.36 2.22-.84c.25-.28.4-.58.4-.88 0-.81-1.08-1.72-2.62-1.72"
      })]
    }))
  }, props));
}

__name(SportsCategoryIcon, "SportsCategoryIcon");

function SportsCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M15.22 6.66 18 0h6l-2.78 6.66zM9.87 24v-7.99h.16c.78 0 1.49-.48 1.79-1.2l2.67-6.4h6l-5.03 12.07A5.72 5.72 0 0 1 10.18 24zM0 20c0 2.21 1.79 4 4 4h4.12v-8H4c-2.21 0-4 1.79-4 4"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.12 6.97c0-1.92 1.96-3.47 4.38-3.47h.01c2.41 0 4.37 1.55 4.37 3.47v3.06c0 1.92-1.96 3.47-4.38 3.47s-4.38-1.55-4.38-3.47zM6.5 8.68c.98 0 1.77-.36 2.22-.84.25-.28.4-.58.4-.88 0-.81-1.08-1.72-2.62-1.72s-2.62.91-2.62 1.72c0 .3.14.61.4.88.44.47 1.24.84 2.22.84"
      })]
    }))
  }, props));
}

__name(SportsCategoryFilledIcon, "SportsCategoryFilledIcon");

function StairsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 2h7v20H2v-8h7V8h6z"
      })
    }))
  }, props));
}

__name(StairsIcon, "StairsIcon");

function StopIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.906 18.32 5.68 7.094A8.002 8.002 0 0 0 16.906 18.32m1.414-1.414A8.001 8.001 0 0 0 7.094 5.68zm.751-11.977c3.905 3.905 3.905 10.237 0 14.142s-10.237 3.905-14.142 0-3.905-10.237 0-14.142 10.237-3.905 14.142 0"
      })
    }))
  }, props));
}

__name(StopIcon, "StopIcon");

function StoreIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 3H6l-4 8h2v10h5v-7h6v7h5V11h2zM8 7h8v3H8z"
      })
    }))
  }, props));
}

__name(StoreIcon, "StoreIcon");

var StoreIcon_default = StoreIcon;

function StoreOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 11h2l-4-8H6l-4 8h2v10h6v-6h4v6h6zM7.236 5l-2 4H8V7h8v2h2.764l-2-4zM18 11H6v8h2v-6h8v6h2z"
      })
    }))
  }, props));
}

__name(StoreOutlineIcon, "StoreOutlineIcon");

function StrikethroughIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.266 20.23c-4.263 0-6.363-1.952-6.594-4.955h3.654c.168 1.386 1.134 2.289 3.087 2.289s2.814-.798 2.814-1.974q.001-.32-.07-.59h3.553q.005.134.003.275c-.021 2.835-2.058 4.956-6.447 4.956M6.176 8.787q-.001 1.29.496 2.214H3v2h18v-2h-5.37a10 10 0 0 0-1.453-.324l-2.478-.4c-1.512-.251-2.058-.776-2.058-1.784 0-1.05.798-1.848 2.583-1.848 1.806 0 2.583.756 2.73 1.995h3.57c-.378-2.73-2.163-4.662-6.132-4.662-4.074 0-6.216 2.037-6.216 4.809"
      })
    }))
  }, props));
}

__name(StrikethroughIcon, "StrikethroughIcon");

function StriketroughIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11.988 20.746c3.851 0 6.361-1.612 6.97-4.246h-4.46c-.442.54-1.307.883-2.44.883-1.055 0-1.977-.269-2.605-.883H5.18v.05c0 .352.07.716.222 1.067.703 1.746 2.918 3.13 6.586 3.13M19.5 13.5a1.5 1.5 0 0 0 0-3h-5.054q-.288-.066-.594-.125l-1.735-.328c-1.84-.352-2.601-.844-2.601-1.735 0-.996.914-1.699 2.472-1.699 1.242 0 2.18.41 2.73 1.465.505.82 1.09 1.16 2.028 1.16 1.078-.011 1.805-.68 1.805-1.675a2.4 2.4 0 0 0-.176-.926c-.82-2.145-3.187-3.387-6.422-3.387-3.89 0-6.715 2.098-6.715 5.355q0 1.051.387 1.895H4.5a1.5 1.5 0 0 0 0 3z"
      })
    }))
  }, props));
}

__name(StriketroughIcon, "StriketroughIcon");

function SubtractIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 10.879h16v2.24H4z"
      })
    }))
  }, props));
}

__name(SubtractIcon, "SubtractIcon");

var SubtractIcon_default = SubtractIcon;

function SugarIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m11 20.825-.001-8.25L4 8.523v7.483c0 .506.271.974.711 1.225zM5.255 6.94 11.3 3.486a1.41 1.41 0 0 1 1.4 0l6.044 3.453L12 10.844zM20 8.523v7.483c0 .506-.271.974-.711 1.225L13 20.825v-8.25z"
      })
    }))
  }, props));
}

__name(SugarIcon, "SugarIcon");

function SugarFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-2c1.849 0 3.55-.627 4.906-1.68l-1.734-1.734L12.687 18v-3.898l-1.375-1.376V18L6.99 15.54a.97.97 0 0 1-.489-.84V9.577l3.926 2.263L5.68 7.094A8 8 0 0 0 12 20m4.974-4.44.037-.02a.97.97 0 0 0 .489-.84V9.577l-4.13 2.38-1.003-1.004 4.27-2.46-4.155-2.366a.97.97 0 0 0-.963 0L8.984 7.57l-1.89-1.89A8 8 0 0 1 18.32 16.906z"
      })
    }))
  }, props));
}

__name(SugarFreeIcon, "SugarFreeIcon");

function SuperSaverIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.91 9.286 13 6.406V3h-2v1.994a3.13 3.13 0 0 0-3.956 1.034l-.002.003a3.12 3.12 0 0 0 .738 4.292l.002.001 2.796 2.043-.003.004 3.786 2.756c.495.362.61 1.042.268 1.543a1.13 1.13 0 0 1-1.59.276l-5.445-4.009-1.186 1.61L11 17.93V21h2v-1.918a3.14 3.14 0 0 0 3.275-1.276l.002-.003a3.12 3.12 0 0 0-.737-4.292l-3.295-2.399.002-.002-3.289-2.403-.002-.002a1.12 1.12 0 0 1-.266-1.542 1.13 1.13 0 0 1 1.59-.276l5.445 4.01z"
      })
    }))
  }, props));
}

__name(SuperSaverIcon, "SuperSaverIcon");

function SupportIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2a7 7 0 0 0-7 7l-2 1v5l2 1h2V9a5 5 0 0 1 10 0v7a3 3 0 0 1-3 3h-.582a1.5 1.5 0 0 0-1.118-.5h-2a1.5 1.5 0 0 0 0 3h2c.444 0 .843-.193 1.118-.5H14a5 5 0 0 0 5-5l2-1v-5l-2-1a7 7 0 0 0-7-7"
      })
    }))
  }, props));
}

__name(SupportIcon, "SupportIcon");

function TargetIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M13 7.5q0 .354-.044.697L7.834 6.579a1 1 0 0 0-1.255 1.255l1.618 5.122Q7.854 13 7.5 13A5.5 5.5 0 1 1 13 7.5"
      }), /* @__PURE__ */jsx("path", {
        d: "M19.686 12.42a1 1 0 0 1 .406 1.66l-1.945 1.945 3.914 3.914a1.5 1.5 0 0 1-2.122 2.122l-3.914-3.914-1.945 1.945a1 1 0 0 1-1.66-.406l-2.775-8.787a1 1 0 0 1 1.254-1.254z"
      })]
    }))
  }, props));
}

__name(TargetIcon, "TargetIcon");

function TeamIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 13c3.302 0 6.008 2.464 6 6H6c-.006-3.534 2.7-6 6-6M12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M19.866 18c-.232-2.044-1.176-3.77-2.553-5 2.57.185 4.614 2.187 4.608 5zM6.53 13c-2.57.185-4.614 2.188-4.61 5h2.056c.232-2.043 1.177-3.77 2.555-5M16.116 10.84A4.98 4.98 0 0 0 17 8c0-.699-.143-1.364-.402-1.968Q16.794 6 17 6a2.5 2.5 0 1 1-.884 4.84M7.402 6.032A5 5 0 0 0 7 8c0 1.055.326 2.033.884 2.84a2.5 2.5 0 1 1-.482-4.807"
      })
    }))
  }, props));
}

__name(TeamIcon, "TeamIcon");

function TechnicalIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5 7 12 2 3.5 7v10l8.5 5 8.5-5zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      })
    }))
  }, props));
}

__name(TechnicalIcon, "TechnicalIcon");

function TestIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 5H5v14h14zM3 3v18h18V3zm14 14h-6v-2h6zm-9.707-4.707L9.586 10 7.293 7.707l1.414-1.414L12.414 10l-3.707 3.707z"
      })
    }))
  }, props));
}

__name(TestIcon, "TestIcon");

function ThreadsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.336 9.382a.94.94 0 0 1-1.181-.607c-1.114-3.502-3.193-4.93-7.177-4.93-4.837 0-7.09 2.734-7.09 8.604 0 4.956 2.488 7.62 7.196 7.703 1.996.068 3.788-.557 4.923-1.643.774-.74 1.184-1.65 1.184-2.627 0-1.03-.358-1.86-1.066-2.466a3.6 3.6 0 0 0-.45-.326c-.494 2.576-2.147 4.144-4.433 4.144-3.001 0-3.882-1.47-4.093-2.702-.16-.934.045-1.81.589-2.529.596-.79 1.546-1.307 2.675-1.455 1.224-.16 2.367-.156 3.394-.01-.169-.713-.506-1.295-.98-1.642-1.06-.762-2.987-.69-4.044.642a.956.956 0 0 1-1.324.165.91.91 0 0 1-.169-1.295c1.747-2.203 4.852-2.292 6.663-.994 1.068.784 1.718 2.1 1.842 3.66a5.9 5.9 0 0 1 1.574.954c1.118.958 1.71 2.29 1.71 3.854 0 1.464-.622 2.865-1.752 3.946C16.878 21.214 14.685 22 12.28 22q-.118 0-.233-.003C6.3 21.897 3 18.417 3 12.449 3 5.516 6.02 2 11.978 2c4.84 0 7.61 1.92 8.98 6.228a.92.92 0 0 1-.622 1.154m-8.673 2.995c-.616.081-1.116.337-1.406.721-.237.314-.32.695-.246 1.13.07.405.2 1.16 2.231 1.16 1.947 0 2.484-1.912 2.632-2.962a9 9 0 0 0-1.68-.152q-.734 0-1.531.103"
      })
    }))
  }, props));
}

__name(ThreadsIcon, "ThreadsIcon");

function TicketIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.243 7.758a2 2 0 0 0 2.828 0l2.121 2.122L9.88 21.193l-2.122-2.12a2 2 0 0 0-2.828-2.83l-2.121-2.12L14.12 2.808l2.122 2.12a2 2 0 0 0 0 2.83"
      })
    }))
  }, props));
}

__name(TicketIcon, "TicketIcon");

function TikTokIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M20.1 5.323a.75.75 0 0 0-.705-.09 2.617 2.617 0 0 1-3.645-2.46.75.75 0 0 0-.456-.712A.8.8 0 0 0 15 2h-3a.75.75 0 0 0-.75.75v12.84a1.875 1.875 0 1 1-1.875-1.875.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75A6.38 6.38 0 0 0 3 15.59a6.3 6.3 0 0 0 1.2 3.75.75.75 0 0 0 .608.315.75.75 0 0 0 .442-.172.75.75 0 0 0 .173-1.05A4.83 4.83 0 0 1 4.5 15.59a4.89 4.89 0 0 1 4.125-4.822v1.5a3.375 3.375 0 1 0 4.125 3.322V3.5h1.553a4.13 4.13 0 0 0 4.635 3.428v1.455a5.34 5.34 0 0 1-3.555-.623.75.75 0 0 0-1.125.652v7.178a4.883 4.883 0 0 1-6.75 4.5.75.75 0 0 0-.578 1.38 6.3 6.3 0 0 0 2.46.495 6.39 6.39 0 0 0 6.36-5.88.6.6 0 0 0 0-.12v-6.39a6.85 6.85 0 0 0 4.14.12.75.75 0 0 0 .54-.75V5.982a.75.75 0 0 0-.33-.66"
      })
    }))
  }, props));
}

__name(TikTokIcon, "TikTokIcon");

function TimeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m1-17v6.52l4.625 3.7-1.25 1.56L11 12.48V5z"
      })
    }))
  }, props));
}

__name(TimeIcon, "TimeIcon");

function TimeFastIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 12a8 8 0 0 1-14.245 5H11v-2H4v-2h7v-2H2V9h4.582A8.003 8.003 0 0 1 22 12m-7-.48V6.4h-2v6.08l4.375 3.5 1.25-1.56z"
      })
    }))
  }, props));
}

__name(TimeFastIcon, "TimeFastIcon");

function ToteIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 5.5A1.5 1.5 0 0 1 3.5 4h17a1.5 1.5 0 0 1 .291 2.972l-.818 11.633A1.5 1.5 0 0 1 18.477 20H5.523a1.5 1.5 0 0 1-1.496-1.395L3.209 6.972A1.5 1.5 0 0 1 2 5.5M9 8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"
      })
    }))
  }, props));
}

__name(ToteIcon, "ToteIcon");

function TouchIDIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.777 3.003a8.98 8.98 0 0 1 9.076 10.504l-1.97-.34a6.979 6.979 0 0 0-10.901-6.89L6.829 4.641a9 9 0 0 1 4.948-1.64M5.275 17.923A8.98 8.98 0 0 1 4.229 7.49l1.732 1a6.98 6.98 0 0 0 .813 8.109z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.83 9.278c-.762-.401-1.356-.393-1.677-.24l-.86-1.806c1.1-.523 2.39-.291 3.468.275 1.104.581 2.143 1.583 2.856 2.9.96 1.77 1.129 4.024 1.095 5.721a22 22 0 0 1-.249 2.837l-.03.181-.009.05-.003.015v.006l-.983-.186-.983-.186.002-.008.006-.036q.01-.05.025-.152a19.664 19.664 0 0 0 .224-2.561c.032-1.61-.149-3.43-.853-4.728-.534-.986-1.293-1.695-2.029-2.082M7.146 13.32c-.635-2.081.194-3.922 1.254-4.793l1.27 1.546c-.461.378-1 1.388-.61 2.662.123.407.303.74.517 1.091l.126.203c.182.292.404.646.566 1.014.223.503.364 1.076.323 1.777-.04.681-.25 1.432-.646 2.31l-1.823-.822c.333-.739.45-1.245.472-1.607a1.7 1.7 0 0 0-.155-.85 6 6 0 0 0-.39-.692q-.083-.132-.18-.292a6.6 6.6 0 0 1-.724-1.547"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.228 15.127c-.3-1.312-.925-2.147-1.302-2.565l1.483-1.34c.536.591 1.372 1.724 1.769 3.46.398 1.744.332 4.016-.813 6.85l-1.854-.75c1.009-2.497 1.014-4.352.717-5.655"
      })]
    }))
  }, props));
}

__name(TouchIDIcon, "TouchIDIcon");

function ToyIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 13.483s1.543-1.104 1.543-3.31v-.73A2.029 2.029 0 0 1 8.234 8.28l.937 1.34c.514-.183 2.272-.619 4.329-.178.14-2.028 1.328-5.89 3.9-6.442v2.207l2.237 1.029a2.03 2.03 0 0 1-1.443 3.786l-1.308-.401c0 1.815 1.136 5.39 2.559 8.018q.307-.127.525-.231a8 8 0 0 0 .494-.253l.018-.01L21 18l.518.855-.003.002-.004.003-.012.007-.177.099c-.116.063-.284.15-.5.251-.433.204-1.062.47-1.874.734C17.324 20.479 14.97 21 12 21s-5.325-.52-6.949-1.05c-.811-.263-1.44-.529-1.873-.733a10 10 0 0 1-.637-.327l-.04-.023-.012-.008-.005-.002-.002-.001S2.481 18.855 3 18l.518-.855.018.01.092.051c.086.046.22.116.402.202.242.114.568.256.973.408 2.136-3.566 2.111-6.54 2.111-6.54C6.085 14.034 3 13.483 3 13.483m5.502 5.243C9.527 18.891 10.696 19 12 19c1.512 0 2.843-.146 3.977-.357l-.883-2.153a3.067 3.067 0 0 0-5.675 0z"
      })
    }))
  }, props));
}

__name(ToyIcon, "ToyIcon");

function TrashIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 6V5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h4v2h-2l-1 14H6L5 8H3V6zm3-2h4a1 1 0 0 1 1 1v1H9V5a1 1 0 0 1 1-1m3 15v-8h2v8zm-2-8H9v8h2z"
      })
    }))
  }, props));
}

__name(TrashIcon, "TrashIcon");

var TrashIcon_default = TrashIcon;

function TreeNutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M11.53 3c-.78 0-1.412.636-1.412 1.421v.474H8.676C6.094 4.895 4 7.003 4 9.603c0 .279.224.522.5.522h15c.276 0 .5-.243.5-.522 0-2.6-2.094-4.708-4.676-4.708h-1.442v-.474c0-.785-.632-1.421-1.411-1.421zM18.523 11.5H5.477v1.515c0 3.927 2.73 7.29 6.57 7.98a.3.3 0 0 0 .094 0c3.736-.692 6.382-3.97 6.382-7.795z"
      })
    }))
  }, props));
}

__name(TreeNutIcon, "TreeNutIcon");

function TreenutFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m3.642-5.011a8.095 8.095 0 0 0 11.37 11.37l-1.45-1.45a6 6 0 0 1-3.453 1.959.2.2 0 0 1-.073 0 6.15 6.15 0 0 1-5.084-6.081v-1.168h3.253l-1.048-1.048h-2.96a.385.385 0 0 1-.387-.383c0-.847.296-1.626.791-2.24zm6.344 3.582 1.047 1.048h4.015v1.31c0 .815-.161 1.6-.456 2.316l1.766 1.766a8.095 8.095 0 0 0-11.37-11.37L8.17 6.824a3.6 3.6 0 0 1 1.258-.222h1.115V6.24c0-.599.49-1.083 1.093-1.083h.728c.603 0 1.093.484 1.093 1.083v.36h1.115c1.998 0 3.619 1.607 3.619 3.588a.385.385 0 0 1-.387.383z"
      })
    }))
  }, props));
}

__name(TreenutFreeIcon, "TreenutFreeIcon");

function TrendingIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M22 18H2v2h20zM19.03 8.03 22 11V4h-7l2.616 2.616-5.686 6.01-3.74-3.74-6.148 6.158 1.416 1.412 4.733-4.741 3.779 3.78z"
      })
    }))
  }, props));
}

__name(TrendingIcon, "TrendingIcon");

function TruckIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 5h13v3h4l3 4.5V17h-3a2 2 0 1 1-4 0H8a2 2 0 1 1-4 0H2zm13 5v2h4.263l-1.333-2z"
      })
    }))
  }, props));
}

__name(TruckIcon, "TruckIcon");

function TwitterIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M14.308 11.045 21.38 3h-1.676l-6.142 6.986L8.658 3H3l7.418 10.563L3 22h1.676l6.486-7.377L16.342 22H22zm-2.296 2.611-.752-1.051-5.98-8.37h2.575l4.826 6.754.751 1.052 6.273 8.78h-2.574z"
      })
    }))
  }, props));
}

__name(TwitterIcon, "TwitterIcon");

function UnderlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M11.976 15.208c-3.328 0-5.056-1.696-5.056-4.72V3h2.688v7.392c0 1.76.864 2.576 2.384 2.576 1.536 0 2.416-.864 2.416-2.576V3h2.672v7.424c0 2.928-1.872 4.784-5.104 4.784"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 21H3v-2h18z"
      })]
    }))
  }, props));
}

__name(UnderlineIcon, "UnderlineIcon");

function UnlockedIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 6a2 2 0 1 1 4 0h2a4 4 0 0 0-8 0v3H4v13h16V9h-4zm-2 8a2 2 0 0 1-1 1.732V19h-2v-3.268A2 2 0 0 1 12 12a2 2 0 0 1 2 2"
      })
    }))
  }, props));
}

__name(UnlockedIcon, "UnlockedIcon");

var UnlockedIcon_default = UnlockedIcon;

function UnpinIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M19.425 19.425a1.5 1.5 0 0 1-2.122 2.121l-3.973-3.973-.754 4.02a.5.5 0 0 1-.49.407h-.171a.5.5 0 0 1-.491-.408L10.056 14.3 9.757 14H5c0-1.286.81-2.384 1.947-2.81L2.454 6.697a1.5 1.5 0 1 1 2.121-2.121zM19 14h-.757L7.13 2.888A1.5 1.5 0 0 1 8.5 2h7a1.5 1.5 0 0 1 0 3h-.3l1.568 6.1A3 3 0 0 1 19 14"
      })
    }))
  }, props));
}

__name(UnpinIcon, "UnpinIcon");

function UploadIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "m16.243 10.071 1.414-1.414L12 3 6.344 8.657l1.414 1.414L11 6.83V16h2V6.828zM4 17.001h2v2h12v-2h2v4H4z"
      })
    }))
  }, props));
}

__name(UploadIcon, "UploadIcon");

function UserIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M12 13a9 9 0 0 1 9 9H3a9 9 0 0 1 9-9"
      })
    }))
  }, props));
}

__name(UserIcon, "UserIcon");

function UserOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m-2 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M12 13a9 9 0 0 1 8.777 7c.146.643.223 1.313.223 2H3c0-.687.077-1.357.223-2 .91-4.008 4.494-7 8.777-7m0 2a7 7 0 0 1 6.71 5H5.29c.86-2.892 3.539-5 6.71-5"
      })
    }))
  }, props));
}

__name(UserOutlineIcon, "UserOutlineIcon");

function ValentinesIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M18.26 17.483c-2.29 0-4.3 1.24-5.39 3.078v-4.998h1.58c.31 0 .6-.04.88-.11 3.78-.6 7-3.798 7-7.666A7.774 7.774 0 0 0 14.55.01v4.938L11.99.83 9.46 4.938V0C5.17 0 1.69 3.489 1.69 7.777c0 3.858 3.2 7.057 6.97 7.667.29.07.6.12.93.12h1.54v4.997a6.26 6.26 0 0 0-5.39-3.078H0v.26C0 21.2 2.8 24 6.26 24h11.48C21.2 24 24 21.201 24 17.743v-.26zM16.31 2.019a6.03 6.03 0 0 1 4.28 5.768c0 1.799-.96 3.478-2.41 4.608.03-.24.02-.49 0-.74-.03-.6-.2-1.2-.55-1.77l-.95-1.528-.37-.6zm-4.3 2.13 3.17 5.107.83 1.37c.3.49.42.93.42 1.349v.07c-.04.33-.16.6-.24.75-.17.3-.68 1.01-1.72 1.01H9.6c-1.04 0-1.55-.71-1.72-1.01-.1-.18-.26-.54-.25-.99.03-.35.14-.72.37-1.12l4.03-6.537zM3.44 7.776c0-2.72 1.81-5.018 4.28-5.768v5.728l-1.2 1.979s-.02.04-.03.07l-.07.11c-.22.36-.37.74-.46 1.12-.03.1-.04.2-.06.3v.05c-.06.36-.08.699-.04 1.029-1.45-1.13-2.41-2.799-2.41-4.608zM6.26 22.24c-1.96 0-3.64-1.26-4.26-3.019h3.74c1.96 0 3.64 1.26 4.26 3.019zm11.48 0H14a4.52 4.52 0 0 1 4.26-3.019H22a4.52 4.52 0 0 1-4.26 3.019"
      })
    }))
  }, props));
}

__name(ValentinesIcon, "ValentinesIcon");

function ValentinesFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M14.56 1.62V0c4.29 0 7.78 3.49 7.78 7.78 0 2.2-1.04 4.18-2.63 5.59.44-1.48.24-3.06-.6-4.42z"
      }), /* @__PURE__ */jsx("path", {
        d: "M11.13 15.56H9.59a3.67 3.67 0 0 1-3.25-1.91 3.67 3.67 0 0 1 .08-3.77L12 .83l5.62 9.05c.72 1.16.76 2.57.09 3.77a3.67 3.67 0 0 1-3.25 1.91h-1.58v4.976a6.25 6.25 0 0 1 5.38-3.056H24v.26C24 21.2 21.2 24 17.74 24H6.26C2.8 24 0 21.2 0 17.74v-.26h5.74c2.295 0 4.3 1.232 5.39 3.072z"
      }), /* @__PURE__ */jsx("path", {
        d: "m4.93 8.97 4.54-7.38V0c-4.3 0-7.78 3.48-7.78 7.78 0 2.21 1.05 4.2 2.66 5.61-.45-1.47-.26-3.06.58-4.42"
      })]
    }))
  }, props));
}

__name(ValentinesFilledIcon, "ValentinesFilledIcon");

function VeganIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m6.707-8.943c0 1.733-1.147 2.983-3.198 2.983-2.173 0-3.482-1.343-3.482-3.657 0-2.285 1.31-3.633 3.438-3.633 1.382 0 2.441.62 2.847 1.42.092.182.127.333.127.494 0 .454-.313.762-.772.762-.361 0-.63-.142-.85-.464-.336-.532-.756-.772-1.347-.772-1.016 0-1.616.796-1.616 2.168 0 1.397.664 2.242 1.694 2.242.81 0 1.377-.479 1.426-1.187l.005-.107h-.698c-.41 0-.684-.22-.684-.616 0-.395.268-.615.684-.615h1.533c.566 0 .893.337.893.933zm-8.74 1.88c-.269.756-.713 1.088-1.44 1.088-.738 0-1.173-.332-1.446-1.088l-1.748-4.805a1.5 1.5 0 0 1-.083-.503c0-.513.38-.864.947-.864.498 0 .786.224.928.717l1.426 4.683h.039L10 9.458c.137-.479.415-.693.894-.693.546 0 .922.337.922.835 0 .166-.029.317-.088.473z"
      })
    }))
  }, props));
}

__name(VeganIcon, "VeganIcon");

function VeganOrVegetarianIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.17 16.06c-1.11 2.04-4.236 2.752-7.054 2.318q-.01.304-.01.622c0 .828-.696 1.5-1.553 1.5C5.695 20.5 5 19.828 5 19v-.006c.013-4.841 3.751-8.492 5.647-10.343.751-.734 1.213-1.185 1.038-1.315-.733-.544-5.566 2.703-8.116 7.13-.174-1.193-.015-2.631.429-4.276 1.094-4.059 4.645-6.22 8.86-6.598 4.214-.377 7.642.456 7.642 1.599 0 .66-.824 1.547-1.705 2.495-.644.693-1.318 1.419-1.723 2.112-.447.765-.607 1.653-.781 2.627-.2 1.118-.421 2.348-1.121 3.635"
      })
    }))
  }, props));
}

__name(VeganOrVegetarianIcon, "VeganOrVegetarianIcon");

function VegetarianIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-1.533-7.078c-.269.757-.713 1.089-1.44 1.089-.738 0-1.173-.332-1.446-1.09l-1.748-4.804a1.5 1.5 0 0 1-.083-.503c0-.512.38-.864.947-.864.498 0 .786.225.928.718l1.426 4.682h.039L10.5 9.443c.137-.478.415-.693.894-.693.546 0 .922.337.922.835 0 .166-.029.317-.088.474zm6.538.981h-3.227c-.567 0-.899-.341-.899-.937V9.795c0-.596.332-.938.899-.938h3.227c.483 0 .796.264.796.723 0 .46-.322.723-.796.723h-2.334v1.401h2.227c.434 0 .722.244.722.66 0 .414-.278.659-.722.659H14.67v1.435h2.334c.474 0 .796.264.796.723s-.312.722-.796.722"
      })
    }))
  }, props));
}

__name(VegetarianIcon, "VegetarianIcon");

function VisitStoreIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_520_1954)",
        children: [/* @__PURE__ */jsx("path", {
          d: "M20.203 0 24 8.705h-1.98V19H11.88l-1.427-1.75h9.818V8.707H9.619l-.031-.079a4.1 4.1 0 0 0 .988-1.673h10.751l-2.27-5.205H9.943l-.469 1.076a4.1 4.1 0 0 0-1.513-.907L8.798 0z"
        }), /* @__PURE__ */jsx("path", {
          d: "M17.458 3.563h-5.916V5.78h5.916zM8.997 5.769a2.322 2.322 0 1 1-4.644 0 2.322 2.322 0 0 1 4.644 0M6.43 9.397c-1.027 0-2.06.23-2.986.73h-.002C1.967 10.928 0 12.61 0 15.747h1.75c0-2.247 1.359-3.447 2.525-4.08q.277-.149.576-.254v2.348c0 1.239.38 2.425 1.071 3.43l5.53 6.808.002.002 1.356-1.106-4.662-5.716c.274-.755.417-1.56.417-2.38v-1.41a7.2 7.2 0 0 0 4.804 1.791h.188v-1.75h-.198a5.46 5.46 0 0 1-5.127-3.476l-.217-.556z"
        }), /* @__PURE__ */jsx("path", {
          d: "m1.497 22.841 3.507-4.007 1.12 1.378-3.31 3.782z"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_520_1954",
          children: /* @__PURE__ */jsx("path", {
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(VisitStoreIcon, "VisitStoreIcon");

function VisitStoreFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_520_1956)",
        children: [/* @__PURE__ */jsx("path", {
          d: "M7.261 3.522a2.322 2.322 0 1 0-.586 4.57V8.09a2.33 2.33 0 0 0 1.34-.426l.002-.001.022-.016.002-.001a2.323 2.323 0 0 0-.78-4.125"
        }), /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.624 8.705H24L20.203 0H8.798l-.832 1.906a4.074 4.074 0 0 1 1.622 6.708zm1.918-5.142h5.916V5.78h-5.916z"
        }), /* @__PURE__ */jsx("path", {
          d: "M10.086 16.786 11.892 19h10.129v-8.545H10.566a3.7 3.7 0 0 0 2.78 1.225h1.961v5.25h-1.932a8.9 8.9 0 0 1-3.2-.57 9 9 0 0 1-.089.426"
        }), /* @__PURE__ */jsx("path", {
          d: "M6.43 9.397c-1.027 0-2.06.23-2.986.73h-.002C1.967 10.928 0 12.61 0 15.747h1.75c0-2.247 1.359-3.447 2.525-4.08q.277-.149.576-.254v2.348c0 1.239.38 2.425 1.071 3.43l5.53 6.808.002.002 1.356-1.106-4.662-5.716c.274-.755.417-1.56.417-2.38v-1.41a7.2 7.2 0 0 0 4.804 1.791h.188v-1.75h-.198a5.46 5.46 0 0 1-5.127-3.476l-.217-.556z"
        }), /* @__PURE__ */jsx("path", {
          d: "M5.004 18.835 1.497 22.84l1.317 1.153 3.31-3.782z"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_520_1956",
          children: /* @__PURE__ */jsx("path", {
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(VisitStoreFilledIcon, "VisitStoreFilledIcon");

function VolumeDownIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 3 9.444 8H5v8h4.444L15 21zm2 7.257a2.31 2.31 0 0 1 .91 1.834c0 .712-.328 1.352-.84 1.777l1.074 1.702a4.3 4.3 0 0 0 1.766-3.48A4.3 4.3 0 0 0 18 8.51z"
      })
    }))
  }, props));
}

__name(VolumeDownIcon, "VolumeDownIcon");

function VolumeUpIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3 6.444 8H2v8h4.444L12 21zm4.014 3.74a6.35 6.35 0 0 1 2.936 5.35 6.35 6.35 0 0 1-2.718 5.206l1.07 1.695a8.34 8.34 0 0 0 3.648-6.9A8.35 8.35 0 0 0 17.01 5zM14 10.256a2.31 2.31 0 0 1 .91 1.834c0 .712-.328 1.352-.84 1.777l1.074 1.702a4.3 4.3 0 0 0 1.766-3.48A4.3 4.3 0 0 0 15 8.51z"
      })
    }))
  }, props));
}

__name(VolumeUpIcon, "VolumeUpIcon");

function WalkIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.88 4.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.44 3.438a6.5 6.5 0 0 0-3.012.713l-.003.002C6.911 9.198 5 10.919 5 14h2c0-2.091 1.248-3.245 2.354-3.826q.332-.173.696-.284v2.15c0 1.194.368 2.337 1.034 3.31.067.075.135.164.209.255l3.374 4.156 1.84 2.248 1.548-1.268-4.67-5.703c.2-.642.305-1.316.305-2.001v-.884c1.094.895 2.477 1.42 4.124 1.41H18v-2h-.198c-2.107.015-3.625-1.194-4.455-3.25l-.252-.626zM6.458 20.649l3.347-3.704 1.275 1.571-3.138 3.474z"
      })
    }))
  }, props));
}

__name(WalkIcon, "WalkIcon");

function WalletIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "m8.5 1.5.849 2.152 2.152.849-2.152.849L8.5 7.502 7.651 5.35 5.5 4.5l2.152-.848z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 7.502h11.003a2 2 0 0 1 2.001 2v2.001H14.79v.73c0 1.726-1.445 3.16-3.271 3.16-1.827 0-3.272-1.434-3.272-3.16v-.73H1.498v-2q0-.105.01-.205a2 2 0 0 1 1.99-1.796zm3.001 1 .566 1.435 1.435.566-1.435.566-.566 1.434-.566-1.434-1.435-.566 1.435-.566z"
      }), /* @__PURE__ */jsx("path", {
        d: "m13.732 5.547-.997-.997.997-.997.997.997zM1.498 13.504v6.001a2 2 0 0 0 2 2.001h16.005a2 2 0 0 0 2.001-2v-6.002H16.63c-.581 2.252-2.67 3.89-5.112 3.89s-4.531-1.638-5.112-3.89z"
      })]
    }))
  }, props));
}

__name(WalletIcon, "WalletIcon");

function WarmIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.323 3c.34.36.64.706.887 1.147.301.54.54 1.264.54 2.353 0 .936-.24 1.375-.578 1.993l-.05.09c-.422.774-.872 1.692-.872 3.417s.45 2.643.872 3.416l.05.09c.338.619.578 1.058.578 1.994 0 .992-.401 1.932-.852 2.663a8 8 0 0 1-.597.837h2.427c.511-.883 1.022-2.107 1.022-3.5 0-1.45-.443-2.259-.82-2.945l-.052-.096c-.328-.602-.628-1.184-.628-2.459s.3-1.857.628-2.459l.053-.096c.376-.686.819-1.495.819-2.945 0-1.411-.317-2.474-.793-3.328l-.1-.172zm8.944 3H17.08c.24.379.42.873.42 1.6 0 .737-.155 1.077-.376 1.56l-.034.076c-.288.632-.59 1.377-.59 2.764s.302 2.132.59 2.764l.034.076c.22.483.376.823.376 1.56 0 .549-.228 1.102-.551 1.6h2.24a4.4 4.4 0 0 0 .311-1.6c0-1.172-.3-1.83-.555-2.389l-.035-.075c-.212-.468-.41-.923-.41-1.936s.198-1.468.41-1.936l.035-.075c.254-.558.555-1.217.555-2.389 0-.602-.085-1.131-.233-1.6m-12 0H5.08c.24.379.42.873.42 1.6 0 .737-.155 1.077-.376 1.56l-.034.076c-.288.632-.59 1.377-.59 2.764s.302 2.132.59 2.764l.034.076c.22.483.376.823.376 1.56 0 .549-.228 1.102-.551 1.6h2.24a4.4 4.4 0 0 0 .311-1.6c0-1.172-.3-1.83-.555-2.389l-.035-.075c-.212-.468-.41-.923-.41-1.936s.198-1.468.41-1.936l.035-.075C7.199 9.43 7.5 8.772 7.5 7.6c0-.602-.085-1.131-.233-1.6"
      })
    }))
  }, props));
}

__name(WarmIcon, "WarmIcon");

function WeeklyFlyersCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_1515_563)",
        children: [/* @__PURE__ */jsx("path", {
          d: "M22.25 1.75h-11.5v1.5H9V0h15v19h-5.177q.136-.822.268-1.75h3.159z"
        }), /* @__PURE__ */jsx("path", {
          d: "M14.063 8.758H6.516a91 91 0 0 1-.315 4.515h7.507a58 58 0 0 0 .354-4.515M13.481 15.023H6.007q-.11.88-.246 1.75h7.452q.143-.87.268-1.75M5.095 20.273q.197-.884.362-1.75h7.455q-.159.876-.326 1.75z"
        }), /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.408 6.75C2.394 5.648 2.344 5 2.344 5H18.21s.017.614 0 1.686l-.001.064a80 80 0 0 1-.57 8.125C16.954 20.531 16.045 24 16.045 24H0s.166-.666.41-1.75c.437-1.933 1.123-5.196 1.559-8.375.403-2.943.46-5.517.44-7.125m-.204 15.5c.442-1.986 1.081-5.091 1.499-8.137a51 51 0 0 0 .455-7.363H16.46a78 78 0 0 1-.557 7.914 89 89 0 0 1-1.035 6.553q-.118.586-.214 1.033z"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_1515_563",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(WeeklyFlyersCategoryIcon, "WeeklyFlyersCategoryIcon");

function WeeklyFlyersCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsxs("g", {
        clipPath: "url(#prefix__clip0_1515_565)",
        children: [/* @__PURE__ */jsx("path", {
          d: "M9 0h15v19h-5.177c.187-1.15.378-2.462.555-3.914.43-3.531.551-6.514.582-8.306v-.065a56 56 0 0 0 .003-1.634l-.002-.093v-.035l-.048-1.703H9z"
        }), /* @__PURE__ */jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.344 5s.05.648.064 1.75a49 49 0 0 1-.44 7.125C1.534 17.054.849 20.317.412 22.25.166 23.334 0 24 0 24h16.044s.91-3.469 1.597-9.125c.42-3.457.54-6.377.569-8.125v-.064c.018-1.072 0-1.686 0-1.686zm11.719 3.758H6.516a91 91 0 0 1-.315 4.515h7.507a58 58 0 0 0 .354-4.515m-.582 6.265H6.007q-.11.88-.246 1.75h7.452q.143-.87.268-1.75m-8.024 3.5q-.165.866-.362 1.75h7.49q.169-.874.327-1.75z"
        })]
      }), /* @__PURE__ */jsx("defs", {
        children: /* @__PURE__ */jsx("clipPath", {
          id: "prefix__clip0_1515_565",
          children: /* @__PURE__ */jsx("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        })
      })]
    }))
  }, props));
}

__name(WeeklyFlyersCategoryFilledIcon, "WeeklyFlyersCategoryFilledIcon");

function WheatIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M12.32 10.41c1.37-.012 2.503-2.52 2.517-3.977S13.763 2.488 12.394 2.5c-1.37.013-2.503 2.522-2.516 3.978-.014 1.456 1.073 3.945 2.443 3.933M10.795 21.112c-.975.95-3.55-.02-4.59-1.033-1.04-1.015-2.034-3.526-1.059-4.477.975-.95 3.55.019 4.59 1.033s2.034 3.526 1.059 4.476M17.82 13.997c-1.106.951-3.745 1.759-4.658.742-.914-1.018.244-3.475 1.35-4.426s3.745-1.76 4.658-.742c.913 1.017-.244 3.474-1.35 4.426M10.838 14.739c-.913 1.017-3.552.209-4.658-.742-1.106-.952-2.263-3.409-1.35-4.426s3.552-.21 4.658.742c1.106.951 2.264 3.408 1.35 4.426M18.003 20.079c-1.04 1.014-3.615 1.983-4.59 1.032-.975-.95.02-3.462 1.06-4.476s3.614-1.984 4.59-1.033c.974.95-.02 3.462-1.06 4.476"
      })
    }))
  }, props));
}

__name(WheatIcon, "WheatIcon");

function WheatFreeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.237 10.154c.93-.008 1.7-1.719 1.71-2.712.009-.993-.73-2.69-1.66-2.68-.932.008-1.702 1.718-1.711 2.711s.73 2.69 1.66 2.681M11.2 17.45c-.663.648-2.413-.013-3.12-.705-.707-.691-1.383-2.403-.72-3.052.663-.648 2.413.013 3.12.705.706.691 1.382 2.403.72 3.051"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M6.989 5.642a8.095 8.095 0 0 1 11.37 11.37l-1.494-1.494c.27-.694.343-1.443-.046-1.825-.385-.375-1.135-.311-1.835-.056l-.355-.355c.523-.152 1.027-.409 1.345-.683.752-.649 1.539-2.324.918-3.017s-2.414-.143-3.166.505c-.35.302-.706.824-.926 1.367zm6.414 9.107-1.992-1.99a.84.84 0 0 1-.182.346c-.621.693-2.414.143-3.166-.506s-1.539-2.324-.918-3.017c.178-.2.454-.296.773-.317L5.642 6.989a8.095 8.095 0 0 0 11.37 11.37l-1.303-1.303c-.827.552-2.169.943-2.73.393-.568-.555-.152-1.894.424-2.7"
      })]
    }))
  }, props));
}

__name(WheatFreeIcon, "WheatFreeIcon");

function WhiteWineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.939 2H8.06l-1.9 6.234a3.72 3.72 0 0 0 1.205 3.964L11 15.18V20l-4 1v1h10v-1l-4-1v-4.82l3.634-2.982a3.72 3.72 0 0 0 1.204-3.964z"
      })
    }))
  }, props));
}

__name(WhiteWineIcon, "WhiteWineIcon");

function Whole30Icon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.5 12a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0M4.605 14.742c.34.82 1.372 1.64 3.17 1.64 2.121 0 3.487-1.019 3.487-2.6 0-1.143-.809-1.864-2.086-1.993v-.041c.967-.193 1.752-.885 1.752-1.969 0-1.435-1.324-2.273-3.164-2.273-1.664 0-2.66.797-2.994 1.617a1.2 1.2 0 0 0-.106.51c0 .492.299.844.885.844.474 0 .732-.17.972-.622.258-.503.65-.75 1.254-.75.733 0 1.155.381 1.155.979 0 .615-.504 1.02-1.33 1.02h-.194c-.51 0-.779.298-.779.726 0 .44.27.732.78.732h.204c.938 0 1.465.381 1.465 1.09 0 .61-.515 1.043-1.254 1.043-.802 0-1.183-.31-1.494-.838-.21-.34-.474-.486-.885-.486-.586 0-.943.34-.943.879 0 .152.035.328.105.492m7.583-2.812c0 2.765 1.388 4.453 3.627 4.453s3.62-1.7 3.62-4.46c0-2.777-1.394-4.423-3.62-4.423-2.221 0-3.627 1.652-3.627 4.43m5.062 0c0 1.845-.54 2.777-1.435 2.777-.891 0-1.442-.932-1.442-2.783 0-1.84.55-2.748 1.442-2.748.89 0 1.435.902 1.435 2.754"
      })
    }))
  }, props));
}

__name(Whole30Icon, "Whole30Icon");

function WholesaleCategoryIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M22.51 17.04c.3-2.5 1.49-6.58 1.49-9.49C24 3.36 21.38 0 18.15 0H5.88C2.63 0 0 3.41 0 7.62s2.62 7.61 5.86 7.62h2.45c-.1.62-.17 1.24-.2 1.79-.21 4.54 1.39 6.96 1.39 6.96H12c-.16-1.24.51-2.32 1.42-2.38.04-.01.08-.01.12-.01 1.57 0 2.16 2.2 2.21 2.39h2c-.14-1.23.31-2.32 1.21-2.38.04-.01.08-.01.12-.01 1.63 0 2.41 2.33 2.42 2.39H24s-1.9-3.65-1.49-6.96zM1.75 7.62c0-3.18 1.89-5.87 4.13-5.87S10 4.44 10 7.63s-1.89 5.88-4.12 5.88-4.13-2.7-4.13-5.89m19.64 5.78c-.26 1.25-.5 2.43-.62 3.43-.15 1.22-.04 2.46.18 3.59-.53-.34-1.15-.56-1.87-.56-.08 0-.16.01-.24.01-.78.05-1.49.42-2 1.03-.14.17-.26.36-.37.55-.68-.92-1.65-1.59-2.93-1.59-.08 0-.16.01-.24.01-.84.06-1.62.47-2.18 1.16-.25.3-.46.65-.6 1.03-.35-.96-.77-2.62-.66-4.93.05-.95.24-2.16.52-3.24.08-.29.19-.63.32-1.03.3-.9.65-2.05.86-3.35.12-.61.19-1.24.19-1.89 0-2.36-.83-4.47-2.13-5.87h8.53c2.22 0 4.1 2.65 4.1 5.8 0 1.66-.46 3.89-.86 5.85"
      }), /* @__PURE__ */jsx("path", {
        d: "M5.86 10.07c.79 0 1.43-1.106 1.43-2.47s-.64-2.47-1.43-2.47S4.43 6.236 4.43 7.6s.64 2.47 1.43 2.47"
      })]
    }))
  }, props));
}

__name(WholesaleCategoryIcon, "WholesaleCategoryIcon");

function WholesaleCategoryFilledIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M23.03 17.957c.3-2.5 1.49-6.583 1.49-9.494C24.52 4.271 21.9.91 18.67.91H6.4C3.16.91.52 4.321.52 8.533s2.62 7.613 5.86 7.623h2.45c-.1.62-.17 1.24-.2 1.791-.21 4.542 1.39 6.963 1.39 6.963h2.5c-.16-1.24.51-2.321 1.42-2.381.04-.01.08-.01.12-.01 1.57 0 2.16 2.2 2.21 2.391h2c-.14-1.23.31-2.321 1.21-2.381.04-.01.08-.01.12-.01 1.63 0 2.41 2.331 2.42 2.391h2.5s-1.9-3.651-1.49-6.963zM2.27 8.533c0-3.181 1.89-5.882 4.12-5.882s4.12 2.69 4.12 5.882-1.89 5.883-4.12 5.883-4.12-2.691-4.12-5.883"
      }), /* @__PURE__ */jsx("path", {
        d: "M6.38 10.984c.79 0 1.43-1.106 1.43-2.47 0-1.366-.64-2.472-1.43-2.472S4.95 7.148 4.95 8.513s.64 2.471 1.43 2.471"
      })]
    }))
  }, props));
}

__name(WholesaleCategoryFilledIcon, "WholesaleCategoryFilledIcon");

function YouTubeIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        d: "M22.54 7.342a2.72 2.72 0 0 0-1.945-1.894C18.88 5 12 5 12 5s-6.88 0-8.595.448A2.72 2.72 0 0 0 1.46 7.342C1 9.013 1 12.5 1 12.5s0 3.487.46 5.158a2.72 2.72 0 0 0 1.945 1.894C5.12 20 12 20 12 20s6.88 0 8.595-.448a2.72 2.72 0 0 0 1.945-1.894C23 15.987 23 12.5 23 12.5s0-3.487-.46-5.158M9.8 15.714V9.286l5.716 3.214z"
      })
    }))
  }, props));
}

__name(YouTubeIcon, "YouTubeIcon");

function YourItemsIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 6.254v-2l-2-2h-6l-2 2v2h-3v16h16v-16zm-8-2h6v2h-6zm3 14.372s-3.509-2.74-4.296-4.75c-.612-1.57.225-2.924 1.53-3.1 1.016-.134 2.114.378 2.766 1.395.652-1.021 1.745-1.534 2.766-1.395 1.305.176 2.142 1.53 1.53 3.1-.783 2.01-4.296 4.75-4.296 4.75"
      })
    }))
  }, props));
}

__name(YourItemsIcon, "YourItemsIcon");

function YourItemsOutlineIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsx("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 4.25v2h3v16h-16v-16h3v-2l2-2h6zm-2 0v2h-6v-2zm3 4h-12v12h12zm-6 10.369s-3.509-2.74-4.296-4.75c-.612-1.57.225-2.924 1.53-3.1 1.016-.134 2.114.378 2.766 1.395.652-1.021 1.745-1.534 2.766-1.394 1.305.175 2.142 1.529 1.53 3.099-.783 2.01-4.296 4.75-4.296 4.75"
      })
    }))
  }, props));
}

__name(YourItemsOutlineIcon, "YourItemsOutlineIcon");

function ZoomInIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M10 7v3H7v2h3v3h2v-3h3v-2h-3V7z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 19c1.667 0 3.215-.51 4.496-1.382l3.943 3.943 2.122-2.122-3.943-3.943A8 8 0 1 0 11 19m0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
      })]
    }))
  }, props));
}

__name(ZoomInIcon, "ZoomInIcon");

function ZoomOutIcon(props) {
  return /* @__PURE__ */jsx(SVGIcon, __spreadValues({
    component: /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [/* @__PURE__ */jsx("path", {
        d: "M7 12h8v-2H7z"
      }), /* @__PURE__ */jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 19c1.667 0 3.215-.51 4.496-1.382l3.943 3.943 2.122-2.122-3.943-3.943A8 8 0 1 0 11 19m0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
      })]
    }))
  }, props));
}

__name(ZoomOutIcon, "ZoomOutIcon");

function ApplePayLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M29.012 36.124c.15 1.433-.42 2.836-1.259 3.88-.869 1.016-2.247 1.821-3.625 1.702-.18-1.373.51-2.835 1.289-3.73.867-1.045 2.366-1.791 3.595-1.852ZM28.996 41.974c-1.218-.072-2.325.362-3.22.714-.578.226-1.067.418-1.441.418-.413 0-.921-.2-1.492-.425-.752-.295-1.613-.634-2.513-.618-2.062.03-3.974 1.19-5.02 3.036-2.152 3.691-.568 9.167 1.524 12.174 1.016 1.487 2.24 3.125 3.854 3.066.707-.028 1.214-.24 1.74-.462.608-.255 1.241-.52 2.235-.52.948 0 1.552.257 2.132.504.553.236 1.085.463 1.872.448 1.674-.03 2.72-1.488 3.736-2.977 1.105-1.607 1.592-3.163 1.665-3.396l.008-.026-.04-.02c-.375-.172-3.189-1.459-3.217-4.892-.028-2.881 2.215-4.343 2.584-4.583a1.21 1.21 0 0 0 .046-.03c-1.434-2.112-3.676-2.35-4.453-2.41Z",
      fill: "#000"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M53.815 45.16c0-4.347-3.03-7.334-7.383-7.334h-8.41v22.328h3.482v-7.629h4.819c4.399 0 7.492-3.001 7.492-7.365Zm-8.316 4.457h-3.995V40.75h4.01c3.016 0 4.741 1.609 4.741 4.425s-1.725 4.44-4.756 4.44ZM54.724 55.527c0-2.847 2.192-4.595 6.079-4.812l4.476-.263V49.2c0-1.81-1.228-2.893-3.28-2.893-1.943 0-3.156.928-3.45 2.382h-3.172c.187-2.94 2.705-5.106 6.746-5.106 3.964 0 6.498 2.089 6.498 5.354v11.218h-3.218v-2.677h-.077c-.948 1.81-3.016 2.955-5.161 2.955-3.202 0-5.44-1.98-5.44-4.905Zm10.555-1.47v-1.284l-4.026.248c-2.005.14-3.14 1.021-3.14 2.414 0 1.423 1.181 2.351 2.984 2.351 2.347 0 4.182-1.609 4.182-3.729Z",
      fill: "#000"
    }), /* @__PURE__ */jsx("path", {
      d: "M71.659 63.434v2.708c.248.046 1.087.077 1.367.077 3.389 0 5.006-1.269 6.404-5.214l6.125-17.129h-3.544l-4.135 13.245h-.062l-4.135-13.245h-3.637l5.906 16.293c0 .007-.05.175-.11.372-.084.28-.185.616-.185.634-.513 1.671-1.352 2.32-2.907 2.32-.28 0-.84 0-1.087-.061Z",
      fill: "#000"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M90.224 19H9.776c-.335 0-.67 0-1.005.002-.283.002-.565.005-.847.013-.615.016-1.235.052-1.843.161-.617.11-1.191.291-1.751.575a5.878 5.878 0 0 0-2.576 2.564 6.147 6.147 0 0 0-.577 1.744c-.11.605-.146 1.223-.163 1.834-.008.281-.01.562-.013.842v46.981c.002.28.006.562.013.843.017.61.053 1.228.163 1.833.11.615.292 1.186.577 1.744A5.844 5.844 0 0 0 4.33 80.7c.56.285 1.134.465 1.751.576a12.47 12.47 0 0 0 1.843.161c.282.006.564.01.847.011.335.003.67.003 1.005.003h80.448c.334 0 .67 0 1.004-.003.282 0 .564-.005.848-.011a12.505 12.505 0 0 0 1.843-.161 6.228 6.228 0 0 0 1.751-.576 5.849 5.849 0 0 0 2.576-2.564c.286-.558.467-1.13.577-1.744.11-.605.145-1.222.162-1.834.007-.28.011-.561.012-.842.003-.334.003-.667.003-1.001V27.737c0-.334 0-.668-.003-1.002 0-.28-.005-.561-.012-.842-.017-.611-.053-1.229-.162-1.834a6.11 6.11 0 0 0-.577-1.744 5.877 5.877 0 0 0-2.576-2.564 6.25 6.25 0 0 0-1.751-.575c-.61-.109-1.23-.145-1.843-.161-.284-.008-.566-.011-.848-.013-.334-.002-.67-.002-1.004-.002Zm0 2.082.99.002c.267.001.536.004.805.012.47.012 1.018.038 1.529.129.444.08.817.2 1.175.382a3.787 3.787 0 0 1 1.66 1.654c.181.354.302.723.382 1.168.091.504.116 1.051.13 1.521.007.265.01.53.011.802.003.321.003.643.003.965v45.017c0 .323 0 .644-.003.973-.001.265-.005.53-.012.795-.013.47-.038 1.016-.13 1.526-.079.44-.2.809-.382 1.164a3.772 3.772 0 0 1-1.663 1.654 4.11 4.11 0 0 1-1.167.38c-.522.093-1.093.118-1.524.13-.27.006-.54.01-.816.01-.321.003-.644.003-.966.003H9.763c-.325 0-.65 0-.982-.002-.27-.001-.54-.005-.8-.01-.44-.013-1.012-.038-1.53-.13-.444-.08-.816-.2-1.175-.383a3.752 3.752 0 0 1-.96-.696 3.746 3.746 0 0 1-.699-.956 4.074 4.074 0 0 1-.382-1.17c-.092-.509-.118-1.054-.13-1.52-.008-.266-.01-.533-.012-.798l-.002-.782V27.53l.001-.78c.002-.268.005-.534.013-.8.012-.467.038-1.012.13-1.525.08-.44.201-.811.383-1.168a3.778 3.778 0 0 1 1.66-1.652c.356-.18.73-.3 1.173-.38.512-.092 1.06-.117 1.53-.13.268-.007.536-.01.802-.011l.993-.002h80.448Z",
      fill: "#000"
    })]
  })), props);
}

__name(ApplePayLogo, "ApplePayLogo");

function GPayLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M72.936 24H27.064C12.729 24 1 35.475 1 49.5S12.729 75 27.064 75h45.872C87.271 75 99 63.525 99 49.5S87.271 24 72.936 24Z",
      fill: "#fff"
    }), /* @__PURE__ */jsx("path", {
      d: "M72.936 26.066c3.22 0 6.347.624 9.292 1.848a24.197 24.197 0 0 1 7.624 5.036 23.475 23.475 0 0 1 5.147 7.46 22.701 22.701 0 0 1 1.89 9.09c0 3.15-.639 6.21-1.89 9.09-1.212 2.793-2.945 5.292-5.147 7.46a24.051 24.051 0 0 1-7.624 5.036 24.095 24.095 0 0 1-9.292 1.849H27.064a24.197 24.197 0 0 1-16.915-6.885A23.476 23.476 0 0 1 5 58.59a22.702 22.702 0 0 1-1.89-9.09c0-3.15.639-6.21 1.89-9.09 1.212-2.793 2.945-5.292 5.147-7.46a24.051 24.051 0 0 1 7.624-5.036 24.095 24.095 0 0 1 9.292-1.849h45.872Zm0-2.066H27.064C12.729 24 1 35.475 1 49.5S12.729 75 27.064 75h45.872C87.271 75 99 63.525 99 49.5S87.271 24 72.936 24Z",
      fill: "#3C4043"
    }), /* @__PURE__ */jsx("path", {
      d: "M47.685 51.607v7.889h-2.5V40.014h6.627c1.68 0 3.111.561 4.283 1.683 1.197 1.121 1.796 2.49 1.796 4.107 0 1.656-.599 3.025-1.796 4.134-1.159 1.108-2.59 1.656-4.283 1.656h-4.127v.013Zm0-9.193v6.794h4.179c.99 0 1.822-.34 2.473-1.005.664-.665 1.003-1.473 1.003-2.386 0-.9-.339-1.695-1.003-2.36-.65-.691-1.47-1.03-2.473-1.03h-4.18v-.013ZM64.427 45.726c1.848 0 3.306.496 4.374 1.487 1.067.99 1.601 2.347 1.601 4.068v8.215H68.02v-1.852h-.104c-1.029 1.526-2.409 2.282-4.127 2.282-1.471 0-2.695-.43-3.684-1.304-.99-.873-1.485-1.956-1.485-3.26 0-1.382.521-2.477 1.563-3.286 1.041-.821 2.434-1.225 4.166-1.225 1.484 0 2.707.273 3.658.821V51.1c0-.874-.339-1.604-1.029-2.217a3.525 3.525 0 0 0-2.421-.913c-1.393 0-2.5.587-3.307 1.773l-2.2-1.382c1.21-1.76 3.007-2.634 5.377-2.634Zm-3.229 9.676c0 .652.273 1.2.833 1.63.547.43 1.198.652 1.94.652 1.055 0 1.992-.392 2.812-1.174.82-.782 1.237-1.695 1.237-2.751-.781-.613-1.862-.926-3.255-.926-1.015 0-1.861.248-2.538.73-.69.508-1.029 1.121-1.029 1.839ZM83.994 46.156l-8.332 19.195h-2.578l3.099-6.716-5.494-12.479h2.72l3.958 9.572h.052l3.854-9.572h2.72Z",
      fill: "#3C4043"
    }), /* @__PURE__ */jsx("path", {
      d: "M37.742 50.016c0-.816-.072-1.597-.208-2.348H27.057v4.303l6.034.001a5.178 5.178 0 0 1-2.24 3.466v2.792h3.593c2.097-1.944 3.298-4.818 3.298-8.214Z",
      fill: "#4285F4"
    }), /* @__PURE__ */jsx("path", {
      d: "M30.853 55.438c-1 .675-2.287 1.07-3.794 1.07-2.91 0-5.378-1.963-6.262-4.61h-3.705v2.879c1.836 3.648 5.609 6.152 9.967 6.152 3.013 0 5.544-.992 7.386-2.7l-3.592-2.791Z",
      fill: "#34A853"
    }), /* @__PURE__ */jsx("path", {
      d: "M20.448 49.762c0-.744.124-1.462.35-2.138v-2.879h-3.706a11.128 11.128 0 0 0-1.186 5.017c0 1.804.429 3.507 1.186 5.016l3.705-2.88a6.747 6.747 0 0 1-.349-2.136Z",
      fill: "#FABB05"
    }), /* @__PURE__ */jsx("path", {
      d: "M27.06 43.014c1.644 0 3.116.567 4.279 1.675l3.183-3.185c-1.934-1.804-4.454-2.91-7.463-2.91-4.357 0-8.131 2.503-9.967 6.151l3.705 2.88c.884-2.648 3.353-4.611 6.262-4.611Z",
      fill: "#E94235"
    })]
  })), props);
}

__name(GPayLogo, "GPayLogo");

function ICBusinessWordmarkDefaultLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 383,
    height: 32,
    viewBox: "0 0 383 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M208.331 31.558h6.603V27.4h.406c1.18 2.834 3.615 4.6 7.267 4.6 6.123 0 10.513-4.71 10.513-12.071 0-7.398-4.058-11.704-9.923-11.704-3.725 0-6.16 1.767-7.673 5.263h-.405V.423h-6.788v31.135Zm12.21-4.931c-3.504 0-5.681-2.245-5.681-6.514 0-4.122 2.251-6.33 5.755-6.33 3.652 0 5.681 2.245 5.681 6.477s-2.25 6.367-5.755 6.367ZM243.343 32c3.542 0 5.792-1.62 7.083-4.748h.332v4.306h6.603V8.63h-6.788v13.654c0 2.944-1.512 4.49-4.242 4.49-2.692 0-3.947-1.472-3.947-4.453V8.63h-6.787v14.683c0 5.631 2.877 8.686 7.746 8.686ZM269.634 32c6.972 0 9.849-3.607 9.849-7.618 0-3.975-1.992-6.257-7.119-6.846l-3.283-.404c-1.845-.221-2.619-.884-2.619-2.025 0-1.25 1.033-2.244 3.209-2.244 2.213 0 3.209.993 3.394 2.686h6.271c-.443-4.38-3.357-7.324-9.481-7.324-6.344 0-9.627 3.386-9.627 7.545 0 4.011 2.287 6.146 7.34 6.735l3.099.405c1.881.22 2.508.883 2.508 2.098 0 1.361-1.033 2.355-3.32 2.355-2.397 0-3.504-1.141-3.688-3.018H259.6c.443 4.416 3.505 7.655 10.034 7.655ZM285.393 7.01c2.36 0 3.799-1.287 3.799-3.238 0-2.024-1.365-3.275-3.763-3.275-2.36 0-3.799 1.288-3.799 3.238 0 2.025 1.365 3.276 3.763 3.276Zm-3.357 24.548h6.787V8.63h-6.787v22.928ZM292.302 31.558h6.788v-13.36c0-3.127 1.549-4.784 4.316-4.784 2.729 0 4.131 1.4 4.131 4.638v13.506h6.788V16.764c0-5.447-2.951-8.539-8.005-8.539-3.652 0-5.828 1.84-7.083 4.711h-.332V8.63h-6.603v22.928ZM328.916 32c6.64 0 10.587-3.239 11.656-8.207h-6.529c-.553 1.95-2.139 3.055-4.869 3.055-3.136 0-5.201-1.473-5.681-5.19h17.079v-.993c0-7.655-3.983-12.44-11.546-12.44-7.599 0-12.283 4.932-12.283 12.072 0 7.25 4.648 11.703 12.173 11.703Zm0-18.696c2.914 0 4.611 1.472 4.943 4.49H323.53c.553-3.018 2.435-4.49 5.386-4.49ZM351.912 32c6.972 0 9.849-3.607 9.849-7.618 0-3.975-1.992-6.257-7.119-6.846l-3.283-.404c-1.845-.221-2.619-.884-2.619-2.025 0-1.25 1.033-2.244 3.209-2.244 2.213 0 3.209.993 3.394 2.686h6.271c-.443-4.38-3.357-7.324-9.481-7.324-6.344 0-9.627 3.386-9.627 7.545 0 4.011 2.287 6.146 7.34 6.735l3.099.405c1.881.22 2.508.883 2.508 2.098 0 1.361-1.032 2.355-3.32 2.355-2.397 0-3.504-1.141-3.688-3.018h-6.566c.442 4.416 3.504 7.655 10.033 7.655ZM373.13 32c6.972 0 9.849-3.607 9.849-7.618 0-3.975-1.992-6.257-7.119-6.846l-3.283-.404c-1.845-.221-2.619-.884-2.619-2.025 0-1.25 1.033-2.244 3.209-2.244 2.213 0 3.209.993 3.394 2.686h6.271c-.443-4.38-3.357-7.324-9.481-7.324-6.344 0-9.627 3.386-9.627 7.545 0 4.011 2.287 6.146 7.34 6.735l3.099.405c1.881.22 2.508.883 2.508 2.098 0 1.361-1.033 2.355-3.32 2.355-2.397 0-3.504-1.141-3.688-3.018h-6.567c.443 4.416 3.505 7.655 10.034 7.655Z",
      fill: "#5D5FEF"
    }), /* @__PURE__ */jsx("path", {
      d: "M21.61 5.468c-1.374 0-2.353.597-3.258 1.893l-2.604 3.733V.44H9.534v10.657L6.93 7.364C6.026 6.07 5.046 5.471 3.672 5.471 1.597 5.468.217 6.997.21 8.88c-.007 1.61.756 2.663 2.36 3.693l10.071 6.472 10.071-6.472c1.605-1.03 2.367-2.083 2.36-3.693-.006-1.883-1.387-3.409-3.461-3.409v-.003Z",
      fill: "#0AAD0A"
    }), /* @__PURE__ */jsx("path", {
      d: "M12.641 20.597c5.984 0 10.893 4.457 10.88 10.85H1.765c-.013-6.392 4.892-10.85 10.876-10.85Z",
      fill: "#FF7009"
    }), /* @__PURE__ */jsx("path", {
      d: "M36.238 7.22c-2.314 0-3.784-1.43-3.784-3.628C32.454 1.394 33.96 0 36.238 0c2.279 0 3.785 1.43 3.785 3.628 0 2.198-1.506 3.592-3.785 3.592Zm3.38 1.394v22.834h-6.76V8.614h6.76ZM49.646 8.614v4.251h.332c1.286-3.005 3.528-4.69 7.128-4.69 4.886 0 7.898 2.896 7.898 8.502v14.77h-6.76V17.924c0-3.152-1.358-4.582-4.04-4.582-2.684 0-4.374 1.538-4.374 4.763v13.34h-6.76V8.615h6.576ZM73.598 24.228c.257 1.978 1.47 3.005 3.637 3.005 2.387 0 3.38-.915 3.38-2.198s-.625-1.978-2.683-2.198l-2.94-.331c-5.254-.587-7.42-2.933-7.42-6.816 0-4.324 3.268-7.512 9.587-7.512 6.32 0 9.075 2.932 9.443 7.367h-6.244c-.148-1.722-1.177-2.713-3.344-2.713-2.166 0-3.231.916-3.231 2.198 0 1.1.697 1.722 2.423 1.942l3.307.44c5.179.695 7.385 2.785 7.385 6.852 0 4.471-3.489 7.623-9.7 7.623-6.21 0-9.662-3.08-10.103-7.659h6.503ZM90.797 24.74V13.964h-2.903V9.493c3.748-.256 5.218-1.65 5.362-5.094h4.298v4.215h5.106v5.35h-5.106v9.64c0 2.274.956 2.97 2.827 2.97.553 0 1.138-.073 1.69-.184v5.094c-1.137.292-2.166.403-3.344.403-5.546 0-7.933-2.493-7.933-7.147h.003ZM117.577 27.636c-1.066 2.677-3.088 4.251-6.576 4.251-4.557 0-7.016-2.82-7.016-6.449 0-3.372 1.91-5.717 7.092-6.672l3.892-.695c1.983-.367 2.683-1.063 2.683-2.237 0-1.578-1.101-2.493-3.232-2.493-2.35 0-3.528 1.063-3.748 2.896h-6.428c.697-4.91 4.298-8.063 10.433-8.063 6.612 0 9.735 3.336 9.735 8.467v14.807h-6.539v-3.812h-.296Zm.072-6.708c-.589.44-1.358.77-2.423 1.027l-2.022.475c-1.762.404-2.423 1.21-2.423 2.457 0 1.614 1.137 2.53 3.048 2.53 2.278 0 3.82-1.247 3.82-4.18v-2.309ZM139.102 8.174c7.128 0 11.093 3.884 11.61 10.117h-6.688c-.332-2.821-1.874-4.619-4.958-4.619-3.452 0-5.399 2.162-5.399 6.233 0 4.323 2.095 6.488 5.475 6.488 2.867 0 4.665-1.686 4.997-4.727h6.724c-.625 6.377-4.922 10.225-11.938 10.225-7.714 0-12.086-4.619-12.086-11.767 0-7.147 4.849-11.946 12.27-11.946l-.007-.004ZM166.115 27.636c-1.065 2.677-3.087 4.251-6.575 4.251-4.557 0-7.017-2.82-7.017-6.449 0-3.372 1.911-5.717 7.092-6.672l3.893-.695c1.983-.367 2.683-1.063 2.683-2.237 0-1.578-1.102-2.493-3.232-2.493-2.351 0-3.528 1.063-3.748 2.896h-6.428c.697-4.91 4.297-8.063 10.432-8.063 6.612 0 9.736 3.336 9.736 8.467v14.807h-6.54v-3.812h-.296Zm.073-6.708c-.589.44-1.358.77-2.424 1.027l-2.022.475c-1.762.404-2.423 1.21-2.423 2.457 0 1.614 1.138 2.53 3.048 2.53 2.279 0 3.821-1.247 3.821-4.18v-2.309ZM182.607 8.614v5.534h.332c1.138-4.655 2.792-5.938 4.995-5.938.476 0 .917.073 1.357.22v6.34c-.552-.071-1.137-.147-1.837-.147-3.196 0-4.482 1.283-4.482 4.875v11.946h-6.76V8.614h6.395ZM191.327 8.87c1.762-.696 2.498-2.126 2.607-4.471h4.153v4.215h5.106v5.35h-5.106v9.64c0 2.274.953 2.97 2.827 2.97a8.71 8.71 0 0 0 1.69-.184v5.094c-1.138.292-2.167.403-3.344.403-5.546 0-7.933-2.493-7.933-7.147V8.87Z",
      fill: "#10004A"
    })]
  })), props);
}

__name(ICBusinessWordmarkDefaultLogo, "ICBusinessWordmarkDefaultLogo");

function ICHalfCarrotLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M15.999 20.2c5.392 0 9.812 4.024 9.8 9.8h-19.6c-.01-5.773 4.409-9.8 9.8-9.8Z",
      fill: "#FF7009"
    }), /* @__PURE__ */jsx("path", {
      d: "M24.082 6.541c-1.238 0-2.12.54-2.935 1.71L18.8 11.624V2h-5.6v9.623l-2.347-3.371C10.04 7.08 9.156 6.54 7.918 6.54c-1.868 0-3.112 1.38-3.118 3.079-.005 1.456.682 2.404 2.128 3.335L16 18.8l9.072-5.845c1.446-.931 2.133-1.88 2.128-3.335-.006-1.7-1.25-3.079-3.118-3.079Z",
      fill: "#0AAD0A"
    })]
  })), props);
}

__name(ICHalfCarrotLogo, "ICHalfCarrotLogo");

function ICHealthWordmarkCashewOliveLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 328,
    height: 32,
    viewBox: "0 0 328 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M211.674 31.552h4.894V18.18c0-4.106 2.032-6.102 5.345-6.102 3.2 0 4.743 1.845 4.743 5.386v14.087h4.894V16.9c0-4.67-2.522-7.684-7.529-7.684-3.576 0-5.835 1.507-7.228 4.144h-.225V.516h-4.894v31.036ZM246.279 31.966c5.872 0 9.072-3.277 9.335-9.152h-1.28c-.414 3.766-2.371 5.725-6.248 5.725-4.555 0-7.906-2.788-7.906-9.718v-.15h15.208c-.414-5.801-3.915-9.455-9.486-9.455-6.06 0-10.54 4.633-10.54 11.639 0 6.554 3.877 11.111 10.917 11.111Zm-.64-21.28c2.936 0 4.668 1.92 4.63 6.553h-10.013c.376-4.558 2.559-6.554 5.383-6.554ZM264.936 31.966c3.2 0 5.007-1.393 6.324-3.88h.301v3.466h4.743V16.599c0-4.67-2.973-7.383-8.62-7.383-5.12 0-8.357 2.712-9.11 6.516h4.706c.113-3.39 1.468-5.01 4.291-5.01 2.597 0 4.028 1.395 4.028 3.993.038 2.788-1.167 3.955-4.743 4.972l-3.275.867c-4.141 1.167-5.383 3.088-5.383 5.65 0 3.352 2.409 5.762 6.738 5.762Zm1.845-2.674c-2.334 0-3.765-1.469-3.765-3.993 0-1.92.828-3.163 3.463-3.992l1.431-.414c1.694-.528 2.785-1.13 3.538-1.921v4.633c0 3.917-1.844 5.687-4.667 5.687ZM281.116 31.552h4.894V.516h-4.894v31.036ZM298.382 31.966c3.915 0 6.023-2.222 5.872-7.684h-1.279c-.038 3.428-1.054 4.596-3.012 4.596-1.769 0-2.786-.98-2.786-3.503V12.079h6.889V9.63h-6.889V4.357h-1.091c-.678 3.767-1.995 5.123-5.797 5.575l-1.28.113v2.034h3.312v14.05c0 3.954 2.334 5.837 6.061 5.837ZM307.805 31.552h4.893V18.18c0-4.106 2.033-6.102 5.346-6.102 3.199 0 4.743 1.845 4.743 5.386v14.087h4.893V16.9c0-4.67-2.522-7.684-7.528-7.684-3.576 0-5.835 1.507-7.228 4.144h-.226V.516h-4.893v31.036Z",
      fill: "#C3C969"
    }), /* @__PURE__ */jsx("path", {
      d: "M13.706 20.663c5.992 0 10.903 4.472 10.889 10.89H2.816c-.01-6.415 4.899-10.89 10.89-10.89Z",
      fill: "#FF7009"
    }), /* @__PURE__ */jsx("path", {
      d: "M22.688 5.487c-1.377 0-2.357.598-3.267 1.9l-2.607 3.746V.44H10.59v10.693L7.984 7.388C7.08 6.085 6.1 5.487 4.717 5.487c-2.075 0-3.458 1.532-3.464 3.422 0 1.618.758 2.67 2.363 3.705l10.082 6.495 10.081-6.495c1.606-1.034 2.37-2.087 2.363-3.705.002-1.89-1.38-3.422-3.454-3.422Z",
      fill: "#0AAD0A"
    }), /* @__PURE__ */jsx("path", {
      d: "M37.33 7.244c-2.316 0-3.788-1.434-3.788-3.641C33.542 1.395 35.05 0 37.33 0c2.317 0 3.788 1.433 3.788 3.64s-1.507 3.604-3.788 3.604Zm3.384 1.4v22.908h-6.767V8.642l6.767.002ZM50.752 8.641v4.267h.331C52.371 9.892 54.614 8.2 58.22 8.2c4.89 0 7.905 2.905 7.905 8.532v14.82h-6.767v-13.57c0-3.162-1.36-4.596-4.044-4.596-2.8 0-4.376 1.545-4.376 4.78v13.386H44.17V8.642h6.582ZM74.728 24.308c.258 1.986 1.472 3.016 3.642 3.016 2.39 0 3.383-.92 3.383-2.207 0-1.245-.622-1.987-2.685-2.206l-2.941-.332c-5.26-.588-7.43-2.941-7.43-6.844 0-4.34 3.267-7.54 9.598-7.54 6.179 0 9.085 2.943 9.452 7.392h-6.252c-.146-1.728-1.176-2.72-3.346-2.72-2.243 0-3.236.919-3.236 2.205 0 1.103.699 1.728 2.427 1.95l3.309.446c5.186.698 7.392 2.8 7.392 6.877 0 4.486-3.494 7.649-9.709 7.649-6.435 0-9.672-3.09-10.11-7.686h6.506ZM91.945 24.823V14.01H89.04V9.525c3.752-.258 5.222-1.655 5.37-5.113h4.302v4.23h5.115v5.37h-5.115v9.67c0 2.28.957 2.98 2.831 2.98a8.82 8.82 0 0 0 1.693-.184v5.111a12.85 12.85 0 0 1-3.348.405c-5.55 0-7.943-2.502-7.943-7.171ZM119.048 27.728h-.287c-1.068 2.684-3.09 4.266-6.584 4.266-4.561 0-7.023-2.831-7.023-6.473 0-3.383 1.912-5.737 7.096-6.689l3.899-.7c1.986-.367 2.685-1.066 2.685-2.243 0-1.58-1.103-2.5-3.236-2.5-2.354 0-3.531 1.066-3.752 2.904h-6.442c.699-4.928 4.303-8.089 10.445-8.089 6.619 0 9.745 3.348 9.745 8.495v14.858h-6.546v-3.829Zm-.221-6.73c-.588.441-1.361.777-2.426 1.03l-2.023.478c-1.764.405-2.426 1.214-2.426 2.464 0 1.618 1.14 2.538 3.052 2.538 2.28 0 3.825-1.245 3.825-4.193l-.002-2.318ZM140.302 8.2c7.136 0 11.107 3.898 11.622 10.15h-6.689c-.33-2.832-1.867-4.634-4.964-4.634-3.458 0-5.405 2.17-5.405 6.253 0 4.339 2.095 6.509 5.478 6.509 2.869 0 4.667-1.693 5.002-4.745h6.729c-.622 6.4-4.927 10.267-11.952 10.267-7.722 0-12.099-4.634-12.099-11.805-.005-7.251 4.85-11.995 12.278-11.995ZM167.639 27.728h-.294c-1.066 2.684-3.088 4.266-6.582 4.266-4.561 0-7.025-2.831-7.025-6.473 0-3.383 1.914-5.737 7.098-6.689l3.899-.7c1.986-.367 2.685-1.066 2.685-2.243 0-1.58-1.105-2.5-3.238-2.5-2.353 0-3.529 1.066-3.75 2.904h-6.436c.699-4.928 4.303-8.089 10.445-8.089 6.619 0 9.745 3.348 9.745 8.495v14.858h-6.547v-3.829Zm-.219-6.73c-.588.441-1.361.777-2.429 1.03l-2.022.478c-1.765.405-2.427 1.214-2.427 2.464 0 1.618 1.141 2.538 3.052 2.538 2.281 0 3.826-1.245 3.826-4.193v-2.318ZM183.856 8.641v5.554h.331c1.14-4.667 2.8-5.958 5.001-5.958.463-.002.923.073 1.362.22v6.363a13.147 13.147 0 0 0-1.839-.148c-3.2 0-4.486 1.288-4.486 4.891v11.989h-6.767V8.642h6.398ZM192.586 8.9c1.765-.7 2.499-2.135 2.61-4.488h4.156v4.23h5.112v5.37h-5.112v9.67c0 2.28.956 2.98 2.832 2.98a8.792 8.792 0 0 0 1.691-.184v5.111a12.832 12.832 0 0 1-3.346.405c-5.554 0-7.943-2.502-7.943-7.171V8.899Z",
      fill: "#FAF1E5"
    })]
  })), props);
}

__name(ICHealthWordmarkCashewOliveLogo, "ICHealthWordmarkCashewOliveLogo");

function ICPlusPlumBadgeLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M14.553 9.873c.592-.85 1.233-1.243 2.134-1.243 1.358 0 2.262 1.002 2.267 2.236.004 1.057-.496 1.745-1.547 2.422l-6.597 4.244-6.597-4.244c-1.05-.677-1.55-1.365-1.546-2.422.004-1.234.909-2.236 2.267-2.236.9 0 1.542.392 2.134 1.243l1.706 2.448V5.333h4.072v6.988l1.707-2.448ZM17.936 25.665c.008-4.194-3.206-7.116-7.127-7.116-3.92 0-7.133 2.924-7.125 7.116h14.252Z",
      fill: "#750046"
    }), /* @__PURE__ */jsx("path", {
      d: "M29.332 15.879H25.03v-4.297h-3.462v4.297h-4.302v3.425h4.302v4.297h3.462v-4.297h4.302V15.88Z",
      fill: "#EC269A"
    })]
  })), props);
}

__name(ICPlusPlumBadgeLogo, "ICPlusPlumBadgeLogo");

function ICPlusWordmarkCashewLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 161,
    height: 32,
    viewBox: "0 0 161 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsxs("g", {
      clipPath: "url(#prefix__clip0_9215_3693)",
      children: [/* @__PURE__ */jsx("path", {
        d: "M159.92 9.927h-5.562V4.373h-4.475v5.554h-5.562v4.428h5.562v5.555h4.475v-5.555h5.562V9.927Z",
        fill: "#EC269A"
      }), /* @__PURE__ */jsx("path", {
        d: "M4.044 2.8C2.164 2.8.92 3.955.92 5.772s1.214 3.002 3.124 3.002c1.88 0 3.124-1.154 3.124-2.971 0-1.818-1.213-3.003-3.124-3.003ZM6.834 9.927h-5.58v18.895h5.58V9.927ZM21.27 9.563c-2.972 0-4.822 1.396-5.883 3.882h-.273V9.927H9.685v18.895h5.58v-11.04c0-2.669 1.305-3.942 3.61-3.942 2.214 0 3.335 1.182 3.335 3.791v11.19h5.58V16.6c.001-4.64-2.486-7.037-6.52-7.037ZM39.77 17.206l-2.73-.363c-1.425-.183-2.002-.698-2.002-1.608 0-1.062.82-1.82 2.67-1.82 1.79 0 2.638.819 2.758 2.245h5.156c-.304-3.67-2.7-6.094-7.795-6.094-5.217 0-7.916 2.638-7.916 6.218 0 3.214 1.79 5.155 6.127 5.64l2.426.274c1.698.181 2.214.788 2.214 1.819 0 1.062-.82 1.82-2.79 1.82-1.79 0-2.79-.85-3.003-2.487h-5.366c.363 3.79 3.032 6.339 8.339 6.339 5.125 0 8.006-2.608 8.006-6.309.002-3.369-1.818-5.098-6.094-5.674ZM54.666 6.44h-3.548c-.122 2.85-1.335 4.003-4.427 4.215v3.7h2.396v8.916c0 3.85 1.971 5.915 6.551 5.915.93.01 1.858-.102 2.759-.334v-4.215c-.46.095-.927.146-1.395.151-1.547 0-2.336-.577-2.336-2.456v-7.977h4.216V9.93h-4.216V6.44ZM68.799 9.563c-5.068 0-8.037 2.609-8.614 6.672h5.308c.182-1.516 1.155-2.396 3.093-2.396 1.76 0 2.67.758 2.67 2.063 0 .97-.578 1.546-2.214 1.85l-3.215.577c-4.277.788-5.854 2.73-5.854 5.516 0 3.003 2.032 5.339 5.793 5.339 2.881 0 4.55-1.305 5.429-3.519h.242v3.154h5.399V16.567c0-4.244-2.578-7.004-8.037-7.004Zm2.456 12.465c0 2.427-1.274 3.458-3.154 3.458-1.577 0-2.517-.758-2.517-2.093 0-1.031.546-1.698 2.001-2.032l1.668-.394c.88-.212 1.517-.485 2.002-.85v1.911ZM88.997 24.637c-2.79 0-4.519-1.79-4.519-5.368 0-3.367 1.604-5.156 4.458-5.156 2.547 0 3.821 1.486 4.095 3.821h5.516c-.424-5.156-3.7-8.37-9.584-8.37-6.126 0-10.13 3.912-10.13 9.886 0 5.914 3.61 9.736 9.979 9.736 5.792 0 9.34-3.185 9.856-8.461h-5.55c-.27 2.516-1.753 3.912-4.121 3.912ZM108.872 9.563c-5.068 0-8.037 2.609-8.613 6.672h5.308c.182-1.516 1.154-2.396 3.093-2.396 1.759 0 2.669.758 2.669 2.063 0 .97-.577 1.546-2.214 1.85l-3.215.577c-4.276.788-5.853 2.73-5.853 5.516 0 3.003 2.031 5.339 5.792 5.339 2.882 0 4.55-1.305 5.429-3.519h.243v3.154h5.398V16.567c0-4.244-2.58-7.004-8.037-7.004Zm2.457 12.465c0 2.427-1.274 3.458-3.154 3.458-1.577 0-2.517-.758-2.517-2.093 0-1.031.546-1.698 2.001-2.032l1.668-.394c.879-.212 1.516-.485 2.002-.85v1.911ZM125.158 14.507h-.273v-4.58h-5.278v18.895h5.581v-9.887c0-2.972 1.062-4.034 3.7-4.034.508.005 1.015.046 1.517.121V9.776a3.471 3.471 0 0 0-1.123-.182c-1.819 0-3.184 1.061-4.124 4.913ZM137.664 6.44h-3.427c-.09 1.94-.697 3.124-2.153 3.7v13.132c0 3.849 1.971 5.914 6.551 5.914.93.01 1.857-.102 2.758-.333v-4.216a7.257 7.257 0 0 1-1.395.151c-1.547 0-2.336-.577-2.336-2.456v-7.977h4.216V9.93h-4.216l.002-3.49Z",
        fill: "#FAF1E5"
      }), /* @__PURE__ */jsx("path", {
        d: "M6.834 9.927h-5.58v18.895h5.58V9.927Z",
        fill: "#FAF1E5"
      })]
    }), /* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx("clipPath", {
        id: "prefix__clip0_9215_3693",
        children: /* @__PURE__ */jsx("path", {
          fill: "#fff",
          d: "M.42 0h160v32H.42z"
        })
      })
    })]
  })), props);
}

__name(ICPlusWordmarkCashewLogo, "ICPlusWordmarkCashewLogo");

function ICPlusWordmarkPlumLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 161,
    height: 32,
    viewBox: "0 0 161 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsxs("g", {
      clipPath: "url(#prefix__clip0_9215_3697)",
      children: [/* @__PURE__ */jsx("path", {
        d: "M159.71 9.927h-5.562V4.373h-4.475v5.554h-5.562v4.428h5.562v5.555h4.475v-5.555h5.562V9.927Z",
        fill: "#EC269A"
      }), /* @__PURE__ */jsx("path", {
        d: "M3.834 2.8C1.954 2.8.71 3.955.71 5.772s1.214 3.002 3.124 3.002c1.88 0 3.124-1.154 3.124-2.971 0-1.818-1.213-3.003-3.124-3.003ZM6.624 9.927h-5.58v18.895h5.58V9.927ZM21.06 9.563c-2.972 0-4.822 1.396-5.883 3.882h-.273V9.927H9.475v18.895h5.58v-11.04c0-2.669 1.305-3.942 3.61-3.942 2.214 0 3.335 1.182 3.335 3.791v11.19h5.58V16.6c.001-4.64-2.486-7.037-6.52-7.037ZM39.56 17.206l-2.73-.363c-1.425-.183-2.002-.698-2.002-1.608 0-1.062.82-1.82 2.67-1.82 1.789 0 2.638.819 2.758 2.245h5.156c-.304-3.67-2.7-6.094-7.795-6.094-5.217 0-7.916 2.638-7.916 6.218 0 3.214 1.79 5.155 6.127 5.64l2.426.274c1.698.181 2.214.788 2.214 1.819 0 1.062-.82 1.82-2.79 1.82-1.79 0-2.79-.85-3.003-2.487h-5.366c.363 3.79 3.032 6.339 8.338 6.339 5.126 0 8.007-2.608 8.007-6.309.002-3.369-1.818-5.098-6.094-5.674ZM54.456 6.44h-3.549c-.12 2.85-1.334 4.003-4.425 4.215v3.7h2.395v8.916c0 3.85 1.971 5.915 6.551 5.915.93.01 1.858-.102 2.759-.334v-4.215c-.46.095-.927.146-1.395.151-1.547 0-2.336-.577-2.336-2.456v-7.977h4.216V9.93h-4.216V6.44ZM68.588 9.563c-5.067 0-8.036 2.609-8.613 6.672h5.308c.182-1.516 1.155-2.396 3.093-2.396 1.76 0 2.67.758 2.67 2.063 0 .97-.578 1.546-2.214 1.85l-3.215.577c-4.277.788-5.854 2.73-5.854 5.516 0 3.003 2.032 5.339 5.793 5.339 2.881 0 4.55-1.305 5.429-3.519h.242v3.154h5.399V16.567c0-4.244-2.578-7.004-8.038-7.004Zm2.457 12.465c0 2.427-1.274 3.458-3.154 3.458-1.577 0-2.517-.758-2.517-2.093 0-1.031.546-1.698 2.002-2.032l1.667-.394c.88-.212 1.517-.485 2.002-.85v1.911ZM88.787 24.637c-2.79 0-4.519-1.79-4.519-5.368 0-3.367 1.604-5.156 4.458-5.156 2.547 0 3.821 1.486 4.095 3.821h5.516c-.425-5.156-3.7-8.37-9.584-8.37-6.126 0-10.13 3.912-10.13 9.886 0 5.914 3.61 9.736 9.979 9.736 5.792 0 9.34-3.185 9.856-8.461h-5.55c-.27 2.516-1.753 3.912-4.121 3.912ZM108.662 9.563c-5.068 0-8.037 2.609-8.613 6.672h5.308c.182-1.516 1.154-2.396 3.093-2.396 1.759 0 2.669.758 2.669 2.063 0 .97-.577 1.546-2.214 1.85l-3.215.577c-4.276.788-5.853 2.73-5.853 5.516 0 3.003 2.031 5.339 5.792 5.339 2.882 0 4.55-1.305 5.429-3.519h.243v3.154h5.398V16.567c0-4.244-2.58-7.004-8.037-7.004Zm2.457 12.465c0 2.427-1.274 3.458-3.154 3.458-1.577 0-2.517-.758-2.517-2.093 0-1.031.545-1.698 2.001-2.032l1.668-.394c.879-.212 1.516-.485 2.002-.85v1.911ZM124.948 14.507h-.273v-4.58h-5.278v18.895h5.581v-9.887c0-2.972 1.062-4.034 3.7-4.034.508.005 1.015.046 1.517.121V9.776a3.471 3.471 0 0 0-1.123-.182c-1.819 0-3.184 1.061-4.124 4.913ZM137.454 6.44h-3.427c-.09 1.94-.697 3.124-2.153 3.7v13.132c0 3.849 1.971 5.914 6.551 5.914.93.01 1.857-.102 2.758-.333v-4.216a7.257 7.257 0 0 1-1.395.151c-1.547 0-2.336-.577-2.336-2.456v-7.977h4.216V9.93h-4.216l.002-3.49Z",
        fill: "#750046"
      }), /* @__PURE__ */jsx("path", {
        d: "M6.624 9.927h-5.58v18.895h5.58V9.927Z",
        fill: "#750046"
      })]
    }), /* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx("clipPath", {
        id: "prefix__clip0_9215_3697",
        children: /* @__PURE__ */jsx("path", {
          fill: "#fff",
          d: "M.21 0h160v32H.21z"
        })
      })
    })]
  })), props);
}

__name(ICPlusWordmarkPlumLogo, "ICPlusWordmarkPlumLogo");

function ICWholeCarrotLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "m16.497 31 4.724-10.383c1.98-4.938-1.159-8.784-5.225-8.784s-7.203 3.85-5.223 8.784L15.497 31h1Z",
      fill: "#FF7009"
    }), /* @__PURE__ */jsx("path", {
      d: "M20.808 3.706c-.736 0-1.261.322-1.747 1.018l-1.396 2.008V1H14.33v5.735l-1.397-2.01c-.485-.693-1.01-1.018-1.746-1.018-1.112 0-1.851.82-1.856 1.833 0 .865.405 1.43 1.265 1.98L15.998 11l5.4-3.478c.86-.555 1.268-1.12 1.265-1.98-.003-1.015-.742-1.836-1.855-1.836Z",
      fill: "#0AAD0A"
    })]
  })), props);
}

__name(ICWholeCarrotLogo, "ICWholeCarrotLogo");

function ICWordmarkCashewLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 204,
    height: 32,
    viewBox: "0 0 204 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsxs("g", {
      clipPath: "url(#prefix__clip0_24283_31714)",
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.662 20.663c5.993 0 10.904 4.472 10.89 10.889H1.773c-.01-6.414 4.899-10.89 10.89-10.89Z",
        fill: "#FF7009"
      }), /* @__PURE__ */jsx("path", {
        d: "M21.645 5.487c-1.377 0-2.357.598-3.267 1.9l-2.607 3.746V.44H9.548v10.693L6.941 7.388c-.905-1.303-1.885-1.901-3.267-1.901C1.6 5.487.216 7.019.21 8.909c0 1.618.758 2.67 2.363 3.705l10.082 6.495 10.082-6.495c1.605-1.034 2.369-2.087 2.362-3.705.002-1.89-1.38-3.422-3.454-3.422Z",
        fill: "#0AAD0A"
      }), /* @__PURE__ */jsx("path", {
        d: "M36.287 7.244c-2.316 0-3.788-1.434-3.788-3.641C32.5 1.395 34.007 0 36.287 0c2.316 0 3.788 1.433 3.788 3.64s-1.507 3.604-3.788 3.604Zm3.384 1.4v22.908h-6.767V8.642l6.767.002ZM49.709 8.641v4.267h.331C51.328 9.892 53.571 8.2 57.176 8.2c4.89 0 7.905 2.905 7.905 8.532v14.82h-6.767v-13.57c0-3.162-1.36-4.596-4.044-4.596-2.8 0-4.376 1.545-4.376 4.78v13.386h-6.767V8.642h6.582ZM73.685 24.308c.258 1.986 1.472 3.016 3.642 3.016 2.39 0 3.383-.92 3.383-2.208 0-1.244-.622-1.986-2.685-2.205l-2.941-.332c-5.26-.588-7.43-2.941-7.43-6.844 0-4.34 3.267-7.54 9.598-7.54 6.179 0 9.085 2.943 9.452 7.392h-6.252c-.146-1.728-1.176-2.72-3.346-2.72-2.243 0-3.236.919-3.236 2.205 0 1.103.699 1.728 2.427 1.95l3.309.446c5.186.698 7.392 2.8 7.392 6.877 0 4.486-3.494 7.649-9.709 7.649-6.435 0-9.672-3.09-10.11-7.686h6.506ZM90.902 24.823V14.01h-2.906V9.525c3.753-.258 5.223-1.655 5.37-5.113h4.303v4.23h5.115v5.37h-5.115v9.67c0 2.28.957 2.98 2.831 2.98a8.82 8.82 0 0 0 1.693-.184v5.111a12.845 12.845 0 0 1-3.348.405c-5.55 0-7.943-2.502-7.943-7.171ZM118.005 27.728h-.287c-1.068 2.684-3.09 4.266-6.584 4.266-4.561 0-7.023-2.831-7.023-6.473 0-3.383 1.912-5.737 7.096-6.689l3.899-.7c1.986-.367 2.685-1.066 2.685-2.243 0-1.58-1.103-2.5-3.236-2.5-2.354 0-3.531 1.066-3.752 2.904h-6.442c.699-4.928 4.303-8.089 10.444-8.089 6.619 0 9.746 3.348 9.746 8.495v14.858h-6.546v-3.829Zm-.221-6.73c-.588.441-1.361.777-2.426 1.03l-2.023.478c-1.764.405-2.426 1.214-2.426 2.464 0 1.618 1.14 2.538 3.052 2.538 2.28 0 3.825-1.245 3.825-4.193l-.002-2.318ZM139.259 8.2c7.136 0 11.107 3.898 11.622 10.15h-6.689c-.33-2.832-1.867-4.634-4.964-4.634-3.458 0-5.405 2.17-5.405 6.253 0 4.339 2.095 6.509 5.478 6.509 2.869 0 4.667-1.693 5.002-4.745h6.729C150.41 28.133 146.106 32 139.081 32c-7.722 0-12.1-4.634-12.1-11.805-.005-7.251 4.85-11.995 12.278-11.995ZM166.596 27.728h-.294c-1.066 2.684-3.088 4.266-6.582 4.266-4.561 0-7.025-2.831-7.025-6.473 0-3.383 1.913-5.737 7.098-6.689l3.898-.7c1.987-.367 2.685-1.066 2.685-2.243 0-1.58-1.104-2.5-3.237-2.5-2.353 0-3.529 1.066-3.75 2.904h-6.436c.699-4.928 4.303-8.089 10.444-8.089 6.619 0 9.746 3.348 9.746 8.495v14.858h-6.547v-3.829Zm-.22-6.73c-.588.441-1.361.777-2.428 1.03l-2.022.478c-1.766.405-2.427 1.214-2.427 2.464 0 1.618 1.14 2.538 3.052 2.538 2.281 0 3.825-1.245 3.825-4.193v-2.318ZM182.813 8.641v5.554h.331c1.14-4.667 2.8-5.958 5.001-5.958.463-.002.923.073 1.361.22v6.363a13.121 13.121 0 0 0-1.838-.148c-3.2 0-4.487 1.288-4.487 4.891v11.989h-6.766V8.642h6.398ZM191.543 8.9c1.765-.7 2.5-2.135 2.61-4.488h4.157v4.23h5.111v5.37h-5.111v9.67c0 2.28.955 2.98 2.831 2.98a8.8 8.8 0 0 0 1.691-.184v5.111a12.827 12.827 0 0 1-3.346.405c-5.554 0-7.943-2.502-7.943-7.171V8.899Z",
        fill: "#FAF1E5"
      })]
    }), /* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx("clipPath", {
        id: "prefix__clip0_24283_31714",
        children: /* @__PURE__ */jsx("path", {
          fill: "#fff",
          d: "M.21 0h203.21v32H.21z"
        })
      })
    })]
  })), props);
}

__name(ICWordmarkCashewLogo, "ICWordmarkCashewLogo");

function ICWordmarkDefaultLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 204,
    height: 32,
    viewBox: "0 0 204 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsxs("g", {
      clipPath: "url(#prefix__clip0_9215_3701)",
      children: [/* @__PURE__ */jsx("path", {
        d: "M12.453 20.663c5.992 0 10.903 4.472 10.889 10.889H1.563c-.01-6.414 4.899-10.89 10.89-10.89Z",
        fill: "#FF7009"
      }), /* @__PURE__ */jsx("path", {
        d: "M21.434 5.487c-1.376 0-2.356.598-3.266 1.9l-2.607 3.746V.44H9.337v10.693L6.731 7.388c-.905-1.303-1.885-1.901-3.267-1.901C1.39 5.487.006 7.019 0 8.909c0 1.618.758 2.67 2.363 3.705l10.082 6.495 10.081-6.495c1.606-1.034 2.37-2.087 2.363-3.705.002-1.89-1.38-3.422-3.455-3.422Z",
        fill: "#0AAD0A"
      }), /* @__PURE__ */jsx("path", {
        d: "M36.077 7.244c-2.316 0-3.788-1.434-3.788-3.641C32.29 1.395 33.797 0 36.077 0c2.317 0 3.788 1.433 3.788 3.64s-1.507 3.604-3.788 3.604Zm3.384 1.4v22.908h-6.767V8.642l6.767.002ZM49.499 8.641v4.267h.331C51.118 9.892 53.361 8.2 56.966 8.2c4.89 0 7.905 2.906 7.905 8.533v14.82h-6.767v-13.57c0-3.162-1.36-4.596-4.044-4.596-2.8 0-4.376 1.545-4.376 4.78v13.386h-6.767V8.642H49.5ZM73.475 24.308c.258 1.986 1.472 3.016 3.642 3.016 2.39 0 3.383-.92 3.383-2.208 0-1.244-.622-1.986-2.685-2.205l-2.941-.332c-5.26-.588-7.43-2.941-7.43-6.844 0-4.34 3.267-7.54 9.598-7.54 6.179 0 9.085 2.943 9.452 7.392h-6.252c-.146-1.728-1.176-2.72-3.346-2.72-2.243 0-3.236.919-3.236 2.205 0 1.103.699 1.728 2.427 1.95l3.309.446c5.186.698 7.392 2.8 7.392 6.877 0 4.486-3.494 7.649-9.709 7.649-6.435 0-9.672-3.09-10.11-7.686h6.506ZM90.692 24.823V14.01h-2.905V9.525c3.752-.258 5.222-1.655 5.37-5.113h4.302v4.23h5.115v5.37h-5.115v9.67c0 2.28.957 2.98 2.831 2.98a8.82 8.82 0 0 0 1.693-.184v5.111a12.845 12.845 0 0 1-3.348.405c-5.55 0-7.943-2.502-7.943-7.171ZM117.795 27.728h-.287c-1.068 2.684-3.09 4.266-6.584 4.266-4.561 0-7.023-2.831-7.023-6.473 0-3.383 1.912-5.737 7.096-6.689l3.899-.7c1.986-.367 2.685-1.066 2.685-2.243 0-1.58-1.103-2.5-3.236-2.5-2.354 0-3.531 1.066-3.752 2.904h-6.442c.699-4.928 4.303-8.089 10.444-8.089 6.62 0 9.746 3.348 9.746 8.495v14.858h-6.546v-3.829Zm-.221-6.73c-.588.441-1.361.777-2.426 1.03l-2.023.478c-1.764.405-2.426 1.214-2.426 2.464 0 1.618 1.14 2.538 3.052 2.538 2.28 0 3.825-1.245 3.825-4.193l-.002-2.318ZM139.049 8.2c7.136 0 11.107 3.898 11.622 10.15h-6.689c-.33-2.832-1.867-4.634-4.964-4.634-3.458 0-5.405 2.17-5.405 6.253 0 4.339 2.095 6.509 5.478 6.509 2.869 0 4.667-1.693 5.002-4.745h6.729C150.2 28.133 145.896 32 138.871 32c-7.722 0-12.1-4.634-12.1-11.805-.005-7.251 4.85-11.996 12.278-11.996ZM166.386 27.728h-.294c-1.066 2.684-3.088 4.266-6.582 4.266-4.561 0-7.025-2.831-7.025-6.473 0-3.383 1.913-5.737 7.098-6.689l3.898-.7c1.987-.367 2.685-1.066 2.685-2.243 0-1.58-1.104-2.5-3.237-2.5-2.353 0-3.529 1.066-3.75 2.904h-6.436c.699-4.928 4.303-8.089 10.444-8.089 6.619 0 9.746 3.348 9.746 8.495v14.858h-6.547v-3.829Zm-.22-6.73c-.588.441-1.361.777-2.428 1.03l-2.022.478c-1.766.405-2.427 1.214-2.427 2.464 0 1.618 1.14 2.538 3.052 2.538 2.281 0 3.825-1.245 3.825-4.193v-2.318ZM182.603 8.641v5.554h.331c1.14-4.667 2.8-5.958 5.001-5.958.463-.002.923.073 1.361.22v6.363a13.121 13.121 0 0 0-1.838-.148c-3.2 0-4.487 1.288-4.487 4.891v11.989h-6.766V8.642h6.398ZM191.333 8.9c1.765-.7 2.5-2.135 2.61-4.488h4.157v4.23h5.111v5.37H198.1v9.67c0 2.28.955 2.98 2.831 2.98a8.8 8.8 0 0 0 1.691-.184v5.111a12.827 12.827 0 0 1-3.346.405c-5.554 0-7.943-2.502-7.943-7.171V8.899Z",
        fill: "#003D29"
      })]
    }), /* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx("clipPath", {
        id: "prefix__clip0_9215_3701",
        children: /* @__PURE__ */jsx("path", {
          fill: "#fff",
          d: "M0 0h203.21v32H0z"
        })
      })
    })]
  })), props);
}

__name(ICWordmarkDefaultLogo, "ICWordmarkDefaultLogo");

function PayPalLogo(props) {
  return /*#__PURE__*/cloneElement( /* @__PURE__ */jsxs("svg", __spreadProps(__spreadValues({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [/* @__PURE__ */jsx("path", {
      d: "M69.415 7.6c2.537 2.924 3.272 6.151 2.537 10.899h.007a9.23 9.23 0 0 1 2.665 2.083c2.385 2.752 2.85 6.67 1.947 11.362-2.156 11.23-9.534 15.113-18.967 15.113h-1.456c-.557 0-1.096.2-1.52.568a2.379 2.379 0 0 0-.79 1.433l-.119.653-1.832 11.786-.098.498a2.379 2.379 0 0 1-.79 1.436 2.32 2.32 0 0 1-1.521.569h-9.736a1.39 1.39 0 0 1-1.068-.499 1.43 1.43 0 0 1-.32-1.147l.795-5.123H27.603a1.587 1.587 0 0 1-1.22-.57 1.633 1.633 0 0 1-.363-1.312l7.786-50.06c.1-.64.42-1.22.905-1.64A2.654 2.654 0 0 1 36.451 3h18.7c6.442 0 11.478 1.38 14.264 4.6Z",
      fill: "#009ADE"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M58.825 71h7.034c2.34 0 4.109.667 5.123 1.931.894 1.149 1.22 2.771.894 4.878-.698 4.776-3.367 7.185-7.994 7.185H61.66a.938.938 0 0 0-.643.248c-.18.163-.299.39-.336.64l-.802 5.496a.754.754 0 0 1-.232.445.657.657 0 0 1-.444.177h-3.618a.552.552 0 0 1-.245-.059.594.594 0 0 1-.2-.163.677.677 0 0 1-.133-.508l2.839-19.385c.037-.25.157-.476.337-.638a.937.937 0 0 1 .642-.247Zm3.67 9.794c1.864 0 3.789 0 4.174-2.714h-.01c.14-.952.03-1.644-.33-2.107-.616-.78-1.814-.78-3.08-.78h-.49a.567.567 0 0 0-.38.152.65.65 0 0 0-.2.382l-.74 5.067h1.056ZM84.668 78.33h3.666a.636.636 0 0 1 .64.464.651.651 0 0 1 .018.282l-1.98 12.657c-.04.256-.17.488-.367.654a1.061 1.061 0 0 1-.7.254h-3.3a.634.634 0 0 1-.485-.227.648.648 0 0 1-.145-.52l.164-1.025a7.016 7.016 0 0 1-2.324 1.588c-.873.366-1.81.55-2.755.543-1.91 0-3.506-.553-4.622-1.88-1.22-1.446-1.722-3.527-1.366-5.68C71.78 81.097 75.24 78 79.29 78c1.767 0 3.535.388 4.328 1.55l.256.359.163-1.034a.634.634 0 0 1 .63-.545Zm-2.849 9.756a4.132 4.132 0 0 0 1.405-2.556 3.213 3.213 0 0 0-.622-2.608 3.079 3.079 0 0 0-2.443-1.008 4.082 4.082 0 0 0-2.718 1 4.15 4.15 0 0 0-1.39 2.559 2.894 2.894 0 0 0 .588 2.596 2.823 2.823 0 0 0 2.45.992 4.064 4.064 0 0 0 2.73-.975Z",
      fill: "#009ADE"
    }), /* @__PURE__ */jsx("path", {
      d: "m92.766 72.509-2.76 18.795a.644.644 0 0 0 .128.484c.052.066.118.12.191.156a.53.53 0 0 0 .234.056h2.776a.899.899 0 0 0 .615-.236c.172-.156.286-.372.321-.61l2.722-18.462a.64.64 0 0 0-.128-.483.563.563 0 0 0-.192-.155.527.527 0 0 0-.236-.054h-3.102a.536.536 0 0 0-.374.14.61.61 0 0 0-.195.369Z",
      fill: "#009ADE"
    }), /* @__PURE__ */jsx("path", {
      d: "M70.146 7.666c2.579 2.964 3.326 6.238 2.579 11.052h.017c-.055.367-.12.741-.192 1.126-2.52 13.017-11.085 17.52-22.047 17.52h-5.58c-.648 0-1.274.233-1.765.66a2.748 2.748 0 0 0-.911 1.645l.09-.577L39.37 58H27.63a1.615 1.615 0 0 1-1.24-.579 1.655 1.655 0 0 1-.37-1.33l7.917-50.77a2.758 2.758 0 0 1 .92-1.663A2.702 2.702 0 0 1 36.627 3h19.016c6.55 0 11.67 1.4 14.504 4.666Z",
      fill: "#002169"
    }), /* @__PURE__ */jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.02 71h7.444c2.488 0 4.365.667 5.454 1.938.951 1.148 1.297 2.77.951 4.876-.74 4.774-3.57 7.182-8.473 7.182H9.042a1.027 1.027 0 0 0-.67.254c-.187.163-.311.388-.35.635l-.812 5.227c-.039.25-.165.477-.356.64-.19.163-.432.251-.681.248h-3.55a.614.614 0 0 1-.474-.221.636.636 0 0 1-.141-.51l3.01-19.377c.038-.245.159-.468.342-.631.183-.163.417-.256.66-.261Zm3.883 9.79c1.974 0 4.013 0 4.418-2.713.148-.951.03-1.643-.36-2.106-.653-.78-1.925-.78-3.266-.78h-.515a.616.616 0 0 0-.403.153.634.634 0 0 0-.21.381l-.787 5.066h1.123ZM31.919 78.33h3.465a.57.57 0 0 1 .261.056c.082.04.155.098.213.172a.684.684 0 0 1 .131.537L34.117 91.75c-.038.255-.16.488-.346.654a.97.97 0 0 1-.663.254h-3.105a.573.573 0 0 1-.253-.06.61.61 0 0 1-.205-.168.686.686 0 0 1-.137-.519l.154-1.026a6.63 6.63 0 0 1-2.196 1.578 6.27 6.27 0 0 1-2.6.536c-1.805 0-3.314-.553-4.37-1.88-1.15-1.446-1.627-3.527-1.29-5.68.631-4.344 3.902-7.44 7.73-7.44 1.67 0 3.341.388 4.094 1.55l.242.359.152-1.034a.655.655 0 0 1 .202-.39.58.58 0 0 1 .393-.155Zm-2.692 9.756a4.208 4.208 0 0 0 1.33-2.556 3.394 3.394 0 0 0-.024-1.373 3.279 3.279 0 0 0-.564-1.235 2.927 2.927 0 0 0-1.049-.78c-.399-.175-.83-.252-1.26-.228a3.736 3.736 0 0 0-2.571.998 4.223 4.223 0 0 0-1.315 2.56c-.11.45-.118.92-.021 1.372.096.452.294.872.576 1.225.283.352.64.627 1.044.8.403.172.84.238 1.272.192a3.722 3.722 0 0 0 2.582-.975Z",
      fill: "#002169"
    }), /* @__PURE__ */jsx("path", {
      d: "M54.387 78h-3.535a.996.996 0 0 0-.477.123c-.147.081-.272.197-.366.34l-4.88 7.43-2.063-7.138a1.06 1.06 0 0 0-.37-.545 1.001 1.001 0 0 0-.61-.21h-3.473a.598.598 0 0 0-.499.266.647.647 0 0 0-.081.574l3.893 11.817-3.661 5.344a.645.645 0 0 0 .18.907c.096.06.206.092.318.092h3.531c.165 0 .328-.04.474-.12.146-.078.271-.192.366-.332l11.758-17.553a.651.651 0 0 0-.188-.903.599.599 0 0 0-.317-.092Z",
      fill: "#002169"
    }), /* @__PURE__ */jsx("path", {
      d: "M45.49 18.79c.061-.384.214-.748.444-1.06.23-.312.531-.564.878-.733.32-.156.672-.237 1.028-.236h14.909c1.645-.016 3.289.1 4.916.347.432.069.85.152 1.257.242.408.09.802.194 1.182.305l.566.18a13.1 13.1 0 0 1 2.055.88c.747-4.814 0-8.086-2.58-11.05C67.312 4.398 62.191 3 55.64 3H36.627c-.648 0-1.276.233-1.769.658a2.757 2.757 0 0 0-.92 1.662L26.02 56.092a1.665 1.665 0 0 0 .37 1.33 1.633 1.633 0 0 0 1.24.578h11.74l2.968-18.904 3.151-20.305Z",
      fill: "#002F87"
    })]
  })), props);
}

__name(PayPalLogo, "PayPalLogo");

export { A11Y, AddIcon_default as AddIcon, ApprovedIcon_default as ApprovedIcon, ArrowDownIcon_default as ArrowDownIcon, ArrowLeftIcon_default as ArrowLeftIcon, ArrowRightIcon_default as ArrowRightIcon, ArrowUpIcon_default as ArrowUpIcon, BOUNCE_EASING_FUNCTION_VARIABLE, BREAKPOINTS, Box, BulletIcon_default as BulletIcon, ButtonCore, CORE_COLORS, CSSReset, CachedTDSThemeContext, CachedThemeContext, CachedThemeProvider, CartIcon_default as CartIcon, CheckboxContext, CheckboxCore, CheckboxDisabledIndeterminateIcon_default as CheckboxDisabledIndeterminateIcon, CheckboxDisabledSelectedIcon_default as CheckboxDisabledSelectedIcon, CheckboxDisabledUnselectedIcon_default as CheckboxDisabledUnselectedIcon, CheckboxGroupContext, CheckboxGroupCoreWithSlots as CheckboxGroupCore, CheckboxGroupStateContext, CheckboxIndeterminateIcon_default as CheckboxIndeterminateIcon, CheckboxSelectedIcon_default as CheckboxSelectedIcon, CheckboxUnselectedIcon_default as CheckboxUnselectedIcon, ChevronDownIcon_default as ChevronDownIcon, ChevronLeftIcon_default as ChevronLeftIcon, ChevronRightIcon_default as ChevronRightIcon, ChevronUpIcon_default as ChevronUpIcon, ClearIcon_default as ClearIcon, CloseIcon_default as CloseIcon, ColorCacheContext, ColorCacheProvider, ConfirmIcon_default as ConfirmIcon, DateIcon_default as DateIcon, DeliveryIcon_default as DeliveryIcon, DislikeIcon_default as DislikeIcon, DollarIcon_default as DollarIcon, ELEVATED_EASING_FUNCTION_VARIABLE, FlagAUIcon_default as FlagAUIcon, FlagBRIcon_default as FlagBRIcon, FlagCAIcon_default as FlagCAIcon, FlagDEIcon_default as FlagDEIcon, FlagFRIcon_default as FlagFRIcon, FlagJPIcon_default as FlagJPIcon, FlagUKIcon_default as FlagUKIcon, FlagUSIcon_default as FlagUSIcon, Flex, FocusRing, FontLoader, FunctionOrReactNodeAsChild, GearIcon_default as GearIcon, Grid, GroupIcon_default as GroupIcon, HiddenIcon_default as HiddenIcon, INSTACART_CONTRAST_FONT_FAMILY, INSTACART_CONTRAST_FONT_FAMILY_WITH_FALLBACKS, INSTACART_SANS_FONT_FAMILY, INSTACART_SANS_FONT_FAMILY_WITH_FALLBACKS, INSTACART_SANS_THEME_TYPOGRAPHY, IdsExperimentOverride, IdsProvider, InformationIcon_default as InformationIcon, InformationOutlineIcon_default as InformationOutlineIcon, InputContext, InputCore, InstacartIcon_default as InstacartIcon, InstacartSansFontLoaderVariants, IssueIcon_default as IssueIcon, LabelContext, LabelCore, LikeIcon_default as LikeIcon, LinkContext, LinkCore, LockedIcon_default as LockedIcon, MarkerIcon_default as MarkerIcon, OptionsIcon_default as OptionsIcon, POSITION_X_Y_CENTER, POSITION_Y_CENTER, PauseIcon_default as PauseIcon, PercentIcon_default as PercentIcon, PickupIcon_default as PickupIcon, PlaceholderDarkIcon_default as PlaceholderDarkIcon, PlayIcon_default as PlayIcon, RadioButtonContext, RadioButtonGroupContext, RadioButtonGroupCoreWithSlots as RadioButtonGroupCore, RadioButtonGroupStateContext, RadioDisabledSelectedIcon_default as RadioDisabledSelectedIcon, RadioDisabledUnselectedIcon_default as RadioDisabledUnselectedIcon, RadioSelectedIcon_default as RadioSelectedIcon, RadioUnselectedIcon_default as RadioUnselectedIcon, RemoveIcon_default as RemoveIcon, RouterProvider, SMOOTH_EASING_FUNCTION_VARIABLE, STRETCH_OVER_RELATIVE_PARENT, SVGIcon, SearchIcon_default as SearchIcon, ShownIcon_default as ShownIcon, SpeedIcon_default as SpeedIcon, StoreIcon_default as StoreIcon, SubtractIcon_default as SubtractIcon, TextAreaContext, TextAreaCore, TextContext, TextCore, TextFieldCoreFR as TextFieldCore, TextFieldCoreContext, TextWithIconsLayout, ThemeOverride, ThemeProvider, ToggleButtonCore, TrashIcon_default as TrashIcon, UnlockedIcon_default as UnlockedIcon, VisuallyHidden, addAlphaToHex, aspectRatio, blendColors, bodyScrollLock, combineStyles, computeBackgroundColor, computeInteractiveBackgroundColors, coreTheme, createGetFontVariationSettings, elevation, extractDWebTypographyStyles, forwardRefWithAs, layers, lineClamp, positionX, positionY, processComponentThemeConfig, removeDataAttributes, responsive_exports as responsive, spacing, useAriaCurrent, useAriaLabel, useAriaLoading, useBreakpoint, useComponentTheme, useCssTransition, useFocusRing, useIdsConfig, useIdsFeatureFlag, useInitialFocusElem, useIsIdsThemeConfigured, useIsPantryEnabled, useMergeRefs, useOnClickOutside, useRenderChildrenStatus, useRequiredContext, useTheme };